'use strict';

/*! dprd-semantic-analytics-framework - v4.0.43 - 2017-10-20 */
(function (window, document, location, undefined) {
    var WDPRO = window.WDPRO = window.WDPRO || {};
    WDPRO.Analytics = WDPRO.Analytics || {};

    /* global WDPRO */
    var inject = WDPRO.Analytics.inject = WDPRO.Analytics.inject || function () {
        var resolutions = {};

        injectFn.resolve = store('resolve', resolve);
        injectFn.store = store('store', store);
        store('ref', ref);

        return injectFn;

        function injectFn(fn) {
            return fn.apply(this, Array.prototype.concat.apply([], Array.prototype.slice.call(arguments, 1)).map(resolve));
        }

        function resolve(str) {
            if (typeof str !== 'string') {
                return str;
            }
            return isStored(str) ? retrieve(str) : store(str, ref(str));
        }

        function key(str) {
            return str.toLowerCase();
        }

        function isStored(str) {
            return key(str) in resolutions;
        }

        function retrieve(str) {
            return resolutions[key(str)];
        }

        function store() /*...aliases, value*/{
            var aliases = Array.prototype.concat.apply([], Array.prototype.slice.call(arguments, 0, -1)),
                value = arguments[arguments.length - 1];

            if (value !== undefined) {
                aliases.forEach(function (alias) {
                    if (typeof alias === 'string') {
                        resolutions[key(alias)] = value;
                    }
                });
            }
            return value;
        }

        function ref(path, base) {
            var i = path.indexOf('.');
            base = base || this || window;
            return i === -1 ? base[path] : (base = base[path.substr(0, i)]) && ref(path.substr(i + 1), base);
        }
    }();
    inject.store('Analytics', WDPRO.Analytics);

    /*
     * jQuery JavaScript Library v1.7.2
     * http://jquery.com/
     *
     * Copyright 2011, John Resig
     * Dual licensed under the MIT or GPL Version 2 licenses.
     * http://jquery.org/license
     *
     * Includes Sizzle.js
     * http://sizzlejs.com/
     * Copyright 2011, The Dojo Foundation
     * Released under the MIT, BSD, and GPL Licenses.
     *
     * Date: Wed Mar 21 12:46:34 2012 -0700
     */
    (function (e, t) {
        function n(e) {
            var t,
                n,
                r = H[e] = {};for (e = e.split(/\s+/), t = 0, n = e.length; n > t; t++) {
                r[e[t]] = !0;
            }return r;
        }function r(e, n, r) {
            if (r === t && 1 === e.nodeType) {
                var i = "data-" + n.replace(q, "-$1").toLowerCase();if (r = e.getAttribute(i), "string" == typeof r) {
                    try {
                        r = "true" === r ? !0 : "false" === r ? !1 : "null" === r ? null : O.isNumeric(r) ? +r : B.test(r) ? O.parseJSON(r) : r;
                    } catch (o) {}O.data(e, n, r);
                } else r = t;
            }return r;
        }function i(e) {
            for (var t in e) {
                if (("data" !== t || !O.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
            }return !0;
        }function o(e, t, n) {
            var r = t + "defer",
                i = t + "queue",
                o = t + "mark",
                a = O._data(e, r);!a || "queue" !== n && O._data(e, i) || "mark" !== n && O._data(e, o) || setTimeout(function () {
                O._data(e, i) || O._data(e, o) || (O.removeData(e, r, !0), a.fire());
            }, 0);
        }function a() {
            return !1;
        }function s() {
            return !0;
        }function l(e) {
            return !e || !e.parentNode || 11 === e.parentNode.nodeType;
        }function u(e, t, n) {
            if (t = t || 0, O.isFunction(t)) return O.grep(e, function (e, r) {
                var i = !!t.call(e, r, e);return i === n;
            });if (t.nodeType) return O.grep(e, function (e) {
                return e === t === n;
            });if ("string" == typeof t) {
                var r = O.grep(e, function (e) {
                    return 1 === e.nodeType;
                });if (ct.test(t)) return O.filter(t, r, !n);t = O.filter(t, r);
            }return O.grep(e, function (e) {
                return O.inArray(e, t) >= 0 === n;
            });
        }function c(e) {
            var t = ht.split("|"),
                n = e.createDocumentFragment();if (n.createElement) for (; t.length;) {
                n.createElement(t.pop());
            }return n;
        }function f(e) {
            return O.nodeName(e, "table") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
        }function d(e, t) {
            if (1 === t.nodeType && O.hasData(e)) {
                var n,
                    r,
                    i,
                    o = O._data(e),
                    a = O._data(t, o),
                    s = o.events;if (s) {
                    delete a.handle, a.events = {};for (n in s) {
                        for (r = 0, i = s[n].length; i > r; r++) {
                            O.event.add(t, n, s[n][r]);
                        }
                    }
                }a.data && (a.data = O.extend({}, a.data));
            }
        }function p(e, t) {
            var n;1 === t.nodeType && (t.clearAttributes && t.clearAttributes(), t.mergeAttributes && t.mergeAttributes(e), n = t.nodeName.toLowerCase(), "object" === n ? t.outerHTML = e.outerHTML : "input" !== n || "checkbox" !== e.type && "radio" !== e.type ? "option" === n ? t.selected = e.defaultSelected : "input" === n || "textarea" === n ? t.defaultValue = e.defaultValue : "script" === n && t.text !== e.text && (t.text = e.text) : (e.checked && (t.defaultChecked = t.checked = e.checked), t.value !== e.value && (t.value = e.value)), t.removeAttribute(O.expando), t.removeAttribute("_submit_attached"), t.removeAttribute("_change_attached"));
        }function h(e) {
            return t !== e.getElementsByTagName ? e.getElementsByTagName("*") : t !== e.querySelectorAll ? e.querySelectorAll("*") : [];
        }function m(e) {
            ("checkbox" === e.type || "radio" === e.type) && (e.defaultChecked = e.checked);
        }function g(e) {
            var n = (e.nodeName || "").toLowerCase();"input" === n ? m(e) : "script" !== n && t !== e.getElementsByTagName && O.grep(e.getElementsByTagName("input"), m);
        }function y(e) {
            var t = j.createElement("div");return At.appendChild(t), t.innerHTML = e.outerHTML, t.firstChild;
        }function v(e, t, n) {
            var r = "width" === t ? e.offsetWidth : e.offsetHeight,
                i = "width" === t ? 1 : 0,
                o = 4;if (r > 0) {
                if ("border" !== n) for (; o > i; i += 2) {
                    n || (r -= parseFloat(O.css(e, "padding" + Wt[i])) || 0), "margin" === n ? r += parseFloat(O.css(e, n + Wt[i])) || 0 : r -= parseFloat(O.css(e, "border" + Wt[i] + "Width")) || 0;
                }return r + "px";
            }if (r = Lt(e, t), (0 > r || null == r) && (r = e.style[t]), Ht.test(r)) return r;if (r = parseFloat(r) || 0, n) for (; o > i; i += 2) {
                r += parseFloat(O.css(e, "padding" + Wt[i])) || 0, "padding" !== n && (r += parseFloat(O.css(e, "border" + Wt[i] + "Width")) || 0), "margin" === n && (r += parseFloat(O.css(e, n + Wt[i])) || 0);
            }return r + "px";
        }function b(e) {
            return function (t, n) {
                if ("string" != typeof t && (n = t, t = "*"), O.isFunction(n)) for (var r, i, o, a = t.toLowerCase().split(tn), s = 0, l = a.length; l > s; s++) {
                    r = a[s], o = /^\+/.test(r), o && (r = r.substr(1) || "*"), i = e[r] = e[r] || [], i[o ? "unshift" : "push"](n);
                }
            };
        }function x(e, n, r, i, o, a) {
            o = o || n.dataTypes[0], a = a || {}, a[o] = !0;for (var s, l = e[o], u = 0, c = l ? l.length : 0, f = e === an; c > u && (f || !s); u++) {
                s = l[u](n, r, i), "string" == typeof s && (!f || a[s] ? s = t : (n.dataTypes.unshift(s), s = x(e, n, r, i, s, a)));
            }return !f && s || a["*"] || (s = x(e, n, r, i, "*", a)), s;
        }function T(e, n) {
            var r,
                i,
                o = O.ajaxSettings.flatOptions || {};for (r in n) {
                n[r] !== t && ((o[r] ? e : i || (i = {}))[r] = n[r]);
            }i && O.extend(!0, e, i);
        }function w(e, t, n, r) {
            if (O.isArray(t)) O.each(t, function (t, i) {
                n || Xt.test(e) ? r(e, i) : w(e + "[" + ("object" == typeof i ? t : "") + "]", i, n, r);
            });else if (n || "object" !== O.type(t)) r(e, t);else for (var i in t) {
                w(e + "[" + i + "]", t[i], n, r);
            }
        }function N(e, n, r) {
            var i,
                o,
                a,
                s,
                l = e.contents,
                u = e.dataTypes,
                c = e.responseFields;for (o in c) {
                o in r && (n[c[o]] = r[o]);
            }for (; "*" === u[0];) {
                u.shift(), i === t && (i = e.mimeType || n.getResponseHeader("content-type"));
            }if (i) for (o in l) {
                if (l[o] && l[o].test(i)) {
                    u.unshift(o);break;
                }
            }if (u[0] in r) a = u[0];else {
                for (o in r) {
                    if (!u[0] || e.converters[o + " " + u[0]]) {
                        a = o;break;
                    }s || (s = o);
                }a = a || s;
            }return a ? (a !== u[0] && u.unshift(a), r[a]) : t;
        }function C(e, n) {
            e.dataFilter && (n = e.dataFilter(n, e.dataType));var r,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                f = e.dataTypes,
                d = {},
                p = f.length,
                h = f[0];for (r = 1; p > r; r++) {
                if (1 === r) for (i in e.converters) {
                    "string" == typeof i && (d[i.toLowerCase()] = e.converters[i]);
                }if (a = h, h = f[r], "*" === h) h = a;else if ("*" !== a && a !== h) {
                    if (s = a + " " + h, l = d[s] || d["* " + h], !l) {
                        c = t;for (u in d) {
                            if (o = u.split(" "), (o[0] === a || "*" === o[0]) && (c = d[o[1] + " " + h])) {
                                u = d[u], u === !0 ? l = c : c === !0 && (l = u);break;
                            }
                        }
                    }l || c || O.error("No conversion from " + s.replace(" ", " to ")), l !== !0 && (n = l ? l(n) : c(u(n)));
                }
            }return n;
        }function E() {
            try {
                return new e.XMLHttpRequest();
            } catch (t) {}
        }function k() {
            try {
                return new e.ActiveXObject("Microsoft.XMLHTTP");
            } catch (t) {}
        }function S() {
            return setTimeout(A, 0), vn = O.now();
        }function A() {
            vn = t;
        }function L(e, t) {
            var n = {};return O.each(wn.concat.apply([], wn.slice(0, t)), function () {
                n[this] = e;
            }), n;
        }function D(e) {
            if (!bn[e]) {
                var t = j.body,
                    n = O("<" + e + ">").appendTo(t),
                    r = n.css("display");n.remove(), ("none" === r || "" === r) && (mn || (mn = j.createElement("iframe"), mn.frameBorder = mn.width = mn.height = 0), t.appendChild(mn), gn && mn.createElement || (gn = (mn.contentWindow || mn.contentDocument).document, gn.write((O.support.boxModel ? "<!doctype html>" : "") + "<html><body>"), gn.close()), n = gn.createElement(e), gn.body.appendChild(n), r = O.css(n, "display"), t.removeChild(mn)), bn[e] = r;
            }return bn[e];
        }function F(e) {
            return O.isWindow(e) ? e : 9 === e.nodeType ? e.defaultView || e.parentWindow : !1;
        }var j = e.document,
            M = e.navigator,
            _ = e.location,
            O = function () {
            function n() {
                if (!s.isReady) {
                    try {
                        j.documentElement.doScroll("left");
                    } catch (e) {
                        return setTimeout(n, 1), t;
                    }s.ready();
                }
            }var r,
                i,
                o,
                _a2,
                s = function s(e, t) {
                return new s.fn.init(e, t, r);
            },
                l = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,
                u = /\S/,
                c = /^\s+/,
                f = /\s+$/,
                d = /^<(\w+)\s*\/?>(?:<\/\1>)?$/,
                p = /^[\],:{}\s]*$/,
                h = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
                m = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                g = /(?:^|:|,)(?:\s*\[)+/g,
                y = /(webkit)[ \/]([\w.]+)/,
                v = /(opera)(?:.*version)?[ \/]([\w.]+)/,
                b = /(msie) ([\w.]+)/,
                x = /(mozilla)(?:.*? rv:([\w.]+))?/,
                T = /-([a-z]|[0-9])/gi,
                w = /^-ms-/,
                N = function N(e, t) {
                return (t + "").toUpperCase();
            },
                C = M.userAgent,
                E = Object.prototype.toString,
                k = Object.prototype.hasOwnProperty,
                S = Array.prototype.push,
                A = Array.prototype.slice,
                L = String.prototype.trim,
                D = Array.prototype.indexOf,
                F = {};return s.fn = s.prototype = { constructor: s, init: function init(e, n, r) {
                    var i, o, a, u;if (!e) return this;if (e.nodeType) return this.context = this[0] = e, this.length = 1, this;if ("body" === e && !n && j.body) return this.context = j, this[0] = j.body, this.selector = e, this.length = 1, this;if ("string" == typeof e) {
                        if (i = "<" !== e.charAt(0) || ">" !== e.charAt(e.length - 1) || e.length < 3 ? l.exec(e) : [null, e, null], !i || !i[1] && n) return !n || n.jquery ? (n || r).find(e) : this.constructor(n).find(e);if (i[1]) return n = n instanceof s ? n[0] : n, u = n ? n.ownerDocument || n : j, a = d.exec(e), a ? s.isPlainObject(n) ? (e = [j.createElement(a[1])], s.fn.attr.call(e, n, !0)) : e = [u.createElement(a[1])] : (a = s.buildFragment([i[1]], [u]), e = (a.cacheable ? s.clone(a.fragment) : a.fragment).childNodes), s.merge(this, e);if (o = j.getElementById(i[2]), o && o.parentNode) {
                            if (o.id !== i[2]) return r.find(e);this.length = 1, this[0] = o;
                        }return this.context = j, this.selector = e, this;
                    }return s.isFunction(e) ? r.ready(e) : (e.selector !== t && (this.selector = e.selector, this.context = e.context), s.makeArray(e, this));
                }, selector: "", jquery: "1.7.2", length: 0, size: function size() {
                    return this.length;
                }, toArray: function toArray() {
                    return A.call(this, 0);
                }, get: function get(e) {
                    return null == e ? this.toArray() : 0 > e ? this[this.length + e] : this[e];
                }, pushStack: function pushStack(e, t, n) {
                    var r = this.constructor();return s.isArray(e) ? S.apply(r, e) : s.merge(r, e), r.prevObject = this, r.context = this.context, "find" === t ? r.selector = this.selector + (this.selector ? " " : "") + n : t && (r.selector = this.selector + "." + t + "(" + n + ")"), r;
                }, each: function each(e, t) {
                    return s.each(this, e, t);
                }, ready: function ready(e) {
                    return s.bindReady(), o.add(e), this;
                }, eq: function eq(e) {
                    return e = +e, -1 === e ? this.slice(e) : this.slice(e, e + 1);
                }, first: function first() {
                    return this.eq(0);
                }, last: function last() {
                    return this.eq(-1);
                }, slice: function slice() {
                    return this.pushStack(A.apply(this, arguments), "slice", A.call(arguments).join(","));
                }, map: function map(e) {
                    return this.pushStack(s.map(this, function (t, n) {
                        return e.call(t, n, t);
                    }));
                }, end: function end() {
                    return this.prevObject || this.constructor(null);
                }, push: S, sort: [].sort, splice: [].splice }, s.fn.init.prototype = s.fn, s.extend = s.fn.extend = function () {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    l = arguments[0] || {},
                    u = 1,
                    c = arguments.length,
                    f = !1;for ("boolean" == typeof l && (f = l, l = arguments[1] || {}, u = 2), "object" == typeof l || s.isFunction(l) || (l = {}), c === u && (l = this, --u); c > u; u++) {
                    if (null != (e = arguments[u])) for (n in e) {
                        r = l[n], i = e[n], l !== i && (f && i && (s.isPlainObject(i) || (o = s.isArray(i))) ? (o ? (o = !1, a = r && s.isArray(r) ? r : []) : a = r && s.isPlainObject(r) ? r : {}, l[n] = s.extend(f, a, i)) : i !== t && (l[n] = i));
                    }
                }return l;
            }, s.extend({ noConflict: function noConflict() {
                    return s;
                }, isReady: !1, readyWait: 1, holdReady: function holdReady(e) {
                    e ? s.readyWait++ : s.ready(!0);
                }, ready: function ready(e) {
                    if (e === !0 && ! --s.readyWait || e !== !0 && !s.isReady) {
                        if (!j.body) return setTimeout(s.ready, 1);if (s.isReady = !0, e !== !0 && --s.readyWait > 0) return;o.fireWith(j, [s]), s.fn.trigger && s(j).trigger("ready").off("ready");
                    }
                }, bindReady: function bindReady() {
                    if (!o) {
                        if (o = s.Callbacks("once memory"), "complete" === j.readyState) return setTimeout(s.ready, 1);if (j.addEventListener) j.addEventListener("DOMContentLoaded", _a2, !1), e.addEventListener("load", s.ready, !1);else if (j.attachEvent) {
                            j.attachEvent("onreadystatechange", _a2), e.attachEvent("onload", s.ready);var t = !1;try {
                                t = null == e.frameElement;
                            } catch (r) {}j.documentElement.doScroll && t && n();
                        }
                    }
                }, isFunction: function isFunction(e) {
                    return "function" === s.type(e);
                }, isArray: Array.isArray || function (e) {
                    return "array" === s.type(e);
                }, isWindow: function isWindow(e) {
                    return null != e && e == e.window;
                }, isNumeric: function isNumeric(e) {
                    return !isNaN(parseFloat(e)) && isFinite(e);
                }, type: function type(e) {
                    return null == e ? e + "" : F[E.call(e)] || "object";
                }, isPlainObject: function isPlainObject(e) {
                    if (!e || "object" !== s.type(e) || e.nodeType || s.isWindow(e)) return !1;try {
                        if (e.constructor && !k.call(e, "constructor") && !k.call(e.constructor.prototype, "isPrototypeOf")) return !1;
                    } catch (n) {
                        return !1;
                    }var r;for (r in e) {}return r === t || k.call(e, r);
                }, isEmptyObject: function isEmptyObject(e) {
                    for (var t in e) {
                        return !1;
                    }return !0;
                }, error: function error(e) {
                    throw Error(e);
                }, parseJSON: function parseJSON(n) {
                    return "string" == typeof n && n ? (n = s.trim(n), e.JSON && e.JSON.parse ? e.JSON.parse(n) : p.test(n.replace(h, "@").replace(m, "]").replace(g, "")) ? Function("return " + n)() : (s.error("Invalid JSON: " + n), t)) : null;
                }, parseXML: function parseXML(n) {
                    if ("string" != typeof n || !n) return null;var r, i;try {
                        e.DOMParser ? (i = new DOMParser(), r = i.parseFromString(n, "text/xml")) : (r = new ActiveXObject("Microsoft.XMLDOM"), r.async = "false", r.loadXML(n));
                    } catch (o) {
                        r = t;
                    }return r && r.documentElement && !r.getElementsByTagName("parsererror").length || s.error("Invalid XML: " + n), r;
                }, noop: function noop() {}, globalEval: function globalEval(t) {
                    t && u.test(t) && (e.execScript || function (t) {
                        e.eval.call(e, t);
                    })(t);
                }, camelCase: function camelCase(e) {
                    return e.replace(w, "ms-").replace(T, N);
                }, nodeName: function nodeName(e, t) {
                    return e.nodeName && e.nodeName.toUpperCase() === t.toUpperCase();
                }, each: function each(e, n, r) {
                    var i,
                        o = 0,
                        a = e.length,
                        l = a === t || s.isFunction(e);if (r) {
                        if (l) {
                            for (i in e) {
                                if (n.apply(e[i], r) === !1) break;
                            }
                        } else for (; a > o && n.apply(e[o++], r) !== !1;) {}
                    } else if (l) {
                        for (i in e) {
                            if (n.call(e[i], i, e[i]) === !1) break;
                        }
                    } else for (; a > o && n.call(e[o], o, e[o++]) !== !1;) {}return e;
                }, trim: L ? function (e) {
                    return null == e ? "" : L.call(e);
                } : function (e) {
                    return null == e ? "" : ("" + e).replace(c, "").replace(f, "");
                }, makeArray: function makeArray(e, t) {
                    var n = t || [];if (null != e) {
                        var r = s.type(e);null == e.length || "string" === r || "function" === r || "regexp" === r || s.isWindow(e) ? S.call(n, e) : s.merge(n, e);
                    }return n;
                }, inArray: function inArray(e, t, n) {
                    var r;if (t) {
                        if (D) return D.call(t, e, n);for (r = t.length, n = n ? 0 > n ? Math.max(0, r + n) : n : 0; r > n; n++) {
                            if (n in t && t[n] === e) return n;
                        }
                    }return -1;
                }, merge: function merge(e, n) {
                    var r = e.length,
                        i = 0;if ("number" == typeof n.length) for (var o = n.length; o > i; i++) {
                        e[r++] = n[i];
                    } else for (; n[i] !== t;) {
                        e[r++] = n[i++];
                    }return e.length = r, e;
                }, grep: function grep(e, t, n) {
                    var r,
                        i = [];n = !!n;for (var o = 0, a = e.length; a > o; o++) {
                        r = !!t(e[o], o), n !== r && i.push(e[o]);
                    }return i;
                }, map: function map(e, n, r) {
                    var i,
                        o,
                        a = [],
                        l = 0,
                        u = e.length,
                        c = e instanceof s || u !== t && "number" == typeof u && (u > 0 && e[0] && e[u - 1] || 0 === u || s.isArray(e));if (c) for (; u > l; l++) {
                        i = n(e[l], l, r), null != i && (a[a.length] = i);
                    } else for (o in e) {
                        i = n(e[o], o, r), null != i && (a[a.length] = i);
                    }return a.concat.apply([], a);
                }, guid: 1, proxy: function proxy(e, n) {
                    if ("string" == typeof n) {
                        var r = e[n];n = e, e = r;
                    }if (!s.isFunction(e)) return t;var i = A.call(arguments, 2),
                        o = function o() {
                        return e.apply(n, i.concat(A.call(arguments)));
                    };return o.guid = e.guid = e.guid || o.guid || s.guid++, o;
                }, access: function access(e, n, r, i, o, a, l) {
                    var u,
                        c = null == r,
                        f = 0,
                        d = e.length;if (r && "object" == typeof r) {
                        for (f in r) {
                            s.access(e, n, f, r[f], 1, a, i);
                        }o = 1;
                    } else if (i !== t) {
                        if (u = l === t && s.isFunction(i), c && (u ? (u = n, n = function n(e, t, _n) {
                            return u.call(s(e), _n);
                        }) : (n.call(e, i), n = null)), n) for (; d > f; f++) {
                            n(e[f], r, u ? i.call(e[f], f, n(e[f], r)) : i, l);
                        }o = 1;
                    }return o ? e : c ? n.call(e) : d ? n(e[0], r) : a;
                }, now: function now() {
                    return new Date().getTime();
                }, uaMatch: function uaMatch(e) {
                    e = e.toLowerCase();var t = y.exec(e) || v.exec(e) || b.exec(e) || e.indexOf("compatible") < 0 && x.exec(e) || [];return { browser: t[1] || "", version: t[2] || "0" };
                }, sub: function sub() {
                    function e(t, n) {
                        return new e.fn.init(t, n);
                    }s.extend(!0, e, this), e.superclass = this, e.fn = e.prototype = this(), e.fn.constructor = e, e.sub = this.sub, e.fn.init = function (n, r) {
                        return r && r instanceof s && !(r instanceof e) && (r = e(r)), s.fn.init.call(this, n, r, t);
                    }, e.fn.init.prototype = e.fn;var t = e(j);return e;
                }, browser: {} }), s.each("Boolean Number String Function Array Date RegExp Object".split(" "), function (e, t) {
                F["[object " + t + "]"] = t.toLowerCase();
            }), i = s.uaMatch(C), i.browser && (s.browser[i.browser] = !0, s.browser.version = i.version), s.browser.webkit && (s.browser.safari = !0), u.test(" ") && (c = /^[\s\xA0]+/, f = /[\s\xA0]+$/), r = s(j), j.addEventListener ? _a2 = function a() {
                j.removeEventListener("DOMContentLoaded", _a2, !1), s.ready();
            } : j.attachEvent && (_a2 = function _a() {
                "complete" === j.readyState && (j.detachEvent("onreadystatechange", _a2), s.ready());
            }), s;
        }(),
            H = {};O.Callbacks = function (e) {
            e = e ? H[e] || n(e) : {};var r,
                i,
                o,
                a,
                s,
                l,
                u = [],
                c = [],
                f = function f(t) {
                var n, r, i, o;for (n = 0, r = t.length; r > n; n++) {
                    i = t[n], o = O.type(i), "array" === o ? f(i) : "function" === o && (e.unique && p.has(i) || u.push(i));
                }
            },
                d = function d(t, n) {
                for (n = n || [], r = !e.memory || [t, n], i = !0, o = !0, l = a || 0, a = 0, s = u.length; u && s > l; l++) {
                    if (u[l].apply(t, n) === !1 && e.stopOnFalse) {
                        r = !0;break;
                    }
                }o = !1, u && (e.once ? r === !0 ? p.disable() : u = [] : c && c.length && (r = c.shift(), p.fireWith(r[0], r[1])));
            },
                p = { add: function add() {
                    if (u) {
                        var e = u.length;f(arguments), o ? s = u.length : r && r !== !0 && (a = e, d(r[0], r[1]));
                    }return this;
                }, remove: function remove() {
                    if (u) for (var t = arguments, n = 0, r = t.length; r > n; n++) {
                        for (var i = 0; i < u.length && (t[n] !== u[i] || (o && (i > s || (s--, i > l || l--)), u.splice(i--, 1), !e.unique)); i++) {}
                    }return this;
                }, has: function has(e) {
                    if (u) for (var t = 0, n = u.length; n > t; t++) {
                        if (e === u[t]) return !0;
                    }return !1;
                }, empty: function empty() {
                    return u = [], this;
                }, disable: function disable() {
                    return u = c = r = t, this;
                }, disabled: function disabled() {
                    return !u;
                }, lock: function lock() {
                    return c = t, r && r !== !0 || p.disable(), this;
                }, locked: function locked() {
                    return !c;
                }, fireWith: function fireWith(t, n) {
                    return c && (o ? e.once || c.push([t, n]) : e.once && r || d(t, n)), this;
                }, fire: function fire() {
                    return p.fireWith(this, arguments), this;
                }, fired: function fired() {
                    return !!i;
                } };return p;
        };var P = [].slice;O.extend({ Deferred: function Deferred(e) {
                var t,
                    n = O.Callbacks("once memory"),
                    r = O.Callbacks("once memory"),
                    i = O.Callbacks("memory"),
                    o = "pending",
                    a = { resolve: n, reject: r, notify: i },
                    s = { done: n.add, fail: r.add, progress: i.add, state: function state() {
                        return o;
                    }, isResolved: n.fired, isRejected: r.fired, then: function then(e, t, n) {
                        return l.done(e).fail(t).progress(n), this;
                    }, always: function always() {
                        return l.done.apply(l, arguments).fail.apply(l, arguments), this;
                    }, pipe: function pipe(e, t, n) {
                        return O.Deferred(function (r) {
                            O.each({ done: [e, "resolve"], fail: [t, "reject"], progress: [n, "notify"] }, function (e, t) {
                                var n,
                                    i = t[0],
                                    o = t[1];l[e](O.isFunction(i) ? function () {
                                    n = i.apply(this, arguments), n && O.isFunction(n.promise) ? n.promise().then(r.resolve, r.reject, r.notify) : r[o + "With"](this === l ? r : this, [n]);
                                } : r[o]);
                            });
                        }).promise();
                    }, promise: function promise(e) {
                        if (null == e) e = s;else for (var t in s) {
                            e[t] = s[t];
                        }return e;
                    } },
                    l = s.promise({});for (t in a) {
                    l[t] = a[t].fire, l[t + "With"] = a[t].fireWith;
                }return l.done(function () {
                    o = "resolved";
                }, r.disable, i.lock).fail(function () {
                    o = "rejected";
                }, n.disable, i.lock), e && e.call(l, l), l;
            }, when: function when(e) {
                function t(e) {
                    return function (t) {
                        r[e] = arguments.length > 1 ? P.call(arguments, 0) : t, --s || l.resolveWith(l, r);
                    };
                }function n(e) {
                    return function (t) {
                        a[e] = arguments.length > 1 ? P.call(arguments, 0) : t, l.notifyWith(u, a);
                    };
                }var r = P.call(arguments, 0),
                    i = 0,
                    o = r.length,
                    a = Array(o),
                    s = o,
                    l = 1 >= o && e && O.isFunction(e.promise) ? e : O.Deferred(),
                    u = l.promise();if (o > 1) {
                    for (; o > i; i++) {
                        r[i] && r[i].promise && O.isFunction(r[i].promise) ? r[i].promise().then(t(i), l.reject, n(i)) : --s;
                    }s || l.resolveWith(l, r);
                } else l !== e && l.resolveWith(l, o ? [e] : []);return u;
            } }), O.support = function () {
            {
                var n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p = j.createElement("div");j.documentElement;
            }if (p.setAttribute("className", "t"), p.innerHTML = "   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/>", r = p.getElementsByTagName("*"), i = p.getElementsByTagName("a")[0], !r || !r.length || !i) return {};o = j.createElement("select"), a = o.appendChild(j.createElement("option")), s = p.getElementsByTagName("input")[0], n = { leadingWhitespace: 3 === p.firstChild.nodeType, tbody: !p.getElementsByTagName("tbody").length, htmlSerialize: !!p.getElementsByTagName("link").length, style: /top/.test(i.getAttribute("style")), hrefNormalized: "/a" === i.getAttribute("href"), opacity: /^0.55/.test(i.style.opacity), cssFloat: !!i.style.cssFloat, checkOn: "on" === s.value, optSelected: a.selected, getSetAttribute: "t" !== p.className, enctype: !!j.createElement("form").enctype, html5Clone: "<:nav></:nav>" !== j.createElement("nav").cloneNode(!0).outerHTML, submitBubbles: !0, changeBubbles: !0, focusinBubbles: !1, deleteExpando: !0, noCloneEvent: !0, inlineBlockNeedsLayout: !1, shrinkWrapBlocks: !1, reliableMarginRight: !0, pixelMargin: !0 }, O.boxModel = n.boxModel = "CSS1Compat" === j.compatMode, s.checked = !0, n.noCloneChecked = s.cloneNode(!0).checked, o.disabled = !0, n.optDisabled = !a.disabled;try {
                delete p.test;
            } catch (h) {
                n.deleteExpando = !1;
            }if (!p.addEventListener && p.attachEvent && p.fireEvent && (p.attachEvent("onclick", function () {
                n.noCloneEvent = !1;
            }), p.cloneNode(!0).fireEvent("onclick")), s = j.createElement("input"), s.value = "t", s.setAttribute("type", "radio"), n.radioValue = "t" === s.value, s.setAttribute("checked", "checked"), s.setAttribute("name", "t"), p.appendChild(s), l = j.createDocumentFragment(), l.appendChild(p.lastChild), n.checkClone = l.cloneNode(!0).cloneNode(!0).lastChild.checked, n.appendChecked = s.checked, l.removeChild(s), l.appendChild(p), p.attachEvent) for (f in { submit: 1, change: 1, focusin: 1 }) {
                c = "on" + f, d = c in p, d || (p.setAttribute(c, "return;"), d = "function" == typeof p[c]), n[f + "Bubbles"] = d;
            }return l.removeChild(p), l = o = a = p = s = null, O(function () {
                var r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    f,
                    h,
                    m,
                    g,
                    y,
                    v = j.getElementsByTagName("body")[0];v && (c = 1, y = "padding:0;margin:0;border:", m = "position:absolute;top:0;left:0;width:1px;height:1px;", g = y + "0;visibility:hidden;", f = "style='" + m + y + "5px solid #000;", h = "<div " + f + "display:block;'><div style='" + y + "0;display:block;overflow:hidden;'></div></div><table " + f + "' cellpadding='0' cellspacing='0'><tr><td></td></tr></table>", r = j.createElement("div"), r.style.cssText = g + "width:0;height:0;position:static;top:0;margin-top:" + c + "px", v.insertBefore(r, v.firstChild), p = j.createElement("div"), r.appendChild(p), p.innerHTML = "<table><tr><td style='" + y + "0;display:none'></td><td>t</td></tr></table>", u = p.getElementsByTagName("td"), d = 0 === u[0].offsetHeight, u[0].style.display = "", u[1].style.display = "none", n.reliableHiddenOffsets = d && 0 === u[0].offsetHeight, e.getComputedStyle && (p.innerHTML = "", l = j.createElement("div"), l.style.width = "0", l.style.marginRight = "0", p.style.width = "2px", p.appendChild(l), n.reliableMarginRight = 0 === (parseInt((e.getComputedStyle(l, null) || { marginRight: 0 }).marginRight, 10) || 0)), t !== p.style.zoom && (p.innerHTML = "", p.style.width = p.style.padding = "1px", p.style.border = 0, p.style.overflow = "hidden", p.style.display = "inline", p.style.zoom = 1, n.inlineBlockNeedsLayout = 3 === p.offsetWidth, p.style.display = "block", p.style.overflow = "visible", p.innerHTML = "<div style='width:5px;'></div>", n.shrinkWrapBlocks = 3 !== p.offsetWidth), p.style.cssText = m + g, p.innerHTML = h, i = p.firstChild, o = i.firstChild, a = i.nextSibling.firstChild.firstChild, s = { doesNotAddBorder: 5 !== o.offsetTop, doesAddBorderForTableAndCells: 5 === a.offsetTop }, o.style.position = "fixed", o.style.top = "20px", s.fixedPosition = 20 === o.offsetTop || 15 === o.offsetTop, o.style.position = o.style.top = "", i.style.overflow = "hidden", i.style.position = "relative", s.subtractsBorderForOverflowNotVisible = -5 === o.offsetTop, s.doesNotIncludeMarginInBodyOffset = v.offsetTop !== c, e.getComputedStyle && (p.style.marginTop = "1%", n.pixelMargin = "1%" !== (e.getComputedStyle(p, null) || { marginTop: 0 }).marginTop), t !== r.style.zoom && (r.style.zoom = 1), v.removeChild(r), l = p = r = null, O.extend(n, s));
            }), n;
        }();var B = /^(?:\{.*\}|\[.*\])$/,
            q = /([A-Z])/g;O.extend({ cache: {}, uuid: 0, expando: "jQuery" + (O.fn.jquery + Math.random()).replace(/\D/g, ""), noData: { embed: !0, object: "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000", applet: !0 }, hasData: function hasData(e) {
                return e = e.nodeType ? O.cache[e[O.expando]] : e[O.expando], !!e && !i(e);
            }, data: function data(e, n, r, i) {
                if (O.acceptData(e)) {
                    var o,
                        a,
                        s,
                        l = O.expando,
                        u = "string" == typeof n,
                        c = e.nodeType,
                        f = c ? O.cache : e,
                        d = c ? e[l] : e[l] && l,
                        p = "events" === n;if (d && f[d] && (p || i || f[d].data) || !u || r !== t) return d || (c ? e[l] = d = ++O.uuid : d = l), f[d] || (f[d] = {}, c || (f[d].toJSON = O.noop)), ("object" == typeof n || "function" == typeof n) && (i ? f[d] = O.extend(f[d], n) : f[d].data = O.extend(f[d].data, n)), o = a = f[d], i || (a.data || (a.data = {}), a = a.data), r !== t && (a[O.camelCase(n)] = r), p && !a[n] ? o.events : (u ? (s = a[n], null == s && (s = a[O.camelCase(n)])) : s = a, s);
                }
            }, removeData: function removeData(e, t, n) {
                if (O.acceptData(e)) {
                    var r,
                        o,
                        a,
                        s = O.expando,
                        l = e.nodeType,
                        u = l ? O.cache : e,
                        c = l ? e[s] : s;if (u[c]) {
                        if (t && (r = n ? u[c] : u[c].data)) {
                            O.isArray(t) || (t in r ? t = [t] : (t = O.camelCase(t), t = t in r ? [t] : t.split(" ")));for (o = 0, a = t.length; a > o; o++) {
                                delete r[t[o]];
                            }if (!(n ? i : O.isEmptyObject)(r)) return;
                        }(n || (delete u[c].data, i(u[c]))) && (O.support.deleteExpando || !u.setInterval ? delete u[c] : u[c] = null, l && (O.support.deleteExpando ? delete e[s] : e.removeAttribute ? e.removeAttribute(s) : e[s] = null));
                    }
                }
            }, _data: function _data(e, t, n) {
                return O.data(e, t, n, !0);
            }, acceptData: function acceptData(e) {
                if (e.nodeName) {
                    var t = O.noData[e.nodeName.toLowerCase()];if (t) return !(t === !0 || e.getAttribute("classid") !== t);
                }return !0;
            } }), O.fn.extend({ data: function data(e, n) {
                var i,
                    o,
                    a,
                    s,
                    l,
                    u = this[0],
                    c = 0,
                    f = null;if (e === t) {
                    if (this.length && (f = O.data(u), 1 === u.nodeType && !O._data(u, "parsedAttrs"))) {
                        for (a = u.attributes, l = a.length; l > c; c++) {
                            s = a[c].name, 0 === s.indexOf("data-") && (s = O.camelCase(s.substring(5)), r(u, s, f[s]));
                        }O._data(u, "parsedAttrs", !0);
                    }return f;
                }return "object" == typeof e ? this.each(function () {
                    O.data(this, e);
                }) : (i = e.split(".", 2), i[1] = i[1] ? "." + i[1] : "", o = i[1] + "!", O.access(this, function (n) {
                    return n === t ? (f = this.triggerHandler("getData" + o, [i[0]]), f === t && u && (f = O.data(u, e), f = r(u, e, f)), f === t && i[1] ? this.data(i[0]) : f) : (i[1] = n, this.each(function () {
                        var t = O(this);t.triggerHandler("setData" + o, i), O.data(this, e, n), t.triggerHandler("changeData" + o, i);
                    }), t);
                }, null, n, arguments.length > 1, null, !1));
            }, removeData: function removeData(e) {
                return this.each(function () {
                    O.removeData(this, e);
                });
            } }), O.extend({ _mark: function _mark(e, t) {
                e && (t = (t || "fx") + "mark", O._data(e, t, (O._data(e, t) || 0) + 1));
            }, _unmark: function _unmark(e, t, n) {
                if (e !== !0 && (n = t, t = e, e = !1), t) {
                    n = n || "fx";var r = n + "mark",
                        i = e ? 0 : (O._data(t, r) || 1) - 1;i ? O._data(t, r, i) : (O.removeData(t, r, !0), o(t, n, "mark"));
                }
            }, queue: function queue(e, n, r) {
                var i;return e ? (n = (n || "fx") + "queue", i = O._data(e, n), r && (!i || O.isArray(r) ? i = O._data(e, n, O.makeArray(r)) : i.push(r)), i || []) : t;
            }, dequeue: function dequeue(e, t) {
                t = t || "fx";var n = O.queue(e, t),
                    r = n.shift(),
                    i = {};"inprogress" === r && (r = n.shift()), r && ("fx" === t && n.unshift("inprogress"), O._data(e, t + ".run", i), r.call(e, function () {
                    O.dequeue(e, t);
                }, i)), n.length || (O.removeData(e, t + "queue " + t + ".run", !0), o(e, t, "queue"));
            } }), O.fn.extend({ queue: function queue(e, n) {
                var r = 2;return "string" != typeof e && (n = e, e = "fx", r--), arguments.length < r ? O.queue(this[0], e) : n === t ? this : this.each(function () {
                    var t = O.queue(this, e, n);"fx" === e && "inprogress" !== t[0] && O.dequeue(this, e);
                });
            }, dequeue: function dequeue(e) {
                return this.each(function () {
                    O.dequeue(this, e);
                });
            }, delay: function delay(e, t) {
                return e = O.fx ? O.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, n) {
                    var r = setTimeout(t, e);n.stop = function () {
                        clearTimeout(r);
                    };
                });
            }, clearQueue: function clearQueue(e) {
                return this.queue(e || "fx", []);
            }, promise: function promise(e, n) {
                function r() {
                    --l || o.resolveWith(a, [a]);
                }"string" != typeof e && (n = e, e = t), e = e || "fx";for (var i, o = O.Deferred(), a = this, s = a.length, l = 1, u = e + "defer", c = e + "queue", f = e + "mark"; s--;) {
                    (i = O.data(a[s], u, t, !0) || (O.data(a[s], c, t, !0) || O.data(a[s], f, t, !0)) && O.data(a[s], u, O.Callbacks("once memory"), !0)) && (l++, i.add(r));
                }return r(), o.promise(n);
            } });var W,
            I,
            R,
            $ = /[\n\t\r]/g,
            X = /\s+/,
            z = /\r/g,
            V = /^(?:button|input)$/i,
            U = /^(?:button|input|object|select|textarea)$/i,
            G = /^a(?:rea)?$/i,
            Y = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
            J = O.support.getSetAttribute;O.fn.extend({ attr: function attr(e, t) {
                return O.access(this, O.attr, e, t, arguments.length > 1);
            }, removeAttr: function removeAttr(e) {
                return this.each(function () {
                    O.removeAttr(this, e);
                });
            }, prop: function prop(e, t) {
                return O.access(this, O.prop, e, t, arguments.length > 1);
            }, removeProp: function removeProp(e) {
                return e = O.propFix[e] || e, this.each(function () {
                    try {
                        this[e] = t, delete this[e];
                    } catch (n) {}
                });
            }, addClass: function addClass(e) {
                var t, n, r, i, o, a, s;if (O.isFunction(e)) return this.each(function (t) {
                    O(this).addClass(e.call(this, t, this.className));
                });if (e && "string" == typeof e) for (t = e.split(X), n = 0, r = this.length; r > n; n++) {
                    if (i = this[n], 1 === i.nodeType) if (i.className || 1 !== t.length) {
                        for (o = " " + i.className + " ", a = 0, s = t.length; s > a; a++) {
                            ~o.indexOf(" " + t[a] + " ") || (o += t[a] + " ");
                        }i.className = O.trim(o);
                    } else i.className = e;
                }return this;
            }, removeClass: function removeClass(e) {
                var n, r, i, o, a, s, l;if (O.isFunction(e)) return this.each(function (t) {
                    O(this).removeClass(e.call(this, t, this.className));
                });if (e && "string" == typeof e || e === t) for (n = (e || "").split(X), r = 0, i = this.length; i > r; r++) {
                    if (o = this[r], 1 === o.nodeType && o.className) if (e) {
                        for (a = (" " + o.className + " ").replace($, " "), s = 0, l = n.length; l > s; s++) {
                            a = a.replace(" " + n[s] + " ", " ");
                        }o.className = O.trim(a);
                    } else o.className = "";
                }return this;
            }, toggleClass: function toggleClass(e, t) {
                var n = typeof e,
                    r = "boolean" == typeof t;return this.each(O.isFunction(e) ? function (n) {
                    O(this).toggleClass(e.call(this, n, this.className, t), t);
                } : function () {
                    if ("string" === n) for (var i, o = 0, a = O(this), s = t, l = e.split(X); i = l[o++];) {
                        s = r ? s : !a.hasClass(i), a[s ? "addClass" : "removeClass"](i);
                    } else ("undefined" === n || "boolean" === n) && (this.className && O._data(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : O._data(this, "__className__") || "");
                });
            }, hasClass: function hasClass(e) {
                for (var t = " " + e + " ", n = 0, r = this.length; r > n; n++) {
                    if (1 === this[n].nodeType && (" " + this[n].className + " ").replace($, " ").indexOf(t) > -1) return !0;
                }return !1;
            }, val: function val(e) {
                var n,
                    r,
                    i,
                    o = this[0];{
                    if (arguments.length) return i = O.isFunction(e), this.each(function (r) {
                        var o,
                            a = O(this);1 === this.nodeType && (o = i ? e.call(this, r, a.val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : O.isArray(o) && (o = O.map(o, function (e) {
                            return null == e ? "" : e + "";
                        })), n = O.valHooks[this.type] || O.valHooks[this.nodeName.toLowerCase()], n && "set" in n && n.set(this, o, "value") !== t || (this.value = o));
                    });if (o) return n = O.valHooks[o.type] || O.valHooks[o.nodeName.toLowerCase()], n && "get" in n && (r = n.get(o, "value")) !== t ? r : (r = o.value, "string" == typeof r ? r.replace(z, "") : null == r ? "" : r);
                }
            } }), O.extend({ valHooks: { option: { get: function get(e) {
                        var t = e.attributes.value;return !t || t.specified ? e.value : e.text;
                    } }, select: { get: function get(e) {
                        var t,
                            n,
                            r,
                            i,
                            o = e.selectedIndex,
                            a = [],
                            s = e.options,
                            l = "select-one" === e.type;if (0 > o) return null;for (n = l ? o : 0, r = l ? o + 1 : s.length; r > n; n++) {
                            if (i = s[n], !(!i.selected || (O.support.optDisabled ? i.disabled : null !== i.getAttribute("disabled")) || i.parentNode.disabled && O.nodeName(i.parentNode, "optgroup"))) {
                                if (t = O(i).val(), l) return t;a.push(t);
                            }
                        }return l && !a.length && s.length ? O(s[o]).val() : a;
                    }, set: function set(e, t) {
                        var n = O.makeArray(t);return O(e).find("option").each(function () {
                            this.selected = O.inArray(O(this).val(), n) >= 0;
                        }), n.length || (e.selectedIndex = -1), n;
                    } } }, attrFn: { val: !0, css: !0, html: !0, text: !0, data: !0, width: !0, height: !0, offset: !0 }, attr: function attr(e, n, r, i) {
                var o,
                    a,
                    s,
                    l = e.nodeType;if (e && 3 !== l && 8 !== l && 2 !== l) return i && n in O.attrFn ? O(e)[n](r) : t === e.getAttribute ? O.prop(e, n, r) : (s = 1 !== l || !O.isXMLDoc(e), s && (n = n.toLowerCase(), a = O.attrHooks[n] || (Y.test(n) ? I : W)), r !== t ? null === r ? (O.removeAttr(e, n), t) : a && "set" in a && s && (o = a.set(e, r, n)) !== t ? o : (e.setAttribute(n, "" + r), r) : a && "get" in a && s && null !== (o = a.get(e, n)) ? o : (o = e.getAttribute(n), null === o ? t : o));
            }, removeAttr: function removeAttr(e, t) {
                var n,
                    r,
                    i,
                    o,
                    a,
                    s = 0;if (t && 1 === e.nodeType) for (r = t.toLowerCase().split(X), o = r.length; o > s; s++) {
                    i = r[s], i && (n = O.propFix[i] || i, a = Y.test(i), a || O.attr(e, i, ""), e.removeAttribute(J ? i : n), a && n in e && (e[n] = !1));
                }
            }, attrHooks: { type: { set: function set(e, t) {
                        if (V.test(e.nodeName) && e.parentNode) O.error("type property can't be changed");else if (!O.support.radioValue && "radio" === t && O.nodeName(e, "input")) {
                            var n = e.value;return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    } }, value: { get: function get(e, t) {
                        return W && O.nodeName(e, "button") ? W.get(e, t) : t in e ? e.value : null;
                    }, set: function set(e, n, r) {
                        return W && O.nodeName(e, "button") ? W.set(e, n, r) : (e.value = n, t);
                    } } }, propFix: { tabindex: "tabIndex", readonly: "readOnly", "for": "htmlFor", "class": "className", maxlength: "maxLength", cellspacing: "cellSpacing", cellpadding: "cellPadding", rowspan: "rowSpan", colspan: "colSpan", usemap: "useMap", frameborder: "frameBorder", contenteditable: "contentEditable" }, prop: function prop(e, n, r) {
                var i,
                    o,
                    a,
                    s = e.nodeType;if (e && 3 !== s && 8 !== s && 2 !== s) return a = 1 !== s || !O.isXMLDoc(e), a && (n = O.propFix[n] || n, o = O.propHooks[n]), r !== t ? o && "set" in o && (i = o.set(e, r, n)) !== t ? i : e[n] = r : o && "get" in o && null !== (i = o.get(e, n)) ? i : e[n];
            }, propHooks: { tabIndex: { get: function get(e) {
                        var n = e.getAttributeNode("tabindex");return n && n.specified ? parseInt(n.value, 10) : U.test(e.nodeName) || G.test(e.nodeName) && e.href ? 0 : t;
                    } } } }), O.attrHooks.tabindex = O.propHooks.tabIndex, I = { get: function get(e, n) {
                var r,
                    i = O.prop(e, n);return i === !0 || "boolean" != typeof i && (r = e.getAttributeNode(n)) && r.nodeValue !== !1 ? n.toLowerCase() : t;
            }, set: function set(e, t, n) {
                var r;return t === !1 ? O.removeAttr(e, n) : (r = O.propFix[n] || n, r in e && (e[r] = !0), e.setAttribute(n, n.toLowerCase())), n;
            } }, J || (R = { name: !0, id: !0, coords: !0 }, W = O.valHooks.button = { get: function get(e, n) {
                var r;return r = e.getAttributeNode(n), r && (R[n] ? "" !== r.nodeValue : r.specified) ? r.nodeValue : t;
            }, set: function set(e, t, n) {
                var r = e.getAttributeNode(n);return r || (r = j.createAttribute(n), e.setAttributeNode(r)), r.nodeValue = t + "";
            } }, O.attrHooks.tabindex.set = W.set, O.each(["width", "height"], function (e, n) {
            O.attrHooks[n] = O.extend(O.attrHooks[n], { set: function set(e, r) {
                    return "" === r ? (e.setAttribute(n, "auto"), r) : t;
                } });
        }), O.attrHooks.contenteditable = { get: W.get, set: function set(e, t, n) {
                "" === t && (t = "false"), W.set(e, t, n);
            } }), O.support.hrefNormalized || O.each(["href", "src", "width", "height"], function (e, n) {
            O.attrHooks[n] = O.extend(O.attrHooks[n], { get: function get(e) {
                    var r = e.getAttribute(n, 2);return null === r ? t : r;
                } });
        }), O.support.style || (O.attrHooks.style = { get: function get(e) {
                return e.style.cssText.toLowerCase() || t;
            }, set: function set(e, t) {
                return e.style.cssText = "" + t;
            } }), O.support.optSelected || (O.propHooks.selected = O.extend(O.propHooks.selected, { get: function get(e) {
                var t = e.parentNode;return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
            } })), O.support.enctype || (O.propFix.enctype = "encoding"), O.support.checkOn || O.each(["radio", "checkbox"], function () {
            O.valHooks[this] = { get: function get(e) {
                    return null === e.getAttribute("value") ? "on" : e.value;
                } };
        }), O.each(["radio", "checkbox"], function () {
            O.valHooks[this] = O.extend(O.valHooks[this], { set: function set(e, n) {
                    return O.isArray(n) ? e.checked = O.inArray(O(e).val(), n) >= 0 : t;
                } });
        });var K = /^(?:textarea|input|select)$/i,
            Q = /^([^\.]*)?(?:\.(.+))?$/,
            Z = /(?:^|\s)hover(\.\S+)?\b/,
            et = /^key/,
            tt = /^(?:mouse|contextmenu)|click/,
            nt = /^(?:focusinfocus|focusoutblur)$/,
            rt = /^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,
            it = function it(e) {
            var t = rt.exec(e);return t && (t[1] = (t[1] || "").toLowerCase(), t[3] = t[3] && RegExp("(?:^|\\s)" + t[3] + "(?:\\s|$)")), t;
        },
            ot = function ot(e, t) {
            var n = e.attributes || {};
            return !(t[1] && e.nodeName.toLowerCase() !== t[1] || t[2] && (n.id || {}).value !== t[2] || t[3] && !t[3].test((n["class"] || {}).value));
        },
            at = function at(e) {
            return O.event.special.hover ? e : e.replace(Z, "mouseenter$1 mouseleave$1");
        };O.event = { add: function add(e, n, r, i, o) {
                var a, _s, l, u, c, f, d, p, h, m, g;if (3 !== e.nodeType && 8 !== e.nodeType && n && r && (a = O._data(e))) {
                    for (r.handler && (h = r, r = h.handler, o = h.selector), r.guid || (r.guid = O.guid++), l = a.events, l || (a.events = l = {}), _s = a.handle, _s || (a.handle = _s = function s(e) {
                        return t === O || e && O.event.triggered === e.type ? t : O.event.dispatch.apply(_s.elem, arguments);
                    }, _s.elem = e), n = O.trim(at(n)).split(" "), u = 0; u < n.length; u++) {
                        c = Q.exec(n[u]) || [], f = c[1], d = (c[2] || "").split(".").sort(), g = O.event.special[f] || {}, f = (o ? g.delegateType : g.bindType) || f, g = O.event.special[f] || {}, p = O.extend({ type: f, origType: c[1], data: i, handler: r, guid: r.guid, selector: o, quick: o && it(o), namespace: d.join(".") }, h), m = l[f], m || (m = l[f] = [], m.delegateCount = 0, g.setup && g.setup.call(e, i, d, _s) !== !1 || (e.addEventListener ? e.addEventListener(f, _s, !1) : e.attachEvent && e.attachEvent("on" + f, _s))), g.add && (g.add.call(e, p), p.handler.guid || (p.handler.guid = r.guid)), o ? m.splice(m.delegateCount++, 0, p) : m.push(p), O.event.global[f] = !0;
                    }e = null;
                }
            }, global: {}, remove: function remove(e, t, n, r, i) {
                var o,
                    a,
                    s,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p,
                    h,
                    m,
                    g,
                    y = O.hasData(e) && O._data(e);if (y && (d = y.events)) {
                    for (t = O.trim(at(t || "")).split(" "), o = 0; o < t.length; o++) {
                        if (a = Q.exec(t[o]) || [], s = l = a[1], u = a[2], s) {
                            for (p = O.event.special[s] || {}, s = (r ? p.delegateType : p.bindType) || s, m = d[s] || [], c = m.length, u = u ? RegExp("(^|\\.)" + u.split(".").sort().join("\\.(?:.*\\.)?") + "(\\.|$)") : null, f = 0; f < m.length; f++) {
                                g = m[f], !i && l !== g.origType || n && n.guid !== g.guid || u && !u.test(g.namespace) || r && r !== g.selector && ("**" !== r || !g.selector) || (m.splice(f--, 1), g.selector && m.delegateCount--, p.remove && p.remove.call(e, g));
                            }0 === m.length && c !== m.length && (p.teardown && p.teardown.call(e, u) !== !1 || O.removeEvent(e, s, y.handle), delete d[s]);
                        } else for (s in d) {
                            O.event.remove(e, s + t[o], n, r, !0);
                        }
                    }O.isEmptyObject(d) && (h = y.handle, h && (h.elem = null), O.removeData(e, ["events", "handle"], !0));
                }
            }, customEvent: { getData: !0, setData: !0, changeData: !0 }, trigger: function trigger(n, r, i, o) {
                if (!i || 3 !== i.nodeType && 8 !== i.nodeType) {
                    var a,
                        s,
                        l,
                        u,
                        c,
                        f,
                        d,
                        p,
                        h,
                        m,
                        g = n.type || n,
                        y = [];if (!nt.test(g + O.event.triggered) && (g.indexOf("!") < 0 || (g = g.slice(0, -1), s = !0), g.indexOf(".") < 0 || (y = g.split("."), g = y.shift(), y.sort()), i && !O.event.customEvent[g] || O.event.global[g])) if (n = "object" == typeof n ? n[O.expando] ? n : new O.Event(g, n) : new O.Event(g), n.type = g, n.isTrigger = !0, n.exclusive = s, n.namespace = y.join("."), n.namespace_re = n.namespace ? RegExp("(^|\\.)" + y.join("\\.(?:.*\\.)?") + "(\\.|$)") : null, f = g.indexOf(":") < 0 ? "on" + g : "", i) {
                        if (n.result = t, n.target || (n.target = i), r = null != r ? O.makeArray(r) : [], r.unshift(n), d = O.event.special[g] || {}, !d.trigger || d.trigger.apply(i, r) !== !1) {
                            if (h = [[i, d.bindType || g]], !o && !d.noBubble && !O.isWindow(i)) {
                                for (m = d.delegateType || g, u = nt.test(m + g) ? i : i.parentNode, c = null; u; u = u.parentNode) {
                                    h.push([u, m]), c = u;
                                }c && c === i.ownerDocument && h.push([c.defaultView || c.parentWindow || e, m]);
                            }for (l = 0; l < h.length && !n.isPropagationStopped(); l++) {
                                u = h[l][0], n.type = h[l][1], p = (O._data(u, "events") || {})[n.type] && O._data(u, "handle"), p && p.apply(u, r), p = f && u[f], p && O.acceptData(u) && p.apply(u, r) === !1 && n.preventDefault();
                            }return n.type = g, o || n.isDefaultPrevented() || d._default && d._default.apply(i.ownerDocument, r) !== !1 || "click" === g && O.nodeName(i, "a") || !O.acceptData(i) || f && i[g] && ("focus" !== g && "blur" !== g || 0 !== n.target.offsetWidth) && !O.isWindow(i) && (c = i[f], c && (i[f] = null), O.event.triggered = g, i[g](), O.event.triggered = t, c && (i[f] = c)), n.result;
                        }
                    } else {
                        a = O.cache;for (l in a) {
                            a[l].events && a[l].events[g] && O.event.trigger(n, r, a[l].handle.elem, !0);
                        }
                    }
                }
            }, dispatch: function dispatch(n) {
                n = O.event.fix(n || e.event);var r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p = (O._data(this, "events") || {})[n.type] || [],
                    h = p.delegateCount,
                    m = [].slice.call(arguments, 0),
                    g = !n.exclusive && !n.namespace,
                    y = O.event.special[n.type] || {},
                    v = [];if (m[0] = n, n.delegateTarget = this, !y.preDispatch || y.preDispatch.call(this, n) !== !1) {
                    if (h && (!n.button || "click" !== n.type)) for (a = O(this), a.context = this.ownerDocument || this, o = n.target; o != this; o = o.parentNode || this) {
                        if (o.disabled !== !0) {
                            for (l = {}, c = [], a[0] = o, r = 0; h > r; r++) {
                                f = p[r], d = f.selector, l[d] === t && (l[d] = f.quick ? ot(o, f.quick) : a.is(d)), l[d] && c.push(f);
                            }c.length && v.push({ elem: o, matches: c });
                        }
                    }for (p.length > h && v.push({ elem: this, matches: p.slice(h) }), r = 0; r < v.length && !n.isPropagationStopped(); r++) {
                        for (u = v[r], n.currentTarget = u.elem, i = 0; i < u.matches.length && !n.isImmediatePropagationStopped(); i++) {
                            f = u.matches[i], (g || !n.namespace && !f.namespace || n.namespace_re && n.namespace_re.test(f.namespace)) && (n.data = f.data, n.handleObj = f, s = ((O.event.special[f.origType] || {}).handle || f.handler).apply(u.elem, m), s !== t && (n.result = s, s === !1 && (n.preventDefault(), n.stopPropagation())));
                        }
                    }return y.postDispatch && y.postDispatch.call(this, n), n.result;
                }
            }, props: "attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(e, t) {
                    return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
                } }, mouseHooks: { props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(e, n) {
                    var r,
                        i,
                        o,
                        a = n.button,
                        s = n.fromElement;return null == e.pageX && null != n.clientX && (r = e.target.ownerDocument || j, i = r.documentElement, o = r.body, e.pageX = n.clientX + (i && i.scrollLeft || o && o.scrollLeft || 0) - (i && i.clientLeft || o && o.clientLeft || 0), e.pageY = n.clientY + (i && i.scrollTop || o && o.scrollTop || 0) - (i && i.clientTop || o && o.clientTop || 0)), !e.relatedTarget && s && (e.relatedTarget = s === e.target ? n.toElement : s), e.which || a === t || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), e;
                } }, fix: function fix(e) {
                if (e[O.expando]) return e;var n,
                    r,
                    i = e,
                    o = O.event.fixHooks[e.type] || {},
                    a = o.props ? this.props.concat(o.props) : this.props;for (e = O.Event(i), n = a.length; n;) {
                    r = a[--n], e[r] = i[r];
                }return e.target || (e.target = i.srcElement || j), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey === t && (e.metaKey = e.ctrlKey), o.filter ? o.filter(e, i) : e;
            }, special: { ready: { setup: O.bindReady }, load: { noBubble: !0 }, focus: { delegateType: "focusin" }, blur: { delegateType: "focusout" }, beforeunload: { setup: function setup(e, t, n) {
                        O.isWindow(this) && (this.onbeforeunload = n);
                    }, teardown: function teardown(e, t) {
                        this.onbeforeunload === t && (this.onbeforeunload = null);
                    } } }, simulate: function simulate(e, t, n, r) {
                var i = O.extend(new O.Event(), n, { type: e, isSimulated: !0, originalEvent: {} });r ? O.event.trigger(i, null, t) : O.event.dispatch.call(t, i), i.isDefaultPrevented() && n.preventDefault();
            } }, O.event.handle = O.event.dispatch, O.removeEvent = j.removeEventListener ? function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n, !1);
        } : function (e, t, n) {
            e.detachEvent && e.detachEvent("on" + t, n);
        }, O.Event = function (e, n) {
            return this instanceof O.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || e.returnValue === !1 || e.getPreventDefault && e.getPreventDefault() ? s : a) : this.type = e, n && O.extend(this, n), this.timeStamp = e && e.timeStamp || O.now(), this[O.expando] = !0, t) : new O.Event(e, n);
        }, O.Event.prototype = { preventDefault: function preventDefault() {
                this.isDefaultPrevented = s;var e = this.originalEvent;e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
            }, stopPropagation: function stopPropagation() {
                this.isPropagationStopped = s;var e = this.originalEvent;e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
            }, stopImmediatePropagation: function stopImmediatePropagation() {
                this.isImmediatePropagationStopped = s, this.stopPropagation();
            }, isDefaultPrevented: a, isPropagationStopped: a, isImmediatePropagationStopped: a }, O.each({ mouseenter: "mouseover", mouseleave: "mouseout" }, function (e, t) {
            O.event.special[e] = { delegateType: t, bindType: t, handle: function handle(e) {
                    {
                        var n,
                            r = this,
                            i = e.relatedTarget,
                            o = e.handleObj;o.selector;
                    }return (!i || i !== r && !O.contains(r, i)) && (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
                } };
        }), O.support.submitBubbles || (O.event.special.submit = { setup: function setup() {
                return O.nodeName(this, "form") ? !1 : (O.event.add(this, "click._submit keypress._submit", function (e) {
                    var n = e.target,
                        r = O.nodeName(n, "input") || O.nodeName(n, "button") ? n.form : t;r && !r._submit_attached && (O.event.add(r, "submit._submit", function (e) {
                        e._submit_bubble = !0;
                    }), r._submit_attached = !0);
                }), t);
            }, postDispatch: function postDispatch(e) {
                e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && O.event.simulate("submit", this.parentNode, e, !0));
            }, teardown: function teardown() {
                return O.nodeName(this, "form") ? !1 : (O.event.remove(this, "._submit"), t);
            } }), O.support.changeBubbles || (O.event.special.change = { setup: function setup() {
                return K.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (O.event.add(this, "propertychange._change", function (e) {
                    "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
                }), O.event.add(this, "click._change", function (e) {
                    this._just_changed && !e.isTrigger && (this._just_changed = !1, O.event.simulate("change", this, e, !0));
                })), !1) : (O.event.add(this, "beforeactivate._change", function (e) {
                    var t = e.target;K.test(t.nodeName) && !t._change_attached && (O.event.add(t, "change._change", function (e) {
                        !this.parentNode || e.isSimulated || e.isTrigger || O.event.simulate("change", this.parentNode, e, !0);
                    }), t._change_attached = !0);
                }), t);
            }, handle: function handle(e) {
                var n = e.target;return this !== n || e.isSimulated || e.isTrigger || "radio" !== n.type && "checkbox" !== n.type ? e.handleObj.handler.apply(this, arguments) : t;
            }, teardown: function teardown() {
                return O.event.remove(this, "._change"), K.test(this.nodeName);
            } }), O.support.focusinBubbles || O.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            var n = 0,
                r = function r(e) {
                O.event.simulate(t, e.target, O.event.fix(e), !0);
            };O.event.special[t] = { setup: function setup() {
                    0 === n++ && j.addEventListener(e, r, !0);
                }, teardown: function teardown() {
                    0 === --n && j.removeEventListener(e, r, !0);
                } };
        }), O.fn.extend({ on: function on(e, n, r, i, o) {
                var s, l;if ("object" == typeof e) {
                    "string" != typeof n && (r = r || n, n = t);for (l in e) {
                        this.on(l, n, r, e[l], o);
                    }return this;
                }if (null == r && null == i ? (i = n, r = n = t) : null == i && ("string" == typeof n ? (i = r, r = t) : (i = r, r = n, n = t)), i === !1) i = a;else if (!i) return this;return 1 === o && (s = i, i = function i(e) {
                    return O().off(e), s.apply(this, arguments);
                }, i.guid = s.guid || (s.guid = O.guid++)), this.each(function () {
                    O.event.add(this, e, i, r, n);
                });
            }, one: function one(e, t, n, r) {
                return this.on(e, t, n, r, 1);
            }, off: function off(e, n, r) {
                if (e && e.preventDefault && e.handleObj) {
                    var i = e.handleObj;return O(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                }if ("object" == typeof e) {
                    for (var o in e) {
                        this.off(o, n, e[o]);
                    }return this;
                }return (n === !1 || "function" == typeof n) && (r = n, n = t), r === !1 && (r = a), this.each(function () {
                    O.event.remove(this, e, r, n);
                });
            }, bind: function bind(e, t, n) {
                return this.on(e, null, t, n);
            }, unbind: function unbind(e, t) {
                return this.off(e, null, t);
            }, live: function live(e, t, n) {
                return O(this.context).on(e, this.selector, t, n), this;
            }, die: function die(e, t) {
                return O(this.context).off(e, this.selector || "**", t), this;
            }, delegate: function delegate(e, t, n, r) {
                return this.on(t, e, n, r);
            }, undelegate: function undelegate(e, t, n) {
                return 1 == arguments.length ? this.off(e, "**") : this.off(t, e, n);
            }, trigger: function trigger(e, t) {
                return this.each(function () {
                    O.event.trigger(e, t, this);
                });
            }, triggerHandler: function triggerHandler(e, n) {
                return this[0] ? O.event.trigger(e, n, this[0], !0) : t;
            }, toggle: function toggle(e) {
                var t = arguments,
                    n = e.guid || O.guid++,
                    r = 0,
                    i = function i(n) {
                    var i = (O._data(this, "lastToggle" + e.guid) || 0) % r;return O._data(this, "lastToggle" + e.guid, i + 1), n.preventDefault(), t[i].apply(this, arguments) || !1;
                };for (i.guid = n; r < t.length;) {
                    t[r++].guid = n;
                }return this.click(i);
            }, hover: function hover(e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            } }), O.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
            O.fn[t] = function (e, n) {
                return null == n && (n = e, e = null), arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
            }, O.attrFn && (O.attrFn[t] = !0), et.test(t) && (O.event.fixHooks[t] = O.event.keyHooks), tt.test(t) && (O.event.fixHooks[t] = O.event.mouseHooks);
        }), function () {
            function e(e, t, n, r, o, a) {
                for (var s = 0, l = r.length; l > s; s++) {
                    var u = r[s];if (u) {
                        var c = !1;for (u = u[e]; u;) {
                            if (u[i] === n) {
                                c = r[u.sizset];break;
                            }if (1 !== u.nodeType || a || (u[i] = n, u.sizset = s), u.nodeName.toLowerCase() === t) {
                                c = u;break;
                            }u = u[e];
                        }r[s] = c;
                    }
                }
            }function n(e, t, n, r, o, a) {
                for (var s = 0, l = r.length; l > s; s++) {
                    var u = r[s];if (u) {
                        var c = !1;for (u = u[e]; u;) {
                            if (u[i] === n) {
                                c = r[u.sizset];break;
                            }if (1 === u.nodeType) if (a || (u[i] = n, u.sizset = s), "string" != typeof t) {
                                if (u === t) {
                                    c = !0;break;
                                }
                            } else if (_d2.filter(t, [u]).length > 0) {
                                c = u;break;
                            }u = u[e];
                        }r[s] = c;
                    }
                }
            }var r = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
                i = "sizcache" + (Math.random() + "").replace(".", ""),
                o = 0,
                a = Object.prototype.toString,
                s = !1,
                l = !0,
                u = /\\/g,
                c = /\r\n/g,
                f = /\W/;[0, 0].sort(function () {
                return l = !1, 0;
            });var _d2 = function d(e, t, n, i) {
                n = n || [], t = t || j;var o = t;if (1 !== t.nodeType && 9 !== t.nodeType) return [];if (!e || "string" != typeof e) return n;var s,
                    l,
                    u,
                    c,
                    f,
                    p,
                    g,
                    y,
                    b = !0,
                    x = _d2.isXML(t),
                    T = [],
                    N = e;do {
                    if (r.exec(""), s = r.exec(N), s && (N = s[3], T.push(s[1]), s[2])) {
                        c = s[3];break;
                    }
                } while (s);if (T.length > 1 && m.exec(e)) {
                    if (2 === T.length && h.relative[T[0]]) l = w(T[0] + T[1], t, i);else for (l = h.relative[T[0]] ? [t] : _d2(T.shift(), t); T.length;) {
                        e = T.shift(), h.relative[e] && (e += T.shift()), l = w(e, l, i);
                    }
                } else if (i || T.length <= 1 || 9 !== t.nodeType || x || !h.match.ID.test(T[0]) || h.match.ID.test(T[T.length - 1]) || (f = _d2.find(T.shift(), t, x), t = f.expr ? _d2.filter(f.expr, f.set)[0] : f.set[0]), t) for (f = i ? { expr: T.pop(), set: v(i) } : _d2.find(T.pop(), 1 !== T.length || "~" !== T[0] && "+" !== T[0] || !t.parentNode ? t : t.parentNode, x), l = f.expr ? _d2.filter(f.expr, f.set) : f.set, T.length > 0 ? u = v(l) : b = !1; T.length;) {
                    p = T.pop(), g = p, h.relative[p] ? g = T.pop() : p = "", null == g && (g = t), h.relative[p](u, g, x);
                } else u = T = [];if (u || (u = l), u || _d2.error(p || e), "[object Array]" === a.call(u)) {
                    if (b) {
                        if (t && 1 === t.nodeType) for (y = 0; null != u[y]; y++) {
                            u[y] && (u[y] === !0 || 1 === u[y].nodeType && _d2.contains(t, u[y])) && n.push(l[y]);
                        } else for (y = 0; null != u[y]; y++) {
                            u[y] && 1 === u[y].nodeType && n.push(l[y]);
                        }
                    } else n.push.apply(n, u);
                } else v(u, n);return c && (_d2(c, o, n, i), _d2.uniqueSort(n)), n;
            };_d2.uniqueSort = function (e) {
                if (x && (s = l, e.sort(x), s)) for (var t = 1; t < e.length; t++) {
                    e[t] === e[t - 1] && e.splice(t--, 1);
                }return e;
            }, _d2.matches = function (e, t) {
                return _d2(e, null, null, t);
            }, _d2.matchesSelector = function (e, t) {
                return _d2(t, null, null, [e]).length > 0;
            }, _d2.find = function (e, n, r) {
                var i, o, a, s, l, c;if (!e) return [];for (o = 0, a = h.order.length; a > o; o++) {
                    if (l = h.order[o], (s = h.leftMatch[l].exec(e)) && (c = s[1], s.splice(1, 1), "\\" !== c.substr(c.length - 1) && (s[1] = (s[1] || "").replace(u, ""), i = h.find[l](s, n, r), null != i))) {
                        e = e.replace(h.match[l], "");break;
                    }
                }return i || (i = t !== n.getElementsByTagName ? n.getElementsByTagName("*") : []), { set: i, expr: e };
            }, _d2.filter = function (e, n, r, i) {
                for (var o, a, s, l, u, c, f, p, m, g = e, y = [], v = n, b = n && n[0] && _d2.isXML(n[0]); e && n.length;) {
                    for (s in h.filter) {
                        if (null != (o = h.leftMatch[s].exec(e)) && o[2]) {
                            if (c = h.filter[s], f = o[1], a = !1, o.splice(1, 1), "\\" === f.substr(f.length - 1)) continue;if (v === y && (y = []), h.preFilter[s]) if (o = h.preFilter[s](o, v, r, y, i, b)) {
                                if (o === !0) continue;
                            } else a = l = !0;if (o) for (p = 0; null != (u = v[p]); p++) {
                                u && (l = c(u, o, p, v), m = i ^ l, r && null != l ? m ? a = !0 : v[p] = !1 : m && (y.push(u), a = !0));
                            }if (l !== t) {
                                if (r || (v = y), e = e.replace(h.match[s], ""), !a) return [];break;
                            }
                        }
                    }if (e === g) {
                        if (null != a) break;_d2.error(e);
                    }g = e;
                }return v;
            }, _d2.error = function (e) {
                throw Error("Syntax error, unrecognized expression: " + e);
            };var p = _d2.getText = function (e) {
                var t,
                    n,
                    r = e.nodeType,
                    i = "";if (r) {
                    if (1 === r || 9 === r || 11 === r) {
                        if ("string" == typeof e.textContent) return e.textContent;if ("string" == typeof e.innerText) return e.innerText.replace(c, "");for (e = e.firstChild; e; e = e.nextSibling) {
                            i += p(e);
                        }
                    } else if (3 === r || 4 === r) return e.nodeValue;
                } else for (t = 0; n = e[t]; t++) {
                    8 !== n.nodeType && (i += p(n));
                }return i;
            },
                h = _d2.selectors = { order: ["ID", "NAME", "TAG"], match: { ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/, CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/, NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/, ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/, TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/, CHILD: /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/, POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/, PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/ }, leftMatch: {}, attrMap: { "class": "className", "for": "htmlFor" }, attrHandle: { href: function href(e) {
                        return e.getAttribute("href");
                    }, type: function type(e) {
                        return e.getAttribute("type");
                    } }, relative: { "+": function _(e, t) {
                        var n = "string" == typeof t,
                            r = n && !f.test(t),
                            i = n && !r;r && (t = t.toLowerCase());for (var o, a = 0, s = e.length; s > a; a++) {
                            if (o = e[a]) {
                                for (; (o = o.previousSibling) && 1 !== o.nodeType;) {}e[a] = i || o && o.nodeName.toLowerCase() === t ? o || !1 : o === t;
                            }
                        }i && _d2.filter(t, e, !0);
                    }, ">": function _(e, t) {
                        var n,
                            r = "string" == typeof t,
                            i = 0,
                            o = e.length;if (r && !f.test(t)) {
                            for (t = t.toLowerCase(); o > i; i++) {
                                if (n = e[i]) {
                                    var a = n.parentNode;e[i] = a.nodeName.toLowerCase() === t ? a : !1;
                                }
                            }
                        } else {
                            for (; o > i; i++) {
                                n = e[i], n && (e[i] = r ? n.parentNode : n.parentNode === t);
                            }r && _d2.filter(t, e, !0);
                        }
                    }, "": function _(t, r, i) {
                        var a,
                            s = o++,
                            l = n;"string" != typeof r || f.test(r) || (r = r.toLowerCase(), a = r, l = e), l("parentNode", r, s, t, a, i);
                    }, "~": function _(t, r, i) {
                        var a,
                            s = o++,
                            l = n;"string" != typeof r || f.test(r) || (r = r.toLowerCase(), a = r, l = e), l("previousSibling", r, s, t, a, i);
                    } }, find: { ID: function ID(e, n, r) {
                        if (t !== n.getElementById && !r) {
                            var i = n.getElementById(e[1]);return i && i.parentNode ? [i] : [];
                        }
                    }, NAME: function NAME(e, n) {
                        if (t !== n.getElementsByName) {
                            for (var r = [], i = n.getElementsByName(e[1]), o = 0, a = i.length; a > o; o++) {
                                i[o].getAttribute("name") === e[1] && r.push(i[o]);
                            }return 0 === r.length ? null : r;
                        }
                    }, TAG: function TAG(e, n) {
                        return t !== n.getElementsByTagName ? n.getElementsByTagName(e[1]) : t;
                    } }, preFilter: { CLASS: function CLASS(e, t, n, r, i, o) {
                        if (e = " " + e[1].replace(u, "") + " ", o) return e;for (var a, s = 0; null != (a = t[s]); s++) {
                            a && (i ^ (a.className && (" " + a.className + " ").replace(/[\t\n\r]/g, " ").indexOf(e) >= 0) ? n || r.push(a) : n && (t[s] = !1));
                        }return !1;
                    }, ID: function ID(e) {
                        return e[1].replace(u, "");
                    }, TAG: function TAG(e) {
                        return e[1].replace(u, "").toLowerCase();
                    }, CHILD: function CHILD(e) {
                        if ("nth" === e[1]) {
                            e[2] || _d2.error(e[0]), e[2] = e[2].replace(/^\+|\s*/g, "");var t = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec("even" === e[2] && "2n" || "odd" === e[2] && "2n+1" || !/\D/.test(e[2]) && "0n+" + e[2] || e[2]);e[2] = t[1] + (t[2] || 1) - 0, e[3] = t[3] - 0;
                        } else e[2] && _d2.error(e[0]);return e[0] = o++, e;
                    }, ATTR: function ATTR(e, t, n, r, i, o) {
                        var a = e[1] = e[1].replace(u, "");return !o && h.attrMap[a] && (e[1] = h.attrMap[a]), e[4] = (e[4] || e[5] || "").replace(u, ""), "~=" === e[2] && (e[4] = " " + e[4] + " "), e;
                    }, PSEUDO: function PSEUDO(e, t, n, i, o) {
                        if ("not" === e[1]) {
                            if ((r.exec(e[3]) || "").length <= 1 && !/^\w/.test(e[3])) {
                                var a = _d2.filter(e[3], t, n, !0 ^ o);return n || i.push.apply(i, a), !1;
                            }e[3] = _d2(e[3], null, null, t);
                        } else if (h.match.POS.test(e[0]) || h.match.CHILD.test(e[0])) return !0;return e;
                    }, POS: function POS(e) {
                        return e.unshift(!0), e;
                    } }, filters: { enabled: function enabled(e) {
                        return e.disabled === !1 && "hidden" !== e.type;
                    }, disabled: function disabled(e) {
                        return e.disabled === !0;
                    }, checked: function checked(e) {
                        return e.checked === !0;
                    }, selected: function selected(e) {
                        return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
                    }, parent: function parent(e) {
                        return !!e.firstChild;
                    }, empty: function empty(e) {
                        return !e.firstChild;
                    }, has: function has(e, t, n) {
                        return !!_d2(n[3], e).length;
                    }, header: function header(e) {
                        return (/h\d/i.test(e.nodeName)
                        );
                    }, text: function text(e) {
                        var t = e.getAttribute("type"),
                            n = e.type;return "input" === e.nodeName.toLowerCase() && "text" === n && (t === n || null === t);
                    }, radio: function radio(e) {
                        return "input" === e.nodeName.toLowerCase() && "radio" === e.type;
                    }, checkbox: function checkbox(e) {
                        return "input" === e.nodeName.toLowerCase() && "checkbox" === e.type;
                    }, file: function file(e) {
                        return "input" === e.nodeName.toLowerCase() && "file" === e.type;
                    }, password: function password(e) {
                        return "input" === e.nodeName.toLowerCase() && "password" === e.type;
                    }, submit: function submit(e) {
                        var t = e.nodeName.toLowerCase();return ("input" === t || "button" === t) && "submit" === e.type;
                    }, image: function image(e) {
                        return "input" === e.nodeName.toLowerCase() && "image" === e.type;
                    }, reset: function reset(e) {
                        var t = e.nodeName.toLowerCase();return ("input" === t || "button" === t) && "reset" === e.type;
                    }, button: function button(e) {
                        var t = e.nodeName.toLowerCase();return "input" === t && "button" === e.type || "button" === t;
                    }, input: function input(e) {
                        return (/input|select|textarea|button/i.test(e.nodeName)
                        );
                    }, focus: function focus(e) {
                        return e === e.ownerDocument.activeElement;
                    } }, setFilters: { first: function first(e, t) {
                        return 0 === t;
                    }, last: function last(e, t, n, r) {
                        return t === r.length - 1;
                    }, even: function even(e, t) {
                        return t % 2 === 0;
                    }, odd: function odd(e, t) {
                        return t % 2 === 1;
                    }, lt: function lt(e, t, n) {
                        return t < n[3] - 0;
                    }, gt: function gt(e, t, n) {
                        return t > n[3] - 0;
                    }, nth: function nth(e, t, n) {
                        return n[3] - 0 === t;
                    }, eq: function eq(e, t, n) {
                        return n[3] - 0 === t;
                    } }, filter: { PSEUDO: function PSEUDO(e, t, n, r) {
                        var i = t[1],
                            o = h.filters[i];if (o) return o(e, n, t, r);if ("contains" === i) return (e.textContent || e.innerText || p([e]) || "").indexOf(t[3]) >= 0;if ("not" === i) {
                            for (var a = t[3], s = 0, l = a.length; l > s; s++) {
                                if (a[s] === e) return !1;
                            }return !0;
                        }_d2.error(i);
                    }, CHILD: function CHILD(e, t) {
                        var n,
                            r,
                            o,
                            a,
                            s,
                            l,
                            u = t[1],
                            c = e;switch (u) {case "only":case "first":
                                for (; c = c.previousSibling;) {
                                    if (1 === c.nodeType) return !1;
                                }if ("first" === u) return !0;c = e;case "last":
                                for (; c = c.nextSibling;) {
                                    if (1 === c.nodeType) return !1;
                                }return !0;case "nth":
                                if (n = t[2], r = t[3], 1 === n && 0 === r) return !0;if (o = t[0], a = e.parentNode, a && (a[i] !== o || !e.nodeIndex)) {
                                    for (s = 0, c = a.firstChild; c; c = c.nextSibling) {
                                        1 === c.nodeType && (c.nodeIndex = ++s);
                                    }a[i] = o;
                                }return l = e.nodeIndex - r, 0 === n ? 0 === l : l % n === 0 && l / n >= 0;}
                    }, ID: function ID(e, t) {
                        return 1 === e.nodeType && e.getAttribute("id") === t;
                    }, TAG: function TAG(e, t) {
                        return "*" === t && 1 === e.nodeType || !!e.nodeName && e.nodeName.toLowerCase() === t;
                    }, CLASS: function CLASS(e, t) {
                        return (" " + (e.className || e.getAttribute("class")) + " ").indexOf(t) > -1;
                    }, ATTR: function ATTR(e, t) {
                        var n = t[1],
                            r = _d2.attr ? _d2.attr(e, n) : h.attrHandle[n] ? h.attrHandle[n](e) : null != e[n] ? e[n] : e.getAttribute(n),
                            i = r + "",
                            o = t[2],
                            a = t[4];return null == r ? "!=" === o : !o && _d2.attr ? null != r : "=" === o ? i === a : "*=" === o ? i.indexOf(a) >= 0 : "~=" === o ? (" " + i + " ").indexOf(a) >= 0 : a ? "!=" === o ? i !== a : "^=" === o ? 0 === i.indexOf(a) : "$=" === o ? i.substr(i.length - a.length) === a : "|=" === o ? i === a || i.substr(0, a.length + 1) === a + "-" : !1 : i && r !== !1;
                    }, POS: function POS(e, n, r, i) {
                        var o = n[2],
                            a = h.setFilters[o];return a ? a(e, r, n, i) : t;
                    } } },
                m = h.match.POS,
                g = function g(e, t) {
                return "\\" + (t - 0 + 1);
            };for (var y in h.match) {
                h.match[y] = RegExp(h.match[y].source + /(?![^\[]*\])(?![^\(]*\))/.source), h.leftMatch[y] = RegExp(/(^(?:.|\r|\n)*?)/.source + h.match[y].source.replace(/\\(\d+)/g, g));
            }h.match.globalPOS = m;var v = function v(e, t) {
                return e = Array.prototype.slice.call(e, 0), t ? (t.push.apply(t, e), t) : e;
            };try {
                Array.prototype.slice.call(j.documentElement.childNodes, 0)[0].nodeType;
            } catch (b) {
                v = function v(e, t) {
                    var n = 0,
                        r = t || [];if ("[object Array]" === a.call(e)) Array.prototype.push.apply(r, e);else if ("number" == typeof e.length) for (var i = e.length; i > n; n++) {
                        r.push(e[n]);
                    } else for (; e[n]; n++) {
                        r.push(e[n]);
                    }return r;
                };
            }var x, T;j.documentElement.compareDocumentPosition ? x = function x(e, t) {
                return e === t ? (s = !0, 0) : e.compareDocumentPosition && t.compareDocumentPosition ? 4 & e.compareDocumentPosition(t) ? -1 : 1 : e.compareDocumentPosition ? -1 : 1;
            } : (x = function x(e, t) {
                if (e === t) return s = !0, 0;if (e.sourceIndex && t.sourceIndex) return e.sourceIndex - t.sourceIndex;var n,
                    r,
                    i = [],
                    o = [],
                    a = e.parentNode,
                    l = t.parentNode,
                    u = a;if (a === l) return T(e, t);if (!a) return -1;if (!l) return 1;for (; u;) {
                    i.unshift(u), u = u.parentNode;
                }for (u = l; u;) {
                    o.unshift(u), u = u.parentNode;
                }n = i.length, r = o.length;for (var c = 0; n > c && r > c; c++) {
                    if (i[c] !== o[c]) return T(i[c], o[c]);
                }return c === n ? T(e, o[c], -1) : T(i[c], t, 1);
            }, T = function T(e, t, n) {
                if (e === t) return n;for (var r = e.nextSibling; r;) {
                    if (r === t) return -1;r = r.nextSibling;
                }return 1;
            }), function () {
                var e = j.createElement("div"),
                    n = "script" + new Date().getTime(),
                    r = j.documentElement;e.innerHTML = "<a name='" + n + "'/>", r.insertBefore(e, r.firstChild), j.getElementById(n) && (h.find.ID = function (e, n, r) {
                    if (t !== n.getElementById && !r) {
                        var i = n.getElementById(e[1]);return i ? i.id === e[1] || t !== i.getAttributeNode && i.getAttributeNode("id").nodeValue === e[1] ? [i] : t : [];
                    }
                }, h.filter.ID = function (e, n) {
                    var r = t !== e.getAttributeNode && e.getAttributeNode("id");return 1 === e.nodeType && r && r.nodeValue === n;
                }), r.removeChild(e), r = e = null;
            }(), function () {
                var e = j.createElement("div");e.appendChild(j.createComment("")), e.getElementsByTagName("*").length > 0 && (h.find.TAG = function (e, t) {
                    var n = t.getElementsByTagName(e[1]);if ("*" === e[1]) {
                        for (var r = [], i = 0; n[i]; i++) {
                            1 === n[i].nodeType && r.push(n[i]);
                        }n = r;
                    }return n;
                }), e.innerHTML = "<a href='#'></a>", e.firstChild && t !== e.firstChild.getAttribute && "#" !== e.firstChild.getAttribute("href") && (h.attrHandle.href = function (e) {
                    return e.getAttribute("href", 2);
                }), e = null;
            }(), j.querySelectorAll && !function () {
                var e = _d2,
                    t = j.createElement("div"),
                    n = "__sizzle__";if (t.innerHTML = "<p class='TEST'></p>", !t.querySelectorAll || 0 !== t.querySelectorAll(".TEST").length) {
                    _d2 = function _d(t, r, i, o) {
                        if (r = r || j, !o && !_d2.isXML(r)) {
                            var a = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(t);if (a && (1 === r.nodeType || 9 === r.nodeType)) {
                                if (a[1]) return v(r.getElementsByTagName(t), i);if (a[2] && h.find.CLASS && r.getElementsByClassName) return v(r.getElementsByClassName(a[2]), i);
                            }if (9 === r.nodeType) {
                                if ("body" === t && r.body) return v([r.body], i);if (a && a[3]) {
                                    var s = r.getElementById(a[3]);if (!s || !s.parentNode) return v([], i);if (s.id === a[3]) return v([s], i);
                                }try {
                                    return v(r.querySelectorAll(t), i);
                                } catch (l) {}
                            } else if (1 === r.nodeType && "object" !== r.nodeName.toLowerCase()) {
                                var u = r,
                                    c = r.getAttribute("id"),
                                    f = c || n,
                                    p = r.parentNode,
                                    m = /^\s*[+~]/.test(t);c ? f = f.replace(/'/g, "\\$&") : r.setAttribute("id", f), m && p && (r = r.parentNode);try {
                                    if (!m || p) return v(r.querySelectorAll("[id='" + f + "'] " + t), i);
                                } catch (g) {} finally {
                                    c || u.removeAttribute("id");
                                }
                            }
                        }return e(t, r, i, o);
                    };for (var r in e) {
                        _d2[r] = e[r];
                    }t = null;
                }
            }(), function () {
                var e = j.documentElement,
                    t = e.matchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.msMatchesSelector;if (t) {
                    var n = !t.call(j.createElement("div"), "div"),
                        r = !1;try {
                        t.call(j.documentElement, "[test!='']:sizzle");
                    } catch (i) {
                        r = !0;
                    }_d2.matchesSelector = function (e, i) {
                        if (i = i.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']"), !_d2.isXML(e)) try {
                            if (r || !h.match.PSEUDO.test(i) && !/!=/.test(i)) {
                                var o = t.call(e, i);if (o || !n || e.document && 11 !== e.document.nodeType) return o;
                            }
                        } catch (a) {}return _d2(i, null, null, [e]).length > 0;
                    };
                }
            }(), function () {
                var e = j.createElement("div");e.innerHTML = "<div class='test e'></div><div class='test'></div>", e.getElementsByClassName && 0 !== e.getElementsByClassName("e").length && (e.lastChild.className = "e", 1 !== e.getElementsByClassName("e").length && (h.order.splice(1, 0, "CLASS"), h.find.CLASS = function (e, n, r) {
                    return t === n.getElementsByClassName || r ? t : n.getElementsByClassName(e[1]);
                }, e = null));
            }(), _d2.contains = j.documentElement.contains ? function (e, t) {
                return e !== t && (e.contains ? e.contains(t) : !0);
            } : j.documentElement.compareDocumentPosition ? function (e, t) {
                return !!(16 & e.compareDocumentPosition(t));
            } : function () {
                return !1;
            }, _d2.isXML = function (e) {
                var t = (e ? e.ownerDocument || e : 0).documentElement;return t ? "HTML" !== t.nodeName : !1;
            };var w = function w(e, t, n) {
                for (var r, i = [], o = "", a = t.nodeType ? [t] : t; r = h.match.PSEUDO.exec(e);) {
                    o += r[0], e = e.replace(h.match.PSEUDO, "");
                }e = h.relative[e] ? e + "*" : e;for (var s = 0, l = a.length; l > s; s++) {
                    _d2(e, a[s], i, n);
                }return _d2.filter(o, i);
            };_d2.attr = O.attr, _d2.selectors.attrMap = {}, O.find = _d2, O.expr = _d2.selectors, O.expr[":"] = O.expr.filters, O.unique = _d2.uniqueSort, O.text = _d2.getText, O.isXMLDoc = _d2.isXML, O.contains = _d2.contains;
        }();var st = /Until$/,
            lt = /^(?:parents|prevUntil|prevAll)/,
            ut = /,/,
            ct = /^.[^:#\[\.,]*$/,
            ft = Array.prototype.slice,
            dt = O.expr.match.globalPOS,
            pt = { children: !0, contents: !0, next: !0, prev: !0 };O.fn.extend({ find: function find(e) {
                var t,
                    n,
                    r = this;if ("string" != typeof e) return O(e).filter(function () {
                    for (t = 0, n = r.length; n > t; t++) {
                        if (O.contains(r[t], this)) return !0;
                    }
                });var i,
                    o,
                    a,
                    s = this.pushStack("", "find", e);for (t = 0, n = this.length; n > t; t++) {
                    if (i = s.length, O.find(e, this[t], s), t > 0) for (o = i; o < s.length; o++) {
                        for (a = 0; i > a; a++) {
                            if (s[a] === s[o]) {
                                s.splice(o--, 1);break;
                            }
                        }
                    }
                }return s;
            }, has: function has(e) {
                var t = O(e);return this.filter(function () {
                    for (var e = 0, n = t.length; n > e; e++) {
                        if (O.contains(this, t[e])) return !0;
                    }
                });
            }, not: function not(e) {
                return this.pushStack(u(this, e, !1), "not", e);
            }, filter: function filter(e) {
                return this.pushStack(u(this, e, !0), "filter", e);
            }, is: function is(e) {
                return !!e && ("string" == typeof e ? dt.test(e) ? O(e, this.context).index(this[0]) >= 0 : O.filter(e, this).length > 0 : this.filter(e).length > 0);
            }, closest: function closest(e, t) {
                var n,
                    r,
                    i = [],
                    o = this[0];if (O.isArray(e)) {
                    for (var a = 1; o && o.ownerDocument && o !== t;) {
                        for (n = 0; n < e.length; n++) {
                            O(o).is(e[n]) && i.push({ selector: e[n], elem: o, level: a });
                        }o = o.parentNode, a++;
                    }return i;
                }var s = dt.test(e) || "string" != typeof e ? O(e, t || this.context) : 0;for (n = 0, r = this.length; r > n; n++) {
                    for (o = this[n]; o;) {
                        if (s ? s.index(o) > -1 : O.find.matchesSelector(o, e)) {
                            i.push(o);break;
                        }if (o = o.parentNode, !o || !o.ownerDocument || o === t || 11 === o.nodeType) break;
                    }
                }return i = i.length > 1 ? O.unique(i) : i, this.pushStack(i, "closest", e);
            }, index: function index(e) {
                return e ? "string" == typeof e ? O.inArray(this[0], O(e)) : O.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.prevAll().length : -1;
            }, add: function add(e, t) {
                var n = "string" == typeof e ? O(e, t) : O.makeArray(e && e.nodeType ? [e] : e),
                    r = O.merge(this.get(), n);return this.pushStack(l(n[0]) || l(r[0]) ? r : O.unique(r));
            }, andSelf: function andSelf() {
                return this.add(this.prevObject);
            } }), O.each({ parent: function parent(e) {
                var t = e.parentNode;return t && 11 !== t.nodeType ? t : null;
            }, parents: function parents(e) {
                return O.dir(e, "parentNode");
            }, parentsUntil: function parentsUntil(e, t, n) {
                return O.dir(e, "parentNode", n);
            }, next: function next(e) {
                return O.nth(e, 2, "nextSibling");
            }, prev: function prev(e) {
                return O.nth(e, 2, "previousSibling");
            }, nextAll: function nextAll(e) {
                return O.dir(e, "nextSibling");
            }, prevAll: function prevAll(e) {
                return O.dir(e, "previousSibling");
            }, nextUntil: function nextUntil(e, t, n) {
                return O.dir(e, "nextSibling", n);
            }, prevUntil: function prevUntil(e, t, n) {
                return O.dir(e, "previousSibling", n);
            }, siblings: function siblings(e) {
                return O.sibling((e.parentNode || {}).firstChild, e);
            }, children: function children(e) {
                return O.sibling(e.firstChild);
            }, contents: function contents(e) {
                return O.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : O.makeArray(e.childNodes);
            } }, function (e, t) {
            O.fn[e] = function (n, r) {
                var i = O.map(this, t, n);return st.test(e) || (r = n), r && "string" == typeof r && (i = O.filter(r, i)), i = this.length > 1 && !pt[e] ? O.unique(i) : i, (this.length > 1 || ut.test(r)) && lt.test(e) && (i = i.reverse()), this.pushStack(i, e, ft.call(arguments).join(","));
            };
        }), O.extend({ filter: function filter(e, t, n) {
                return n && (e = ":not(" + e + ")"), 1 === t.length ? O.find.matchesSelector(t[0], e) ? [t[0]] : [] : O.find.matches(e, t);
            }, dir: function dir(e, n, r) {
                for (var i = [], o = e[n]; o && 9 !== o.nodeType && (r === t || 1 !== o.nodeType || !O(o).is(r));) {
                    1 === o.nodeType && i.push(o), o = o[n];
                }return i;
            }, nth: function nth(e, t, n) {
                t = t || 1;for (var r = 0; e && (1 !== e.nodeType || ++r !== t); e = e[n]) {}return e;
            }, sibling: function sibling(e, t) {
                for (var n = []; e; e = e.nextSibling) {
                    1 === e.nodeType && e !== t && n.push(e);
                }return n;
            } });var ht = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
            mt = / jQuery\d+="(?:\d+|null)"/g,
            gt = /^\s+/,
            yt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
            vt = /<([\w:]+)/,
            bt = /<tbody/i,
            xt = /<|&#?\w+;/,
            Tt = /<(?:script|style)/i,
            wt = /<(?:script|object|embed|option|style)/i,
            Nt = RegExp("<(?:" + ht + ")[\\s/>]", "i"),
            Ct = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Et = /\/(java|ecma)script/i,
            kt = /^\s*<!(?:\[CDATA\[|\-\-)/,
            St = { option: [1, "<select multiple='multiple'>", "</select>"], legend: [1, "<fieldset>", "</fieldset>"], thead: [1, "<table>", "</table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"], area: [1, "<map>", "</map>"], _default: [0, "", ""] },
            At = c(j);St.optgroup = St.option, St.tbody = St.tfoot = St.colgroup = St.caption = St.thead, St.th = St.td, O.support.htmlSerialize || (St._default = [1, "div<div>", "</div>"]), O.fn.extend({ text: function text(e) {
                return O.access(this, function (e) {
                    return e === t ? O.text(this) : this.empty().append((this[0] && this[0].ownerDocument || j).createTextNode(e));
                }, null, e, arguments.length);
            }, wrapAll: function wrapAll(e) {
                if (O.isFunction(e)) return this.each(function (t) {
                    O(this).wrapAll(e.call(this, t));
                });if (this[0]) {
                    var t = O(e, this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                        for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) {
                            e = e.firstChild;
                        }return e;
                    }).append(this);
                }return this;
            }, wrapInner: function wrapInner(e) {
                return this.each(O.isFunction(e) ? function (t) {
                    O(this).wrapInner(e.call(this, t));
                } : function () {
                    var t = O(this),
                        n = t.contents();n.length ? n.wrapAll(e) : t.append(e);
                });
            }, wrap: function wrap(e) {
                var t = O.isFunction(e);return this.each(function (n) {
                    O(this).wrapAll(t ? e.call(this, n) : e);
                });
            }, unwrap: function unwrap() {
                return this.parent().each(function () {
                    O.nodeName(this, "body") || O(this).replaceWith(this.childNodes);
                }).end();
            }, append: function append() {
                return this.domManip(arguments, !0, function (e) {
                    1 === this.nodeType && this.appendChild(e);
                });
            }, prepend: function prepend() {
                return this.domManip(arguments, !0, function (e) {
                    1 === this.nodeType && this.insertBefore(e, this.firstChild);
                });
            }, before: function before() {
                if (this[0] && this[0].parentNode) return this.domManip(arguments, !1, function (e) {
                    this.parentNode.insertBefore(e, this);
                });if (arguments.length) {
                    var e = O.clean(arguments);return e.push.apply(e, this.toArray()), this.pushStack(e, "before", arguments);
                }
            }, after: function after() {
                if (this[0] && this[0].parentNode) return this.domManip(arguments, !1, function (e) {
                    this.parentNode.insertBefore(e, this.nextSibling);
                });if (arguments.length) {
                    var e = this.pushStack(this, "after", arguments);return e.push.apply(e, O.clean(arguments)), e;
                }
            }, remove: function remove(e, t) {
                for (var n, r = 0; null != (n = this[r]); r++) {
                    (!e || O.filter(e, [n]).length) && (t || 1 !== n.nodeType || (O.cleanData(n.getElementsByTagName("*")), O.cleanData([n])), n.parentNode && n.parentNode.removeChild(n));
                }return this;
            }, empty: function empty() {
                for (var e, t = 0; null != (e = this[t]); t++) {
                    for (1 === e.nodeType && O.cleanData(e.getElementsByTagName("*")); e.firstChild;) {
                        e.removeChild(e.firstChild);
                    }
                }return this;
            }, clone: function clone(e, t) {
                return e = null == e ? !1 : e, t = null == t ? e : t, this.map(function () {
                    return O.clone(this, e, t);
                });
            }, html: function html(e) {
                return O.access(this, function (e) {
                    var n = this[0] || {},
                        r = 0,
                        i = this.length;if (e === t) return 1 === n.nodeType ? n.innerHTML.replace(mt, "") : null;if (!("string" != typeof e || Tt.test(e) || !O.support.leadingWhitespace && gt.test(e) || St[(vt.exec(e) || ["", ""])[1].toLowerCase()])) {
                        e = e.replace(yt, "<$1></$2>");try {
                            for (; i > r; r++) {
                                n = this[r] || {}, 1 === n.nodeType && (O.cleanData(n.getElementsByTagName("*")), n.innerHTML = e);
                            }n = 0;
                        } catch (o) {}
                    }n && this.empty().append(e);
                }, null, e, arguments.length);
            }, replaceWith: function replaceWith(e) {
                return this[0] && this[0].parentNode ? O.isFunction(e) ? this.each(function (t) {
                    var n = O(this),
                        r = n.html();n.replaceWith(e.call(this, t, r));
                }) : ("string" != typeof e && (e = O(e).detach()), this.each(function () {
                    var t = this.nextSibling,
                        n = this.parentNode;O(this).remove(), t ? O(t).before(e) : O(n).append(e);
                })) : this.length ? this.pushStack(O(O.isFunction(e) ? e() : e), "replaceWith", e) : this;
            }, detach: function detach(e) {
                return this.remove(e, !0);
            }, domManip: function domManip(e, n, r) {
                var i,
                    o,
                    a,
                    s,
                    l = e[0],
                    u = [];if (!O.support.checkClone && 3 === arguments.length && "string" == typeof l && Ct.test(l)) return this.each(function () {
                    O(this).domManip(e, n, r, !0);
                });if (O.isFunction(l)) return this.each(function (i) {
                    var o = O(this);e[0] = l.call(this, i, n ? o.html() : t), o.domManip(e, n, r);
                });if (this[0]) {
                    if (s = l && l.parentNode, i = O.support.parentNode && s && 11 === s.nodeType && s.childNodes.length === this.length ? { fragment: s } : O.buildFragment(e, this, u), a = i.fragment, o = 1 === a.childNodes.length ? a = a.firstChild : a.firstChild) {
                        n = n && O.nodeName(o, "tr");for (var c = 0, d = this.length, p = d - 1; d > c; c++) {
                            r.call(n ? f(this[c], o) : this[c], i.cacheable || d > 1 && p > c ? O.clone(a, !0, !0) : a);
                        }
                    }u.length && O.each(u, function (e, t) {
                        t.src ? O.ajax({ type: "GET", global: !1, url: t.src, async: !1, dataType: "script" }) : O.globalEval((t.text || t.textContent || t.innerHTML || "").replace(kt, "/*$0*/")), t.parentNode && t.parentNode.removeChild(t);
                    });
                }return this;
            } }), O.buildFragment = function (e, t, n) {
            var r,
                i,
                o,
                a,
                s = e[0];return t && t[0] && (a = t[0].ownerDocument || t[0]), a.createDocumentFragment || (a = j), 1 !== e.length || "string" != typeof s || s.length >= 512 || a !== j || "<" !== s.charAt(0) || wt.test(s) || !O.support.checkClone && Ct.test(s) || !O.support.html5Clone && Nt.test(s) || (i = !0, o = O.fragments[s], o && 1 !== o && (r = o)), r || (r = a.createDocumentFragment(), O.clean(e, a, r, n)), i && (O.fragments[s] = o ? r : 1), { fragment: r, cacheable: i };
        }, O.fragments = {}, O.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
            O.fn[e] = function (n) {
                var r = [],
                    i = O(n),
                    o = 1 === this.length && this[0].parentNode;if (o && 11 === o.nodeType && 1 === o.childNodes.length && 1 === i.length) return i[t](this[0]), this;for (var a = 0, s = i.length; s > a; a++) {
                    var l = (a > 0 ? this.clone(!0) : this).get();O(i[a])[t](l), r = r.concat(l);
                }return this.pushStack(r, e, i.selector);
            };
        }), O.extend({ clone: function clone(e, t, n) {
                var r,
                    i,
                    o,
                    a = O.support.html5Clone || O.isXMLDoc(e) || !Nt.test("<" + e.nodeName + ">") ? e.cloneNode(!0) : y(e);if (!(O.support.noCloneEvent && O.support.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || O.isXMLDoc(e))) for (p(e, a), r = h(e), i = h(a), o = 0; r[o]; ++o) {
                    i[o] && p(r[o], i[o]);
                }if (t && (d(e, a), n)) for (r = h(e), i = h(a), o = 0; r[o]; ++o) {
                    d(r[o], i[o]);
                }return r = i = null, a;
            }, clean: function clean(e, n, r, i) {
                var o,
                    a,
                    s,
                    l = [];n = n || j, t === n.createElement && (n = n.ownerDocument || n[0] && n[0].ownerDocument || j);for (var u, f = 0; null != (u = e[f]); f++) {
                    if ("number" == typeof u && (u += ""), u) {
                        if ("string" == typeof u) if (xt.test(u)) {
                            u = u.replace(yt, "<$1></$2>");var d,
                                p = (vt.exec(u) || ["", ""])[1].toLowerCase(),
                                h = St[p] || St._default,
                                m = h[0],
                                y = n.createElement("div"),
                                v = At.childNodes;for (n === j ? At.appendChild(y) : c(n).appendChild(y), y.innerHTML = h[1] + u + h[2]; m--;) {
                                y = y.lastChild;
                            }if (!O.support.tbody) {
                                var b = bt.test(u),
                                    x = "table" !== p || b ? "<table>" !== h[1] || b ? [] : y.childNodes : y.firstChild && y.firstChild.childNodes;for (s = x.length - 1; s >= 0; --s) {
                                    O.nodeName(x[s], "tbody") && !x[s].childNodes.length && x[s].parentNode.removeChild(x[s]);
                                }
                            }!O.support.leadingWhitespace && gt.test(u) && y.insertBefore(n.createTextNode(gt.exec(u)[0]), y.firstChild), u = y.childNodes, y && (y.parentNode.removeChild(y), v.length > 0 && (d = v[v.length - 1], d && d.parentNode && d.parentNode.removeChild(d)));
                        } else u = n.createTextNode(u);var T;if (!O.support.appendChecked) if (u[0] && "number" == typeof (T = u.length)) for (s = 0; T > s; s++) {
                            g(u[s]);
                        } else g(u);u.nodeType ? l.push(u) : l = O.merge(l, u);
                    }
                }if (r) for (o = function o(e) {
                    return !e.type || Et.test(e.type);
                }, f = 0; l[f]; f++) {
                    if (a = l[f], i && O.nodeName(a, "script") && (!a.type || Et.test(a.type))) i.push(a.parentNode ? a.parentNode.removeChild(a) : a);else {
                        if (1 === a.nodeType) {
                            var w = O.grep(a.getElementsByTagName("script"), o);l.splice.apply(l, [f + 1, 0].concat(w));
                        }r.appendChild(a);
                    }
                }return l;
            }, cleanData: function cleanData(e) {
                for (var t, n, r, i = O.cache, o = O.event.special, a = O.support.deleteExpando, s = 0; null != (r = e[s]); s++) {
                    if ((!r.nodeName || !O.noData[r.nodeName.toLowerCase()]) && (n = r[O.expando])) {
                        if (t = i[n], t && t.events) {
                            for (var l in t.events) {
                                o[l] ? O.event.remove(r, l) : O.removeEvent(r, l, t.handle);
                            }t.handle && (t.handle.elem = null);
                        }a ? delete r[O.expando] : r.removeAttribute && r.removeAttribute(O.expando), delete i[n];
                    }
                }
            } });var Lt,
            Dt,
            Ft,
            jt = /alpha\([^)]*\)/i,
            Mt = /opacity=([^)]*)/,
            _t = /([A-Z]|^ms)/g,
            Ot = /^[\-+]?(?:\d*\.)?\d+$/i,
            Ht = /^-?(?:\d*\.)?\d+(?!px)[^\d\s]+$/i,
            Pt = /^([\-+])=([\-+.\de]+)/,
            Bt = /^margin/,
            qt = { position: "absolute", visibility: "hidden", display: "block" },
            Wt = ["Top", "Right", "Bottom", "Left"];O.fn.css = function (e, n) {
            return O.access(this, function (e, n, r) {
                return r !== t ? O.style(e, n, r) : O.css(e, n);
            }, e, n, arguments.length > 1);
        }, O.extend({ cssHooks: { opacity: { get: function get(e, t) {
                        if (t) {
                            var n = Lt(e, "opacity");return "" === n ? "1" : n;
                        }return e.style.opacity;
                    } } }, cssNumber: { fillOpacity: !0, fontWeight: !0, lineHeight: !0, opacity: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { "float": O.support.cssFloat ? "cssFloat" : "styleFloat" }, style: function style(e, n, r, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        a,
                        s = O.camelCase(n),
                        l = e.style,
                        u = O.cssHooks[s];if (n = O.cssProps[s] || s, r === t) return u && "get" in u && (o = u.get(e, !1, i)) !== t ? o : l[n];if (a = typeof r, "string" === a && (o = Pt.exec(r)) && (r = +(o[1] + 1) * +o[2] + parseFloat(O.css(e, n)), a = "number"), !(null == r || "number" === a && isNaN(r) || ("number" !== a || O.cssNumber[s] || (r += "px"), u && "set" in u && (r = u.set(e, r)) === t))) try {
                        l[n] = r;
                    } catch (c) {}
                }
            }, css: function css(e, n, r) {
                var i, o;return n = O.camelCase(n), o = O.cssHooks[n], n = O.cssProps[n] || n, "cssFloat" === n && (n = "float"), o && "get" in o && (i = o.get(e, !0, r)) !== t ? i : Lt ? Lt(e, n) : t;
            }, swap: function swap(e, t, n) {
                var r,
                    i,
                    o = {};for (i in t) {
                    o[i] = e.style[i], e.style[i] = t[i];
                }r = n.call(e);for (i in t) {
                    e.style[i] = o[i];
                }return r;
            } }), O.curCSS = O.css, j.defaultView && j.defaultView.getComputedStyle && (Dt = function Dt(e, t) {
            var n,
                r,
                i,
                o,
                a = e.style;return t = t.replace(_t, "-$1").toLowerCase(), (r = e.ownerDocument.defaultView) && (i = r.getComputedStyle(e, null)) && (n = i.getPropertyValue(t), "" !== n || O.contains(e.ownerDocument.documentElement, e) || (n = O.style(e, t))), !O.support.pixelMargin && i && Bt.test(t) && Ht.test(n) && (o = a.width, a.width = n, n = i.width, a.width = o), n;
        }), j.documentElement.currentStyle && (Ft = function Ft(e, t) {
            var n,
                r,
                i,
                o = e.currentStyle && e.currentStyle[t],
                a = e.style;return null == o && a && (i = a[t]) && (o = i), Ht.test(o) && (n = a.left, r = e.runtimeStyle && e.runtimeStyle.left, r && (e.runtimeStyle.left = e.currentStyle.left), a.left = "fontSize" === t ? "1em" : o, o = a.pixelLeft + "px", a.left = n, r && (e.runtimeStyle.left = r)), "" === o ? "auto" : o;
        }), Lt = Dt || Ft, O.each(["height", "width"], function (e, n) {
            O.cssHooks[n] = { get: function get(e, r, i) {
                    return r ? 0 !== e.offsetWidth ? v(e, n, i) : O.swap(e, qt, function () {
                        return v(e, n, i);
                    }) : t;
                }, set: function set(e, t) {
                    return Ot.test(t) ? t + "px" : t;
                } };
        }), O.support.opacity || (O.cssHooks.opacity = { get: function get(e, t) {
                return Mt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? parseFloat(RegExp.$1) / 100 + "" : t ? "1" : "";
            }, set: function set(e, t) {
                var n = e.style,
                    r = e.currentStyle,
                    i = O.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
                    o = r && r.filter || n.filter || "";n.zoom = 1, (1 > t || "" !== O.trim(o.replace(jt, "")) || (n.removeAttribute("filter"), !r || r.filter)) && (n.filter = jt.test(o) ? o.replace(jt, i) : o + " " + i);
            } }), O(function () {
            O.support.reliableMarginRight || (O.cssHooks.marginRight = { get: function get(e, t) {
                    return O.swap(e, { display: "inline-block" }, function () {
                        return t ? Lt(e, "margin-right") : e.style.marginRight;
                    });
                } });
        }), O.expr && O.expr.filters && (O.expr.filters.hidden = function (e) {
            var t = e.offsetWidth,
                n = e.offsetHeight;return 0 === t && 0 === n || !O.support.reliableHiddenOffsets && "none" === (e.style && e.style.display || O.css(e, "display"));
        }, O.expr.filters.visible = function (e) {
            return !O.expr.filters.hidden(e);
        }), O.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            O.cssHooks[e + t] = { expand: function expand(n) {
                    var r,
                        i = "string" == typeof n ? n.split(" ") : [n],
                        o = {};for (r = 0; 4 > r; r++) {
                        o[e + Wt[r] + t] = i[r] || i[r - 2] || i[0];
                    }return o;
                } };
        });var It,
            Rt,
            $t = /%20/g,
            Xt = /\[\]$/,
            zt = /\r?\n/g,
            Vt = /#.*$/,
            Ut = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
            Gt = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,
            Yt = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
            Jt = /^(?:GET|HEAD)$/,
            Kt = /^\/\//,
            Qt = /\?/,
            Zt = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
            en = /^(?:select|textarea)/i,
            tn = /\s+/,
            nn = /([?&])_=[^&]*/,
            rn = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,
            on = O.fn.load,
            an = {},
            sn = {},
            ln = ["*/"] + ["*"];try {
            It = _.href;
        } catch (un) {
            It = j.createElement("a"), It.href = "", It = It.href;
        }Rt = rn.exec(It.toLowerCase()) || [], O.fn.extend({ load: function load(e, n, r) {
                if ("string" != typeof e && on) return on.apply(this, arguments);if (!this.length) return this;var i = e.indexOf(" ");if (i >= 0) {
                    var o = e.slice(i, e.length);e = e.slice(0, i);
                }var a = "GET";n && (O.isFunction(n) ? (r = n, n = t) : "object" == typeof n && (n = O.param(n, O.ajaxSettings.traditional), a = "POST"));var s = this;return O.ajax({ url: e, type: a, dataType: "html", data: n, complete: function complete(e, t, n) {
                        n = e.responseText, e.isResolved() && (e.done(function (e) {
                            n = e;
                        }), s.html(o ? O("<div>").append(n.replace(Zt, "")).find(o) : n)), r && s.each(r, [n, t, e]);
                    } }), this;
            }, serialize: function serialize() {
                return O.param(this.serializeArray());
            }, serializeArray: function serializeArray() {
                return this.map(function () {
                    return this.elements ? O.makeArray(this.elements) : this;
                }).filter(function () {
                    return this.name && !this.disabled && (this.checked || en.test(this.nodeName) || Gt.test(this.type));
                }).map(function (e, t) {
                    var n = O(this).val();return null == n ? null : O.isArray(n) ? O.map(n, function (e) {
                        return { name: t.name, value: e.replace(zt, "\r\n") };
                    }) : { name: t.name, value: n.replace(zt, "\r\n") };
                }).get();
            } }), O.each("ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split(" "), function (e, t) {
            O.fn[t] = function (e) {
                return this.on(t, e);
            };
        }), O.each(["get", "post"], function (e, n) {
            O[n] = function (e, r, i, o) {
                return O.isFunction(r) && (o = o || i, i = r, r = t), O.ajax({ type: n, url: e, data: r, success: i, dataType: o });
            };
        }), O.extend({ getScript: function getScript(e, n) {
                return O.get(e, t, n, "script");
            }, getJSON: function getJSON(e, t, n) {
                return O.get(e, t, n, "json");
            }, ajaxSetup: function ajaxSetup(e, t) {
                return t ? T(e, O.ajaxSettings) : (t = e, e = O.ajaxSettings), T(e, t), e;
            }, ajaxSettings: { url: It, isLocal: Yt.test(Rt[1]), global: !0, type: "GET", contentType: "application/x-www-form-urlencoded; charset=UTF-8", processData: !0, async: !0, accepts: { xml: "application/xml, text/xml", html: "text/html", text: "text/plain", json: "application/json, text/javascript", "*": ln }, contents: { xml: /xml/, html: /html/, json: /json/ }, responseFields: { xml: "responseXML", text: "responseText" }, converters: { "* text": e.String, "text html": !0, "text json": O.parseJSON, "text xml": O.parseXML }, flatOptions: { context: !0, url: !0 } }, ajaxPrefilter: b(an), ajaxTransport: b(sn), ajax: function ajax(e, n) {
                function r(e, n, r, a) {
                    if (2 !== T) {
                        T = 2, l && clearTimeout(l), s = t, o = a || "", w.readyState = e > 0 ? 4 : 0;var u,
                            f,
                            v,
                            b,
                            x,
                            E = n,
                            k = r ? N(d, w, r) : t;if (e >= 200 && 300 > e || 304 === e) {
                            if (d.ifModified && ((b = w.getResponseHeader("Last-Modified")) && (O.lastModified[i] = b), (x = w.getResponseHeader("Etag")) && (O.etag[i] = x)), 304 === e) E = "notmodified", u = !0;else try {
                                f = C(d, k), E = "success", u = !0;
                            } catch (S) {
                                E = "parsererror", v = S;
                            }
                        } else v = E, (!E || e) && (E = "error", 0 > e && (e = 0));w.status = e, w.statusText = "" + (n || E), u ? m.resolveWith(p, [f, E, w]) : m.rejectWith(p, [w, E, v]), w.statusCode(y), y = t, c && h.trigger("ajax" + (u ? "Success" : "Error"), [w, d, u ? f : v]), g.fireWith(p, [w, E]), c && (h.trigger("ajaxComplete", [w, d]), --O.active || O.event.trigger("ajaxStop"));
                    }
                }"object" == typeof e && (n = e, e = t), n = n || {};var i,
                    o,
                    a,
                    s,
                    l,
                    u,
                    c,
                    f,
                    d = O.ajaxSetup({}, n),
                    p = d.context || d,
                    h = p !== d && (p.nodeType || p instanceof O) ? O(p) : O.event,
                    m = O.Deferred(),
                    g = O.Callbacks("once memory"),
                    y = d.statusCode || {},
                    v = {},
                    b = {},
                    T = 0,
                    w = { readyState: 0, setRequestHeader: function setRequestHeader(e, t) {
                        if (!T) {
                            var n = e.toLowerCase();e = b[n] = b[n] || e, v[e] = t;
                        }return this;
                    }, getAllResponseHeaders: function getAllResponseHeaders() {
                        return 2 === T ? o : null;
                    }, getResponseHeader: function getResponseHeader(e) {
                        var n;if (2 === T) {
                            if (!a) for (a = {}; n = Ut.exec(o);) {
                                a[n[1].toLowerCase()] = n[2];
                            }n = a[e.toLowerCase()];
                        }return n === t ? null : n;
                    }, overrideMimeType: function overrideMimeType(e) {
                        return T || (d.mimeType = e), this;
                    }, abort: function abort(e) {
                        return e = e || "abort", s && s.abort(e), r(0, e), this;
                    } };if (m.promise(w), w.success = w.done, w.error = w.fail, w.complete = g.add, w.statusCode = function (e) {
                    if (e) {
                        var t;if (2 > T) for (t in e) {
                            y[t] = [y[t], e[t]];
                        } else t = e[w.status], w.then(t, t);
                    }return this;
                }, d.url = ((e || d.url) + "").replace(Vt, "").replace(Kt, Rt[1] + "//"), d.dataTypes = O.trim(d.dataType || "*").toLowerCase().split(tn), null == d.crossDomain && (u = rn.exec(d.url.toLowerCase()), d.crossDomain = !(!u || u[1] == Rt[1] && u[2] == Rt[2] && (u[3] || ("http:" === u[1] ? 80 : 443)) == (Rt[3] || ("http:" === Rt[1] ? 80 : 443)))), d.data && d.processData && "string" != typeof d.data && (d.data = O.param(d.data, d.traditional)), x(an, d, n, w), 2 === T) return !1;if (c = d.global, d.type = d.type.toUpperCase(), d.hasContent = !Jt.test(d.type), c && 0 === O.active++ && O.event.trigger("ajaxStart"), !d.hasContent && (d.data && (d.url += (Qt.test(d.url) ? "&" : "?") + d.data, delete d.data), i = d.url, d.cache === !1)) {
                    var E = O.now(),
                        k = d.url.replace(nn, "$1_=" + E);d.url = k + (k === d.url ? (Qt.test(d.url) ? "&" : "?") + "_=" + E : "");
                }(d.data && d.hasContent && d.contentType !== !1 || n.contentType) && w.setRequestHeader("Content-Type", d.contentType), d.ifModified && (i = i || d.url, O.lastModified[i] && w.setRequestHeader("If-Modified-Since", O.lastModified[i]), O.etag[i] && w.setRequestHeader("If-None-Match", O.etag[i])), w.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + ln + "; q=0.01" : "") : d.accepts["*"]);for (f in d.headers) {
                    w.setRequestHeader(f, d.headers[f]);
                }if (d.beforeSend && (d.beforeSend.call(p, w, d) === !1 || 2 === T)) return w.abort(), !1;for (f in { success: 1, error: 1, complete: 1 }) {
                    w[f](d[f]);
                }if (s = x(sn, d, n, w)) {
                    w.readyState = 1, c && h.trigger("ajaxSend", [w, d]), d.async && d.timeout > 0 && (l = setTimeout(function () {
                        w.abort("timeout");
                    }, d.timeout));try {
                        T = 1, s.send(v, r);
                    } catch (S) {
                        if (T >= 2) throw S;r(-1, S);
                    }
                } else r(-1, "No Transport");return w;
            }, param: function param(e, n) {
                var r = [],
                    i = function i(e, t) {
                    t = O.isFunction(t) ? t() : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
                };if (n === t && (n = O.ajaxSettings.traditional), O.isArray(e) || e.jquery && !O.isPlainObject(e)) O.each(e, function () {
                    i(this.name, this.value);
                });else for (var o in e) {
                    w(o, e[o], n, i);
                }return r.join("&").replace($t, "+");
            } }), O.extend({ active: 0, lastModified: {}, etag: {} });var cn = O.now(),
            fn = /(\=)\?(&|$)|\?\?/i;O.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
                return O.expando + "_" + cn++;
            } }), O.ajaxPrefilter("json jsonp", function (t, n, r) {
            var i = "string" == typeof t.data && /^application\/x\-www\-form\-urlencoded/.test(t.contentType);if ("jsonp" === t.dataTypes[0] || t.jsonp !== !1 && (fn.test(t.url) || i && fn.test(t.data))) {
                var o,
                    a = t.jsonpCallback = O.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback,
                    s = e[a],
                    l = t.url,
                    u = t.data,
                    c = "$1" + a + "$2";return t.jsonp !== !1 && (l = l.replace(fn, c), t.url === l && (i && (u = u.replace(fn, c)), t.data === u && (l += (/\?/.test(l) ? "&" : "?") + t.jsonp + "=" + a))), t.url = l, t.data = u, e[a] = function (e) {
                    o = [e];
                }, r.always(function () {
                    e[a] = s, o && O.isFunction(s) && e[a](o[0]);
                }), t.converters["script json"] = function () {
                    return o || O.error(a + " was not called"), o[0];
                }, t.dataTypes[0] = "json", "script";
            }
        }), O.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /javascript|ecmascript/ }, converters: { "text script": function textScript(e) {
                    return O.globalEval(e), e;
                } } }), O.ajaxPrefilter("script", function (e) {
            e.cache === t && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
        }), O.ajaxTransport("script", function (e) {
            if (e.crossDomain) {
                var n,
                    r = j.head || j.getElementsByTagName("head")[0] || j.documentElement;return { send: function send(i, o) {
                        n = j.createElement("script"), n.async = "async", e.scriptCharset && (n.charset = e.scriptCharset), n.src = e.url, n.onload = n.onreadystatechange = function (e, i) {
                            (i || !n.readyState || /loaded|complete/.test(n.readyState)) && (n.onload = n.onreadystatechange = null, r && n.parentNode && r.removeChild(n), n = t, i || o(200, "success"));
                        }, r.insertBefore(n, r.firstChild);
                    }, abort: function abort() {
                        n && n.onload(0, 1);
                    } };
            }
        });var dn,
            pn = e.ActiveXObject ? function () {
            for (var e in dn) {
                dn[e](0, 1);
            }
        } : !1,
            hn = 0;O.ajaxSettings.xhr = e.ActiveXObject ? function () {
            return !this.isLocal && E() || k();
        } : E, function (e) {
            O.extend(O.support, { ajax: !!e, cors: !!e && "withCredentials" in e });
        }(O.ajaxSettings.xhr()), O.support.ajax && O.ajaxTransport(function (n) {
            if (!n.crossDomain || O.support.cors) {
                var _r;return { send: function send(i, o) {
                        var a,
                            s,
                            l = n.xhr();if (n.username ? l.open(n.type, n.url, n.async, n.username, n.password) : l.open(n.type, n.url, n.async), n.xhrFields) for (s in n.xhrFields) {
                            l[s] = n.xhrFields[s];
                        }n.mimeType && l.overrideMimeType && l.overrideMimeType(n.mimeType), n.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");try {
                            for (s in i) {
                                l.setRequestHeader(s, i[s]);
                            }
                        } catch (u) {}l.send(n.hasContent && n.data || null), _r = function r(e, i) {
                            var s, u, c, f, d;try {
                                if (_r && (i || 4 === l.readyState)) if (_r = t, a && (l.onreadystatechange = O.noop, pn && delete dn[a]), i) 4 !== l.readyState && l.abort();else {
                                    s = l.status, c = l.getAllResponseHeaders(), f = {}, d = l.responseXML, d && d.documentElement && (f.xml = d);try {
                                        f.text = l.responseText;
                                    } catch (e) {}try {
                                        u = l.statusText;
                                    } catch (p) {
                                        u = "";
                                    }s || !n.isLocal || n.crossDomain ? 1223 === s && (s = 204) : s = f.text ? 200 : 404;
                                }
                            } catch (h) {
                                i || o(-1, h);
                            }f && o(s, u, f, c);
                        }, n.async && 4 !== l.readyState ? (a = ++hn, pn && (dn || (dn = {}, O(e).unload(pn)), dn[a] = _r), l.onreadystatechange = _r) : _r();
                    }, abort: function abort() {
                        _r && _r(0, 1);
                    } };
            }
        });var mn,
            gn,
            yn,
            vn,
            bn = {},
            xn = /^(?:toggle|show|hide)$/,
            Tn = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,
            wn = [["height", "marginTop", "marginBottom", "paddingTop", "paddingBottom"], ["width", "marginLeft", "marginRight", "paddingLeft", "paddingRight"], ["opacity"]];O.fn.extend({ show: function show(e, t, n) {
                var r, i;if (e || 0 === e) return this.animate(L("show", 3), e, t, n);for (var o = 0, a = this.length; a > o; o++) {
                    r = this[o], r.style && (i = r.style.display, O._data(r, "olddisplay") || "none" !== i || (i = r.style.display = ""), ("" === i && "none" === O.css(r, "display") || !O.contains(r.ownerDocument.documentElement, r)) && O._data(r, "olddisplay", D(r.nodeName)));
                }for (o = 0; a > o; o++) {
                    r = this[o], r.style && (i = r.style.display, ("" === i || "none" === i) && (r.style.display = O._data(r, "olddisplay") || ""));
                }return this;
            }, hide: function hide(e, t, n) {
                if (e || 0 === e) return this.animate(L("hide", 3), e, t, n);for (var r, i, o = 0, a = this.length; a > o; o++) {
                    r = this[o], r.style && (i = O.css(r, "display"), "none" === i || O._data(r, "olddisplay") || O._data(r, "olddisplay", i));
                }for (o = 0; a > o; o++) {
                    this[o].style && (this[o].style.display = "none");
                }return this;
            }, _toggle: O.fn.toggle, toggle: function toggle(e, t, n) {
                var r = "boolean" == typeof e;return O.isFunction(e) && O.isFunction(t) ? this._toggle.apply(this, arguments) : null == e || r ? this.each(function () {
                    var t = r ? e : O(this).is(":hidden");O(this)[t ? "show" : "hide"]();
                }) : this.animate(L("toggle", 3), e, t, n), this;
            }, fadeTo: function fadeTo(e, t, n, r) {
                return this.filter(":hidden").css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            }, animate: function animate(e, t, n, r) {
                function i() {
                    o.queue === !1 && O._mark(this);var t,
                        n,
                        r,
                        i,
                        a,
                        s,
                        l,
                        u,
                        c,
                        f,
                        d,
                        p = O.extend({}, o),
                        h = 1 === this.nodeType,
                        m = h && O(this).is(":hidden");p.animatedProperties = {};for (r in e) {
                        if (t = O.camelCase(r), r !== t && (e[t] = e[r], delete e[r]), (a = O.cssHooks[t]) && "expand" in a) {
                            s = a.expand(e[t]), delete e[t];for (r in s) {
                                r in e || (e[r] = s[r]);
                            }
                        }
                    }for (t in e) {
                        if (n = e[t], O.isArray(n) ? (p.animatedProperties[t] = n[1], n = e[t] = n[0]) : p.animatedProperties[t] = p.specialEasing && p.specialEasing[t] || p.easing || "swing", "hide" === n && m || "show" === n && !m) return p.complete.call(this);!h || "height" !== t && "width" !== t || (p.overflow = [this.style.overflow, this.style.overflowX, this.style.overflowY], "inline" === O.css(this, "display") && "none" === O.css(this, "float") && (O.support.inlineBlockNeedsLayout && "inline" !== D(this.nodeName) ? this.style.zoom = 1 : this.style.display = "inline-block"));
                    }null != p.overflow && (this.style.overflow = "hidden");for (r in e) {
                        i = new O.fx(this, p, r), n = e[r], xn.test(n) ? (d = O._data(this, "toggle" + r) || ("toggle" === n ? m ? "show" : "hide" : 0), d ? (O._data(this, "toggle" + r, "show" === d ? "hide" : "show"), i[d]()) : i[n]()) : (l = Tn.exec(n), u = i.cur(), l ? (c = parseFloat(l[2]), f = l[3] || (O.cssNumber[r] ? "" : "px"), "px" !== f && (O.style(this, r, (c || 1) + f), u = (c || 1) / i.cur() * u, O.style(this, r, u + f)), l[1] && (c = ("-=" === l[1] ? -1 : 1) * c + u), i.custom(u, c, f)) : i.custom(u, n, ""));
                    }return !0;
                }var o = O.speed(t, n, r);return O.isEmptyObject(e) ? this.each(o.complete, [!1]) : (e = O.extend({}, e), o.queue === !1 ? this.each(i) : this.queue(o.queue, i));
            }, stop: function stop(e, n, r) {
                return "string" != typeof e && (r = n, n = e, e = t), n && e !== !1 && this.queue(e || "fx", []), this.each(function () {
                    function t(e, t, n) {
                        var i = t[n];O.removeData(e, n, !0), i.stop(r);
                    }var n,
                        i = !1,
                        o = O.timers,
                        a = O._data(this);if (r || O._unmark(!0, this), null == e) for (n in a) {
                        a[n] && a[n].stop && n.indexOf(".run") === n.length - 4 && t(this, a, n);
                    } else a[n = e + ".run"] && a[n].stop && t(this, a, n);for (n = o.length; n--;) {
                        o[n].elem !== this || null != e && o[n].queue !== e || (r ? o[n](!0) : o[n].saveState(), i = !0, o.splice(n, 1));
                    }r && i || O.dequeue(this, e);
                });
            } }), O.each({ slideDown: L("show", 1), slideUp: L("hide", 1), slideToggle: L("toggle", 1), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
            O.fn[e] = function (e, n, r) {
                return this.animate(t, e, n, r);
            };
        }), O.extend({ speed: function speed(e, t, n) {
                var r = e && "object" == typeof e ? O.extend({}, e) : { complete: n || !n && t || O.isFunction(e) && e, duration: e, easing: n && t || t && !O.isFunction(t) && t };return r.duration = O.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in O.fx.speeds ? O.fx.speeds[r.duration] : O.fx.speeds._default, (null == r.queue || r.queue === !0) && (r.queue = "fx"), r.old = r.complete, r.complete = function (e) {
                    O.isFunction(r.old) && r.old.call(this), r.queue ? O.dequeue(this, r.queue) : e !== !1 && O._unmark(this);
                }, r;
            }, easing: { linear: function linear(e) {
                    return e;
                }, swing: function swing(e) {
                    return -Math.cos(e * Math.PI) / 2 + .5;
                } }, timers: [], fx: function fx(e, t, n) {
                this.options = t, this.elem = e, this.prop = n, t.orig = t.orig || {};
            } }), O.fx.prototype = { update: function update() {
                this.options.step && this.options.step.call(this.elem, this.now, this), (O.fx.step[this.prop] || O.fx.step._default)(this);
            }, cur: function cur() {
                if (null != this.elem[this.prop] && (!this.elem.style || null == this.elem.style[this.prop])) return this.elem[this.prop];var e,
                    t = O.css(this.elem, this.prop);return isNaN(e = parseFloat(t)) ? t && "auto" !== t ? t : 0 : e;
            }, custom: function custom(e, n, r) {
                function i(e) {
                    return o.step(e);
                }var o = this,
                    a = O.fx;this.startTime = vn || S(), this.end = n, this.now = this.start = e, this.pos = this.state = 0, this.unit = r || this.unit || (O.cssNumber[this.prop] ? "" : "px"), i.queue = this.options.queue, i.elem = this.elem, i.saveState = function () {
                    O._data(o.elem, "fxshow" + o.prop) === t && (o.options.hide ? O._data(o.elem, "fxshow" + o.prop, o.start) : o.options.show && O._data(o.elem, "fxshow" + o.prop, o.end));
                }, i() && O.timers.push(i) && !yn && (yn = setInterval(a.tick, a.interval));
            }, show: function show() {
                var e = O._data(this.elem, "fxshow" + this.prop);this.options.orig[this.prop] = e || O.style(this.elem, this.prop), this.options.show = !0, e !== t ? this.custom(this.cur(), e) : this.custom("width" === this.prop || "height" === this.prop ? 1 : 0, this.cur()), O(this.elem).show();
            }, hide: function hide() {
                this.options.orig[this.prop] = O._data(this.elem, "fxshow" + this.prop) || O.style(this.elem, this.prop), this.options.hide = !0, this.custom(this.cur(), 0);
            }, step: function step(e) {
                var t,
                    n,
                    r,
                    i = vn || S(),
                    o = !0,
                    a = this.elem,
                    s = this.options;if (e || i >= s.duration + this.startTime) {
                    this.now = this.end, this.pos = this.state = 1, this.update(), s.animatedProperties[this.prop] = !0;for (t in s.animatedProperties) {
                        s.animatedProperties[t] !== !0 && (o = !1);
                    }if (o) {
                        if (null == s.overflow || O.support.shrinkWrapBlocks || O.each(["", "X", "Y"], function (e, t) {
                            a.style["overflow" + t] = s.overflow[e];
                        }), s.hide && O(a).hide(), s.hide || s.show) for (t in s.animatedProperties) {
                            O.style(a, t, s.orig[t]), O.removeData(a, "fxshow" + t, !0), O.removeData(a, "toggle" + t, !0);
                        }r = s.complete, r && (s.complete = !1, r.call(a));
                    }return !1;
                }return 1 / 0 == s.duration ? this.now = i : (n = i - this.startTime, this.state = n / s.duration, this.pos = O.easing[s.animatedProperties[this.prop]](this.state, n, 0, 1, s.duration), this.now = this.start + (this.end - this.start) * this.pos), this.update(), !0;
            } }, O.extend(O.fx, { tick: function tick() {
                for (var e, t = O.timers, n = 0; n < t.length; n++) {
                    e = t[n], e() || t[n] !== e || t.splice(n--, 1);
                }t.length || O.fx.stop();
            }, interval: 13, stop: function stop() {
                clearInterval(yn), yn = null;
            }, speeds: { slow: 600, fast: 200, _default: 400 }, step: { opacity: function opacity(e) {
                    O.style(e.elem, "opacity", e.now);
                }, _default: function _default(e) {
                    e.elem.style && null != e.elem.style[e.prop] ? e.elem.style[e.prop] = e.now + e.unit : e.elem[e.prop] = e.now;
                } } }), O.each(wn.concat.apply([], wn), function (e, t) {
            t.indexOf("margin") && (O.fx.step[t] = function (e) {
                O.style(e.elem, t, Math.max(0, e.now) + e.unit);
            });
        }), O.expr && O.expr.filters && (O.expr.filters.animated = function (e) {
            return O.grep(O.timers, function (t) {
                return e === t.elem;
            }).length;
        });var Nn,
            Cn = /^t(?:able|d|h)$/i,
            En = /^(?:body|html)$/i;Nn = "getBoundingClientRect" in j.documentElement ? function (e, t, n, r) {
            try {
                r = e.getBoundingClientRect();
            } catch (i) {}if (!r || !O.contains(n, e)) return r ? { top: r.top, left: r.left } : { top: 0, left: 0 };var o = t.body,
                a = F(t),
                s = n.clientTop || o.clientTop || 0,
                l = n.clientLeft || o.clientLeft || 0,
                u = a.pageYOffset || O.support.boxModel && n.scrollTop || o.scrollTop,
                c = a.pageXOffset || O.support.boxModel && n.scrollLeft || o.scrollLeft,
                f = r.top + u - s,
                d = r.left + c - l;return { top: f, left: d };
        } : function (e, t, n) {
            for (var r, i = e.offsetParent, o = e, a = t.body, s = t.defaultView, l = s ? s.getComputedStyle(e, null) : e.currentStyle, u = e.offsetTop, c = e.offsetLeft; (e = e.parentNode) && e !== a && e !== n && (!O.support.fixedPosition || "fixed" !== l.position);) {
                r = s ? s.getComputedStyle(e, null) : e.currentStyle, u -= e.scrollTop, c -= e.scrollLeft, e === i && (u += e.offsetTop, c += e.offsetLeft, !O.support.doesNotAddBorder || O.support.doesAddBorderForTableAndCells && Cn.test(e.nodeName) || (u += parseFloat(r.borderTopWidth) || 0, c += parseFloat(r.borderLeftWidth) || 0), o = i, i = e.offsetParent), O.support.subtractsBorderForOverflowNotVisible && "visible" !== r.overflow && (u += parseFloat(r.borderTopWidth) || 0, c += parseFloat(r.borderLeftWidth) || 0), l = r;
            }return ("relative" === l.position || "static" === l.position) && (u += a.offsetTop, c += a.offsetLeft), O.support.fixedPosition && "fixed" === l.position && (u += Math.max(n.scrollTop, a.scrollTop), c += Math.max(n.scrollLeft, a.scrollLeft)), { top: u, left: c };
        }, O.fn.offset = function (e) {
            if (arguments.length) return e === t ? this : this.each(function (t) {
                O.offset.setOffset(this, e, t);
            });var n = this[0],
                r = n && n.ownerDocument;return r ? n === r.body ? O.offset.bodyOffset(n) : Nn(n, r, r.documentElement) : null;
        }, O.offset = { bodyOffset: function bodyOffset(e) {
                var t = e.offsetTop,
                    n = e.offsetLeft;return O.support.doesNotIncludeMarginInBodyOffset && (t += parseFloat(O.css(e, "marginTop")) || 0, n += parseFloat(O.css(e, "marginLeft")) || 0), { top: t, left: n };
            }, setOffset: function setOffset(e, t, n) {
                var r = O.css(e, "position");"static" === r && (e.style.position = "relative");var i,
                    o,
                    a = O(e),
                    s = a.offset(),
                    l = O.css(e, "top"),
                    u = O.css(e, "left"),
                    c = ("absolute" === r || "fixed" === r) && O.inArray("auto", [l, u]) > -1,
                    f = {},
                    d = {};c ? (d = a.position(), i = d.top, o = d.left) : (i = parseFloat(l) || 0, o = parseFloat(u) || 0), O.isFunction(t) && (t = t.call(e, n, s)), null != t.top && (f.top = t.top - s.top + i), null != t.left && (f.left = t.left - s.left + o), "using" in t ? t.using.call(e, f) : a.css(f);
            } }, O.fn.extend({ position: function position() {
                if (!this[0]) return null;var e = this[0],
                    t = this.offsetParent(),
                    n = this.offset(),
                    r = En.test(t[0].nodeName) ? { top: 0, left: 0 } : t.offset();return n.top -= parseFloat(O.css(e, "marginTop")) || 0, n.left -= parseFloat(O.css(e, "marginLeft")) || 0, r.top += parseFloat(O.css(t[0], "borderTopWidth")) || 0, r.left += parseFloat(O.css(t[0], "borderLeftWidth")) || 0, { top: n.top - r.top, left: n.left - r.left };
            }, offsetParent: function offsetParent() {
                return this.map(function () {
                    for (var e = this.offsetParent || j.body; e && !En.test(e.nodeName) && "static" === O.css(e, "position");) {
                        e = e.offsetParent;
                    }return e;
                });
            } }), O.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, n) {
            var r = /Y/.test(n);O.fn[e] = function (i) {
                return O.access(this, function (e, i, o) {
                    var a = F(e);return o === t ? a ? n in a ? a[n] : O.support.boxModel && a.document.documentElement[i] || a.document.body[i] : e[i] : (a ? a.scrollTo(r ? O(a).scrollLeft() : o, r ? o : O(a).scrollTop()) : e[i] = o, t);
                }, e, i, arguments.length, null);
            };
        }), O.each({ Height: "height", Width: "width" }, function (e, n) {
            var r = "client" + e,
                i = "scroll" + e,
                o = "offset" + e;O.fn["inner" + e] = function () {
                var e = this[0];return e ? e.style ? parseFloat(O.css(e, n, "padding")) : this[n]() : null;
            }, O.fn["outer" + e] = function (e) {
                var t = this[0];return t ? t.style ? parseFloat(O.css(t, n, e ? "margin" : "border")) : this[n]() : null;
            }, O.fn[n] = function (e) {
                return O.access(this, function (e, n, a) {
                    var s, l, u, c;return O.isWindow(e) ? (s = e.document, l = s.documentElement[r], O.support.boxModel && l || s.body && s.body[r] || l) : 9 === e.nodeType ? (s = e.documentElement, s[r] < s[i] ? Math.max(e.body[i], s[i], e.body[o], s[o]) : s[r]) : a === t ? (u = O.css(e, n), c = parseFloat(u), O.isNumeric(c) ? c : u) : (O(e).css(n, a), t);
                }, n, e, arguments.length, null);
            };
        }), WDPRO.Analytics.wdwQuery = O;
    })(window);
    inject.store('jQuery', 'wdwQuery', '$', WDPRO.Analytics.wdwQuery);
    inject.store('extend', WDPRO.Analytics.wdwQuery.extend);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
            value: function value(predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            }
        });
    }

    /* global console, inject */
    /* eslint-disable no-console */
    inject(function (Analytics, store) {
        /* Enables/Disabled Debugging */
        Analytics.Debug = {
            isEnabled: false,
            setDebug: function setDebug(enableDbg) {
                'use strict';

                this.isEnabled = enableDbg;
                if (this.isEnabled) {
                    if (typeof console !== 'undefined') {
                        if (!console.debug) {
                            // IE Developer tools does not support console.debug
                            console.debug = function (name, value) {
                                console.warn('DEBUG: ' + name + '==' + value);
                            };
                        }

                        this.info('WDPRO Analytics Debug Enabled');
                    }
                } else {
                    this.isEnabled = false;
                }
            },
            warn: function warn() {
                if (typeof console !== 'undefined') {
                    if (console.warn && this.isEnabled === true) {
                        if (typeof console.warn === 'object') {
                            console.warn(Array.prototype.slice.call(arguments));
                        } else {
                            console.warn.apply(console, arguments);
                        }
                    }
                }
            },
            log: function log() {
                if (typeof console !== 'undefined') {
                    if (console.log && this.isEnabled === true) {
                        if (typeof console.log === 'object') {
                            console.log(Array.prototype.slice.call(arguments));
                        } else {
                            console.log.apply(console, arguments);
                        }
                    }
                }
            },
            debug: function debug() {
                if (typeof console !== 'undefined') {
                    if (console.debug && this.isEnabled === true) {
                        if (typeof console.debug === 'object') {
                            console.debug(Array.prototype.slice.call(arguments));
                        } else {
                            console.debug.apply(console, arguments);
                        }
                    }
                }
            },
            error: function error() {
                if (typeof console !== 'undefined') {
                    if (console.error && this.isEnabled === true) {
                        if (typeof console.error === 'object') {
                            console.error(Array.prototype.slice.call(arguments));
                        } else {
                            console.error.apply(console, arguments);
                        }
                    }
                }
            },
            info: function info() {
                if (typeof console !== 'undefined') {
                    if (console.info && this.isEnabled === true) {
                        if (typeof console.info === 'object') {
                            console.info(Array.prototype.slice.call(arguments));
                        } else {
                            console.info.apply(console, arguments);
                        }
                    }
                }
            }
        };
        store('Debug', Analytics.Debug);
    }, 'Analytics', 'store');

    /* global inject */
    inject.store('objForEach', function objForEach(obj, callback, thisArg) {
        var key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                callback.call(thisArg, obj[key], key, obj);
            }
        }
    });

    /* global inject */
    inject(function (store, objForEach) {
        store('storeMultiple', function storeMultiple(obj) {
            objForEach(obj, function (value, key) {
                return store(key, value);
            });
        });
    }, 'store', 'objForEach');

    /* global inject */
    inject.store('dateDaysFromNow', function (days) {
        return new Date(Date.now() + days * 86400000);
    });

    /* global inject */
    inject.store('safeJsonParse', function safeJsonParse(value) {
        try {
            value = JSON.parse(value);
        } catch (e) {/* ignore */}
        return value;
    });

    /* global inject */
    inject.store('isObject', function (obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    });

    /* global inject */
    inject.store('addPixel', function (src) {
        return document.body.appendChild(new Image(1, 1)).src = src;
    });

    /* global inject */
    inject.store('addScript', function (src) {
        return document.head.appendChild(document.createElement('script')).src = src;
    });

    /* global inject */
    inject.store('arrayGetUnique', function (array) {
        var valuesMap = {};
        var uniqueArray = [];
        for (var i = 0, l = array.length; i < l; i++) {
            if (valuesMap.hasOwnProperty(array[i])) continue;
            uniqueArray.push(array[i]);
            valuesMap[array[i]] = 1;
        }
        return uniqueArray;
    });

    /* global inject */
    inject(function (store, Debug) {
        store('arrayIndexOfFunc', function (arr, searchElement, fromIndex, compareFunc) {
            var k;
            compareFunc = compareFunc || function (value, compareValue) {
                return value === compareValue;
            };

            // 1. Let O be the result of calling ToObject passing
            //    the this value as the argument.
            if (arr == null) {
                Debug.error('"arr" is null or not defined');
                return -1;
            }

            var O = Object(arr);

            // 2. Let lenValue be the result of calling the Get
            //    internal method of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If len is 0, return -1.
            if (len === 0) {
                return -1;
            }

            // 5. If argument fromIndex was passed let n be
            //    ToInteger(fromIndex); else let n be 0.
            var n = +fromIndex || 0;

            if (Math.abs(n) === Infinity) {
                n = 0;
            }

            // 6. If n >= len, return -1.
            if (n >= len) {
                return -1;
            }

            // 7. If n >= 0, then Let k be n.
            // 8. Else, n<0, Let k be len - abs(n).
            //    If k is less than 0, then let k be 0.
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            // 9. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the
                //    HasProperty internal method of O with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                //    i.  Let elementK be the result of calling the Get
                //        internal method of O with the argument ToString(k).
                //   ii.  Let same be the result of applying the
                //        Strict Equality Comparison Algorithm to
                //        searchElement and elementK.
                //  iii.  If same is true, return k.
                if (k in O) {
                    if (compareFunc(O[k], searchElement)) {
                        return k;
                    }
                }
                k++;
            }
            return -1;
        });
    }, 'store', 'Debug');

    /* global inject */
    // Array Remove - By John Resig (MIT Licensed)
    // https://johnresig.com/blog/javascript-array-remove/
    inject.store('arrayRemove', function (array, from, to) {
        var rest = array.slice((to || from) + 1 || array.length);
        array.length = from < 0 ? array.length + from : from;
        return array.push.apply(array, rest);
    });

    /* global inject */
    inject.store('cleanArray', function cleanArray(arr) {
        /* don't update to use .filter - this mutates the array */
        if (Array.isArray(arr)) {
            for (var i = arr.length; i >= 0; i--) {
                if (arr[i] === null) {
                    arr.splice(i, 1);
                }
            }
        }
        return arr;
    });

    /* global inject */
    inject(function ($, store) {
        store('convertPromise', convertPromise);

        /**
         * Wraps non-jQuery promises as jQuery promises
         */
        function convertPromise(maybePromise) {
            if (maybePromise && typeof maybePromise.then === 'function' && !maybePromise.always) {
                var deferred = $.Deferred();
                maybePromise.then(deferred.resolve.bind(deferred), deferred.reject.bind(deferred));
                return deferred.promise();
            }
            return maybePromise;
        }
    }, '$', 'store');

    /* global inject */
    inject(function (storeMultiple, dateDaysFromNow, safeJsonParse) {
        storeMultiple({
            deleteCookie: deleteCookie,
            setCookie: setCookie,
            getCookie: getCookie
        });

        function deleteCookie(name) {
            setCookie(name, '', -1);
        }

        function setCookie(name, value, exdays) {
            var jsonEncode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var domain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
            var secure = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            document.cookie = name + '=' + encodeURIComponent(jsonEncode ? JSON.stringify(value) : value) + (exdays ? ';expires=' + dateDaysFromNow(exdays).toUTCString() : '');
            ';path=/' + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
        }

        function getCookie(sName) {
            var decodeJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var cookieValue,
                indicator = sName + '=',
                indicatorLength = indicator.length,
                cookie = document.cookie.split('; ').find(function (c) {
                return c.substr(0, indicatorLength) === indicator;
            });

            if (!cookie) return null;
            cookieValue = decodeURIComponent(cookie.substr(indicatorLength));
            return decodeJSON ? safeJsonParse(cookieValue) : cookieValue;
        }
    }, 'storeMultiple', 'dateDaysFromNow', 'safeJsonParse');

    /* global inject */
    inject.store('ensureArray', function ensureArray(val) {
        if (val === undefined) return [];
        return Array.isArray(val) ? val : [val];
    });

    /* global inject */
    inject(function (store, isObject) {
        store('ensureObject', function (val) {
            return val === undefined ? {} : isObject(val) ? val : { val: val };
        });
    }, 'store', 'isObject');

    /* global inject */
    inject.store('fnReturnValue', function (value) {
        return function () {
            return value;
        };
    });

    /* global inject */
    inject.store('getURLParameter', function (paramName) {
        if (!location.search) return null;

        var indicator = paramName + '=';
        var indicatorLength = indicator.length;
        var param = location.search.substr(1).split('&').find(function (c) {
            return c.substr(0, indicatorLength) === indicator;
        });

        return param ? decodeURIComponent(param.substr(indicatorLength)) : null;
    });

    /* global inject */
    inject.store('getURLProtocol', function (forceHttps) {
        var result = 'http://',
            protocol = location.protocol;

        if (forceHttps === true || forceHttps === 'true') {
            result = 'https://';
            //make sure this is an http protocol (for example in our tests the protocol is going to be 'file:')
        } else if (protocol.indexOf('http') !== -1) {
            result = protocol + '//';
        }
        return result;
    });
    /* global inject */
    /**
     * -- method getUTCTime(date) -> Number
     * - {Date} date: the date to convert to UTCTime.
     *
     * Returns the unix UTC timestamp for the given date.
     * The return value will disregard the seconds, by dividing
     * the time by 1000 (since JS also includes miliseconds) and
     * flooring the division).
     */
    inject.store('getUTCTime', function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        return Math.floor(date.getTime() / 1000);
    });

    /* global inject */
    inject(function (ref, store) {
        store('iniBoolean', function (value, defaultValue) {
            if (value === true || value === 1 || typeof value === 'string' && /^\s*(?:true|1|on|yes)\s*$/i.test(value)) return true;
            if (value === false || value === 0 || typeof value === 'string' && /^\s*(?:false|0|off|no)\s*$/i.test(value)) return false;
            return defaultValue;
        });
    }, 'ref', 'store');
    /* global inject */
    inject(function (store, resolve) {
        // converts 'MM/DD/YYYY' strings to ISO 'YYYY-MM-DD' strings
        // also allows for other types of inputs, date, ms, etc
        // see https://momentjs.com/docs/#/parsing/
        store('isoDate', function (dt) {
            var iso = resolve('moment').apply(null, typeof dt === 'string' ? [dt, 'MM/DD/YYYY'] : arguments);
            return iso && iso.isValid() ? iso.format('YYYY-MM-DD') : dt;
        });
    }, 'store', 'resolve');

    /* global inject */
    inject(function (storeMultiple) {
        storeMultiple({
            limit: limit,
            once: once
        });

        function limit(fn, maxCalls, resettable) {
            var calls = 0;
            if (resettable) proxy.reset = reset;
            return proxy;

            function proxy() {
                if (calls++ < maxCalls) {
                    return fn.apply(this, arguments);
                }
            }

            function reset() {
                calls = 0;
            }
        }

        function once(fn, resettable) {
            return limit(fn, 1, resettable);
        }
    }, 'storeMultiple');

    /* global inject */
    /*
    * mergeObjectsByKey
    * Because of how $.extend works we may need to loop through an array of objects and merge them if
    * a given property matches, otherwise if the orders or numbers in each array do not match the
    * data will be messed up
    */
    inject(function (store, $) {
        store('mergeObjectsByKey', function mergeObjectsByKey(key, targetArray, sourceArray, forcePush) {
            sourceArray.forEach(function (srcVal) {
                var found = false;
                if (srcVal[key]) {
                    targetArray.forEach(function (targetVal) {
                        if (targetVal[key] && srcVal[key] === targetVal[key] && found === false) {
                            $.extend(true, targetVal, srcVal);
                            found = true;
                        }
                    });
                    if (!found && forcePush) {
                        targetArray.push(srcVal);
                    }
                }
            });
        });
    }, 'store', '$');

    /* global inject */
    inject(function (store, ensureArray) {
        store('moveProp', function (srcObj, srcProp, targetObj) {
            var targetProp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : srcProp;
            var overwrite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            targetProp = ensureArray(targetProp);
            ensureArray(srcProp).forEach(function (sProp, i) {
                var tProp = targetProp[i] || sProp;
                if (srcObj.hasOwnProperty(sProp) && (overwrite || !targetObj.hasOwnProperty(tProp))) targetObj[tProp] = srcObj[sProp];
                delete srcObj[sProp];
            });
        });
    }, 'store', 'ensureArray');

    /*!
     * mustache.js - Logic-less {{mustache}} templates with JavaScript
     * http://github.com/janl/mustache.js
     */

    inject(function (Analytics, store, Mustache) {
        Analytics.Mustache = store('Mustache', Mustache);
    }, 'Analytics', 'store', function () {
        var exports = {};

        exports.name = "mustache.js";
        exports.version = "0.7.2";
        exports.tags = ["{{", "}}"];

        exports.Scanner = Scanner;
        exports.Context = Context;
        exports.Writer = Writer;

        var whiteRe = /\s*/;
        var spaceRe = /\s+/;
        var nonSpaceRe = /\S/;
        var eqRe = /\s*=/;
        var curlyRe = /\s*\}/;
        var tagRe = /#|\^|\/|>|\{|&|=|!/;

        // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
        // See https://github.com/janl/mustache.js/issues/189
        function testRe(re, string) {
            return RegExp.prototype.test.call(re, string);
        }

        function isWhitespace(string) {
            return !testRe(nonSpaceRe, string);
        }

        var isArray = Array.isArray || function (obj) {
            return Object.prototype.toString.call(obj) === "[object Array]";
        };

        function escapeRe(string) {
            return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        }

        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#x2F;'
        };

        function escapeHtml(string) {
            return String(string).replace(/[&<>"'\/]/g, function (s) {
                return entityMap[s];
            });
        }

        // Export the escaping function so that the user may override it.
        // See https://github.com/janl/mustache.js/issues/244
        exports.escape = escapeHtml;

        function Scanner(string) {
            this.string = string;
            this.tail = string;
            this.pos = 0;
        }

        /**
         * Returns `true` if the tail is empty (end of string).
         */
        Scanner.prototype.eos = function () {
            return this.tail === "";
        };

        /**
         * Tries to match the given regular expression at the current position.
         * Returns the matched text if it can match, the empty string otherwise.
         */
        Scanner.prototype.scan = function (re) {
            var match = this.tail.match(re);

            if (match && match.index === 0) {
                this.tail = this.tail.substring(match[0].length);
                this.pos += match[0].length;
                return match[0];
            }

            return "";
        };

        /**
         * Skips all text until the given regular expression can be matched. Returns
         * the skipped string, which is the entire tail if no match can be made.
         */
        Scanner.prototype.scanUntil = function (re) {
            var match,
                pos = this.tail.search(re);

            switch (pos) {
                case -1:
                    match = this.tail;
                    this.pos += this.tail.length;
                    this.tail = "";
                    break;
                case 0:
                    match = "";
                    break;
                default:
                    match = this.tail.substring(0, pos);
                    this.tail = this.tail.substring(pos);
                    this.pos += pos;
            }

            return match;
        };

        function Context(view, parent) {
            this.view = view;
            this.parent = parent;
            this.clearCache();
        }

        Context.make = function (view) {
            return view instanceof Context ? view : new Context(view);
        };

        Context.prototype.clearCache = function () {
            this._cache = {};
        };

        Context.prototype.push = function (view) {
            return new Context(view, this);
        };

        Context.prototype.lookup = function (name) {
            var value = this._cache[name];

            if (!value) {
                if (name === ".") {
                    value = this.view;
                } else {
                    var context = this;

                    while (context) {
                        if (name.indexOf(".") > 0) {
                            var names = name.split("."),
                                i = 0;

                            value = context.view;

                            while (value && i < names.length) {
                                value = value[names[i++]];
                            }
                        } else {
                            value = context.view[name];
                        }

                        if (value != null) {
                            break;
                        }

                        context = context.parent;
                    }
                }

                this._cache[name] = value;
            }

            if (typeof value === "function") {
                value = value.call(this.view);
            }

            return value;
        };

        function Writer() {
            this.clearCache();
        }

        Writer.prototype.clearCache = function () {
            this._cache = {};
            this._partialCache = {};
        };

        Writer.prototype.compile = function (template, tags) {
            var fn = this._cache[template];

            if (!fn) {
                var tokens = exports.parse(template, tags);
                fn = this._cache[template] = this.compileTokens(tokens, template);
            }

            return fn;
        };

        Writer.prototype.compilePartial = function (name, template, tags) {
            var fn = this.compile(template, tags);
            this._partialCache[name] = fn;
            return fn;
        };

        Writer.prototype.compileTokens = function (tokens, template) {
            var fn = compileTokens(tokens);
            var self = this;

            return function (view, partials) {
                if (partials) {
                    if (typeof partials === "function") {
                        self._loadPartial = partials;
                    } else {
                        for (var name in partials) {
                            self.compilePartial(name, partials[name]);
                        }
                    }
                }

                return fn(self, Context.make(view), template);
            };
        };

        Writer.prototype.render = function (template, view, partials) {
            return this.compile(template)(view, partials);
        };

        Writer.prototype._section = function (name, context, text, callback) {
            var value = context.lookup(name);

            switch (typeof value) {
                case "object":
                    if (isArray(value)) {
                        var buffer = "";

                        for (var i = 0, len = value.length; i < len; ++i) {
                            buffer += callback(this, context.push(value[i]));
                        }

                        return buffer;
                    }

                    return value ? callback(this, context.push(value)) : "";
                case "function":
                    var self = this;
                    var scopedRender = function scopedRender(template) {
                        return self.render(template, context);
                    };

                    var result = value.call(context.view, text, scopedRender);
                    return result != null ? result : "";
                default:
                    if (value) {
                        return callback(this, context);
                    }
            }

            return "";
        };

        Writer.prototype._inverted = function (name, context, callback) {
            var value = context.lookup(name);

            // Use JavaScript's definition of falsy. Include empty arrays.
            // See https://github.com/janl/mustache.js/issues/186
            if (!value || isArray(value) && value.length === 0) {
                return callback(this, context);
            }

            return "";
        };

        Writer.prototype._partial = function (name, context) {
            if (!(name in this._partialCache) && this._loadPartial) {
                this.compilePartial(name, this._loadPartial(name));
            }

            var fn = this._partialCache[name];

            return fn ? fn(context) : "";
        };

        Writer.prototype._name = function (name, context) {
            var value = context.lookup(name);

            if (typeof value === "function") {
                value = value.call(context.view);
            }

            return value == null ? "" : String(value);
        };

        Writer.prototype._escaped = function (name, context) {
            return exports.escape(this._name(name, context));
        };

        /**
         * Low-level function that compiles the given `tokens` into a function
         * that accepts three arguments: a Writer, a Context, and the template.
         */
        function compileTokens(tokens) {
            var subRenders = {};

            function subRender(i, tokens, template) {
                if (!subRenders[i]) {
                    var fn = compileTokens(tokens);
                    subRenders[i] = function (writer, context) {
                        return fn(writer, context, template);
                    };
                }

                return subRenders[i];
            }

            return function (writer, context, template) {
                var buffer = "";
                var token, sectionText;

                for (var i = 0, len = tokens.length; i < len; ++i) {
                    token = tokens[i];

                    switch (token[0]) {
                        case "#":
                            sectionText = template.slice(token[3], token[5]);
                            buffer += writer._section(token[1], context, sectionText, subRender(i, token[4], template));
                            break;
                        case "^":
                            buffer += writer._inverted(token[1], context, subRender(i, token[4], template));
                            break;
                        case ">":
                            buffer += writer._partial(token[1], context);
                            break;
                        case "&":
                            buffer += writer._name(token[1], context);
                            break;
                        case "name":
                            buffer += writer._escaped(token[1], context);
                            break;
                        case "text":
                            buffer += token[1];
                            break;
                    }
                }

                return buffer;
            };
        }

        /**
         * Forms the given array of `tokens` into a nested tree structure where
         * tokens that represent a section have two additional items: 1) an array of
         * all tokens that appear in that section and 2) the index in the original
         * template that represents the end of that section.
         */
        function nestTokens(tokens) {
            var tree = [];
            var collector = tree;
            var sections = [];

            var token;
            for (var i = 0, len = tokens.length; i < len; ++i) {
                token = tokens[i];
                switch (token[0]) {
                    case '#':
                    case '^':
                        sections.push(token);
                        collector.push(token);
                        collector = token[4] = [];
                        break;
                    case '/':
                        var section = sections.pop();
                        section[5] = token[2];
                        collector = sections.length > 0 ? sections[sections.length - 1][4] : tree;
                        break;
                    default:
                        collector.push(token);
                }
            }

            return tree;
        }

        /**
         * Combines the values of consecutive text tokens in the given `tokens` array
         * to a single token.
         */
        function squashTokens(tokens) {
            var squashedTokens = [];

            var token, lastToken;
            for (var i = 0, len = tokens.length; i < len; ++i) {
                token = tokens[i];
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    lastToken = token;
                    squashedTokens.push(token);
                }
            }

            return squashedTokens;
        }

        function escapeTags(tags) {
            return [new RegExp(escapeRe(tags[0]) + "\\s*"), new RegExp("\\s*" + escapeRe(tags[1]))];
        }

        /**
         * Breaks up the given `template` string into a tree of token objects. If
         * `tags` is given here it must be an array with two string values: the
         * opening and closing tags used in the template (e.g. ["<%", "%>"]). Of
         * course, the default is to use mustaches (i.e. Mustache.tags).
         */
        exports.parse = function (template, tags) {
            template = template || '';
            tags = tags || exports.tags;

            if (typeof tags === 'string') tags = tags.split(spaceRe);
            if (tags.length !== 2) {
                throw new Error('Invalid tags: ' + tags.join(', '));
            }

            var tagRes = escapeTags(tags);
            var scanner = new Scanner(template);

            var sections = []; // Stack to hold section tokens
            var tokens = []; // Buffer to hold the tokens
            var spaces = []; // Indices of whitespace tokens on the current line
            var hasTag = false; // Is there a {{tag}} on the current line?
            var nonSpace = false; // Is there a non-space char on the current line?

            // Strips all whitespace tokens array for the current line
            // if there was a {{#tag}} on it and otherwise only space.
            function stripSpace() {
                if (hasTag && !nonSpace) {
                    while (spaces.length) {
                        tokens.splice(spaces.pop(), 1);
                    }
                } else {
                    spaces = [];
                }

                hasTag = false;
                nonSpace = false;
            }

            var start, type, value, chr;
            while (!scanner.eos()) {
                start = scanner.pos;
                value = scanner.scanUntil(tagRes[0]);

                if (value) {
                    for (var i = 0, len = value.length; i < len; ++i) {
                        chr = value.charAt(i);

                        if (isWhitespace(chr)) {
                            spaces.push(tokens.length);
                        } else {
                            nonSpace = true;
                        }

                        tokens.push(["text", chr, start, start + 1]);
                        start += 1;

                        if (chr === "\n") {
                            stripSpace(); // Check for whitespace on the current line.
                        }
                    }
                }

                start = scanner.pos;

                // Match the opening tag.
                if (!scanner.scan(tagRes[0])) {
                    break;
                }

                hasTag = true;
                type = scanner.scan(tagRe) || "name";

                // Skip any whitespace between tag and value.
                scanner.scan(whiteRe);

                // Extract the tag value.
                if (type === "=") {
                    value = scanner.scanUntil(eqRe);
                    scanner.scan(eqRe);
                    scanner.scanUntil(tagRes[1]);
                } else if (type === "{") {
                    var closeRe = new RegExp("\\s*" + escapeRe("}" + tags[1]));
                    value = scanner.scanUntil(closeRe);
                    scanner.scan(curlyRe);
                    scanner.scanUntil(tagRes[1]);
                    type = "&";
                } else {
                    value = scanner.scanUntil(tagRes[1]);
                }

                // Match the closing tag.
                if (!scanner.scan(tagRes[1])) {
                    throw new Error('Unclosed tag at ' + scanner.pos);
                }

                // Check section nesting.
                if (type === '/') {
                    if (sections.length === 0) {
                        throw new Error('Unopened section "' + value + '" at ' + start);
                    }

                    var section = sections.pop();

                    if (section[1] !== value) {
                        throw new Error('Unclosed section "' + section[1] + '" at ' + start);
                    }
                }

                var token = [type, value, start, scanner.pos];
                tokens.push(token);

                if (type === '#' || type === '^') {
                    sections.push(token);
                } else if (type === "name" || type === "{" || type === "&") {
                    nonSpace = true;
                } else if (type === "=") {
                    // Set the tags for the next time around.
                    tags = value.split(spaceRe);

                    if (tags.length !== 2) {
                        throw new Error('Invalid tags at ' + start + ': ' + tags.join(', '));
                    }

                    tagRes = escapeTags(tags);
                }
            }

            // Make sure there are no open sections when we're done.
            var section = sections.pop();
            if (section) {
                throw new Error('Unclosed section "' + section[1] + '" at ' + scanner.pos);
            }

            return nestTokens(squashTokens(tokens));
        };

        // The high-level clearCache, compile, compilePartial, and render functions
        // use this default writer.
        var _writer = new Writer();

        /**
         * Clears all cached templates and partials in the default writer.
         */
        exports.clearCache = function () {
            return _writer.clearCache();
        };

        /**
         * Compiles the given `template` to a reusable function using the default
         * writer.
         */
        exports.compile = function (template, tags) {
            return _writer.compile(template, tags);
        };

        /**
         * Compiles the partial with the given `name` and `template` to a reusable
         * function using the default writer.
         */
        exports.compilePartial = function (name, template, tags) {
            return _writer.compilePartial(name, template, tags);
        };

        /**
         * Compiles the given array of tokens (the output of a parse) to a reusable
         * function using the default writer.
         */
        exports.compileTokens = function (tokens, template) {
            return _writer.compileTokens(tokens, template);
        };

        /**
         * Renders the `template` with the given `view` and `partials` using the
         * default writer.
         */
        exports.render = function (template, view, partials) {
            return _writer.render(template, view, partials);
        };

        // This is here for backwards compatibility with 0.4.x.
        exports.to_html = function (template, view, partials, send) {
            var result = exports.render(template, view, partials);

            if (typeof send === "function") {
                send(result);
            } else {
                return result;
            }
        };

        return exports;
    }());
    /* global inject */
    /**
     * pollForElement - polls every X millisecond (default 200) for a given element(s)
     * @param string selector
     * @param function callback
     * @param int maxTries
     * @param int tryNum
     */
    inject.store('pollForElement', function pollForElement(selector, callback) {
        var maxTries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var tryNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

        var elm = document.querySelectorAll(selector);
        if (elm.length > 0) {
            callback(elm);
        } else if (tryNum <= maxTries || maxTries === 0) {
            setTimeout(pollForElement.bind(null, selector, callback, maxTries, ++tryNum), 200);
        }
    });

    /* global inject */
    inject(function (store) {
        store('removeArrayDuplicates', function removeDuplicates(val) {
            if (!Array.isArray(val)) return val;
            return val.filter(unique);
        });

        function unique(value, index, arr) {
            return arr.indexOf(value) === index;
        }
    }, 'store');

    /* global inject */

    inject.store('set', function set(obj, path, value) {
        var tokens = path.split('.'),
            j = tokens.length - 1,
            i = 0,
            key;

        for (; key = tokens[i], i < j; i++) {
            obj = obj[key] = obj[key] || {};
        }

        return obj[key] = value;
    });

    /* global inject */
    inject.store('sha1', function () {
        function rotl(n, s) {
            return n << s | n >>> 32 - s;
        }

        function tohex(i) {
            for (var h = "", s = 28;; s -= 4) {
                h += (i >>> s & 0xf).toString(16);
                if (!s) return h;
            }
        }

        return function sha1(msg) {
            var H0 = 0x67452301,
                H1 = 0xEFCDAB89,
                H2 = 0x98BADCFE,
                H3 = 0x10325476,
                H4 = 0xC3D2E1F0,
                M = 0x0ffffffff;
            var i,
                t,
                W = new Array(80),
                ml = msg.length,
                wa = new Array();
            msg += String.fromCharCode(0x80);
            while (msg.length % 4) {
                msg += String.fromCharCode(0);
            }for (i = 0; i < msg.length; i += 4) {
                wa.push(msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 | msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3));
            }while (wa.length % 16 != 14) {
                wa.push(0);
            }wa.push(ml >>> 29), wa.push(ml << 3 & M);
            for (var bo = 0; bo < wa.length; bo += 16) {
                for (i = 0; i < 16; i++) {
                    W[i] = wa[bo + i];
                }for (i = 16; i <= 79; i++) {
                    W[i] = rotl(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
                }var A = H0,
                    B = H1,
                    C = H2,
                    D = H3,
                    E = H4;
                for (i = 0; i <= 19; i++) {
                    t = rotl(A, 5) + (B & C | ~B & D) + E + W[i] + 0x5A827999 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
                }for (i = 20; i <= 39; i++) {
                    t = rotl(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
                }for (i = 40; i <= 59; i++) {
                    t = rotl(A, 5) + (B & C | B & D | C & D) + E + W[i] + 0x8F1BBCDC & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
                }for (i = 60; i <= 79; i++) {
                    t = rotl(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6 & M, E = D, D = C, C = rotl(B, 30), B = A, A = t;
                }H0 = H0 + A & M;
                H1 = H1 + B & M;
                H2 = H2 + C & M;
                H3 = H3 + D & M;
                H4 = H4 + E & M;
            }
            return tohex(H0) + tohex(H1) + tohex(H2) + tohex(H3) + tohex(H4);
        };
    }());
    /* global inject */
    inject(function (storeMultiple, safeJsonParse, dateDaysFromNow, getCookie, deleteCookie, setCookie) {
        storeMultiple({
            sessionStorage: sessionStorageWithCookieFallback('aSess_'),
            localStorage: localStorageWithCookieFallback('aLocs_')
        });

        function validateStorage(storageKey) {
            var storage;
            var key = '__' + Math.random();

            try {
                storage = window[storageKey];
                storage.setItem(key, key);
                storage.removeItem(key);
            } catch (e) {
                storage = undefined;
            }

            return storage;
        }

        function sessionStorageWithCookieFallback(fallbackCookiePrefix) {
            var storage = validateStorage('sessionStorage');
            return storage ? {
                getItem: function getItem(key) {
                    return safeJsonParse(storage.getItem(key));
                },
                removeItem: storage.removeItem.bind(storage),
                setItem: function setItem(key, value) {
                    storage.setItem(key, JSON.stringify(value));
                }
            } : cookieSessionInterface(fallbackCookiePrefix);
        }

        function localStorageWithCookieFallback(fallbackCookiePrefix) {
            var storage = validateStorage('localStorage');
            return storage ? {
                getItem: function getItem(key) {
                    var result = safeJsonParse(storage.getItem(key));
                    if (result) {
                        if (result.expires > Date.now()) {
                            return result.value;
                        } else {
                            this.removeItem(key);
                        }
                    }
                    return null;
                },
                removeItem: storage.removeItem.bind(storage),
                setItem: function setItem(key, value) {
                    var expiresDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;

                    storage.setItem(key, JSON.stringify({ value: value, expires: dateDaysFromNow(expiresDays).getTime() }));
                }
            } : cookieLocalInterface(fallbackCookiePrefix);
        }

        function cookieSessionInterface(fallbackCookiePrefix) {
            return {
                getItem: function getItem(key) {
                    return safeJsonParse(getCookie(fallbackCookiePrefix + key));
                },
                removeItem: function removeItem(key) {
                    deleteCookie(fallbackCookiePrefix + key);
                },
                setItem: function setItem(key, value) {
                    setCookie(fallbackCookiePrefix + key, JSON.stringify(value));
                }
            };
        }

        function cookieLocalInterface(fallbackCookiePrefix) {
            return {
                getItem: function getItem(key) {
                    return safeJsonParse(getCookie(fallbackCookiePrefix + key));
                },
                removeItem: function removeItem(key) {
                    deleteCookie(fallbackCookiePrefix + key);
                },
                setItem: function setItem(key, value) {
                    var expiresDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;

                    setCookie(fallbackCookiePrefix + key, JSON.stringify(value), expiresDays);
                }
            };
        }
    }, 'storeMultiple', 'safeJsonParse', 'dateDaysFromNow', 'getCookie', 'deleteCookie', 'setCookie');

    /* global inject */
    inject(function (Analytics, extend, store, resolve) {
        var Utils = Analytics.Utils = store('Utils', Analytics.Utils || {});
        extend(Utils, {
            sessionStorage: resolve('sessionStorage'),
            Array: {
                indexOfFunc: resolve('arrayIndexOfFunc'),
                indexOf: function indexOf(arr, elt, from) {
                    return arr.indexOf(elt, from);
                },
                getUnique: resolve('arrayGetUnique'),
                remove: resolve('arrayRemove'),
                forEach: function forEach(arr, callback, thisArg) {
                    return arr.forEach(callback, thisArg);
                },
                map: function map(arr, callback, thisArg) {
                    return arr.map(callback, thisArg);
                }
            },
            deleteCookie: resolve('deleteCookie'),
            setCookie: resolve('setCookie'),
            getCookie: resolve('getCookie'),
            getURLParameter: resolve('getURLParameter'),
            getUTCTime: resolve('getUTCTime'),
            getRandomInt: function getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            },
            getURLProtocol: resolve('getURLProtocol'),
            convertStringToDate: function convertStringToDate(strDate) {
                return Analytics.moment(strDate).toDate();
            },
            Page: {
                getWidth: function getWidth() {
                    return window.innerWidth || document.documentElement.clientWidth || null;
                }
            },
            pollForElement: resolve('pollForElement')
        });
    }, 'Analytics', 'extend', 'store', 'resolve');

    /* global inject */
    inject(function (Analytics, $, Debug) {
        var handlers = Analytics.Handlers = Analytics.Handlers || [];

        handlers.push = bindHandler;
        bindHandler.apply(null, handlers);

        $(document).trigger('jQueryReady.framework', [$]);

        function bindHandler() {
            Array.prototype.slice.call(arguments).forEach(function (o) {
                $(o.element || document).on(o.events, o.selector, o.data, o.handler);
                Debug.debug('WDPRO.Analytics.Handlers - bound handler', o);
            });
        }
    }, 'Analytics', 'jQuery', 'Debug');

    /*! analytics - v5.3.13-0 - 2017-07-25 */
    (function () {
        /* global s_wdpro */

        /* SiteCatalyst code version: H.27.5.
        Copyright 1996-2015 Adobe, Inc. All Rights Reserved
        More info available at http://www.omniture.com */

        /************************ ADDITIONAL FEATURES ************************
            Adobe Plugins
                manageQueryParam v1.2
                Form Analysis v2.1
                getPercentPageViewed v1.4
                TNT Integration v1.0
                Channel Manager
                getQueryParam v2.3
                getQueryParamNoEncode v2.3
                channelExtract  v1.1
                clickPast v1.0
                manageQueryParam v1.2
                crossVisitParticipation v1.7
                getLinkParams v1.3g
                Media
        
            Adobe Utility Functions
            * = modified by WDPRO
                setLinkId v1.1 *
                getLinkId v1.1 *
                getinnerHTML v1.0
                Replace v1.0
                apl v1.1
                split v1.5
                join v1.0
        
            WDPRO Plugins
                modifyAccountFromURL
                parseAnyQueryString
                setSiteCatalystAccountVar
                addLinkInternalFilter
                Tracking for Marin
                External Campaign Tracking
                Campaign Stacking
                getsiteLoadTime
                tracking for marin
                determineProp9
                trackClick
                trackLink
                trackPage
                trackVideo
        */

        /*********************
         * parseAnyQueryString()
         * @Original Author electrum press http://feather.elektrum.org/book/src.html
         * @Author Matt Alexander (changed variable names to avoid name collisions)
         * @LastModified 11/16/09
         *
         * @Description - Parses any query string into a hashmap of values indexed by var name.
         * @param {String} strQuery The entire query string to parse, except for the ? or # identifier.
        */
        function parseAnyQueryString(strQuery) {
            var objParams = new Object();
            if (!strQuery) {
                return objParams;
            }
            var objPairs = strQuery.split(/[;&]/); // split key value pairs at ; or &
            for (var i = 0; i < objPairs.length; i++) {
                var objKeyVal = objPairs[i].split('=');
                if (!objKeyVal || objKeyVal.length != 2) {
                    continue;
                }
                var strKey = unescape(objKeyVal[0]);
                var strValue = unescape(objKeyVal[1]);
                strValue = strValue.replace(/\+/g, ' '); // replace + with space
                objParams[strKey] = strValue;
            }
            return objParams;
        }

        /********** WDPRO Report Suite ID Plugin **********
        WDPRO Plugin: Pass report suite into script src
        */
        (function () {
            // Get all script tags in DOM so far.
            var objScripts = document.getElementsByTagName('script');
            // Get query string from src of the most recently executed script tag (this file).
            // This file is currently being executed and no other script will download until this one is done. So, it is definately the last one in the collection.
            var strQueryString = objScripts[objScripts.length - 1].src.replace(/^[^\?]+\??/, '');
            // Parse query string into a hashmap.
            var objQSParams = parseAnyQueryString(strQueryString);

            // s_account could be set in a script block prior to calling this s_code.js file.
            // The report suite IDs passed into script via the query string trumps all.
            // s_account will usually be a comma-separated list: "wdgwdprowdw,wdgwdprosec,wdgdsec".
            if (!!objQSParams['rsid']) {
                // using window.s_account to reference the global var.
                window.s_account = objQSParams['rsid'];
            }
        })();
        /********** End WDPRO Report Suite ID Plugin **********/

        function isHKDLRSId(rsId) {
            if (rsId.indexOf('wdprohkdl') > -1) {
                return true;
            }
            return false;
        }
        /**************************
         * modifyAccountFromURL
         * @Description - Looks at the current URL and sets s_account based on the URL, this is particularly helpful with
         *     soft launch and load testing URLS so that we do not send data to the production report suites
         * @param host
         * @param s_account
         */
        function modifyAccountFromURL(host, s_account) {
            if (typeof s_account !== 'undefined') {
                var parts,
                    newAccounts = [],
                    retVal,
                    forceDevPattern;
                /*
                 * Matches the following domains
                 * disneyworld-qa02-2.disney.go.com, disneycruise-qa01-1.disney.go.com,
                 * disneyworld-dev1.disney.go.com, disneyworld-lt.disney.go.com,
                 * wdw-latest.disney.go.com, wdw-stage.disney.go.com,
                 * pep-demo1.nge.go.com, wdprolt01.disney.go.com,
                 * disneyvacations-dev.com, dpchina-dev.com
                 */
                forceDevPattern = /(([\-]{1}(qa|dev|local|sl|lt|latest|stage|demo)[a-z0-9\-]*|wdprolt[0-9]+).(disney|nge){1}.go.com|disneyvacations-dev.com|dpchina-dev.com)(:[0-9]+)*/i;
                if (forceDevPattern.test(host) === true) {
                    if (!!s_account) {
                        if (isHKDLRSId(s_account)) {
                            s_account += ',wdgwdprohkdlroll';
                        }
                        parts = s_account.split(',');
                        for (var i = 0; i < parts.length; i++) {
                            newAccounts.push(parts[i] + 'dev');
                        }
                        retVal = newAccounts.join(',') + ',wdgwdprosecdev';
                    } else {
                        retVal = '';
                    }
                } else {
                    retVal = s_account + ",wdgwdprosec,wdgdsec";
                }
                return retVal;
            }
        }

        /**************************
         * setSiteCatalystAccountVars
         * @Description - appends additional report suite ids based on initial value of s_account
         * @param s_account
         * @param s_appendIds
         */

        function setSiteCatalystAccountVar(s_account, s_appendIds) {
            if (s_account && typeof s_account != "undefined" && s_account != "" && s_account.indexOf(",") == -1 && s_appendIds === true) {
                var host = window.location.host;
                if (s_account.substring(s_account.length - 3, s_account.length).indexOf("dev") > -1) {
                    if (isHKDLRSId(s_account)) {
                        s_account += ',wdgwdprohkdlrolldev';
                    }
                    s_account = s_account + ",wdgwdprosecdev";
                } else {
                    s_account = modifyAccountFromURL(host, s_account);
                }
            }
            if (s_account === undefined) {
                s_account = "";
            }
            if (!s_wdpro) {
                s_wdpro = s_gi(s_account);
            } else {
                s_wdpro.un = s_account;
            }
            s_wdpro.prop44 = s_account;
            window.s_account = s_account;
        }
        s_wdpro = undefined;

        if (typeof window.s_appendIds === 'undefined') {
            window.s_appendIds = true;
        }

        if (typeof _satellite !== 'undefined') {
            if (!window.s_account) {
                window.s_account = _satellite.getVar('configuration.SiteCatalyst.reportSuiteId');
            }
        }

        setSiteCatalystAccountVar(window.s_account, window.s_appendIds);

        /*Config utilities*/

        /*******
         * getParentLinkId
         * @Description - keep moving up the document until it finds a parent node with the analyticsLinkId attribute set
         */
        s_wdpro.getParentLinkId = function (elem) {
            var linkId;
            if (elem.attributes && elem.attributes.analyticsLinkId && (linkId = elem.attributes.analyticsLinkId.value)) {
                return linkId;
            } else if (elem.parentNode && elem.parentNode !== elem) {
                return s_wdpro.getParentLinkId(elem.parentNode);
            }
        };

        /**************************
         * addLinkInternalFilter
         * @Description - ensures our defaults are always there and prevents bad or
         *     duplicated values from being added to linkInternalFilters property
         * @param domain
         */

        s_wdpro.addLinkInternalFilter = function (domain) {
            var domains = "#,javascript:,disney.go.com,nge.go.com",
                p = /([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}/g,
                m = null;

            if (!!domain && typeof domain === 'string') {
                m = domain.match(p);
                //compare domain to list before adding
                if (m !== null && domain.indexOf('file://') === -1 && domains.indexOf(m[0]) === -1) {
                    domains += ',' + m[0];
                }
            }
            return s_wdpro.linkInternalFilters = domains;
        };

        /************************** CONFIG SECTION **************************/

        /* VisitorAPI Integration */
        s_wdpro.visitor = Visitor.getInstance(AdobeMarketingCloudId);

        /* You may add or alter any code config here. */
        s_wdpro.charSet = "UTF-8";

        // defaults to "2" for backward compatibility (go.com) if not specified.
        if (!s_wdpro.cookieDomainPeriods) {
            s_wdpro.cookieDomainPeriods = "2";
        }

        /* Conversion Config */
        s_wdpro.currencyCode = "USD";
        /* Link Tracking Config */
        s_wdpro.blnAutomateProp9 = true;
        s_wdpro.trackDownloadLinks = true;
        s_wdpro.trackExternalLinks = true;
        s_wdpro.trackInlineStats = true;
        s_wdpro.linkDownloadFileTypes = "exe,zip,wav,mp3,mov,mpg,avi,wmv,doc,pdf,xls";
        s_wdpro.addLinkInternalFilter(window.location.host);
        s_wdpro.linkLeaveQueryString = true;
        s_wdpro.linkTrackVars = ['server', 'prop1', 'prop2', 'prop4', 'prop9', 'prop11', 'prop12', 'prop13', 'prop14', 'prop20', 'prop29', 'prop52', 'eVar10', 'prop43', 'prop44', 'eVar4', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
        s_wdpro.linkTrackEvents = "None";
        /* Set media prop variable */
        if (s_wdpro.eVar2) {
            s_wdpro.prop3 = s_wdpro.eVar2;
        }

        /* Form Analysis Config (should be above doPlugins section) */
        s_wdpro.formList = ""; // Comma-separated list. Set this in the HTML configuration block.
        s_wdpro.trackFormList = true; // If trackFormList=true, forms in formList are tracked. If false, formList lists forms NOT to track.
        s_wdpro.trackPageName = true;
        s_wdpro.useCommerce = false;
        s_wdpro.varUsed = "prop28"; // When useCommerce=true, set to an eVar. Otherwise set to a prop.
        s_wdpro.eventList = ""; //Abandon,Success,Error - only used when useCommerce=true

        s_wdpro.channelSep = '/';

        s_wdpro.exec = 0; //toggle for page view vs custom link
        /* Plugin Config */
        s_wdpro.usePlugins = true;

        /*clean link id function*/
        s_wdpro.cleanLinkId = function (linkId) {
            if (linkId && linkId.replace) {
                //remove html characters, special chars
                linkId = linkId.replace(/<\/?[^>]+(>|$)/g, '').replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ').replace(/[^a-z0-9\-\+\_\&\s]/ig, '').substring(0, 99);
            }
            return linkId;
        };

        /************************** Do Plugins **************************/
        function s_wdpro_doPlugins(s_wdpro) {
            /* read referrer from cookie*/
            var tmpRef = s_wdpro.c_r('HBXREF');
            if (tmpRef && tmpRef.length > 0) {
                s_wdpro.referrer = tmpRef;
                s_wdpro.c_w('HBXREF', '', 0);
            }

            /***** Clicktale Integration *****/
            function clickTaleGetUID_PID() {
                if (document.cookie.indexOf("WRUID") > -1 && document.cookie.indexOf("WRIgnore=true") == -1) {
                    var ca = document.cookie.split(';');
                    var PID = 0,
                        UID = 0;
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1, c.length);
                        }
                        if (c.indexOf("CT_Data") > -1) {
                            PID = c.substring(c.indexOf("apv_")).split("_")[1];
                        }
                        if ((document.cookie.match(/WRUID/g) || []).length == 1 && c.indexOf("WRUID") > -1 || c.indexOf("WRUID") > -1 && (document.cookie.match(/WRUID/g) || []).length > 1 && c.indexOf("WRUID=") == -1) {
                            UID = c.split("=")[1];
                        }
                    }
                    return UID == 0 || PID == 0 ? null : UID + "." + PID;
                } else {
                    return null;
                }
            }
            var clickTaleValues = clickTaleGetUID_PID();
            if (clickTaleValues != null) {
                s_wdpro.eVar75 = clickTaleValues;
            }

            /***** Add calls to plugins here *****/

            /* Tracking for Marin */
            if (!s_wdpro.eVar54) s_wdpro.eVar54 = s_wdpro.getQueryParam('keyword_id');

            /* Pull in Test&Target mBox details */
            s_wdpro.tnt = s_wdpro.trackTNT();

            /* External Campaign Tracking */
            if (!s_wdpro.campaign) s_wdpro.campaign = unescape(s_wdpro.getValOnce(s_wdpro.getQueryParam('CMP'), 's_v12', 0));
            if (!s_wdpro.campaign) s_wdpro.campaign = unescape(s_wdpro.getValOnce(s_wdpro.getQueryParam('ecid'), 's_v12', 0));

            /* manageQueryParam v1.2 */
            s_wdpro.pageURL = s_wdpro.manageQueryParam('s_kwcid', 1, 1);

            if (!s_wdpro.prop2) s_wdpro.prop2 = "D=SWID"; //dynamically pull SWID from header
            if (!s_wdpro.prop19) s_wdpro.prop19 = "not set"; // used for contentDisplayed
            s_wdpro.events = s_wdpro.apl(s_wdpro.events, 'event3', ',', 1); //set page view event

            /* Form Analysis */
            s_wdpro.setupFormAnalysis();

            /* getPercentPageViewed */
            s_wdpro.prop43 = s_wdpro.getPercentPageViewed();

            /* Set Search Vars */
            if (s_wdpro.prop7) {
                /* Lowercase variables */
                s_wdpro.prop7 = s_wdpro.prop7.toLowerCase(); // internalSearchKeywords
                /* if no results, modify search query for pathing purposes */
                if ((s_wdpro.prop8 == "0" || s_wdpro.prop8 == "zero" || s_wdpro.prop8 == "null" || !s_wdpro.prop8) && s_wdpro.prop7.indexOf('null:') === -1) {
                    s_wdpro.prop8 = "0"; // internalSearchNumResults
                    s_wdpro.prop7 = "null:" + s_wdpro.prop7; // internalSearchKeywords
                }
                s_wdpro.eVar4 = "D=c7"; // internalSearchKeywords

                /* Set de-duped onsite search event */
                var t_search = s_wdpro.getValOnce(s_wdpro.eVar4, 's_v4', 0);
                if (t_search) s_wdpro.events = s_wdpro.apl(s_wdpro.events, 'event2', ',', 1); // event2 is for internalSearch
            }

            /*
             * First Check to see if this is firing because of a link click
             *   this check makes sure that the object that has been clicked on is a link because
             *   anchor objects are the only thing that support inline linkId's
             *
             */

            s_wdpro.lid = null;
            if (!!this.eo || !!this.lnk) {
                var lnkObj = this.eo ? this.eo : this.lnk;
                //if analyticslinkid attribute is set use that as the linkId
                try {
                    if (typeof lnkObj.getAttribute == 'function') {
                        s_wdpro.lid = lnkObj.getAttribute('analyticsLinkId');
                    }
                    if (!s_wdpro.lid) {
                        s_wdpro.lid = s_wdpro.getParentLinkId(lnkObj);
                    }
                } catch (e) {}

                // If name attribute is not set but the id attribute is then we should be using that
                if (!s_wdpro.lid && !lnkObj.name && !!lnkObj.id) {
                    s_wdpro.lid = lnkObj.id;
                }
            }

            if (!s_wdpro.eVar3) s_wdpro.eVar3 = s_wdpro.getQueryParam('int_cmp,addata', ':'); //Internal Campaign Tracking
            s_wdpro.eVar3 = s_wdpro.getValOnce(s_wdpro.eVar3, 's_v3', 0); //de-duplicate consecutive instances of tracking code

            /* Dynamically populate link ids for link tracking; also captures click data for internal promotions*/
            s_wdpro.linkidT = s_wdpro.setLinkId('lpos,lid', 'addata', 'goto', '|', '+', '3', 's_wdpro_lid', '1', s_wdpro.pageName, '^', s_wdpro.lid) || '';

            s_wdpro.gpv_pageName = s_wdpro.getPreviousValue(s_wdpro.pageName, 's_gpv_pn', ''); //backup method for setting previous value of pagename

            s_wdpro.linkidX = s_wdpro.linkidT.indexOf('^');

            // Per John Hodson, prop12 should be populated on EVERY sitecatalyst call
            s_wdpro.prop12 = s_wdpro.linkidX > -1 ? s_wdpro.linkidT.substring(s_wdpro.linkidX + 1) : s_wdpro.gpv_pageName;
            s_wdpro.linkidT = s_wdpro.linkidX > -1 ? s_wdpro.linkidT.substring(0, s_wdpro.linkidX) : s_wdpro.linkidT;
            s_wdpro.tmpprop9 = s_wdpro.linkidT;

            s_wdpro.linkidI = s_wdpro.tmpprop9.indexOf('+');
            s_wdpro.linkidLpos = s_wdpro.linkidI > 0 ? s_wdpro.tmpprop9.substring(0, s_wdpro.linkidI) : s_wdpro.tmpprop9; //populate with lpos if value found

            if (s_wdpro.tmpprop9 || s_wdpro.linkidI) {
                if (s_wdpro.blnAutomateProp9) s_wdpro.prop9 = s_wdpro.linkidI > 0 ? s_wdpro.tmpprop9.substring(s_wdpro.linkidI + 1) : s_wdpro.tmpprop9; //populate with lid if value found
            }
            //clean up on link id including removing path for images and html tags from links
            if (window.s_wdpro.linkidLpos && s_wdpro.linkidLpos == "atxt") {
                if (typeof window.s_wdpro.prop9 === 'string') {
                    s_wdpro.prop9 = s_wdpro.prop9.lastIndexOf('/') > 0 ? s_wdpro.prop9.substring(s_wdpro.prop9.lastIndexOf('/') + 1) : s_wdpro.prop9;
                }
            }

            // If prop9 is not set but anchor element has a linkID set we should use it.
            if (!!lnkObj && lnkObj.tagName == 'A' && !!lnkObj.name) {
                var lnkIdx = lnkObj.name.indexOf('&lid=');
                if (lnkIdx > -1 && s_wdpro.prop9 == '') {
                    s_wdpro.prop9 = lnkObj.name.substring(lnkIdx + 5);
                }
            }

            // If discid parameter is present in URL that that is what should be used for the linkId
            if (s_wdpro.getQueryParam('discid') !== '') {
                s_wdpro.prop9 = s_wdpro.getQueryParam('discid');
            }

            if (s_wdpro.eVar3) {
                if (s_wdpro.exec < 1) s_wdpro.products = s_wdpro.apl(s_wdpro.products, "ads;" + s_wdpro.eVar3 + ";;;event7=1", ',', 2); //don't overwrite product string on page load
                else s_wdpro.products = "ads;" + s_wdpro.eVar3 + ";;;event7=1"; //overwrite product string on all other executions to prevent old values from being included
                s_wdpro.linkTrackVars = ['server', 'prop1', 'prop2', 'prop4', 'prop9', 'prop11', 'prop12', 'prop13', 'prop14', 'prop20', 'prop29', 'prop52', 'products', 'eVar3', 'eVar10', 'eVar4', 'events', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
                s_wdpro.linkTrackEvents = "event7";
                s_wdpro.events = s_wdpro.apl(s_wdpro.events, "event7", ",", 2);
            }

            /* Set Internal Campaign Views */
            /* Don't allow function to execute more than once per page */
            if (s_wdpro.exec < 1) {
                s_wdpro.AdsT = s_wdpro.getLinkParams('addata', 'goto', '6', 'ads;', '');
                if (s_wdpro.AdsT) s_wdpro.products = s_wdpro.apl(s_wdpro.products, s_wdpro.AdsT, ",", 2);
                s_wdpro.exec++;
            }

            //ensure pageName and heir are always properly in sync

            // 1) pagName value must contain hier1 value
            if (!!s_wdpro.pageName && !!s_wdpro.hier1 && s_wdpro.pageName.indexOf(s_wdpro.hier1) === -1) {
                s_wdpro.pageName = s_wdpro.hier1 + s_wdpro.channelSep + s_wdpro.pageName;
            }
            // 2) pageName should be only 1 stem more than hier1 (example pageName="a/b/c" hier="a/b")
            if (!!s_wdpro.pageName && !!s_wdpro.hier1) {
                s_wdpro.hier1 = s_wdpro.pageName.split(s_wdpro.channelSep);
                s_wdpro.hier1.pop();
                s_wdpro.hier1 = s_wdpro.hier1.join(s_wdpro.channelSep);
            }

            /* channelExtract Example: 1.0 */
            if (s_wdpro.hier1) {
                s_wdpro.prevHier1 = s_wdpro.prevHier1 || '';
                if (s_wdpro.hier1 !== s_wdpro.prevHier1) {
                    var channelSep = s_wdpro.channelSep || '/',
                        nlevel;

                    nlevel = s_wdpro.hier1.split(channelSep);

                    if (nlevel.length < 6) {
                        s_wdpro.channel = s_wdpro.channelExtract(channelSep, nlevel.length, s_wdpro.hier1);
                    } else {

                        s_wdpro.channel = s_wdpro.channelExtract(channelSep, 6, s_wdpro.hier1);
                    }

                    if (nlevel.length < 7) {
                        s_wdpro.prop5 = s_wdpro.channelExtract(channelSep, nlevel.length, s_wdpro.hier1);
                    } else {
                        s_wdpro.prop5 = s_wdpro.channelExtract(channelSep, 7, s_wdpro.hier1);
                    }

                    if (nlevel.length < 8) {
                        s_wdpro.prop6 = s_wdpro.channelExtract(channelSep, nlevel.length, s_wdpro.hier1);
                    } else {
                        s_wdpro.prop6 = s_wdpro.channelExtract(channelSep, 8, s_wdpro.hier1);
                    }

                    if (nlevel.length < 9) {
                        s_wdpro.prop24 = s_wdpro.channelExtract(channelSep, nlevel.length, s_wdpro.hier1);
                    } else {
                        s_wdpro.prop24 = s_wdpro.channelExtract(channelSep, 9, s_wdpro.hier1);
                    }
                    s_wdpro.prevHier1 = s_wdpro.hier1;
                }
            }

            if (s_wdpro.events.indexOf('purchase') > -1 && !s_wdpro.purchaseID) s_wdpro.events = s_wdpro.repl(s_wdpro.events, 'purchase', ''); //temporary code to remove purchase event if purchaseID not set

            /* Campaign Stacking */
            s_wdpro.eVar12 = s_wdpro.crossVisitParticipation(s_wdpro.campaign, 's_cpm', '90', '5', '>', 'purchase', 1);

            /* Capture TNT PCID */
            if (window.mboxFactoryDefault && typeof mboxFactoryDefault.getPCId == "function") {
                s_wdpro.prop46 = mboxFactoryDefault.getPCId().getId();
            }
        }
        s_wdpro.doPlugins = s_wdpro_doPlugins;
        /******************** End of doPlugins ********************/

        /********** WDPRO Functions **********/

        /*********************
         * s_wdpro.determineProp9()
         *
         * @Author Matt Alexander
         * @LastModified 06/23/09
         *
         * @Description - Determines prop9 based on properties of the HTML node passed in. Prop9 is the linkID.
         * @param {DOM node} nodeElem The DOM element being clicked. Can be an anchor or input or any element you want.
            Priority order of values:
            1) nodeElem's id attribute
            2) nodeElem's name attribute
            3) nodeElem's link text / input value / image filename
            4) nodeElem's tag type
        */
        s_wdpro.determineProp9 = function (nodeElem) {
            //Make sure the node is included and is an object.
            if (!!nodeElem && typeof nodeElem == 'object') {

                // Remove current value.
                s_wdpro.prop9 = "";

                if (nodeElem.id) {
                    s_wdpro.prop9 = nodeElem.id;
                } else if (nodeElem.name) {
                    // Finds linkIDs identified with &lid=, &amp;lid=, or just lid=
                    // The (?: notation is for grouping without saving a numeric reference for the group
                    s_wdpro.prop9 = nodeElem.name.replace(/(?:&(?:amp;)?)?lid=/, '');
                } else if (nodeElem.nodeName) {
                    var strNodeName = nodeElem.nodeName.toLowerCase();
                    switch (strNodeName) {
                        case 'a':
                            // Check if the anchor contains an image. If so, use the image filename.
                            // This will only report the image filename even if the anchor contains an image plus text.
                            var arrChildImages = nodeElem.getElementsByTagName("img");
                            if (arrChildImages && arrChildImages.length > 0) {
                                s_wdpro.prop9 = arrChildImages[0].src.substring(arrChildImages[0].src.lastIndexOf('/') + 1);
                                break;
                            }
                            /* Use this block instead of the childImages block above to only track image filenames for anchors that do not contain text too.
                            If the anchor contains and image and text the whole innerHTML will come through in prop9.
                             if (nodeElem.hasChildNodes() && nodeElem.firstChild.nodeName.toLowerCase() == "img"){
                                s_wdpro.prop9 = nodeElem.firstChild.src.substring(nodeElem.firstChild.src.lastIndexOf('/')+1);
                            }
                            */
                            // If prop9 is still not set, use innerHTML to pull the hyperlink text.
                            if (!s_wdpro.prop9 && nodeElem.innerHTML) {
                                s_wdpro.prop9 = nodeElem.innerHTML;
                            }
                            break;

                        case 'input':
                            if ((nodeElem.type == 'button' || nodeElem.type == 'submit' || nodeElem.type == 'reset') && nodeElem.value) {
                                s_wdpro.prop9 = nodeElem.value;
                            } else {
                                s_wdpro.prop9 = strNodeName;
                            }
                            break;

                        default:
                            if (strNodeName != 'textarea' && nodeElem.innerHTML) {
                                s_wdpro.prop9 = nodeElem.innerHTML;
                            } else {
                                s_wdpro.prop9 = strNodeName;
                            }
                    }
                }
                s_wdpro.prop9 = s_wdpro.cleanLinkId(s_wdpro.prop9);
            }
        };

        /*********************
         * s_wdpro.trackClick()
         *
         * @Author Matt Alexander, Jose Bergiste, John Marty
         * @LastModified 06/23/09
         *
         * @Description - Tracks a link via JavaScript instead of relying on automatic tracking.
         * Automatic tracking only works if the next page is also a WDPRO page with standard SiteCatalyst tracking.
         * trackClick comes in handy for exit links or links that open hidden content instead of going to the next URL.
         *
         * @param {DOM node} nodeElem The DOM element being clicked. Can be an anchor or input or any element you want.
         * @param {String} strLinkId Optional ID of the link being tracked. This is what shows up in the reports.
         *      Link IDs are provided by the site's analyst in the analytics solution design spreadsheet. The usually end in "_Link".
         *      strLinkId is here for backward compatibility. Proper implementation is to pull the LinkId from the nodeElem's id attribute.
         *      To get the id into the element, put it in the pageName property of an Analytic object referenced from a UIElement.
         *          Your renderLink.tea template may not be set up to put that link id from the CMS into the element's id attribute.
         *          In the past they went into the name atribute with &lid= prepended.
         *      If strLinkId is passed in it takes precedence over nodeElem's id attribute and over objAdditionalVariables.prop9.
         * @param {Object} objAdditionalVariables Optional object with properties that match SiteCatalyst variable names.
         *      Typically not needed since the default tracking variables satisfy 90% of links.
         *
         * @example For example implementation details using jQuery and DEWEY, visit wikipage:
         * (http://wiki.wdpro.wdig.com/display/Tech/Tracking+Link+Clicks+and+Page+Views+with+SiteCatalyst#TrackingLinkClicksandPageViewswithSiteCatalyst-ManualLinkTracking%3A)
         *
         **/
        s_wdpro.trackClick = function (nodeElem, strLinkId, objAdditionalVariables) {

            //Make sure the node is included and is an object.
            if (nodeElem && typeof nodeElem == 'object') {

                // Some variables may be changed for this trackClick call and will need to be restored when this call is complete.
                var arrVariablesToRestore = {};

                // Disable automatic setting of prop9, since we are passing in a specific value.
                s_wdpro.blnAutomateProp9 = false;

                /**** Defaults ****/
                // These defaults comprise the base tracking for any link.

                // Note that s_wdpro is a global object. Properties defined in it when the HTML loaded are maintained and passed in link tracking calls.
                // linkTrackVars and linkTrackEvents allow you to filter down the properties to the few you want to pass.
                s_wdpro.linkTrackVars = ['prop1', 'prop2', 'prop9', 'prop12', 'prop52', 'eVar10', 'eVar4', 'contextData.product.title', 'contextData.cart.value', 'contextData.cart.alert.message', 'contextData.rec.source', 'contextData.rec.num', 'contextData.user.uuid'].join(',');
                // Note that linkTrackEvents is ignored unless you include "events" as a variable to track in linkTrackVars.
                s_wdpro.linkTrackEvents = 'None';
                // For page views prop12 is the previous page. For link clicks it is the current page.
                s_wdpro.prop12 = s_wdpro.pageName;

                /**** End Defaults ****/

                // Add or overwrite variables passed in objAdditionalVariables
                if (objAdditionalVariables) {
                    for (strProperty in objAdditionalVariables) {
                        if (objAdditionalVariables.hasOwnProperty(strProperty)) {

                            // Save original value from s_wdpro
                            arrVariablesToRestore[strProperty] = s_wdpro[strProperty];

                            // Update value in s_wdpro object
                            s_wdpro[strProperty] = objAdditionalVariables[strProperty];

                            // Add this property to the list of variables to track if it is not already in there.
                            if ((',' + s_wdpro.linkTrackVars + ',').indexOf(',' + strProperty + ',') == -1) {
                                s_wdpro.linkTrackVars += ',' + strProperty;
                            }

                            // Now that s_wdpro.events has been updated and "events" has been added to linkTrackVars,
                            // s_wdpro.linkTrackEvents needs to be updated as well. The regex removes values from the events.
                            if (strProperty == 'events') {
                                s_wdpro.linkTrackEvents = objAdditionalVariables['events'].replace(/[=:].+?(?=,|$)/g, '');
                            }
                        }
                    }
                }

                /***** Set prop9 *****
                prop9 = LinkId.
                Priority order of inputs:
                1) strLinkId
                2) objAdditionalVariables.prop9 (set in for loop above)
                3) nodeElem's attributes
                */
                if (strLinkId) {
                    s_wdpro.prop9 = s_wdpro.cleanLinkId(strLinkId);
                } else if (!objAdditionalVariables || !objAdditionalVariables.hasOwnProperty('prop9')) {
                    s_wdpro.determineProp9(nodeElem);
                }

                /***** Report the link click to Omniture. *****/
                // "o" indicates a custom link, "d" is download, and "e" is for exit links. Download links and exit links are automated elsewhere in s_code.js.
                // trackClick is only for custom links so this is always set to "o".
                // It is redundant to pass s_wdpro.prop9 here since it is in the s_wdpro object, but this function doesn't work without it.

                // Passing the element in the first argument enables a 500 millisecond pause before the link href is fired
                // to give time for the tracking call to go out. Otherwise this tracking call could be aborted by the browser.
                s_wdpro.tl({}, 'o', s_wdpro.prop9);

                /***** Resets *****/
                // Reset variables to prevent recounting of the values intended only for this one link tracking call.
                for (strProperty in arrVariablesToRestore) {
                    if (arrVariablesToRestore.hasOwnProperty(strProperty)) {
                        s_wdpro[strProperty] = arrVariablesToRestore[strProperty];
                    }
                }
                // Re-enable automatic determination of prop9 for Exit links and others that are automatically tracked outside of this function.
                s_wdpro.blnAutomateProp9 = true;
                s_wdpro.prop9 = undefined;
            }
        };
        /*********************
         *  trackLink
         *  @Description - kept for backwards compatibility
         **/
        s_wdpro.trackLink = function (nodeElem, strLinkId, objAdditionalVariables) {
            s_wdpro.trackClick(nodeElem, strLinkId, objAdditionalVariables);
        };

        /*********************
         * s_wdpro.trackPage()
         *
         * @Author Matt Alexander
         * @LastModified 06/23/09
         *
         * @Description - Reports a page view representing a previously hidden layer that replaces the main content of the page.
         *      Note: All current properties of the s_wdpro object will be reported along with the new name and linkID you pass in.
         *          This is because the JS page view would usually be in the same site section and have the same values as
         *          the page view that fired when the page first loaded.
         *      Note: For AJAX responses, the analytics values are returned from the CMS and Java in the Analytics section of the model.
         *          You typically parse your JSON or XML resoponse and populate the objAdditionalVariables object and then call this function.
         * @param {String} strPageName the name of the new page to be reported. If not passed in the original page name is reported again.
         * @param {String} strLinkId Optional ID of the link being tracked. This shows up as prop9 in the reports.
         *      Link IDs are provided by the site's analyst in the analytics solution design spreadsheet. The usually end in "_Link".
         *      strLinkId is here for backward compatibility. Proper implementation is to pull the LinkId from the nodeElem's id attribute.
         *      If strLinkId is passed in it takes precedence over nodeElem's id attribute.
         * @param {DOM node} nodeElem The DOM element being clicked. Can be an anchor or input or any element you want.
         * @param {Object} objAdditionalVariables Optional object with properties that match SiteCatalyst variable names.
         *      Typically not needed since JS page views usually reuse properties previously set in the s_wdpro object.
         *
         * @example
            s_wdpro.trackPage("mickeysecrets", "", document.getElementById("hiddenMickeyButton"));
         *
         * @example
            var objAdditionalVariables = {
                pageName: "MyNewPage"
                , hier1: "MyNewHierarchy"
                , prop9: "MyAddtoCart_Link"
                , events: "scAdd,event3"
                , prop19: "myTestValue"
                , eVar24: "myTestValue"
            }
            s_wdpro.trackPage("", "", "", objAdditionalVariables);
         *
         **/
        s_wdpro.trackPage = function (strPageName, strLinkId, nodeElem, objAdditionalVariables) {
            // Disable automatic setting of prop9, since we are passing in a specific value.
            s_wdpro.blnAutomateProp9 = false;
            var channelSep = s_wdpro.channelSep || '/';
            // Add or overwrite variables passed in objAdditionalVariables
            if (!!objAdditionalVariables) {
                channelSep = objAdditionalVariables.channelSep || channelSep;
                for (strProperty in objAdditionalVariables) {
                    if (objAdditionalVariables.hasOwnProperty(strProperty)) {
                        // Update value in s_wdpro object
                        // Note that pageName and hierarchy should be lowercase to adhere to our WDPRO reporting standard.
                        if (strProperty == "hier1") {
                            s_wdpro["hier1"] = objAdditionalVariables["hier1"].toLowerCase();
                        }
                        if (strProperty == "pageName") {
                            if (objAdditionalVariables["hier1"]) {
                                s_wdpro["pageName"] = objAdditionalVariables["hier1"] + channelSep + objAdditionalVariables["pageName"];
                            } else {
                                s_wdpro["pageName"] = s_wdpro.hier1 + channelSep + objAdditionalVariables["pageName"];
                            }
                            s_wdpro["pageName"] = s_wdpro["pageName"].toLowerCase();
                        } else {
                            s_wdpro[strProperty] = objAdditionalVariables[strProperty];
                        }
                    }
                }
            }

            /***** Set prop9 *****
            prop9 = LinkId.
            Priority order of inputs:
            1) strLinkId
            2) objAdditionalVariables.prop9 (set in for loop above)
            3) nodeElem's attributes
            */
            if (!!strLinkId) {
                s_wdpro.prop9 = strLinkId;
                s_wdpro.prop9 = s_wdpro.cleanLinkId(s_wdpro.prop9);
            } else if (!objAdditionalVariables || !objAdditionalVariables.hasOwnProperty('prop9')) {
                s_wdpro.determineProp9(nodeElem);
            }

            /***** Set pageName *****
            Priority order of inputs:
            1) strPageName
            2) objAdditionalVariables.pageName (set in for loop above)
            3) original strPageName (would already be set)
            */
            // Note that pageName and hierarchy should be lowercase to adhere to our WDPRO reporting standard.
            if (!!strPageName) {
                s_wdpro.pageName = s_wdpro.hier1 + channelSep + strPageName.toLowerCase();
            }

            /***** Report page view to Omniture. *****/
            s_wdpro.t();

            /***** Resets *****/
            // Re-enable automatic determination of prop9 for Exit links and others that are automatically tracked.
            s_wdpro.blnAutomateProp9 = true;
        };

        /********** End WDPRO Functions **********/

        /************************** PLUGINS SECTION *************************/
        /* You may insert any plugins you wish to use here.                 */

        /************************ getPercentPageViewed **********************/
        /*
        * Plugin: getPercentPageViewed v1.4
        */
        s_wdpro.handlePPVevents = new Function("", "" + "if(!s_wdpro.getPPVid)return;var dh=Math.max(Math.max(s_wdpro.d.body.scrollHeigh" + "t,s_wdpro.d.documentElement.scrollHeight),Math.max(s_wdpro.d.body.offsetHeight," + "s_wdpro.d.documentElement.offsetHeight),Math.max(s_wdpro.d.body.clientHeight,s_wdpro." + "d.documentElement.clientHeight)),vph=s_wdpro.wd.innerHeight||(s_wdpro.d.documen" + "tElement.clientHeight||s_wdpro.d.body.clientHeight),st=s_wdpro.wd.pageYOffset||" + "(s_wdpro.wd.document.documentElement.scrollTop||s_wdpro.wd.document.body.scroll" + "Top),vh=st+vph,pv=Math.min(Math.round(vh/dh*100),100),c=s_wdpro.c_r('s_pp" + "v'),a=(c.indexOf(',')>-1)?c.split(',',4):[],id=(a.length>0)?(a[0]):" + "escape(s_wdpro.getPPVid),cv=(a.length>1)?parseInt(a[1]):(0),p0=(a.length>" + "2)?parseInt(a[2]):(pv),cy=(a.length>3)?parseInt(a[3]):(0),cn=(pv>0)" + "?(id+','+((pv>cv)?pv:cv)+','+p0+','+((vh>cy)?vh:cy)):'';s_wdpro.c_w('s_pp" + "v',cn);");
        s_wdpro.getPercentPageViewed = new Function("pid", "" + "pid=pid?pid:'-';var s=this,ist=!s_wdpro.getPPVid?true:false;if(typeof(s_wdpro.l" + "inkType)!='undefined'&&s_wdpro.linkType!='e')return'';var v=s_wdpro.c_r('s_ppv'" + "),a=(v.indexOf(',')>-1)?v.split(',',4):[];if(a.length<4){for(var i=" + "3;i>0;i--){a[i]=(i<a.length)?(a[i-1]):('');}a[0]='';}a[0]=unescape(" + "a[0]);s_wdpro.getPPVpid=pid;s_wdpro.c_w('s_ppv',escape(pid));if(ist){s_wdpro.getPPVid" + "=(pid)?(pid):(s_wdpro.pageName?s_wdpro.pageName:document.location.href);s_wdpro.c_w('" + "s_ppv',escape(s_wdpro.getPPVid));if(s_wdpro.wd.addEventListener){s_wdpro.wd.addEventL" + "istener('load',s_wdpro.handlePPVevents,false);s_wdpro.wd.addEventListener('scro" + "ll',s_wdpro.handlePPVevents,false);s_wdpro.wd.addEventListener('resize',s_wdpro.handl" + "ePPVevents,false);}else if(s_wdpro.wd.attachEvent){s_wdpro.wd.attachEvent('onlo" + "ad',s_wdpro.handlePPVevents);s_wdpro.wd.attachEvent('onscroll',s_wdpro.handlePPVevent" + "s);s_wdpro.wd.attachEvent('onresize',s_wdpro.handlePPVevents);}}return(pid!='-'" + ")?(a):(a[1]);");

        /*
         * TNT Integration Plugin v1.0
         * v - Name of the javascript variable that is used. Defaults to s_tnt (optional)
         * p - Name of the url parameter. Defaults to s_tnt (optional)
         * b - Blank Global variable after plugin runs. Defaults to true (Optional)
         */
        s_wdpro.trackTNT = function (v, p, b) {
            var s = this,
                n = "s_tnt",
                p = p ? p : n,
                v = v ? v : n,
                r = "",
                pm = false,
                b = b ? b : true;
            if (s_wdpro.getQueryParam) pm = s_wdpro.getQueryParam(p); //grab the parameter
            if (pm) r += pm + ","; // append the parameter
            if (s.wd[v] != undefined) r += s.wd[v]; // get the global variable
            if (b) s.wd[v] = ""; // Blank out the global variable for ajax requests
            return r;
        };
        /*
         * channel manager
         */
        s_wdpro.isEntry = new Function("" + "var s=this;var l=s.linkInternalFilters,r=s.referrer||typeof s.referrer!='undefined'?s.referrer:document.referrer,p=l.indexOf(','),b=0,v='';if(!r){return 1;}while((p=l.indexOf(','))){v=p>-1?l.substr" + "ing(b,p):l;if(v=='.'||r.indexOf(v)>-1){return 0;}if(p==-1){break;}b=p+1;while(l.indexOf(',')+1==b){b++;}l=l.substring(b,l.length);}return 1;");
        s_wdpro.fireOnce = new Function("" + "if(!s_wdpro.__fo){s_wdpro.__fo=new Object;return 1;}else {return 0;}");
        /*
         * Plugin: getQueryParam 2.3 - return query string parameter(s)
         */
        s_wdpro.getQueryParam = new Function("p", "d", "u", "" + "var s=this,v='',i,t;d=d?d:'';u=u?u:(s.pageURL?s.pageURL:s.wd.locati" + "on);if(u=='f')u=s.gtfs().location;while(p){i=p.indexOf(',');i=i<0?p" + ".length:i;t=s.p_gpv(p.substring(0,i),u+'');if(t){t=t.indexOf('#')>-" + "1?t.substring(0,t.indexOf('#')):t;}if(t)v+=v?d+t:t;p=p.substring(i=" + "=p.length?i:i+1)}return v");
        s_wdpro.p_gpv = new Function("k", "u", "" + "var s=this,v='',i=u.indexOf('?'),q;if(k&&i>-1){q=u.substring(i+1);v" + "=s.pt(q,'&','p_gvf',k)}return v");
        s_wdpro.p_gvf = new Function("t", "k", "" + "if(t){var s=this,i=t.indexOf('='),p=i<0?t:t.substring(0,i),v=i<0?'T" + "rue':t.substring(i+1);if(p.toLowerCase()==k.toLowerCase())return s." + "epa(v)}return ''");
        /*
         * Plugin: getQueryParamNoEncode - return non-encoded query string parameter(s)
         */
        s_wdpro.getQueryParamNoEncode = new Function("p", "d", "u", "" + "var s=this,v='',i,t;d=d?d:'';u=u?u:(s.pageURL?s.pageURL:s.wd.locati" + "on);if(u=='f')u=s.gtfs().location;while(p){i=p.indexOf(',');i=i<0?p" + ".length:i;t=s.p_gpvne(p.substring(0,i),u+'');if(t)v+=v?d+t:t;p=p.subs" + "tring(i==p.length?i:i+1)}return v");
        s_wdpro.p_gpvne = new Function("k", "u", "" + "var s=this,v='',i=u.indexOf('?'),q;if(k&&i>-1){q=u.substring(i+1);v" + "=s.pt(q,'&','p_gvfne',k)}return v");
        s_wdpro.p_gvfne = new Function("t", "k", "" + "if(t){var s=this,i=t.indexOf('='),p=i<0?t:t.substring(0,i),v=i<0?'T" + "rue':t.substring(i+1);if(p.toLowerCase()==k.toLowerCase())return v;" + "}return ''");
        /*
         * Plugin: channelExtract : 1.1 - returns site section based on delimiter
         */
        s_wdpro.channelExtract = new Function("d", "p", "u", "pv", "td", "" + "var s=this,v='';u=u?u:(s.pageURL?s.pageURL:s.wd.location);if(u=='f'" + ")u=s.gtfs().location;u=td?u+'':u+d;li=u.lastIndexOf(d);if(li>0){u=u" + ".substring(0,li);var i,n,a=s.split(u,d),al=a.length;if(al<p){if(pv=" + "=1) p=al;else return '';}for(i=0;i<p;i++){n=a[i];if(i<p-1)v=v+n+d;e" + "lse v=v+n;}return v}return '';");
        /*
        * Plugin: clickPast v1.0 - SearchCenter Bounce Rate
        */
        s_wdpro.clickPast = new Function("scp", "ct_ev", "cp_ev", "cpc", "" + "var s=this,scp,ct_ev,cp_ev,cpc,ev,tct;if(s.p_fo(ct_ev)==1){if(!cpc)" + "{cpc='s_cpc';}ev=s.events?s.events+',':'';if(scp){s.events=ev+ct_ev" + ";s.c_w(cpc,1,0);}else{if(s.c_r(cpc)>=1){s.events=ev+cp_ev;s.c_w(cpc" + ",0,0);}}}");
        s_wdpro.p_fo = new Function("n", "" + "var s=this;if(!s.__fo){s.__fo=new Object;}if(!s.__fo[n]){s.__fo[n]=" + "new Object;return 1;}else {return 0;}");
        /*
         * Plugin: manageQueryParam 1.2 - swap parameters in query string
         */
        s_wdpro.manageQueryParam = new Function("p", "w", "e", "u", "" + "var s=this,x,y,i,qs,qp,qv,f,b;u=u?u:(s.pageURL?s.pageURL:''+s.wd.lo" + "cation);u=u=='f'?''+s.gtfs().location:u+'';x=u.indexOf('?');qs=x>-1" + "?u.substring(x,u.length):'';u=x>-1?u.substring(0,x):u;x=qs.indexOf(" + "'?'+p+'=');if(x>-1){y=qs.indexOf('&');f='';if(y>-1){qp=qs.substring" + "(x+1,y);b=qs.substring(y+1,qs.length);}else{qp=qs.substring(1,qs.le" + "ngth);b='';}}else{x=qs.indexOf('&'+p+'=');if(x>-1){f=qs.substring(1" + ",x);b=qs.substring(x+1,qs.length);y=b.indexOf('&');if(y>-1){qp=b.su" + "bstring(0,y);b=b.substring(y,b.length);}else{qp=b;b='';}}}if(e&&qp)" + "{y=qp.indexOf('=');qv=y>-1?qp.substring(y+1,qp.length):'';var eui=0" + ";while(qv.indexOf('%25')>-1){qv=unescape(qv);eui++;if(eui==10)break" + ";}qv=s.rep(qv,'+',' ');qv=escape(qv);qv=s.rep(qv,'%25','%');qv=s.re" + "p(qv,'%7C','|');qv=s.rep(qv,'%7c','|');qp=qp.substring(0,y+1)+qv;}i" + "f(w&&qp){if(f)qs='?'+qp+'&'+f+b;else if(b)qs='?'+qp+'&'+b;else qs='" + "?'+qp}else if(f)qs='?'+f+'&'+qp+b;else if(b)qs='?'+qp+'&'+b;else if" + "(qp)qs='?'+qp;return u+qs;");
        /*
         *  Plugin: crossVisitParticipation v1.7 - stacks values from
         *  specified variable in cookie and returns value
         */

        s_wdpro.crossVisitParticipation = new Function("v", "cn", "ex", "ct", "dl", "ev", "dv", "" + "var s=this,ce;if(typeof(dv)==='undefined')dv=0;if(s.events&&ev){var" + " ay=s.split(ev,',');var ea=s.split(s.events,',');for(var u=0;u<ay.l" + "ength;u++){for(var x=0;x<ea.length;x++){if(ay[u]==ea[x]){ce=1;}}}}i" + "f(!v||v==''){if(ce){s.c_w(cn,'');return'';}else return'';}v=escape(" + "v);var arry=new Array(),a=new Array(),c=s.c_r(cn),g=0,h=new Array()" + ";if(c&&c!=''){arry=s.split(c,'],[');for(q=0;q<arry.length;q++){z=ar" + "ry[q];z=s.repl(z,'[','');z=s.repl(z,']','');z=s.repl(z,\"'\",'');arry" + "[q]=s.split(z,',')}}var e=new Date();e.setFullYear(e.getFullYear()+" + "5);if(dv==0&&arry.length>0&&arry[arry.length-1][0]==v)arry[arry.len" + "gth-1]=[v,new Date().getTime()];else arry[arry.length]=[v,new Date(" + ").getTime()];var start=arry.length-ct<0?0:arry.length-ct;var td=new" + " Date();for(var x=start;x<arry.length;x++){var diff=Math.round((td." + "getTime()-arry[x][1])/86400000);if(diff<ex){h[g]=unescape(arry[x][0" + "]);a[g]=[arry[x][0],arry[x][1]];g++;}}var data=s.join(a,{delim:','," + "front:'[',back:']',wrap:\"'\"});s.c_w(cn,data,e);var r=s.join(h,{deli" + "m:dl});if(ce)s.c_w(cn,'');return r;");

        /*
         *  Plugin: getLinkParams 1.3g
         */
        s_wdpro.getLinkParams = new Function("p", "qp", "m", "q", "ev", "" + "var s=this,a='',t=0,l,ll,l2,r,e,la,ap,ev=ev?';;;'+ev+'=1':'';if(s.d.links){for(i=0;i<s.d.links.length;i++){l=s.d.links[i];r=l.href;e=l.name;e=!e?'':e.indexOf('&')!=0?'&'+e:e;la=r.indexOf('?')>-1?" + "r.substring(r.indexOf('?'))+e:e?'?'+e:'';ll=la.toLowerCase();if(qp&&ll.indexOf(qp.toLowerCase())>0) l2=qp?s.getQueryParam(qp,'',ll):'';else l2='';if(l2&&l2.indexOf(p.toLowerCase())>0){ap=s.getQueryParam(p,''," + "l2+'');if(ap!=''&&ap.indexOf('#')<0){a=s.apl(a,q+ap+ev,',',2);t=t+1;}}else if(ll.indexOf(p.toLowerCase())>0){ap=s.getQueryParam(p,'',la+'');if(ap!=''&&ap.indexOf('#')<0){a=s.apl(a,q+ap+ev,',',2);t=" + "t+1;}}if(t==m)return a;}return a;}");
        /*
         * Utility Function: setLinkId v1.1
         */
        s_wdpro.setLinkId = function (p1, p2, qp, d, id, t, k, L, v1, vd, lid) {
            var s = this;
            if (s.c_r(k) == 'customlink') {
                s.c_w(k, '');
                return '';
            }
            var h = s.getLinkId(p1, p2, qp, d, id, L, v1, vd, lid);
            var v,
                kv,
                wh = s.c_gd().substring(1);
            if (!h[0]) {
                kv = s.c_r(k);
                s.c_w(k, '');
                return kv;
            }
            wh = h[0].indexOf(wh) > -1 ? '0' : h[0].indexOf('javascript:') > -1 ? '0' : '1';
            v = h[1].indexOf('atxt:') > -1 ? '1' : '-1';
            if (s.linkType || s.linkName) {
                s.c_w(k, 'customlink');
                return h[1];
            } else if (t == '0' || s.lt(h[0]) == 'd' || s.lt(h[0]) == 'e') {
                s.c_w(k, '');
                return h[1];
            } else if (wh == '1') {
                s.linkName = h[1];
                s.linkType = 'o';
                return h[1];
            } else if (t == '1') {
                if (v > -1) {
                    s.c_w(k, h[1]);
                    return '';
                } else {
                    s.linkName = h[1];
                    s.linkType = 'o';
                    return h[1];
                }
            } else if (t == '2') {
                s.linkName = h[1];
                s.linkType = 'o';
                return h[1];
            } else {
                s.c_w(k, h[1]);
                return '';
            }
            s.c_w(k, '');
            return '';
        };
        /*
         * Utility Function: getLinkId v1.1
         */
        s_wdpro.getLinkId = function (p1, p2, qp, d, id, L, v1, vd, lid) {
            var s = this,
                h,
                n,
                r,
                h1,
                h2,
                h3,
                a,
                e,
                q;
            if (!s.eo && !s.lnk) return '';
            var o = s.eo ? s.eo : s.lnk;
            var y = s.ot(o);
            var n = s.oid(o);
            var x = o.s_oidt;
            if (s.eo && o == s.eo) {
                while (o && !n && y != 'BODY') {
                    o = o.parentElement ? o.parentElement : o.parentNode;
                    if (!o) return '';
                    y = s.ot(o);
                    n = s.oid(o);
                    x = o.s_oidt;
                }
            }
            d = d ? d : '|';
            id = id ? id : ':';
            if (!o.href) {
                if (lid) {
                    r = 'javascript:';
                } else {
                    return '';
                }
            } else {
                r = o.href;
            }
            q = r.indexOf('?');

            if (lid) {
                e = '&lid=' + lid;
            } else {
                e = !o.name ? '' : o.name.indexOf('&') != 0 ? '&' + o.name : o.name;
            }
            h = q > -1 ? r.substring(q) + e : e ? '?' + e : '';
            if (s.linkLeaveQueryString == false) r = q > 0 ? r.substring(0, q) : r;
            if (h) {
                h1 = p1 ? s.getQueryParam(p1, id, h) : '';
                h2 = p2 ? s.getQueryParam(p2, id, h) : '';
                h3 = qp ? s.getQueryParam(qp, id, h) : '';
            }
            if (h3 && s.getQueryParam(p2, id, h3)) h2 = p2 ? s.getQueryParam(p2, id, h3) : '';
            if (!h1 && !h2) {
                if (!s.getinnerHTML(o)) return '';else h = L < 1 ? 'atxt' + id : 'atxt' + id + s_wdpro.cleanLinkId(s.getinnerHTML(o));
            } else h = h1 ? h1 += h2 ? d + h2 : '' : h2;
            h = v1 ? h + vd + v1 : h;
            a = new Array();
            a[0] = r ? r : '';
            a[1] = h;
            return a ? a : '';
        };
        /*
         * Utility Function: getinnerHTML v1.0
         */
        s_wdpro.getinnerHTML = new Function("o", "" + "var ih=''+o.innerHTML,ihl=ih.toLowerCase(),i=ihl.indexOf('<img');if(ih&&i>-1){eval(\"evl=/ src\s*=\s*['\\\"]?([^'\\\" ]+)['\\\"]?/i\");evl.exec(ih);if(RegExp.$1) ih=RegExp.$1}return(ih);");
        /*
         * Plugin Utility: Replace v1.0
         */
        s_wdpro.repl = new Function("x", "o", "n", "" + "var i=x.indexOf(o),l=n.length;while(x&&i>=0){x=x.substring(0,i)+n+x." + "substring(i+o.length);i=x.indexOf(o,i+l)}return x");
        /*
         * Plugin: getValOnce 0.2 - get a value once per session or number of days
         */
        s_wdpro.getValOnce = new Function("v", "c", "e", "" + "var s=this,k=s.c_r(c),a=new Date;e=e?e:0;if(v){a.setTime(a.getTime(" + ")+e*86400000);s.c_w(c,v,e?a:0);}return v==k?'':v");
        /*
         * Plugin: getPreviousValue_v1.0 - return previous value of designated
         *   variable (requires split utility)
         */
        s_wdpro.getPreviousValue = new Function("v", "c", "el", "" + "var s=this,t=new Date,i,j,r='';t.setTime(t.getTime()+1800000);if(el" + "){if(s.events){i=s.split(el,',');j=s.split(s.events,',');for(x in i" + "){for(y in j){if(i[x]==j[y]){if(s.c_r(c)) r=s.c_r(c);v?s.c_w(c,v,t)" + ":s.c_w(c,'no value',t);return r}}}}}else{if(s.c_r(c)) r=s.c_r(c);v?" + "s.c_w(c,v,t):s.c_w(c,'no value',t);return r}");
        /*
         * Plugin Utility: apl v1.1
         */
        s_wdpro.apl = new Function("L", "v", "d", "u", "" + "var s=this,m=0;if(!L)L='';if(u){var i,n,a=s.split(L,d);for(i=0;i<a." + "length;i++){n=a[i];m=m||(u==1?(n==v):(n.toLowerCase()==v.toLowerCas" + "e()));}}if(!m)L=L?L+d+v:v;return L");
        /*
         * Utility Function: split v1.5 - split a string (JS 1.0 compatible)
         */
        s_wdpro.split = new Function("l", "d", "" + "var i,x=0,a=new Array;while(l){i=l.indexOf(d);i=i>-1?i:l.length;a[x" + "++]=l.substring(0,i);l=l.substring(i+d.length);}return a");
        /*
         * Utility Function: join v1.0 - Joins an array into a string
         */
        s_wdpro.join = new Function("v", "p", "" + "var s = this;var f,b,d,w;if(p){f=p.front?p.front:'';b=p.back?p.back" + ":'';d=p.delim?p.delim:'';w=p.wrap?p.wrap:'';}var str='';for(var x=0" + ";x<v.length;x++){if(typeof(v[x])=='object' )str+=s.join( v[x],p);el" + "se str+=w+v[x]+w;if(x<v.length-1)str+=d;}return f+str+b;");
        /*
         * Plugin: Form Analysis 2.1 (Success, Error, Abandonment)
         */
        s_wdpro.setupFormAnalysis = new Function("" + "var s=this;if(!s.fa){s.fa=new Object;var f=s.fa;f.ol=s.wd.onload;s." + "wd.onload=s.faol;f.uc=s.useCommerce;f.vu=s.varUsed;f.vl=f.uc?s.even" + "tList:'';f.tfl=s.trackFormList;f.fl=s.formList;f.va=new Array('',''" + ",'','')}");
        s_wdpro.sendFormEvent = new Function("t", "pn", "fn", "en", "" + "var s=this,f=s.fa;t=t=='s'?t:'e';f.va[0]=pn;f.va[1]=fn;f.va[3]=t=='" + "s'?'Success':en;s.fasl(t);f.va[1]='';f.va[3]='';");
        s_wdpro.faol = new Function("e", "" + "var s=s_c_il[" + s_wdpro._in + "],f=s.fa,r=true,fo,fn,i,en,t,tf;if(!e)e=s.wd." + "event;f.os=new Array;if(f.ol)r=f.ol(e);if(s.d.forms&&s.d.forms.leng" + "th>0){for(i=s.d.forms.length-1;i>=0;i--){fo=s.d.forms[i];fn=(fo.name)? " + "fo.name : fo.id;tf=f.tfl&&s.pt(f.fl,',','ee',fn)||!f.tfl&&!s.pt(f.fl,',','ee',fn);" + "if(tf){f.os[fn]=fo.onsubmit;fo.onsubmit=s.faos;f.va[1]=fn;f.va[3]='" + "No Data Entered';for(en=0;en<fo.elements.length;en++){el=fo.element" + "s[en];t=el.type;if(t&&t.toUpperCase){t=t.toUpperCase();var md=el.on" + "mousedown,kd=el.onkeydown,omd=md?md.toString():'',okd=kd?kd.toStrin" + "g():'';if(omd.indexOf('.fam(')<0&&okd.indexOf('.fam(')<0){el.s_famd" + "=md;el.s_fakd=kd;el.onmousedown=s.fam;el.onkeydown=s.fam}}}}}f.ul=s" + ".wd.onunload;s.wd.onunload=s.fasl;}return r;");
        s_wdpro.faos = new Function("e", "" + "var s=s_c_il[" + s_wdpro._in + "],f=s.fa,su;if(!e)e=s.wd.event;if(f.vu){s[f.v" + "u]='';f.va[1]='';f.va[3]='';}su=f.os[(this.name)? this.name : this.id];return su?su(e):tru" + "e;");
        s_wdpro.fasl = new Function("e", "" + "var s=s_c_il[" + s_wdpro._in + "],f=s.fa,a=f.va,l=s.wd.location,ip=s.trackPag" + "eName,p=s.pageName;if(a[1]!=''&&a[3]!=''){a[0]=!p&&ip?l.host+l.path" + "name:a[0]?a[0]:p;if(!f.uc&&a[3]!='No Data Entered'){if(e=='e')a[2]=" + "'Error';else if(e=='s')a[2]='Success';else a[2]='Abandon'}else a[2]" + "='';var tp=ip?a[0]+':':'',t3=e!='s'?':('+a[3]+')':'',ym=!f.uc&&a[3]" + "!='No Data Entered'?tp+a[1]+':'+a[2]+t3:tp+a[1]+t3,ltv=s.linkTrackV" + "ars,lte=s.linkTrackEvents,up=s.usePlugins;if(f.uc){s.linkTrackVars=" + "ltv=='None'?f.vu+',events':ltv+',events,'+f.vu;s.linkTrackEvents=lt" + "e=='None'?f.vl:lte+','+f.vl;f.cnt=-1;if(e=='e')s.events=s.pt(f.vl,'" + ",','fage',2);else if(e=='s')s.events=s.pt(f.vl,',','fage',1);else s" + ".events=s.pt(f.vl,',','fage',0)}else{s.linkTrackVars=ltv=='None'?f." + "vu:ltv+','+f.vu}s[f.vu]=ym;s.usePlugins=false;var faLink=new Object" + "();faLink.href='#';s.tl(faLink,'o','Form Analysis');s[f.vu]='';s.us" + "ePlugins=up}return f.ul&&e!='e'&&e!='s'?f.ul(e):true;");
        s_wdpro.fam = new Function("e", "" + "var s=s_c_il[" + s_wdpro._in + "],f=s.fa;if(!e) e=s.wd.event;var o=s.trackLas" + "tChanged,et=e.type.toUpperCase(),t=this.type.toUpperCase(),fn=" + "(this.form.name)? this.form.name:this.form.id,en=this.name,sc=false;if(document.layers){kp=e.which;b=e." + "which}else{kp=e.keyCode;b=e.button}et=et=='MOUSEDOWN'?1:et=='KEYDOW" + "N'?2:et;if(f.ce!=en||f.cf!=fn){if(et==1&&b!=2&&'BUTTONSUBMITRESETIM" + "AGERADIOCHECKBOXSELECT-ONEFILE'.indexOf(t)>-1){f.va[1]=fn;f.va[3]=e" + "n;sc=true}else if(et==1&&b==2&&'TEXTAREAPASSWORDFILE'.indexOf(t)>-1" + "){f.va[1]=fn;f.va[3]=en;sc=true}else if(et==2&&kp!=9&&kp!=13){f.va[" + "1]=fn;f.va[3]=en;sc=true}if(sc){nface=en;nfacf=fn}}if(et==1&&this.s" + "_famd)return this.s_famd(e);if(et==2&&this.s_fakd)return this.s_fak" + "d(e);");
        s_wdpro.ee = new Function("e", "n", "" + "return n&&n.toLowerCase?e.toLowerCase()==n.toLowerCase():false;");
        s_wdpro.fage = new Function("e", "a", "" + "var s=this,f=s.fa,x=f.cnt;x=x?x+1:1;f.cnt=x;return x==a?e:'';");
        /*
         * Function - read combined cookies v 0.2
         */
        s_wdpro.c_rr = s_wdpro.c_r;
        s_wdpro.c_r = new Function("k", "" + "var s=this,d=new Date,v=s.c_rr(k),c=s.c_rr('s_pers'),i,m,e;if(v)ret" + "urn v;k=s.ape(k);i=c.indexOf(' '+k+'=');c=i<0?s.c_rr('s_sess'):c;i=" + "c.indexOf(' '+k+'=');m=i<0?i:c.indexOf('|',i);e=i<0?i:c.indexOf(';'" + ",i);m=m>0?m:e;v=i<0?'':s.epa(c.substring(i+2+k.length,m<0?c.length:" + "m));if(m>0&&m!=e)if(parseInt(c.substring(m+1,e<0?c.length:e))<d.get" + "Time()){d.setTime(d.getTime()-60000);s.c_w(s.epa(k),'',d);v='';}ret" + "urn v;");
        /*
         * Function - write combined cookies v 0.2
         */
        s_wdpro.c_wr = s_wdpro.c_w;
        s_wdpro.c_w = new Function("k", "v", "e", "" + "var s=this,d=new Date,ht=0,pn='s_pers',sn='s_sess',pc=0,sc=0,pv,sv," + "c,i,t;d.setTime(d.getTime()-60000);if(s.c_rr(k)) s.c_wr(k,'',d);k=s" + ".ape(k);pv=s.c_rr(pn);i=pv.indexOf(' '+k+'=');if(i>-1){pv=pv.substr" + "ing(0,i)+pv.substring(pv.indexOf(';',i)+1);pc=1;}sv=s.c_rr(sn);i=sv" + ".indexOf(' '+k+'=');if(i>-1){sv=sv.substring(0,i)+sv.substring(sv.i" + "ndexOf(';',i)+1);sc=1;}d=new Date;if(e){if(e.getTime()>d.getTime())" + "{pv+=' '+k+'='+s.ape(v)+'|'+e.getTime()+';';pc=1;}}else{sv+=' '+k+'" + "='+s.ape(v)+';';sc=1;}if(sc) s.c_wr(sn,sv,0);if(pc){t=pv;while(t&&t" + ".indexOf(';')!=-1){var t1=parseInt(t.substring(t.indexOf('|')+1,t.i" + "ndexOf(';')));t=t.substring(t.indexOf(';')+1);ht=ht<t1?t1:ht;}d.set" + "Time(ht);s.c_wr(pn,pv,d);}return v==s.c_r(s.epa(k));");

        s_wdpro.allTrafficSources = new Function("a", "b", "c", "d", "e", "f", "g", "h", "i", "var s=this,A,B,C,D,E,F,G,H,I," + "J,K,L,M,N,O,P,Q,R,T,U,V,W,X,Y,Z,z,y,x,w,v,u;E=s.referrer?s.referrer:document.referrer;if(!E){F='1'}" + "G=s.split(h,'>');A=G[0]?G[0]:'Paid Search';B=G[1]?G[1]:'Natural Search';C=G[2]?G[2]:'Paid Non-Searc" + "h';D=G[3]?G[3]:'Referrers';I=E.indexOf('?')>-1?E.indexOf('?'):E.length;x=E.substring(0,I);w=s.split" + "(s.linkInternalFilters,',');P=w.length-1;for(Q=0;Q<=P;Q++){if(w[Q]){v=x.indexOf(w[Q])==-1?'':E;if(v" + ")u=v}}if(!u&&!F){H=E.indexOf('://')>-1?E.indexOf('://')+3:0;J=E.indexOf('/',H)>-1?E.indexOf('/',H):" + "I;K=E.substring(H,J);L=K;L=L.toLowerCase();M=D;N='';N=c?N+'>'+c:N;O=s.split(N,'>');P=O.length-1;for" + "(Q=0;Q<=P;Q++){R=O[Q];R=s.split(R,'|');T=K.indexOf(R[0]);if(T>-1){U=s.getQueryParam(R[1],'',E);if(U" + "){V=U;L=R[2]?R[2]:L;}}}}if(V)V=V.toLowerCase();W=s.getQueryParam(a,f);if(W){L=W;if(V){M=A}else{M=C}" + "}if(!W&&V){L=b+L;M=B}if(L){L=s.repl(L,'www.','')}if(d){O=s.split(d,'>');P=O.length;for(Q=0;Q<=P;Q++" + "){if(O[Q]){R=s.split(O[Q],'|');T=s.getQueryParam(R[1]);if(T)M=R[0]}}}if(e){O=s.split(e,'>');P=O.len" + "gth;for(Q=0;Q<=P;Q++){if(O[Q]){R=s.split(O[Q],'|');T=W.indexOf(R[1]);if(T==0)M=R[0]}}}X=M;Y=L;if(F=" + "='1'&&!W&&g){Z=s.split(g,'>');M=Z[0];X=Z[1];L=Z[2];Y=Z[3];}z=V+L+Y+M+X;y=i?i:'s_ats';z=i!='0'?s.get" + "ValOnce(z,y,0):z;s.atsCampaign=z?L:'';s.atsCampaignStack=z?Y:'';s.atsKeywords=z?V:'';s.atsChannel=z" + "?M:'';s.atsChannelStack=z?X:'';");

        /* WARNING: Changing any of the below variables will cause drastic
        changes to how your visitor data is collected.  Changes should only be
        made when instructed to do so by your account manager.*/
        s_wdpro.visitorNamespace = "wdpro";

        if (!s_wdpro.trackingServer) {
            s_wdpro.trackingServer = "w88.go.com";
        }

        if (!s_wdpro.trackingServerSecure) {
            s_wdpro.trackingServerSecure = "sw88.go.com";
        }

        s_wdpro.dc = 112;

        /*********************
         * s_wdpro.trackVideo()
         *
         * @Author Donald Organ
         * @LastModified 08/08/12
         *
         * @Description - beinds play, pause and ended events for a given video element to sitecatalysts tracking
         *      Note the following evens will be sent:
         *          assetStart=>event1
         *          assetComplete=>event11
         *          videoTime=>event43
         *       Note the following properties/eVars will be set:
         *          assetID=>prop3/eVar2
         *
         * @param {object} videoElement The Video DOM element
         * @param {DOM node} videoId The ID attribute assigned to the DOM element
         *
         * @example
            s_wdpro.trackVideo($('#video1').get(0), 'video1');
         *
         *
         **/
        s_wdpro.trackVideo = function (videoElement, videoId) {

            if (!!videoElement && !!videoId) {
                s_wdpro.Media.open('vid:' + videoId, videoElement.duration, 'vid:' + videoId);

                videoElement.addEventListener('play', function (e) {
                    s_wdpro.Media.play('vid:' + videoId, videoElement.currentTime);
                });

                videoElement.addEventListener('pause', function (e) {
                    s_wdpro.Media.stop('vid:' + videoId, videoElement.currentTime);
                });
                videoElement.addEventListener('ended', function (e) {
                    s_wdpro.Media.stop('vid:' + videoId, videoElement.currentTime);
                    s_wdpro.Media.close('vid:' + videoId);
                });
            }
        };

        s_wdpro.untrackVideo = function (videoId) {
            s_wdpro.Media.close('vid:' + videoId);
        };

        /****************************** MODULES *****************************/

        /***** UNCOMMENT TO USE THE Media MODULE *****/
        s_wdpro.loadModule("Media");
        s_wdpro.Media.onLoad = function (s, m) {
            /*
            * Module: Media
            */
            s_wdpro.Media.autoTrack = true;
            s_wdpro.Media.trackVars = "events,prop3,eVar2";
            s_wdpro.Media.trackEvents = "event1,event11,event43,event97,event98,event99";
            s_wdpro.Media.completeCloseOffsetThreshold = 10;
            s_wdpro.Media.completeByCloseOffset = true;
            s_wdpro.Media.trackUsingContextData = true;
            s_wdpro.Media.trackMilestones = "25,50,75";
            s_wdpro.Media.contextDataMapping = {
                "a.media.name": "prop3,eVar2",
                "a.media.timePlayed": "event43",
                "a.media.view": "event1",
                "a.media.complete": "event11",
                "a.media.milestones": {
                    25: "event97",
                    50: "event98",
                    75: "event99"
                }
            };
        };
        s_wdpro.m_Media_c = "var m=s.m_i('Media');if(m.completeByCloseOffset==undefined)m.completeByCloseOffset=1;if(m.completeCloseOffsetThreshold==undefined)m.completeCloseOffsetThreshold=1;m.cn=function(n){var m=" + "this;return m.s.rep(m.s.rep(m.s.rep(n,\"\\n\",''),\"\\r\",''),'--**--','')};m.open=function(n,l,p,b){var m=this,i=new Object,tm=new Date,a='',x;n=m.cn(n);if(!l)l=-1;if(n&&p){if(!m.l)m.l=new Object;" + "if(m.l[n])m.close(n);if(b&&b.id)a=b.id;if(a)for (x in m.l)if(m.l[x]&&m.l[x].a==a)m.close(m.l[x].n);i.n=n;i.l=l;i.o=0;i.x=0;i.p=m.cn(m.playerName?m.playerName:p);i.a=a;i.t=0;i.ts=0;i.s=Math.floor(tm" + ".getTime()/1000);i.lx=0;i.lt=i.s;i.lo=0;i.e='';i.to=-1;i.tc=0;i.fel=new Object;i.vt=0;i.sn=0;i.sx=\"\";i.sl=0;i.sg=0;i.sc=0;i.us=0;i.ad=0;i.adpn;i.adpp;i.adppp;i.clk;i.CPM;i.co=0;i.cot=0;i.lm=0;i.l" + "om=0;m.l[n]=i}};m.openAd=function(n,l,p,pn,pp,ppp,CPM,b){var m=this,i=new Object;n=m.cn(n);m.open(n,l,p,b);i=m.l[n];if(i){i.ad=1;i.adpn=m.cn(pn);i.adpp=pp;i.adppp=ppp;i.CPM=CPM}};m._delete=function" + "(n){var m=this,i;n=m.cn(n);i=m.l[n];m.l[n]=0;if(i&&i.m)clearTimeout(i.m.i)};m.close=function(n){this.e(n,0,-1)};m.play=function(n,o,sn,sx,sl){var m=this,i;i=m.e(n,1,o,sn,sx,sl);if(i&&!i.m){i.m=new " + "Object;i.m.m=new Function('var m=s_c_il['+m._in+'],i;if(m.l){i=m.l[\"'+m.s.rep(i.n,'\"','\\\\\"')+'\"];if(i){if(i.lx==1)m.e(i.n,3,-1);i.m.i=setTimeout(i.m.m,1000)}}');i.m.m()}};m.click=function(n,o" + "){this.e(n,7,o)};m.complete=function(n,o){this.e(n,5,o)};m.stop=function(n,o){this.e(n,2,o)};m.track=function(n){this.e(n,4,-1)};m.bcd=function(vo,i){var m=this,ns='a.media.',v=vo.linkTrackVars,e=v" + "o.linkTrackEvents,pe='m_i',pev3,c=vo.contextData,x;if(i.ad){ns+='ad.';if(i.adpn){c['a.media.name']=i.adpn;c[ns+'pod']=i.adpp;c[ns+'podPosition']=i.adppp;}if(!i.vt)c[ns+'CPM']=i.CPM;}if (i.clk) {c[n" + "s+'clicked']=true;i.clk=0}c['a.contentType']='video'+(i.ad?'Ad':'');c['a.media.channel']=m.channel;c[ns+'name']=i.n;c[ns+'playerName']=i.p;if(i.l>0)c[ns+'length']=i.l;if(Math.floor(i.ts)>0)c[ns+'ti" + "mePlayed']=Math.floor(i.ts);if(!i.vt){c[ns+'view']=true;pe='m_s';i.vt=1}if(i.sx){c[ns+'segmentNum']=i.sn;c[ns+'segment']=i.sx;if(i.sl>0)c[ns+'segmentLength']=i.sl;if(i.sc&&i.ts>0)c[ns+'segmentView'" + "]=true}if(!i.cot&&i.co){c[ns+\"complete\"]=true;i.cot=1}if(i.lm>0)c[ns+'milestone']=i.lm;if(i.lom>0)c[ns+'offsetMilestone']=i.lom;if(v)for(x in c)v+=',contextData.'+x;pev3=c['a.contentType'];vo.pe=" + "pe;vo.pev3=pev3;var d=m.contextDataMapping,y,a,l,n;if(d){vo.events2='';if(v)v+=',events';for(x in d){if(x.substring(0,ns.length)==ns)y=x.substring(ns.length);else y=\"\";a=d[x];if(typeof(a)=='strin" + "g'){l=m.s.sp(a,',');for(n=0;n<l.length;n++){a=l[n];if(x==\"a.contentType\"){if(v)v+=','+a;vo[a]=c[x]}else if(y=='view'||y=='segmentView'||y=='clicked'||y=='complete'||y=='timePlayed'||y=='CPM'){if(" + "e)e+=','+a;if(y=='timePlayed'||y=='CPM'){if(c[x])vo.events2+=(vo.events2?',':'')+a+'='+c[x];}else if(c[x])vo.events2+=(vo.events2?',':'')+a}else if(y=='segment'&&c[x+'Num']){if(v)v+=','+a;vo[a]=c[x" + "+'Num']+':'+c[x]}else{if(v)v+=','+a;vo[a]=c[x]}}}else if(y=='milestones'||y=='offsetMilestones'){x=x.substring(0,x.length-1);if(c[x]&&d[x+'s'][c[x]]){if(e)e+=','+d[x+'s'][c[x]];vo.events2+=(vo.even" + "ts2?',':'')+d[x+'s'][c[x]]}}if(c[x])c[x]=undefined;if(y=='segment'&&c[x+'Num'])c[x+\"Num\"]=undefined}}vo.linkTrackVars=v;vo.linkTrackEvents=e};m.bpe=function(vo,i,x,o){var m=this,pe='m_o',pev3,d='" + "--**--';pe='m_o';if(!i.vt){pe='m_s';i.vt=1}else if(x==4)pe='m_i';pev3=m.s.ape(i.n)+d+Math.floor(i.l>0?i.l:1)+d+m.s.ape(i.p)+d+Math.floor(i.t)+d+i.s+d+(i.to>=0?'L'+Math.floor(i.to):'')+i.e+(x!=0&&x!" + "=2?'L'+Math.floor(o):'');vo.pe=pe;vo.pev3=pev3};m.e=function(n,x,o,sn,sx,sl,pd){var m=this,i,tm=new Date,ts=Math.floor(tm.getTime()/1000),c,l,v=m.trackVars,e=m.trackEvents,ti=m.trackSeconds,tp=m.tr" + "ackMilestones,to=m.trackOffsetMilestones,sm=m.segmentByMilestones,so=m.segmentByOffsetMilestones,z=new Array,j,t=1,w=new Object,x,ek,tc,vo=new Object;if(!m.channel)m.channel=m.s.wd.location.hostnam" + "e;n=m.cn(n);i=n&&m.l&&m.l[n]?m.l[n]:0;if(i){if(i.ad){ti=m.adTrackSeconds;tp=m.adTrackMilestones;to=m.adTrackOffsetMilestones;sm=m.adSegmentByMilestones;so=m.adSegmentByOffsetMilestones}if(o<0){if(i" + ".lx==1&&i.lt>0)o=(ts-i.lt)+i.lo;else o=i.lo}if(i.l>0)o=o<i.l?o:i.l;if(o<0)o=0;i.o=o;if(i.l>0){i.x=(i.o/i.l)*100;i.x=i.x>100?100:i.x}if(i.lo<0)i.lo=o;tc=i.tc;w.name=n;w.ad=i.ad;w.length=i.l;w.openTi" + "me=new Date;w.openTime.setTime(i.s*1000);w.offset=i.o;w.percent=i.x;w.playerName=i.p;if(i.to<0)w.mediaEvent=w.event='OPEN';else w.mediaEvent=w.event=(x==1?'PLAY':(x==2?'STOP':(x==3?'MONITOR':(x==4?" + "'TRACK':(x==5?'COMPLETE':(x==7?'CLICK':('CLOSE')))))));if(!pd){if(i.pd)pd=i.pd}else i.pd=pd;w.player=pd;if(x>2||(x!=i.lx&&(x!=2||i.lx==1))) {if(!sx){sn=i.sn;sx=i.sx;sl=i.sl}if(x){if(x==1)i.lo=o;if(" + "(x<=3||x>=5)&&i.to>=0){t=0;v=e=\"None\";if(i.to!=o){l=i.to;if(l>o){l=i.lo;if(l>o)l=o}z=tp?m.s.sp(tp,','):0;if(i.l>0&&z&&o>=l)for(j=0;j<z.length;j++){c=z[j]?parseFloat(''+z[j]):0;if(c&&(l/i.l)*100<c" + "&&i.x>=c){t=1;j=z.length;w.mediaEvent=w.event='MILESTONE';i.lm=w.milestone=c}}z=to?m.s.sp(to,','):0;if(z&&o>=l)for(j=0;j<z.length;j++){c=z[j]?parseFloat(''+z[j]):0;if(c&&l<c&&o>=c){t=1;j=z.length;w" + ".mediaEvent=w.event='OFFSET_MILESTONE';i.lom=w.offsetMilestone=c}}}}if(i.sg||!sx){if(sm&&tp&&i.l>0){z=m.s.sp(tp,',');if(z){z[z.length]='100';l=0;for(j=0;j<z.length;j++){c=z[j]?parseFloat(''+z[j]):0" + ";if(c){if(i.x<c){sn=j+1;sx='M:'+l+'-'+c;j=z.length}l=c}}}}else if(so&&to){z=m.s.sp(to,',');if(z){z[z.length]=''+(i.l>0?i.l:'E');l=0;for(j=0;j<z.length;j++){c=z[j]?parseFloat(''+z[j]):0;if(c||z[j]==" + "'E'){if(o<c||z[j]=='E'){sn=j+1;sx='O:'+l+'-'+c;j=z.length}l=c}}}}if(sx)i.sg=1}if((sx||i.sx)&&sx!=i.sx){i.us=1;if(!i.sx){i.sn=sn;i.sx=sx}if(i.to>=0)t=1}if((x>=2||i.x>=100)&&i.lo<o){i.t+=o-i.lo;i.ts+" + "=o-i.lo}if(x<=2||(x==3&&!i.lx)){i.e+=(x==1||x==3?'S':'E')+Math.floor(o);i.lx=(x==3?1:x)}if(!t&&i.to>=0&&x<=3){ti=ti?ti:0;if(ti&&i.ts>=ti){t=1;w.mediaEvent=w.event='SECONDS'}}i.lt=ts;i.lo=o}if(!x||(" + "x<=3&&i.x>=100)){if(i.lx!=2)i.e+='E'+Math.floor(o);x=0;v=e=\"None\";w.mediaEvent=w.event=\"CLOSE\"}if(x==7){w.clicked=i.clk=1;t=1}if(x==5||(m.completeByCloseOffset&&(!x||i.x>=100)&&i.l>0&&o>=i.l-m." + "completeCloseOffsetThreshold)){w.complete=i.co=1;t=1}ek=w.mediaEvent;if(ek=='MILESTONE')ek+='_'+w.milestone;else if(ek=='OFFSET_MILESTONE')ek+='_'+w.offsetMilestone;if(!i.fel[ek]) {w.eventFirstTime" + "=true;i.fel[ek]=1}else w.eventFirstTime=false;w.timePlayed=i.t;w.segmentNum=i.sn;w.segment=i.sx;w.segmentLength=i.sl;if(m.monitor&&x!=4)m.monitor(m.s,w);if(x==0)m._delete(n);if(t&&i.tc==tc){vo=new " + "Object;vo.contextData=new Object;vo.linkTrackVars=v;vo.linkTrackEvents=e;if(!vo.linkTrackVars)vo.linkTrackVars='';if(!vo.linkTrackEvents)vo.linkTrackEvents='';if(m.trackUsingContextData)m.bcd(vo,i)" + ";else m.bpe(vo,i,x,o);m.s.t(vo);if(i.us){i.sn=sn;i.sx=sx;i.sc=1;i.us=0}else if(i.ts>0)i.sc=0;i.e=\"\";i.lm=i.lom=0;i.ts-=Math.floor(i.ts);i.to=o;i.tc++}}}return i};m.ae=function(n,l,p,x,o,sn,sx,sl," + "pd,b){var m=this,r=0;if(n&&(!m.autoTrackMediaLengthRequired||(length&&length>0)) &&p){if(!m.l||!m.l[n]){if(x==1||x==3){m.open(n,l,p,b);r=1}}else r=1;if(r)m.e(n,x,o,sn,sx,sl,pd)}};m.a=function(o,t){" + "var m=this,i=o.id?o.id:o.name,n=o.name,p=0,v,c,c1,c2,xc=m.s.h,x,e,f1,f2='s_media_'+m._in+'_oc',f3='s_media_'+m._in+'_t',f4='s_media_'+m._in+'_s',f5='s_media_'+m._in+'_l',f6='s_media_'+m._in+'_m',f7" + "='s_media_'+m._in+'_c',tcf,w;if(!i){if(!m.c)m.c=0;i='s_media_'+m._in+'_'+m.c;m.c++}if(!o.id)o.id=i;if(!o.name)o.name=n=i;if(!m.ol)m.ol=new Object;if(m.ol[i])return;m.ol[i]=o;if(!xc)xc=m.s.b;tcf=new" + " Function('o','var e,p=0;try{if(o.versionInfo&&o.currentMedia&&o.controls)p=1}catch(e){p=0}return p');p=tcf(o);if(!p){tcf=new Function('o','var e,p=0,t;try{t=o.GetQuickTimeVersion();if(t)p=2}catch(" + "e){p=0}return p');p=tcf(o);if(!p){tcf=new Function('o','var e,p=0,t;try{t=o.GetVersionInfo();if(t)p=3}catch(e){p=0}return p');p=tcf(o)}}v=\"var m=s_c_il[\"+m._in+\"],o=m.ol['\"+i+\"']\";if(p==1){p=" + "'Windows Media Player '+o.versionInfo;c1=v+',n,p,l,x=-1,cm,c,mn;if(o){cm=o.currentMedia;c=o.controls;if(cm&&c){mn=cm.name?cm.name:c.URL;l=cm.duration;p=c.currentPosition;n=o.playState;if(n){if(n==8" + ")x=0;if(n==3)x=1;if(n==1||n==2||n==4||n==5||n==6)x=2;}';c2='if(x>=0)m.ae(mn,l,\"'+p+'\",x,x!=2?p:-1,0,\"\",0,0,o)}}';c=c1+c2;if(m.s.isie&&xc){x=m.s.d.createElement('script');x.language='jscript';x." + "type='text/javascript';x.htmlFor=i;x.event='PlayStateChange(NewState)';x.defer=true;x.text=c;xc.appendChild(x);o[f6]=new Function(c1+'if(n==3){x=3;'+c2+'}setTimeout(o.'+f6+',5000)');o[f6]()}}if(p==" + "2){p='QuickTime Player '+(o.GetIsQuickTimeRegistered()?'Pro ':'')+o.GetQuickTimeVersion();f1=f2;c=v+',n,x,t,l,p,p2,mn;if(o){mn=o.GetMovieName()?o.GetMovieName():o.GetURL();n=o.GetRate();t=o.GetTime" + "Scale();l=o.GetDuration()/t;p=o.GetTime()/t;p2=o.'+f5+';if(n!=o.'+f4+'||p<p2||p-p2>5){x=2;if(n!=0)x=1;else if(p>=l)x=0;if(p<p2||p-p2>5)m.ae(mn,l,\"'+p+'\",2,p2,0,\"\",0,0,o);m.ae(mn,l,\"'+p+'\",x,x" + "!=2?p:-1,0,\"\",0,0,o)}if(n>0&&o.'+f7+'>=10){m.ae(mn,l,\"'+p+'\",3,p,0,\"\",0,0,o);o.'+f7+'=0}o.'+f7+'++;o.'+f4+'=n;o.'+f5+'=p;setTimeout(\"'+v+';o.'+f2+'(0,0)\",500)}';o[f1]=new Function('a','b',c" + ");o[f4]=-1;o[f7]=0;o[f1](0,0)}if(p==3){p='RealPlayer '+o.GetVersionInfo();f1=n+'_OnPlayStateChange';c1=v+',n,x=-1,l,p,mn;if(o){mn=o.GetTitle()?o.GetTitle():o.GetSource();n=o.GetPlayState();l=o.GetL" + "ength()/1000;p=o.GetPosition()/1000;if(n!=o.'+f4+'){if(n==3)x=1;if(n==0||n==2||n==4||n==5)x=2;if(n==0&&(p>=l||p==0))x=0;if(x>=0)m.ae(mn,l,\"'+p+'\",x,x!=2?p:-1,0,\"\",0,0,o)}if(n==3&&(o.'+f7+'>=10|" + "|!o.'+f3+')){m.ae(mn,l,\"'+p+'\",3,p,0,\"\",0,0,o);o.'+f7+'=0}o.'+f7+'++;o.'+f4+'=n;';c2='if(o.'+f2+')o.'+f2+'(o,n)}';if(m.s.wd[f1])o[f2]=m.s.wd[f1];m.s.wd[f1]=new Function('a','b',c1+c2);o[f1]=new" + " Function('a','b',c1+'setTimeout(\"'+v+';o.'+f1+'(0,0)\",o.'+f3+'?500:5000);'+c2);o[f4]=-1;if(m.s.isie)o[f3]=1;o[f7]=0;o[f1](0,0)}};m.as=new Function('e','var m=s_c_il['+m._in+'],l,n;if(m.autoTrack" + "&&m.s.d.getElementsByTagName){l=m.s.d.getElementsByTagName(m.s.isie?\"OBJECT\":\"EMBED\");if(l)for(n=0;n<l.length;n++)m.a(l[n]);}');if(s.wd.attachEvent)s.wd.attachEvent('onload',m.as);else if(s.wd." + "addEventListener)s.wd.addEventListener('load',m.as,false);if(m.onLoad)m.onLoad(s,m)";s_wdpro.m_i("Media");
        /**** END Media MODULE COMMENT ***/

        /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
        var s_code = '',
            s_objectID;function s_gi(un, pg, ss) {
            var c = "s.version='H.27.5';s.an=s_an;s.logDebug=function(m){var s=this,tcf=new Function('var e;try{console.log(\"'+s.rep(s.rep(s.rep(m,\"\\\\\",\"\\\\" + "\\\\\"),\"\\n\",\"\\\\n\"),\"\\\"\",\"\\\\\\\"\")+'\");}catch(e){}');tcf()};s.cls=function(x,c){var i,y='';if(!c)c=this.an;for(i=0;i<x.length;i++){n=x.substring(i,i+1);if(c.indexOf(n)>=0)y+=n}retur" + "n y};s.fl=function(x,l){return x?(''+x).substring(0,l):x};s.co=function(o){return o};s.num=function(x){x=''+x;for(var p=0;p<x.length;p++)if(('0123456789').indexOf(x.substring(p,p+1))<0)return 0;ret" + "urn 1};s.rep=s_rep;s.sp=s_sp;s.jn=s_jn;s.ape=function(x){var s=this,h='0123456789ABCDEF',f=\"+~!*()'\",i,c=s.charSet,n,l,e,y='';c=c?c.toUpperCase():'';if(x){x=''+x;if(s.em==3){x=encodeURIComponent(" + "x);for(i=0;i<f.length;i++) {n=f.substring(i,i+1);if(x.indexOf(n)>=0)x=s.rep(x,n,\"%\"+n.charCodeAt(0).toString(16).toUpperCase())}}else if(c=='AUTO'&&('').charCodeAt){for(i=0;i<x.length;i++){c=x.su" + "bstring(i,i+1);n=x.charCodeAt(i);if(n>127){l=0;e='';while(n||l<4){e=h.substring(n%16,n%16+1)+e;n=(n-n%16)/16;l++}y+='%u'+e}else if(c=='+')y+='%2B';else y+=escape(c)}x=y}else x=s.rep(escape(''+x),'+" + "','%2B');if(c&&c!='AUTO'&&s.em==1&&x.indexOf('%u')<0&&x.indexOf('%U')<0){i=x.indexOf('%');while(i>=0){i++;if(h.substring(8).indexOf(x.substring(i,i+1).toUpperCase())>=0)return x.substring(0,i)+'u00" + "'+x.substring(i);i=x.indexOf('%',i)}}}return x};s.epa=function(x){var s=this,y,tcf;if(x){x=s.rep(''+x,'+',' ');if(s.em==3){tcf=new Function('x','var y,e;try{y=decodeURIComponent(x)}catch(e){y=unesc" + "ape(x)}return y');return tcf(x)}else return unescape(x)}return y};s.pt=function(x,d,f,a){var s=this,t=x,z=0,y,r;while(t){y=t.indexOf(d);y=y<0?t.length:y;t=t.substring(0,y);r=s[f](t,a);if(r)return r" + ";z+=y+d.length;t=x.substring(z,x.length);t=z<x.length?t:''}return ''};s.isf=function(t,a){var c=a.indexOf(':');if(c>=0)a=a.substring(0,c);c=a.indexOf('=');if(c>=0)a=a.substring(0,c);if(t.substring(" + "0,2)=='s_')t=t.substring(2);return (t!=''&&t==a)};s.fsf=function(t,a){var s=this;if(s.pt(a,',','isf',t))s.fsg+=(s.fsg!=''?',':'')+t;return 0};s.fs=function(x,f){var s=this;s.fsg='';s.pt(x,',','fsf'" + ",f);return s.fsg};s.mpc=function(m,a){var s=this,c,l,n,v;v=s.d.visibilityState;if(!v)v=s.d.webkitVisibilityState;if(v&&v=='prerender'){if(!s.mpq){s.mpq=new Array;l=s.sp('webkitvisibilitychange,visi" + "bilitychange',',');for(n=0;n<l.length;n++){s.d.addEventListener(l[n],new Function('var s=s_c_il['+s._in+'],c,v;v=s.d.visibilityState;if(!v)v=s.d.webkitVisibilityState;if(s.mpq&&v==\"visible\"){whil" + "e(s.mpq.length>0){c=s.mpq.shift();s[c.m].apply(s,c.a)}s.mpq=0}'),false)}}c=new Object;c.m=m;c.a=a;s.mpq.push(c);return 1}return 0};s.si=function(){var s=this,i,k,v,c=s_gi+'var s=s_gi(\"'+s.oun+'\")" + ";s.sa(\"'+s.un+'\");';for(i=0;i<s.va_g.length;i++){k=s.va_g[i];v=s[k];if(v!=undefined){if(typeof(v)!='number')c+='s.'+k+'=\"'+s_fe(v)+'\";';else c+='s.'+k+'='+v+';'}}c+=\"s.lnk=s.eo=s.linkName=s.li" + "nkType=s.wd.s_objectID=s.ppu=s.pe=s.pev1=s.pev2=s.pev3='';\";return c};s.c_d='';s.c_gdf=function(t,a){var s=this;if(!s.num(t))return 1;return 0};s.c_gd=function(){var s=this,d=s.wd.location.hostnam" + "e,n=s.fpCookieDomainPeriods,p;if(!n)n=s.cookieDomainPeriods;if(d&&!s.c_d){n=n?parseInt(n):2;n=n>2?n:2;p=d.lastIndexOf('.');if(p>=0){while(p>=0&&n>1){p=d.lastIndexOf('.',p-1);n--}s.c_d=p>0&&s.pt(d,'" + ".','c_gdf',0)?d.substring(p):d}}return s.c_d};s.c_r=function(k){var s=this;k=s.ape(k);var c=' '+s.d.cookie,i=c.indexOf(' '+k+'='),e=i<0?i:c.indexOf(';',i),v=i<0?'':s.epa(c.substring(i+2+k.length,e<" + "0?c.length:e));return v!='[[B]]'?v:''};s.c_w=function(k,v,e){var s=this,d=s.c_gd(),l=s.cookieLifetime,t;v=''+v;l=l?(''+l).toUpperCase():'';if(e&&l!='SESSION'&&l!='NONE'){t=(v!=''?parseInt(l?l:0):-6" + "0);if(t){e=new Date;e.setTime(e.getTime()+(t*1000))}}if(k&&l!='NONE'){s.d.cookie=k+'='+s.ape(v!=''?v:'[[B]]')+'; path=/;'+(e&&l!='SESSION'?' expires='+e.toGMTString()+';':'')+(d?' domain='+d+';':''" + ");return s.c_r(k)==v}return 0};s.eh=function(o,e,r,f){var s=this,b='s_'+e+'_'+s._in,n=-1,l,i,x;if(!s.ehl)s.ehl=new Array;l=s.ehl;for(i=0;i<l.length&&n<0;i++){if(l[i].o==o&&l[i].e==e)n=i}if(n<0){n=i" + ";l[n]=new Object}x=l[n];x.o=o;x.e=e;f=r?x.b:f;if(r||f){x.b=r?0:o[e];x.o[e]=f}if(x.b){x.o[b]=x.b;return b}return 0};s.cet=function(f,a,t,o,b){var s=this,r,tcf;if(s.apv>=5&&(!s.isopera||s.apv>=7)){tc" + "f=new Function('s','f','a','t','var e,r;try{r=s[f](a)}catch(e){r=s[t](e)}return r');r=tcf(s,f,a,t)}else{if(s.ismac&&s.u.indexOf('MSIE 4')>=0)r=s[b](a);else{s.eh(s.wd,'onerror',0,o);r=s[f](a);s.eh(s" + ".wd,'onerror',1)}}return r};s.gtfset=function(e){var s=this;return s.tfs};s.gtfsoe=new Function('e','var s=s_c_il['+s._in+'],c;s.eh(window,\"onerror\",1);s.etfs=1;c=s.t();if(c)s.d.write(c);s.etfs=0" + ";return true');s.gtfsfb=function(a){return window};s.gtfsf=function(w){var s=this,p=w.parent,l=w.location;s.tfs=w;if(p&&p.location!=l&&p.location.host==l.host){s.tfs=p;return s.gtfsf(s.tfs)}return " + "s.tfs};s.gtfs=function(){var s=this;if(!s.tfs){s.tfs=s.wd;if(!s.etfs)s.tfs=s.cet('gtfsf',s.tfs,'gtfset',s.gtfsoe,'gtfsfb')}return s.tfs};s.mrq=function(u){var s=this,l=s.rl[u],n,r;s.rl[u]=0;if(l)fo" + "r(n=0;n<l.length;n++){r=l[n];s.mr(0,0,r.r,r.t,r.u)}};s.flushBufferedRequests=function(){};s.tagContainerMarker='';s.mr=function(sess,q,rs,ta,u){var s=this,dc=s.dc,t1=s.trackingServer,t2=s.trackingS" + "erverSecure,tb=s.trackingServerBase,p='.sc',ns=s.visitorNamespace,un=s.cls(u?u:(ns?ns:s.fun)),r=new Object,l,imn='s_i_'+s._in+'_'+un,im,b,e;if(!rs){if(t1){if(t2&&s.ssl)t1=t2}else{if(!tb)tb='2o7.net" + "';if(dc)dc=(''+dc).toLowerCase();else dc='d1';if(tb=='2o7.net'){if(dc=='d1')dc='112';else if(dc=='d2')dc='122';p=''}t1=un+'.'+dc+'.'+p+tb}rs='http'+(s.ssl?'s':'')+'://'+t1+'/b/ss/'+s.un+'/'+(s.mobi" + "le?'5.1':'1')+'/'+s.version+(s.tcn?'T':'')+(s.tagContainerMarker?\"-\"+s.tagContainerMarker:\"\")+'/'+sess+'?AQB=1&ndh=1'+(q?q:'')+'&AQE=1';if(s.isie&&!s.ismac)rs=s.fl(rs,2047)}if(s.d.images&&s.apv" + ">=3&&(!s.isopera||s.apv>=7)&&(s.ns6<0||s.apv>=6.1)){if(!s.rc)s.rc=new Object;if(!s.rc[un]){s.rc[un]=1;if(!s.rl)s.rl=new Object;s.rl[un]=new Array;setTimeout('if(window.s_c_il)window.s_c_il['+s._in+" + "'].mrq(\"'+un+'\")',750)}else{l=s.rl[un];if(l){r.t=ta;r.u=un;r.r=rs;l[l.length]=r;return ''}imn+='_'+s.rc[un];s.rc[un]++}if(s.debugTracking){var d='AppMeasurement Debug: '+rs,dl=s.sp(rs,'&'),dln;fo" + "r(dln=0;dln<dl.length;dln++)d+=\"\\n\\t\"+s.epa(dl[dln]);s.logDebug(d)}im=s.wd[imn];if(!im)im=s.wd[imn]=new Image;im.alt=\"\";im.s_l=0;im.onload=im.onerror=new Function('e','this.s_l=1;var wd=windo" + "w,s;if(wd.s_c_il){s=wd.s_c_il['+s._in+'];s.bcr();s.mrq(\"'+un+'\");s.nrs--;if(!s.nrs)s.m_m(\"rr\")}');if(!s.nrs){s.nrs=1;s.m_m('rs')}else s.nrs++;im.src=rs;if(s.useForcedLinkTracking||s.bcf){if(!s." + "forcedLinkTrackingTimeout)s.forcedLinkTrackingTimeout=250;setTimeout('if(window.s_c_il)window.s_c_il['+s._in+'].bcr()',s.forcedLinkTrackingTimeout);}else if((s.lnk||s.eo)&&(!ta||ta=='_self'||ta=='_" + "top'||ta=='_parent'||(s.wd.name&&ta==s.wd.name))){b=e=new Date;while(!im.s_l&&e.getTime()-b.getTime()<500)e=new Date}return ''}return '<im'+'g sr'+'c=\"'+rs+'\" width=1 height=1 border=0 alt=\"\">'" + "};s.gg=function(v){var s=this;if(!s.wd['s_'+v])s.wd['s_'+v]='';return s.wd['s_'+v]};s.glf=function(t,a){if(t.substring(0,2)=='s_')t=t.substring(2);var s=this,v=s.gg(t);if(v)s[t]=v};s.gl=function(v)" + "{var s=this;if(s.pg)s.pt(v,',','glf',0)};s.rf=function(x){var s=this,y,i,j,h,p,l=0,q,a,b='',c='',t;if(x&&x.length>255){y=''+x;i=y.indexOf('?');if(i>0){q=y.substring(i+1);y=y.substring(0,i);h=y.toLo" + "werCase();j=0;if(h.substring(0,7)=='http://')j+=7;else if(h.substring(0,8)=='https://')j+=8;i=h.indexOf(\"/\",j);if(i>0){h=h.substring(j,i);p=y.substring(i);y=y.substring(0,i);if(h.indexOf('google'" + ")>=0)l=',q,ie,start,search_key,word,kw,cd,';else if(h.indexOf('yahoo.co')>=0)l=',p,ei,';if(l&&q){a=s.sp(q,'&');if(a&&a.length>1){for(j=0;j<a.length;j++){t=a[j];i=t.indexOf('=');if(i>0&&l.indexOf('," + "'+t.substring(0,i)+',')>=0)b+=(b?'&':'')+t;else c+=(c?'&':'')+t}if(b&&c)q=b+'&'+c;else c=''}i=253-(q.length-c.length)-y.length;x=y+(i>0?p.substring(0,i):'')+'?'+q}}}}return x};s.s2q=function(k,v,vf" + ",vfp,f){var s=this,qs='',sk,sv,sp,ss,nke,nk,nf,nfl=0,nfn,nfm;if(k==\"contextData\")k=\"c\";if(v){for(sk in v)if((!f||sk.substring(0,f.length)==f)&&v[sk]&&(!vf||vf.indexOf(','+(vfp?vfp+'.':'')+sk+'," + "')>=0)&&(!Object||!Object.prototype||!Object.prototype[sk])){nfm=0;if(nfl)for(nfn=0;nfn<nfl.length;nfn++)if(sk.substring(0,nfl[nfn].length)==nfl[nfn])nfm=1;if(!nfm){if(qs=='')qs+='&'+k+'.';sv=v[sk]" + ";if(f)sk=sk.substring(f.length);if(sk.length>0){nke=sk.indexOf('.');if(nke>0){nk=sk.substring(0,nke);nf=(f?f:'')+nk+'.';if(!nfl)nfl=new Array;nfl[nfl.length]=nf;qs+=s.s2q(nk,v,vf,vfp,nf)}else{if(ty" + "peof(sv)=='boolean'){if(sv)sv='true';else sv='false'}if(sv){if(vfp=='retrieveLightData'&&f.indexOf('.contextData.')<0){sp=sk.substring(0,4);ss=sk.substring(4);if(sk=='transactionID')sk='xact';else " + "if(sk=='channel')sk='ch';else if(sk=='campaign')sk='v0';else if(s.num(ss)){if(sp=='prop')sk='c'+ss;else if(sp=='eVar')sk='v'+ss;else if(sp=='list')sk='l'+ss;else if(sp=='hier'){sk='h'+ss;sv=sv.subs" + "tring(0,255)}}}qs+='&'+s.ape(sk)+'='+s.ape(sv)}}}}}if(qs!='')qs+='&.'+k}return qs};s.hav=function(){var s=this,qs='',l,fv='',fe='',mn,i,e;if(s.lightProfileID){l=s.va_m;fv=s.lightTrackVars;if(fv)fv=" + "','+fv+','+s.vl_mr+','}else{l=s.va_t;if(s.pe||s.linkType){fv=s.linkTrackVars;fe=s.linkTrackEvents;if(s.pe){mn=s.pe.substring(0,1).toUpperCase()+s.pe.substring(1);if(s[mn]){fv=s[mn].trackVars;fe=s[m" + "n].trackEvents}}}if(fv)fv=','+fv+','+s.vl_l+','+s.vl_l2;if(fe){fe=','+fe+',';if(fv)fv+=',events,'}if (s.events2)e=(e?',':'')+s.events2}for(i=0;i<l.length;i++){var k=l[i],v=s[k],b=k.substring(0,4),x" + "=k.substring(4),n=parseInt(x),q=k;if(!v)if(k=='events'&&e){v=e;e=''}if(v&&(!fv||fv.indexOf(','+k+',')>=0)&&k!='linkName'&&k!='linkType'){if(k=='supplementalDataID')q='sdid';else if(k=='timestamp')q" + "='ts';else if(k=='dynamicVariablePrefix')q='D';else if(k=='visitorID')q='vid';else if(k=='marketingCloudVisitorID')q='mid';else if(k=='analyticsVisitorID')q='aid';else if(k=='audienceManagerLocatio" + "nHint')q='aamlh';else if(k=='audienceManagerBlob')q='aamb';else if(k=='authState')q='as';else if(k=='pageURL'){q='g';if(v.length>255){s.pageURLRest=v.substring(255);v=v.substring(0,255);}}else if(k" + "=='pageURLRest')q='-g';else if(k=='referrer'){q='r';v=s.fl(s.rf(v),255)}else if(k=='vmk'||k=='visitorMigrationKey')q='vmt';else if(k=='visitorMigrationServer'){q='vmf';if(s.ssl&&s.visitorMigrationS" + "erverSecure)v=''}else if(k=='visitorMigrationServerSecure'){q='vmf';if(!s.ssl&&s.visitorMigrationServer)v=''}else if(k=='charSet'){q='ce';if(v.toUpperCase()=='AUTO')v='ISO8859-1';else if(s.em==2||s" + ".em==3)v='UTF-8'}else if(k=='visitorNamespace')q='ns';else if(k=='cookieDomainPeriods')q='cdp';else if(k=='cookieLifetime')q='cl';else if(k=='variableProvider')q='vvp';else if(k=='currencyCode')q='" + "cc';else if(k=='channel')q='ch';else if(k=='transactionID')q='xact';else if(k=='campaign')q='v0';else if(k=='resolution')q='s';else if(k=='colorDepth')q='c';else if(k=='javascriptVersion')q='j';els" + "e if(k=='javaEnabled')q='v';else if(k=='cookiesEnabled')q='k';else if(k=='browserWidth')q='bw';else if(k=='browserHeight')q='bh';else if(k=='connectionType')q='ct';else if(k=='homepage')q='hp';else" + " if(k=='plugins')q='p';else if(k=='events'){if(e)v+=(v?',':'')+e;if(fe)v=s.fs(v,fe)}else if(k=='events2')v='';else if(k=='contextData'){qs+=s.s2q('c',s[k],fv,k,0);v=''}else if(k=='lightProfileID')q" + "='mtp';else if(k=='lightStoreForSeconds'){q='mtss';if(!s.lightProfileID)v=''}else if(k=='lightIncrementBy'){q='mti';if(!s.lightProfileID)v=''}else if(k=='retrieveLightProfiles')q='mtsr';else if(k==" + "'deleteLightProfiles')q='mtsd';else if(k=='retrieveLightData'){if(s.retrieveLightProfiles)qs+=s.s2q('mts',s[k],fv,k,0);v=''}else if(s.num(x)){if(b=='prop')q='c'+n;else if(b=='eVar')q='v'+n;else if(" + "b=='list')q='l'+n;else if(b=='hier'){q='h'+n;v=s.fl(v,255)}}if(v)qs+='&'+s.ape(q)+'='+(k.substring(0,3)!='pev'?s.ape(v):v)}}return qs};s.ltdf=function(t,h){t=t?t.toLowerCase():'';h=h?h.toLowerCase(" + "):'';var qi=h.indexOf('?'),hi=h.indexOf('#');if(qi>=0){if(hi>=0&&hi<qi)qi=hi;}else qi=hi;h=qi>=0?h.substring(0,qi):h;if(t&&h.substring(h.length-(t.length+1))=='.'+t)return 1;return 0};s.ltef=functi" + "on(t,h){t=t?t.toLowerCase():'';h=h?h.toLowerCase():'';if(t&&h.indexOf(t)>=0)return 1;return 0};s.lt=function(h){var s=this,lft=s.linkDownloadFileTypes,lef=s.linkExternalFilters,lif=s.linkInternalFi" + "lters;lif=lif?lif:s.wd.location.hostname;h=h.toLowerCase();if(s.trackDownloadLinks&&lft&&s.pt(lft,',','ltdf',h))return 'd';if(s.trackExternalLinks&&h.indexOf('#')!=0&&h.indexOf('about:')!=0&&h.inde" + "xOf('javascript:')!=0&&(lef||lif)&&(!lef||s.pt(lef,',','ltef',h))&&(!lif||!s.pt(lif,',','ltef',h)))return 'e';return ''};s.lc=new Function('e','var s=s_c_il['+s._in+'],b=s.eh(this,\"onclick\");s.ln" + "k=this;s.t();s.lnk=0;if(b)return this[b](e);return true');s.bcr=function(){var s=this;if(s.bct&&s.bce)s.bct.dispatchEvent(s.bce);if(s.bcf){if(typeof(s.bcf)=='function')s.bcf();else if(s.bct&&s.bct." + "href)s.d.location=s.bct.href}s.bct=s.bce=s.bcf=0};s.bc=new Function('e','if(e&&e.s_fe)return;var s=s_c_il['+s._in+'],f,tcf,t,n,nrs,a,h;if(s.d&&s.d.all&&s.d.all.cppXYctnr)return;if(!s.bbc)s.useForce" + "dLinkTracking=0;else if(!s.useForcedLinkTracking){s.b.removeEventListener(\"click\",s.bc,true);s.bbc=s.useForcedLinkTracking=0;return}else s.b.removeEventListener(\"click\",s.bc,false);s.eo=e.srcEl" + "ement?e.srcElement:e.target;nrs=s.nrs;s.t();s.eo=0;if(s.nrs>nrs&&s.useForcedLinkTracking&&e.target){a=e.target;while(a&&a!=s.b&&a.tagName.toUpperCase()!=\"A\"&&a.tagName.toUpperCase()!=\"AREA\")a=a" + ".parentNode;if(a){h=a.href;if(h.indexOf(\"#\")==0||h.indexOf(\"about:\")==0||h.indexOf(\"javascript:\")==0)h=0;t=a.target;if(e.target.dispatchEvent&&h&&(!t||t==\"_self\"||t==\"_top\"||t==\"_parent" + "\"||(s.wd.name&&t==s.wd.name))){tcf=new Function(\"s\",\"var x;try{n=s.d.createEvent(\\\\\"MouseEvents\\\\\")}catch(x){n=new MouseEvent}return n\");n=tcf(s);if(n){tcf=new Function(\"n\",\"e\",\"var" + " x;try{n.initMouseEvent(\\\\\"click\\\\\",e.bubbles,e.cancelable,e.view,e.detail,e.screenX,e.screenY,e.clientX,e.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,e.button,e.relatedTarget)}catch(x){n" + "=0}return n\");n=tcf(n,e);if(n){n.s_fe=1;e.stopPropagation();if (e.stopImmediatePropagation) {e.stopImmediatePropagation();}e.preventDefault();s.bct=e.target;s.bce=n}}}}}');s.oh=function(o){var s=t" + "his,l=s.wd.location,h=o.href?o.href:'',i,j,k,p;i=h.indexOf(':');j=h.indexOf('?');k=h.indexOf('/');if(h&&(i<0||(j>=0&&i>j)||(k>=0&&i>k))){p=o.protocol&&o.protocol.length>1?o.protocol:(l.protocol?l.p" + "rotocol:'');i=l.pathname.lastIndexOf('/');h=(p?p+'//':'')+(o.host?o.host:(l.host?l.host:''))+(h.substring(0,1)!='/'?l.pathname.substring(0,i<0?0:i)+'/':'')+h}return h};s.ot=function(o){var t=o.tagN" + "ame;if(o.tagUrn||(o.scopeName&&o.scopeName.toUpperCase()!='HTML'))return '';t=t&&t.toUpperCase?t.toUpperCase():'';if(t=='SHAPE')t='';if(t){if((t=='INPUT'||t=='BUTTON')&&o.type&&o.type.toUpperCase)t" + "=o.type.toUpperCase();else if(!t&&o.href)t='A';}return t};s.oid=function(o){var s=this,t=s.ot(o),p,c,n='',x=0;if(t&&!o.s_oid){p=o.protocol;c=o.onclick;if(o.href&&(t=='A'||t=='AREA')&&(!c||!p||p.toL" + "owerCase().indexOf('javascript')<0))n=s.oh(o);else if(c){n=s.rep(s.rep(s.rep(s.rep(''+c,\"\\r\",''),\"\\n\",''),\"\\t\",''),' ','');x=2}else if(t=='INPUT'||t=='SUBMIT'){if(o.value)n=o.value;else if" + "(o.innerText)n=o.innerText;else if(o.textContent)n=o.textContent;x=3}else if(o.src&&t=='IMAGE')n=o.src;if(n){o.s_oid=s.fl(n,100);o.s_oidt=x}}return o.s_oid};s.rqf=function(t,un){var s=this,e=t.inde" + "xOf('='),u=e>=0?t.substring(0,e):'',q=e>=0?s.epa(t.substring(e+1)):'';if(u&&q&&(','+u+',').indexOf(','+un+',')>=0){if(u!=s.un&&s.un.indexOf(',')>=0)q='&u='+u+q+'&u=0';return q}return ''};s.rq=funct" + "ion(un){if(!un)un=this.un;var s=this,c=un.indexOf(','),v=s.c_r('s_sq'),q='';if(c<0)return s.pt(v,'&','rqf',un);return s.pt(un,',','rq',0)};s.sqp=function(t,a){var s=this,e=t.indexOf('='),q=e<0?'':s" + ".epa(t.substring(e+1));s.sqq[q]='';if(e>=0)s.pt(t.substring(0,e),',','sqs',q);return 0};s.sqs=function(un,q){var s=this;s.squ[un]=q;return 0};s.sq=function(q){var s=this,k='s_sq',v=s.c_r(k),x,c=0;s" + ".sqq=new Object;s.squ=new Object;s.sqq[q]='';s.pt(v,'&','sqp',0);s.pt(s.un,',','sqs',q);v='';for(x in s.squ)if(x&&(!Object||!Object.prototype||!Object.prototype[x]))s.sqq[s.squ[x]]+=(s.sqq[s.squ[x]" + "]?',':'')+x;for(x in s.sqq)if(x&&(!Object||!Object.prototype||!Object.prototype[x])&&s.sqq[x]&&(x==q||c<2)){v+=(v?'&':'')+s.sqq[x]+'='+s.ape(x);c++}return s.c_w(k,v,0)};s.wdl=new Function('e','var " + "s=s_c_il['+s._in+'],r=true,b=s.eh(s.wd,\"onload\"),i,o,oc;if(b)r=this[b](e);for(i=0;i<s.d.links.length;i++){o=s.d.links[i];oc=o.onclick?\"\"+o.onclick:\"\";if((oc.indexOf(\"s_gs(\")<0||oc.indexOf(" + "\".s_oc(\")>=0)&&oc.indexOf(\".tl(\")<0)s.eh(o,\"onclick\",0,s.lc);}return r');s.wds=function(){var s=this;if(s.apv>3&&(!s.isie||!s.ismac||s.apv>=5)){if(s.b&&s.b.attachEvent)s.b.attachEvent('onclic" + "k',s.bc);else if(s.b&&s.b.addEventListener){if(s.n&&((s.n.userAgent.indexOf('WebKit')>=0&&s.d.createEvent)||(s.n.userAgent.indexOf('Firefox/2')>=0&&s.wd.MouseEvent))){s.bbc=1;s.useForcedLinkTrackin" + "g=1;s.b.addEventListener('click',s.bc,true)}s.b.addEventListener('click',s.bc,false)}else s.eh(s.wd,'onload',0,s.wdl)}};s.vs=function(x){var s=this,v=s.visitorSampling,g=s.visitorSamplingGroup,k='s" + "_vsn_'+s.un+(g?'_'+g:''),n=s.c_r(k),e=new Date,y=e.getYear();e.setYear(y+10+(y<1900?1900:0));if(v){v*=100;if(!n){if(!s.c_w(k,x,e))return 0;n=x}if(n%10000>v)return 0}return 1};s.dyasmf=function(t,m)" + "{if(t&&m&&m.indexOf(t)>=0)return 1;return 0};s.dyasf=function(t,m){var s=this,i=t?t.indexOf('='):-1,n,x;if(i>=0&&m){var n=t.substring(0,i),x=t.substring(i+1);if(s.pt(x,',','dyasmf',m))return n}retu" + "rn 0};s.uns=function(){var s=this,x=s.dynamicAccountSelection,l=s.dynamicAccountList,m=s.dynamicAccountMatch,n,i;s.un=s.un.toLowerCase();if(x&&l){if(!m)m=s.wd.location.host;if(!m.toLowerCase)m=''+m" + ";l=l.toLowerCase();m=m.toLowerCase();n=s.pt(l,';','dyasf',m);if(n)s.un=n}i=s.un.indexOf(',');s.fun=i<0?s.un:s.un.substring(0,i)};s.sa=function(un){var s=this;if(s.un&&s.mpc('sa',arguments))return;s" + ".un=un;if(!s.oun)s.oun=un;else if((','+s.oun+',').indexOf(','+un+',')<0)s.oun+=','+un;s.uns()};s.m_i=function(n,a){var s=this,m,f=n.substring(0,1),r,l,i;if(!s.m_l)s.m_l=new Object;if(!s.m_nl)s.m_nl" + "=new Array;m=s.m_l[n];if(!a&&m&&m._e&&!m._i)s.m_a(n);if(!m){m=new Object,m._c='s_m';m._in=s.wd.s_c_in;m._il=s._il;m._il[m._in]=m;s.wd.s_c_in++;m.s=s;m._n=n;m._l=new Array('_c','_in','_il','_i','_e'" + ",'_d','_dl','s','n','_r','_g','_g1','_t','_t1','_x','_x1','_rs','_rr','_l');s.m_l[n]=m;s.m_nl[s.m_nl.length]=n}else if(m._r&&!m._m){r=m._r;r._m=m;l=m._l;for(i=0;i<l.length;i++)if(m[l[i]])r[l[i]]=m[" + "l[i]];r._il[r._in]=r;m=s.m_l[n]=r}if(f==f.toUpperCase())s[n]=m;return m};s.m_a=new Function('n','g','e','if(!g)g=\"m_\"+n;var s=s_c_il['+s._in+'],c=s[g+\"_c\"],m,x,f=0;if(s.mpc(\"m_a\",arguments))r" + "eturn;if(!c)c=s.wd[\"s_\"+g+\"_c\"];if(c&&s_d)s[g]=new Function(\"s\",s_ft(s_d(c)));x=s[g];if(!x)x=s.wd[\\'s_\\'+g];if(!x)x=s.wd[g];m=s.m_i(n,1);if(x&&(!m._i||g!=\"m_\"+n)){m._i=f=1;if((\"\"+x).ind" + "exOf(\"function\")>=0)x(s);else s.m_m(\"x\",n,x,e)}m=s.m_i(n,1);if(m._dl)m._dl=m._d=0;s.dlt();return f');s.m_m=function(t,n,d,e){t='_'+t;var s=this,i,x,m,f='_'+t,r=0,u;if(s.m_l&&s.m_nl)for(i=0;i<s." + "m_nl.length;i++){x=s.m_nl[i];if(!n||x==n){m=s.m_i(x);u=m[t];if(u){if((''+u).indexOf('function')>=0){if(d&&e)u=m[t](d,e);else if(d)u=m[t](d);else u=m[t]()}}if(u)r=1;u=m[t+1];if(u&&!m[f]){if((''+u).i" + "ndexOf('function')>=0){if(d&&e)u=m[t+1](d,e);else if(d)u=m[t+1](d);else u=m[t+1]()}}m[f]=1;if(u)r=1}}return r};s.m_ll=function(){var s=this,g=s.m_dl,i,o;if(g)for(i=0;i<g.length;i++){o=g[i];if(o)s.l" + "oadModule(o.n,o.u,o.d,o.l,o.e,1);g[i]=0}};s.loadModule=function(n,u,d,l,e,ln){var s=this,m=0,i,g,o=0,f1,f2,c=s.h?s.h:s.b,b,tcf;if(n){i=n.indexOf(':');if(i>=0){g=n.substring(i+1);n=n.substring(0,i)}" + "else g=\"m_\"+n;m=s.m_i(n)}if((l||(n&&!s.m_a(n,g)))&&u&&s.d&&c&&s.d.createElement){if(d){m._d=1;m._dl=1}if(ln){if(s.ssl)u=s.rep(u,'http:','https:');i='s_s:'+s._in+':'+n+':'+g;b='var s=s_c_il['+s._i" + "n+'],o=s.d.getElementById(\"'+i+'\");if(s&&o){if(!o.l&&s.wd.'+g+'){o.l=1;if(o.i)clearTimeout(o.i);o.i=0;s.m_a(\"'+n+'\",\"'+g+'\"'+(e?',\"'+e+'\"':'')+')}';f2=b+'o.c++;if(!s.maxDelay)s.maxDelay=250" + ";if(!o.l&&o.c<(s.maxDelay*2)/100)o.i=setTimeout(o.f2,100)}';f1=new Function('e',b+'}');tcf=new Function('s','c','i','u','f1','f2','var e,o=0;try{o=s.d.createElement(\"script\");if(o){o.type=\"text/" + "javascript\";'+(n?'o.id=i;o.defer=true;o.onload=o.onreadystatechange=f1;o.f2=f2;o.l=0;':'')+'o.src=u;c.appendChild(o);'+(n?'o.c=0;o.i=setTimeout(f2,100)':'')+'}}catch(e){o=0}return o');o=tcf(s,c,i," + "u,f1,f2)}else{o=new Object;o.n=n+':'+g;o.u=u;o.d=d;o.l=l;o.e=e;g=s.m_dl;if(!g)g=s.m_dl=new Array;i=0;while(i<g.length&&g[i])i++;g[i]=o}}else if(n){m=s.m_i(n);m._e=1}return m};s.voa=function(vo,r){v" + "ar s=this,l=s.va_g,i,k,v,x;for(i=0;i<l.length;i++){k=l[i];v=vo[k];if(v||vo['!'+k]){if(!r&&(k==\"contextData\"||k==\"retrieveLightData\")&&s[k])for(x in s[k])if(!v[x])v[x]=s[k][x];s[k]=v}}};s.vob=fu" + "nction(vo,onlySet){var s=this,l=s.va_g,i,k;for(i=0;i<l.length;i++){k=l[i];vo[k]=s[k];if(!onlySet&&!vo[k])vo['!'+k]=1}};s.dlt=new Function('var s=s_c_il['+s._in+'],d=new Date,i,vo,f=0;if(s.dll)for(i" + "=0;i<s.dll.length;i++){vo=s.dll[i];if(vo){if(!s.m_m(\"d\")||d.getTime()-vo._t>=s.maxDelay){s.dll[i]=0;s.t(vo)}else f=1}}if(s.dli)clearTimeout(s.dli);s.dli=0;if(f){if(!s.dli)s.dli=setTimeout(s.dlt,s" + ".maxDelay)}else s.dll=0');s.dl=function(vo){var s=this,d=new Date;if(!vo)vo=new Object;s.vob(vo);vo._t=d.getTime();if(!s.dll)s.dll=new Array;s.dll[s.dll.length]=vo;if(!s.maxDelay)s.maxDelay=250;s.d" + "lt()};s._waitingForMarketingCloudVisitorID = false;s._doneWaitingForMarketingCloudVisitorID = false;s._marketingCloudVisitorIDCallback=function(marketingCloudVisitorID) {var s=this;s.marketingCloud" + "VisitorID = marketingCloudVisitorID;s._doneWaitingForMarketingCloudVisitorID = true;s._callbackWhenReadyToTrackCheck();};s._waitingForAnalyticsVisitorID = false;s._doneWaitingForAnalyticsVisitorID " + "= false;s._analyticsVisitorIDCallback=function(analyticsVisitorID) {var s=this;s.analyticsVisitorID = analyticsVisitorID;s._doneWaitingForAnalyticsVisitorID = true;s._callbackWhenReadyToTrackCheck(" + ");};s._waitingForAudienceManagerLocationHint = false;s._doneWaitingForAudienceManagerLocationHint = false;s._audienceManagerLocationHintCallback=function(audienceManagerLocationHint) {var s=this;s." + "audienceManagerLocationHint = audienceManagerLocationHint;s._doneWaitingForAudienceManagerLocationHint = true;s._callbackWhenReadyToTrackCheck();};s._waitingForAudienceManagerBlob = false;s._doneWa" + "itingForAudienceManagerBlob = false;s._audienceManagerBlobCallback=function(audienceManagerBlob) {var s=this;s.audienceManagerBlob = audienceManagerBlob;s._doneWaitingForAudienceManagerBlob = true;" + "s._callbackWhenReadyToTrackCheck();};s.isReadyToTrack=function() {var s=this,readyToTrack = true,visitor = s.visitor;if ((visitor) && (visitor.isAllowed())) {if ((!s._waitingForMarketingCloudVisito" + "rID) && (!s.marketingCloudVisitorID) && (visitor.getMarketingCloudVisitorID)) {s._waitingForMarketingCloudVisitorID = true;s.marketingCloudVisitorID = visitor.getMarketingCloudVisitorID([s,s._marke" + "tingCloudVisitorIDCallback]);if (s.marketingCloudVisitorID) {s._doneWaitingForMarketingCloudVisitorID = true;}}if ((!s._waitingForAnalyticsVisitorID) && (!s.analyticsVisitorID) && (visitor.getAnaly" + "ticsVisitorID)) {s._waitingForAnalyticsVisitorID = true;s.analyticsVisitorID = visitor.getAnalyticsVisitorID([s,s._analyticsVisitorIDCallback]);if (s.analyticsVisitorID) {s._doneWaitingForAnalytics" + "VisitorID = true;}}if ((!s._waitingForAudienceManagerLocationHint) && (!s.audienceManagerLocationHint) && (visitor.getAudienceManagerLocationHint)) {s._waitingForAudienceManagerLocationHint = true;" + "s.audienceManagerLocationHint = visitor.getAudienceManagerLocationHint([s,s._audienceManagerLocationHintCallback]);if (s.audienceManagerLocationHint) {s._doneWaitingForAudienceManagerLocationHint =" + " true;}}if ((!s._waitingForAudienceManagerBlob) && (!s.audienceManagerBlob) && (visitor.getAudienceManagerBlob)) {s._waitingForAudienceManagerBlob = true;s.audienceManagerBlob = visitor.getAudience" + "ManagerBlob([s,s._audienceManagerBlobCallback]);if (s.audienceManagerBlob) {s._doneWaitingForAudienceManagerBlob = true;}}if (((s._waitingForMarketingCloudVisitorID)     && (!s._doneWaitingForMarke" + "tingCloudVisitorID)     && (!s.marketingCloudVisitorID)) ||((s._waitingForAnalyticsVisitorID)          && (!s._doneWaitingForAnalyticsVisitorID)          && (!s.analyticsVisitorID)) ||((s._waitingF" + "orAudienceManagerLocationHint) && (!s._doneWaitingForAudienceManagerLocationHint) && (!s.audienceManagerLocationHint)) ||((s._waitingForAudienceManagerBlob)         && (!s._doneWaitingForAudienceMa" + "nagerBlob)         && (!s.audienceManagerBlob))) {readyToTrack = false;}}return readyToTrack;};s._callbackWhenReadyToTrackQueue = null;s._callbackWhenReadyToTrackInterval = 0;s.callbackWhenReadyToT" + "rack=function(callbackThis,callback,args) {var s=this,callbackInfo;callbackInfo = {};callbackInfo.callbackThis = callbackThis;callbackInfo.callback     = callback;callbackInfo.args         = args;i" + "f (s._callbackWhenReadyToTrackQueue == null) {s._callbackWhenReadyToTrackQueue = [];}s._callbackWhenReadyToTrackQueue.push(callbackInfo);if (s._callbackWhenReadyToTrackInterval == 0) {s._callbackWh" + "enReadyToTrackInterval = setInterval(s._callbackWhenReadyToTrackCheck,100);}};s._callbackWhenReadyToTrackCheck=new Function('var s=s_c_il['+s._in+'],callbackNum,callbackInfo;if (s.isReadyToTrack())" + " {if (s._callbackWhenReadyToTrackInterval) {clearInterval(s._callbackWhenReadyToTrackInterval);s._callbackWhenReadyToTrackInterval = 0;}if (s._callbackWhenReadyToTrackQueue != null) {while (s._call" + "backWhenReadyToTrackQueue.length > 0) {callbackInfo = s._callbackWhenReadyToTrackQueue.shift();callbackInfo.callback.apply(callbackInfo.callbackThis,callbackInfo.args);}}}');s._handleNotReadyToTrac" + "k=function(variableOverrides) {var s=this,args,varKey,variableOverridesCopy = null,setVariables = null;if (!s.isReadyToTrack()) {args = [];if (variableOverrides != null) {variableOverridesCopy = {}" + ";for (varKey in variableOverrides) {variableOverridesCopy[varKey] = variableOverrides[varKey];}}setVariables = {};s.vob(setVariables,true);args.push(variableOverridesCopy);args.push(setVariables);s" + ".callbackWhenReadyToTrack(s,s.track,args);return true;}return false;};s.gfid=function(){var s=this,d='0123456789ABCDEF',k='s_fid',fid=s.c_r(k),h='',l='',i,j,m=8,n=4,e=new Date,y;if(!fid||fid.indexO" + "f('-')<0){for(i=0;i<16;i++){j=Math.floor(Math.random()*m);h+=d.substring(j,j+1);j=Math.floor(Math.random()*n);l+=d.substring(j,j+1);m=n=16}fid=h+'-'+l;}y=e.getYear();e.setYear(y+2+(y<1900?1900:0));" + "if(!s.c_w(k,fid,e))fid=0;return fid};s.track=s.t=function(vo,setVariables){var s=this,notReadyToTrack,trk=1,tm=new Date,sed=Math&&Math.random?Math.floor(Math.random()*10000000000000):tm.getTime(),s" + "ess='s'+Math.floor(tm.getTime()/10800000)%10+sed,y=tm.getYear(),vt=tm.getDate()+'/'+tm.getMonth()+'/'+(y<1900?y+1900:y)+' '+tm.getHours()+':'+tm.getMinutes()+':'+tm.getSeconds()+' '+tm.getDay()+' '" + "+tm.getTimezoneOffset(),tcf,tfs=s.gtfs(),ta=-1,q='',qs='',code='',vb=new Object;if (s.visitor) {if (s.visitor.getAuthState) {s.authState = s.visitor.getAuthState();}if ((!s.supplementalDataID) && (" + "s.visitor.getSupplementalDataID)) {s.supplementalDataID = s.visitor.getSupplementalDataID(\"AppMeasurement:\" + s._in,(s.expectSupplementalData ? false : true));}}if(s.mpc('t',arguments))return;s.g" + "l(s.vl_g);s.uns();s.m_ll();notReadyToTrack = s._handleNotReadyToTrack(vo);if (!notReadyToTrack) {if (setVariables) {s.voa(setVariables);}if(!s.td){var tl=tfs.location,a,o,i,x='',c='',v='',p='',bw='" + "',bh='',j='1.0',k=s.c_w('s_cc','true',0)?'Y':'N',hp='',ct='',pn=0,ps;if(String&&String.prototype){j='1.1';if(j.match){j='1.2';if(tm.setUTCDate){j='1.3';if(s.isie&&s.ismac&&s.apv>=5)j='1.4';if(pn.to" + "Precision){j='1.5';a=new Array;if(a.forEach){j='1.6';i=0;o=new Object;tcf=new Function('o','var e,i=0;try{i=new Iterator(o)}catch(e){}return i');i=tcf(o);if(i&&i.next){j='1.7';if(a.reduce){j='1.8';" + "if(j.trim){j='1.8.1';if(Date.parse){j='1.8.2';if(Object.create)j='1.8.5'}}}}}}}}}if(s.apv>=4)x=screen.width+'x'+screen.height;if(s.isns||s.isopera){if(s.apv>=3){v=s.n.javaEnabled()?'Y':'N';if(s.apv" + ">=4){c=screen.pixelDepth;bw=s.wd.innerWidth;bh=s.wd.innerHeight}}s.pl=s.n.plugins}else if(s.isie){if(s.apv>=4){v=s.n.javaEnabled()?'Y':'N';c=screen.colorDepth;if(s.apv>=5){bw=s.d.documentElement.of" + "fsetWidth;bh=s.d.documentElement.offsetHeight;if(!s.ismac&&s.b){tcf=new Function('s','tl','var e,hp=0;try{s.b.addBehavior(\"#default#homePage\");hp=s.b.isHomePage(tl)?\"Y\":\"N\"}catch(e){}return h" + "p');hp=tcf(s,tl);tcf=new Function('s','var e,ct=0;try{s.b.addBehavior(\"#default#clientCaps\");ct=s.b.connectionType}catch(e){}return ct');ct=tcf(s)}}}else r=''}if(s.pl)while(pn<s.pl.length&&pn<30)" + "{ps=s.fl(s.pl[pn].name,100)+';';if(p.indexOf(ps)<0)p+=ps;pn++}s.resolution=x;s.colorDepth=c;s.javascriptVersion=j;s.javaEnabled=v;s.cookiesEnabled=k;s.browserWidth=bw;s.browserHeight=bh;s.connectio" + "nType=ct;s.homepage=hp;s.plugins=p;s.td=1}if(vo){s.vob(vb);s.voa(vo)}if(!s.analyticsVisitorID&&!s.marketingCloudVisitorID)s.fid=s.gfid();if((vo&&vo._t)||!s.m_m('d')){if(s.usePlugins){s.doPlugins(s);}" + "if(!s.abort){var l=s.wd.location,r=tfs.document.referrer;if(!s.pageURL)s.pageURL=l.href?l.href:l;if(!s.referrer&&!s._1_referrer)s.referrer=r;s._1_referrer=1;s.m_m('g');if(s.lnk||s.eo){var o=s.eo?s." + "eo:s.lnk,p=s.pageName,w=1,t=s.ot(o),n=s.oid(o),x=o.s_oidt,h,l,i,oc;if(s.eo&&o==s.eo){while(o&&!n&&t!='BODY'){o=o.parentElement?o.parentElement:o.parentNode;if(o){t=s.ot(o);n=s.oid(o);x=o.s_oidt}}if" + "(!n||t=='BODY')o='';if(o){oc=o.onclick?''+o.onclick:'';if((oc.indexOf('s_gs(')>=0&&oc.indexOf('.s_oc(')<0)||oc.indexOf('.tl(')>=0)o=0}}if(o){if(n)ta=o.target;h=s.oh(o);i=h.indexOf('?');h=s.linkLeav" + "eQueryString||i<0?h:h.substring(0,i);l=s.linkName;t=s.linkType?s.linkType.toLowerCase():s.lt(h);if(t&&(h||l)){s.pe='lnk_'+(t=='d'||t=='e'?t:'o');s.pev1=(h?s.ape(h):'');s.pev2=(l?s.ape(l):'')}else t" + "rk=0;if(s.trackInlineStats){if(!p){p=s.pageURL;w=0}t=s.ot(o);i=o.sourceIndex;if(o.dataset&&o.dataset.sObjectId){s.wd.s_objectID=o.dataset.sObjectId;}else if(o.getAttribute&&o.getAttribute('data-s-o" + "bject-id')){s.wd.s_objectID=o.getAttribute('data-s-object-id');}else if(s.useForcedLinkTracking){s.wd.s_objectID='';oc=o.onclick?''+o.onclick:'';if(oc){var ocb=oc.indexOf('s_objectID'),oce,ocq,ocx;" + "if(ocb>=0){ocb+=10;while(ocb<oc.length&&(\"= \\t\\r\\n\").indexOf(oc.charAt(ocb))>=0)ocb++;if(ocb<oc.length){oce=ocb;ocq=ocx=0;while(oce<oc.length&&(oc.charAt(oce)!=';'||ocq)){if(ocq){if(oc.charAt(" + "oce)==ocq&&!ocx)ocq=0;else if(oc.charAt(oce)==\"\\\\\")ocx=!ocx;else ocx=0;}else{ocq=oc.charAt(oce);if(ocq!='\"'&&ocq!=\"'\")ocq=0}oce++;}oc=oc.substring(ocb,oce);if(oc){o.s_soid=new Function('s','" + "var e;try{s.wd.s_objectID='+oc+'}catch(e){}');o.s_soid(s)}}}}}if(s.gg('objectID')){n=s.gg('objectID');x=1;i=1}if(p&&n&&t)qs='&pid='+s.ape(s.fl(p,255))+(w?'&pidt='+w:'')+'&oid='+s.ape(s.fl(n,100))+(" + "x?'&oidt='+x:'')+'&ot='+s.ape(t)+(i?'&oi='+i:'')}}else trk=0}if(trk||qs){s.sampled=s.vs(sed);if(trk){if(s.sampled)code=s.mr(sess,(vt?'&t='+s.ape(vt):'')+s.hav()+q+(qs?qs:s.rq()),0,ta);qs='';s.m_m('" + "t');if(s.p_r)s.p_r();s.referrer=s.lightProfileID=s.retrieveLightProfiles=s.deleteLightProfiles=''}s.sq(qs)}}}else s.dl(vo);if(vo)s.voa(vb,1);}s.abort=0;s.supplementalDataID=s.pageURLRest=s.lnk=s.eo" + "=s.linkName=s.linkType=s.wd.s_objectID=s.ppu=s.pe=s.pev1=s.pev2=s.pev3='';if(s.pg)s.wd.s_lnk=s.wd.s_eo=s.wd.s_linkName=s.wd.s_linkType='';return code};s.trackLink=s.tl=function(o,t,n,vo,f){var s=th" + "is;s.lnk=o;s.linkType=t;s.linkName=n;if(f){s.bct=o;s.bcf=f}s.t(vo)};s.trackLight=function(p,ss,i,vo){var s=this;s.lightProfileID=p;s.lightStoreForSeconds=ss;s.lightIncrementBy=i;s.t(vo)};s.setTagCo" + "ntainer=function(n){var s=this,l=s.wd.s_c_il,i,t,x,y;s.tcn=n;if(l)for(i=0;i<l.length;i++){t=l[i];if(t&&t._c=='s_l'&&t.tagContainerName==n){s.voa(t);if(t.lmq)for(i=0;i<t.lmq.length;i++){x=t.lmq[i];y" + "='m_'+x.n;if(!s[y]&&!s[y+'_c']){s[y]=t[y];s[y+'_c']=t[y+'_c']}s.loadModule(x.n,x.u,x.d)}if(t.ml)for(x in t.ml)if(s[x]){y=s[x];x=t.ml[x];for(i in x)if(!Object.prototype[i]){if(typeof(x[i])!='functio" + "n'||(''+x[i]).indexOf('s_c_il')<0)y[i]=x[i]}}if(t.mmq)for(i=0;i<t.mmq.length;i++){x=t.mmq[i];if(s[x.m]){y=s[x.m];if(y[x.f]&&typeof(y[x.f])=='function'){if(x.a)y[x.f].apply(y,x.a);else y[x.f].apply(" + "y)}}}if(t.tq)for(i=0;i<t.tq.length;i++)s.t(t.tq[i]);t.s=s;return}}};s.wd=window;s.ssl=(s.wd.location.protocol.toLowerCase().indexOf('https')>=0);s.d=document;s.b=s.d.body;if(s.d.getElementsByTagNam" + "e){s.h=s.d.getElementsByTagName('HEAD');if(s.h)s.h=s.h[0]}s.n=navigator;s.u=s.n.userAgent;s.ns6=s.u.indexOf('Netscape6/');var apn=s.n.appName,v=s.n.appVersion,ie=v.indexOf('MSIE '),o=s.u.indexOf('O" + "pera '),i;if(v.indexOf('Opera')>=0||o>0)apn='Opera';s.isie=(apn=='Microsoft Internet Explorer');s.isns=(apn=='Netscape');s.isopera=(apn=='Opera');s.ismac=(s.u.indexOf('Mac')>=0);if(o>0)s.apv=parseF" + "loat(s.u.substring(o+6));else if(ie>0){s.apv=parseInt(i=v.substring(ie+5));if(s.apv>3)s.apv=parseFloat(i)}else if(s.ns6>0)s.apv=parseFloat(s.u.substring(s.ns6+10));else s.apv=parseFloat(v);s.em=0;i" + "f(s.em.toPrecision)s.em=3;else if(String.fromCharCode){i=escape(String.fromCharCode(256)).toUpperCase();s.em=(i=='%C4%80'?2:(i=='%U0100'?1:0))}if(s.oun)s.sa(s.oun);s.sa(un);s.vl_l='supplementalData" + "ID,timestamp,dynamicVariablePrefix,visitorID,marketingCloudVisitorID,analyticsVisitorID,audienceManagerLocationHint,fid,vmk,visitorMigrationKey,visitorMigrationServer,visitorMigrationServerSecure,p" + "pu,charSet,visitorNamespace,cookieDomainPeriods,cookieLifetime,pageName,pageURL,referrer,contextData,currencyCode,lightProfileID,lightStoreForSeconds,lightIncrementBy,retrieveLightProfiles,deleteLi" + "ghtProfiles,retrieveLightData';s.va_l=s.sp(s.vl_l,',');s.vl_mr=s.vl_m='timestamp,charSet,visitorNamespace,cookieDomainPeriods,cookieLifetime,contextData,lightProfileID,lightStoreForSeconds,lightInc" + "rementBy';s.vl_t=s.vl_l+',variableProvider,channel,server,pageType,transactionID,purchaseID,campaign,state,zip,events,events2,products,audienceManagerBlob,authState,linkName,linkType';var n;for(n=1" + ";n<=75;n++){s.vl_t+=',prop'+n+',eVar'+n;s.vl_m+=',prop'+n+',eVar'+n}for(n=1;n<=5;n++)s.vl_t+=',hier'+n;for(n=1;n<=3;n++)s.vl_t+=',list'+n;s.va_m=s.sp(s.vl_m,',');s.vl_l2=',tnt,pe,pev1,pev2,pev3,res" + "olution,colorDepth,javascriptVersion,javaEnabled,cookiesEnabled,browserWidth,browserHeight,connectionType,homepage,pageURLRest,plugins';s.vl_t+=s.vl_l2;s.va_t=s.sp(s.vl_t,',');s.vl_g=s.vl_t+',track" + "ingServer,trackingServerSecure,trackingServerBase,fpCookieDomainPeriods,disableBufferedRequests,mobile,visitorSampling,visitorSamplingGroup,dynamicAccountSelection,dynamicAccountList,dynamicAccount" + "Match,trackDownloadLinks,trackExternalLinks,trackInlineStats,linkLeaveQueryString,linkDownloadFileTypes,linkExternalFilters,linkInternalFilters,linkTrackVars,linkTrackEvents,linkNames,lnk,eo,lightT" + "rackVars,_1_referrer,un';s.va_g=s.sp(s.vl_g,',');s.pg=pg;s.gl(s.vl_g);s.contextData=new Object;s.retrieveLightData=new Object;if(!ss)s.wds();if(pg){s.wd.s_co=function(o){return o};s.wd.s_gs=functio" + "n(un){s_gi(un,1,1).t()};s.wd.s_dc=function(un){s_gi(un,1).t()}}",
                w = window,
                l = w.s_c_il,
                n = navigator,
                u = n.userAgent,
                v = n.appVersion,
                e = v.indexOf('MSIE '),
                m = u.indexOf('Netscape6/'),
                a,
                i,
                j,
                x,
                s;if (un) {
                un = un.toLowerCase();if (l) for (j = 0; j < 2; j++) {
                    for (i = 0; i < l.length; i++) {
                        s = l[i];x = s._c;if ((!x || x == 's_c' || j > 0 && x == 's_l') && (s.oun == un || s.fs && s.sa && s.fs(s.oun, un))) {
                            if (s.sa) s.sa(un);if (x == 's_c') return s;
                        } else s = 0;
                    }
                }
            }w.s_an = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            w.s_sp = new Function("x", "d", "var a=new Array,i=0,j;if(x){if(x.split)a=x.split(d);else if(!d)for(i=0;i<x.length;i++)a[a.length]=x.substring(i,i+1);else while(i>=0){j=x.indexOf(d,i);a[a.length]=x.subst" + "ring(i,j<0?x.length:j);i=j;if(i>=0)i+=d.length}}return a");
            w.s_jn = new Function("a", "d", "var x='',i,j=a.length;if(a&&j>0){x=a[0];if(j>1){if(a.join)x=a.join(d);else for(i=1;i<j;i++)x+=d+a[i]}}return x");
            w.s_rep = new Function("x", "o", "n", "return s_jn(s_sp(x,o),n)");
            w.s_d = new Function("x", "var t='`^@$#',l=s_an,l2=new Object,x2,d,b=0,k,i=x.lastIndexOf('~~'),j,v,w;if(i>0){d=x.substring(0,i);x=x.substring(i+2);l=s_sp(l,'');for(i=0;i<62;i++)l2[l[i]]=i;t=s_sp(t,'');d" + "=s_sp(d,'~');i=0;while(i<5){v=0;if(x.indexOf(t[i])>=0) {x2=s_sp(x,t[i]);for(j=1;j<x2.length;j++){k=x2[j].substring(0,1);w=t[i]+k;if(k!=' '){v=1;w=d[b+l2[k]]}x2[j]=w+x2[j].substring(1)}}if(v)x=s_jn(" + "x2,'');else{w=t[i]+' ';if(x.indexOf(w)>=0)x=s_rep(x,w,t[i]);i++;b+=62}}}return x");
            w.s_fe = new Function("c", "return s_rep(s_rep(s_rep(c,'\\\\','\\\\\\\\'),'\"','\\\\\"'),\"\\n\",\"\\\\n\")");
            w.s_fa = new Function("f", "var s=f.indexOf('(')+1,e=f.indexOf(')'),a='',c;while(s>=0&&s<e){c=f.substring(s,s+1);if(c==',')a+='\",\"';else if((\"\\n\\r\\t \").indexOf(c)<0)a+=c;s++}return a?'\"'+a+'\"':" + "a");
            w.s_ft = new Function("c", "c+='';var s,e,o,a,d,q,f,h,x;s=c.indexOf('=function(');while(s>=0){s++;d=1;q='';x=0;f=c.substring(s);a=s_fa(f);e=o=c.indexOf('{',s);e++;while(d>0){h=c.substring(e,e+1);if(q){i" + "f(h==q&&!x)q='';if(h=='\\\\')x=x?0:1;else x=0}else{if(h=='\"'||h==\"'\")q=h;if(h=='{')d++;if(h=='}')d--}if(d>0)e++}c=c.substring(0,s)+'new Function('+(a?a+',':'')+'\"'+s_fe(c.substring(o+1,e))+'\")" + "'+c.substring(e+1);s=c.indexOf('=function(')}return c;");
            c = s_d(c);if (e > 0) {
                a = parseInt(i = v.substring(e + 5));if (a > 3) a = parseFloat(i);
            } else if (m > 0) a = parseFloat(u.substring(m + 10));else a = parseFloat(v);if (a < 5 || v.indexOf('Opera') >= 0 || u.indexOf('Opera') >= 0) c = s_ft(c);if (!s) {
                s = new Object();if (!w.s_c_in) {
                    w.s_c_il = new Array();w.s_c_in = 0;
                }s._il = w.s_c_il;s._in = w.s_c_in;s._il[s._in] = s;w.s_c_in++;
            }s._c = 's_c';new Function("s", "un", "pg", "ss", c)(s, un, pg, ss);return s;
        }
        function s_giqf() {
            var w = window,
                q = w.s_giq,
                i,
                t,
                s;
            if (q) {
                for (i = 0; i < q.length; i++) {
                    t = q[i];
                    s = s_gi(t.oun);
                    s.sa(t.un);
                    s.setTagContainer(t.tagContainerName);
                }
            }
            w.s_giq = 0;
        };
        s_giqf();

        [["isHKDLRSId", isHKDLRSId], ["modifyAccountFromURL", modifyAccountFromURL], ["parseAnyQueryString", parseAnyQueryString], ["s_code", s_code], ["s_gi", s_gi], ["s_giqf", s_giqf], ["s_objectID", s_objectID], ["s_wdpro_doPlugins", s_wdpro_doPlugins], ["setSiteCatalystAccountVar", setSiteCatalystAccountVar]].forEach(function (arr) {
            window[arr[0]] = arr[1];
        });
    })();
    //! moment.js
    //! version : 2.10.6
    //! authors : Tim Wood, Iskren Chernev, Moment.js contributors
    //! license : MIT
    //! momentjs.com

    (function (global, factory) {
        inject(function (Analytics, store, moment) {
            Analytics.moment = store('moment', moment);
            moment.suppressDeprecationWarnings = true;
        }, 'Analytics', 'store', factory());
    })(this, function () {
        'use strict';

        var hookCallback;

        function utils_hooks__hooks() {
            return hookCallback.apply(null, arguments);
        }

        // This is done to register the method called with moment()
        // without creating circular dependencies.
        function setHookCallback(callback) {
            hookCallback = callback;
        }

        function isArray(input) {
            return Object.prototype.toString.call(input) === '[object Array]';
        }

        function isDate(input) {
            return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
        }

        function map(arr, fn) {
            var res = [],
                i;
            for (i = 0; i < arr.length; ++i) {
                res.push(fn(arr[i], i));
            }
            return res;
        }

        function hasOwnProp(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }

        function extend(a, b) {
            for (var i in b) {
                if (hasOwnProp(b, i)) {
                    a[i] = b[i];
                }
            }

            if (hasOwnProp(b, 'toString')) {
                a.toString = b.toString;
            }

            if (hasOwnProp(b, 'valueOf')) {
                a.valueOf = b.valueOf;
            }

            return a;
        }

        function create_utc__createUTC(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, true).utc();
        }

        function defaultParsingFlags() {
            // We need to deep clone this object.
            return {
                empty: false,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: false,
                invalidMonth: null,
                invalidFormat: false,
                userInvalidated: false,
                iso: false
            };
        }

        function getParsingFlags(m) {
            if (m._pf == null) {
                m._pf = defaultParsingFlags();
            }
            return m._pf;
        }

        function valid__isValid(m) {
            if (m._isValid == null) {
                var flags = getParsingFlags(m);
                m._isValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated;

                if (m._strict) {
                    m._isValid = m._isValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
                }
            }
            return m._isValid;
        }

        function valid__createInvalid(flags) {
            var m = create_utc__createUTC(NaN);
            if (flags != null) {
                extend(getParsingFlags(m), flags);
            } else {
                getParsingFlags(m).userInvalidated = true;
            }

            return m;
        }

        var momentProperties = utils_hooks__hooks.momentProperties = [];

        function copyConfig(to, from) {
            var i, prop, val;

            if (typeof from._isAMomentObject !== 'undefined') {
                to._isAMomentObject = from._isAMomentObject;
            }
            if (typeof from._i !== 'undefined') {
                to._i = from._i;
            }
            if (typeof from._f !== 'undefined') {
                to._f = from._f;
            }
            if (typeof from._l !== 'undefined') {
                to._l = from._l;
            }
            if (typeof from._strict !== 'undefined') {
                to._strict = from._strict;
            }
            if (typeof from._tzm !== 'undefined') {
                to._tzm = from._tzm;
            }
            if (typeof from._isUTC !== 'undefined') {
                to._isUTC = from._isUTC;
            }
            if (typeof from._offset !== 'undefined') {
                to._offset = from._offset;
            }
            if (typeof from._pf !== 'undefined') {
                to._pf = getParsingFlags(from);
            }
            if (typeof from._locale !== 'undefined') {
                to._locale = from._locale;
            }

            if (momentProperties.length > 0) {
                for (i in momentProperties) {
                    prop = momentProperties[i];
                    val = from[prop];
                    if (typeof val !== 'undefined') {
                        to[prop] = val;
                    }
                }
            }

            return to;
        }

        var updateInProgress = false;

        // Moment prototype object
        function Moment(config) {
            copyConfig(this, config);
            this._d = new Date(config._d != null ? config._d.getTime() : NaN);
            // Prevent infinite loop in case updateOffset creates new moment
            // objects.
            if (updateInProgress === false) {
                updateInProgress = true;
                utils_hooks__hooks.updateOffset(this);
                updateInProgress = false;
            }
        }

        function isMoment(obj) {
            return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
        }

        function absFloor(number) {
            if (number < 0) {
                return Math.ceil(number);
            } else {
                return Math.floor(number);
            }
        }

        function toInt(argumentForCoercion) {
            var coercedNumber = +argumentForCoercion,
                value = 0;

            if (coercedNumber !== 0 && isFinite(coercedNumber)) {
                value = absFloor(coercedNumber);
            }

            return value;
        }

        function compareArrays(array1, array2, dontConvert) {
            var len = Math.min(array1.length, array2.length),
                lengthDiff = Math.abs(array1.length - array2.length),
                diffs = 0,
                i;
            for (i = 0; i < len; i++) {
                if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                    diffs++;
                }
            }
            return diffs + lengthDiff;
        }

        function Locale() {}

        var locales = {};
        var globalLocale;

        function normalizeLocale(key) {
            return key ? key.toLowerCase().replace('_', '-') : key;
        }

        // pick the locale from the array
        // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
        // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
        function chooseLocale(names) {
            var i = 0,
                j,
                next,
                locale,
                split;

            while (i < names.length) {
                split = normalizeLocale(names[i]).split('-');
                j = split.length;
                next = normalizeLocale(names[i + 1]);
                next = next ? next.split('-') : null;
                while (j > 0) {
                    locale = loadLocale(split.slice(0, j).join('-'));
                    if (locale) {
                        return locale;
                    }
                    if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                        //the next array item is better than a shallower substring of this one
                        break;
                    }
                    j--;
                }
                i++;
            }
            return null;
        }

        function loadLocale(name) {
            var oldLocale = null;
            // TODO: Find a better way to register and load all the locales in Node
            if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
                try {
                    oldLocale = globalLocale._abbr;
                    require('./locale/' + name);
                    // because defineLocale currently also sets the global locale, we
                    // want to undo that for lazy loaded locales
                    locale_locales__getSetGlobalLocale(oldLocale);
                } catch (e) {}
            }
            return locales[name];
        }

        // This function will load locale and then set the global locale.  If
        // no arguments are passed in, it will simply return the current global
        // locale key.
        function locale_locales__getSetGlobalLocale(key, values) {
            var data;
            if (key) {
                if (typeof values === 'undefined') {
                    data = locale_locales__getLocale(key);
                } else {
                    data = defineLocale(key, values);
                }

                if (data) {
                    // moment.duration._locale = moment._locale = data;
                    globalLocale = data;
                }
            }

            return globalLocale._abbr;
        }

        function defineLocale(name, values) {
            if (values !== null) {
                values.abbr = name;
                locales[name] = locales[name] || new Locale();
                locales[name].set(values);

                // backwards compat for now: also set the locale
                locale_locales__getSetGlobalLocale(name);

                return locales[name];
            } else {
                // useful for testing
                delete locales[name];
                return null;
            }
        }

        // returns locale data
        function locale_locales__getLocale(key) {
            var locale;

            if (key && key._locale && key._locale._abbr) {
                key = key._locale._abbr;
            }

            if (!key) {
                return globalLocale;
            }

            if (!isArray(key)) {
                //short-circuit everything else
                locale = loadLocale(key);
                if (locale) {
                    return locale;
                }
                key = [key];
            }

            return chooseLocale(key);
        }

        var aliases = {};

        function addUnitAlias(unit, shorthand) {
            var lowerCase = unit.toLowerCase();
            aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
        }

        function normalizeUnits(units) {
            return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
        }

        function normalizeObjectUnits(inputObject) {
            var normalizedInput = {},
                normalizedProp,
                prop;

            for (prop in inputObject) {
                if (hasOwnProp(inputObject, prop)) {
                    normalizedProp = normalizeUnits(prop);
                    if (normalizedProp) {
                        normalizedInput[normalizedProp] = inputObject[prop];
                    }
                }
            }

            return normalizedInput;
        }

        function makeGetSet(unit, keepTime) {
            return function (value) {
                if (value != null) {
                    get_set__set(this, unit, value);
                    utils_hooks__hooks.updateOffset(this, keepTime);
                    return this;
                } else {
                    return get_set__get(this, unit);
                }
            };
        }

        function get_set__get(mom, unit) {
            return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
        }

        function get_set__set(mom, unit, value) {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }

        // MOMENTS

        function getSet(units, value) {
            var unit;
            if (typeof units === 'object') {
                for (unit in units) {
                    this.set(unit, units[unit]);
                }
            } else {
                units = normalizeUnits(units);
                if (typeof this[units] === 'function') {
                    return this[units](value);
                }
            }
            return this;
        }

        function zeroFill(number, targetLength, forceSign) {
            var absNumber = '' + Math.abs(number),
                zerosToFill = targetLength - absNumber.length,
                sign = number >= 0;
            return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
        }

        var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

        var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

        var formatFunctions = {};

        var formatTokenFunctions = {};

        // token:    'M'
        // padded:   ['MM', 2]
        // ordinal:  'Mo'
        // callback: function () { this.month() + 1 }
        function addFormatToken(token, padded, ordinal, callback) {
            var func = callback;
            if (typeof callback === 'string') {
                func = function func() {
                    return this[callback]();
                };
            }
            if (token) {
                formatTokenFunctions[token] = func;
            }
            if (padded) {
                formatTokenFunctions[padded[0]] = function () {
                    return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
                };
            }
            if (ordinal) {
                formatTokenFunctions[ordinal] = function () {
                    return this.localeData().ordinal(func.apply(this, arguments), token);
                };
            }
        }

        function removeFormattingTokens(input) {
            if (input.match(/\[[\s\S]/)) {
                return input.replace(/^\[|\]$/g, '');
            }
            return input.replace(/\\/g, '');
        }

        function makeFormatFunction(format) {
            var array = format.match(formattingTokens),
                i,
                length;

            for (i = 0, length = array.length; i < length; i++) {
                if (formatTokenFunctions[array[i]]) {
                    array[i] = formatTokenFunctions[array[i]];
                } else {
                    array[i] = removeFormattingTokens(array[i]);
                }
            }

            return function (mom) {
                var output = '';
                for (i = 0; i < length; i++) {
                    output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
                }
                return output;
            };
        }

        // format date using native date object
        function formatMoment(m, format) {
            if (!m.isValid()) {
                return m.localeData().invalidDate();
            }

            format = expandFormat(format, m.localeData());
            formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

            return formatFunctions[format](m);
        }

        function expandFormat(format, locale) {
            var i = 5;

            function replaceLongDateFormatTokens(input) {
                return locale.longDateFormat(input) || input;
            }

            localFormattingTokens.lastIndex = 0;
            while (i >= 0 && localFormattingTokens.test(format)) {
                format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                localFormattingTokens.lastIndex = 0;
                i -= 1;
            }

            return format;
        }

        var match1 = /\d/; //       0 - 9
        var match2 = /\d\d/; //      00 - 99
        var match3 = /\d{3}/; //     000 - 999
        var match4 = /\d{4}/; //    0000 - 9999
        var match6 = /[+-]?\d{6}/; // -999999 - 999999
        var match1to2 = /\d\d?/; //       0 - 99
        var match1to3 = /\d{1,3}/; //       0 - 999
        var match1to4 = /\d{1,4}/; //       0 - 9999
        var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

        var matchUnsigned = /\d+/; //       0 - inf
        var matchSigned = /[+-]?\d+/; //    -inf - inf

        var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

        var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

        // any word (or two) characters or numbers including two/three word month in arabic.
        var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

        var regexes = {};

        function isFunction(sth) {
            // https://github.com/moment/moment/issues/2325
            return typeof sth === 'function' && Object.prototype.toString.call(sth) === '[object Function]';
        }

        function addRegexToken(token, regex, strictRegex) {
            regexes[token] = isFunction(regex) ? regex : function (isStrict) {
                return isStrict && strictRegex ? strictRegex : regex;
            };
        }

        function getParseRegexForToken(token, config) {
            if (!hasOwnProp(regexes, token)) {
                return new RegExp(unescapeFormat(token));
            }

            return regexes[token](config._strict, config._locale);
        }

        // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
        function unescapeFormat(s) {
            return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
                return p1 || p2 || p3 || p4;
            }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        }

        var tokens = {};

        function addParseToken(token, callback) {
            var i,
                func = callback;
            if (typeof token === 'string') {
                token = [token];
            }
            if (typeof callback === 'number') {
                func = function func(input, array) {
                    array[callback] = toInt(input);
                };
            }
            for (i = 0; i < token.length; i++) {
                tokens[token[i]] = func;
            }
        }

        function addWeekParseToken(token, callback) {
            addParseToken(token, function (input, array, config, token) {
                config._w = config._w || {};
                callback(input, config._w, config, token);
            });
        }

        function addTimeToArrayFromToken(token, input, config) {
            if (input != null && hasOwnProp(tokens, token)) {
                tokens[token](input, config._a, config, token);
            }
        }

        var YEAR = 0;
        var MONTH = 1;
        var DATE = 2;
        var HOUR = 3;
        var MINUTE = 4;
        var SECOND = 5;
        var MILLISECOND = 6;

        function daysInMonth(year, month) {
            return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
        }

        // FORMATTING

        addFormatToken('M', ['MM', 2], 'Mo', function () {
            return this.month() + 1;
        });

        addFormatToken('MMM', 0, 0, function (format) {
            return this.localeData().monthsShort(this, format);
        });

        addFormatToken('MMMM', 0, 0, function (format) {
            return this.localeData().months(this, format);
        });

        // ALIASES

        addUnitAlias('month', 'M');

        // PARSING

        addRegexToken('M', match1to2);
        addRegexToken('MM', match1to2, match2);
        addRegexToken('MMM', matchWord);
        addRegexToken('MMMM', matchWord);

        addParseToken(['M', 'MM'], function (input, array) {
            array[MONTH] = toInt(input) - 1;
        });

        addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
            var month = config._locale.monthsParse(input, token, config._strict);
            // if we didn't find a month name, mark the date as invalid.
            if (month != null) {
                array[MONTH] = month;
            } else {
                getParsingFlags(config).invalidMonth = input;
            }
        });

        // LOCALES

        var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
        function localeMonths(m) {
            return this._months[m.month()];
        }

        var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
        function localeMonthsShort(m) {
            return this._monthsShort[m.month()];
        }

        function localeMonthsParse(monthName, format, strict) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                mom = create_utc__createUTC([2000, i]);
                if (strict && !this._longMonthsParse[i]) {
                    this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                    this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
                }
                if (!strict && !this._monthsParse[i]) {
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                    return i;
                } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                    return i;
                } else if (!strict && this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        }

        // MOMENTS

        function setMonth(mom, value) {
            var dayOfMonth;

            // TODO: Move this out of here!
            if (typeof value === 'string') {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }

            dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
            return mom;
        }

        function getSetMonth(value) {
            if (value != null) {
                setMonth(this, value);
                utils_hooks__hooks.updateOffset(this, true);
                return this;
            } else {
                return get_set__get(this, 'Month');
            }
        }

        function getDaysInMonth() {
            return daysInMonth(this.year(), this.month());
        }

        function checkOverflow(m) {
            var overflow;
            var a = m._a;

            if (a && getParsingFlags(m).overflow === -2) {
                overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

                if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                    overflow = DATE;
                }

                getParsingFlags(m).overflow = overflow;
            }

            return m;
        }

        function warn(msg) {
            if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
                console.warn('Deprecation warning: ' + msg);
            }
        }

        function deprecate(msg, fn) {
            var firstTime = true;

            return extend(function () {
                if (firstTime) {
                    warn(msg + '\n' + new Error().stack);
                    firstTime = false;
                }
                return fn.apply(this, arguments);
            }, fn);
        }

        var deprecations = {};

        function deprecateSimple(name, msg) {
            if (!deprecations[name]) {
                warn(msg);
                deprecations[name] = true;
            }
        }

        utils_hooks__hooks.suppressDeprecationWarnings = false;

        var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

        var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/], ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/], ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/], ['GGGG-[W]WW', /\d{4}-W\d{2}/], ['YYYY-DDD', /\d{4}-\d{3}/]];

        // iso time formats and regexes
        var isoTimes = [['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/], ['HH:mm', /(T| )\d\d:\d\d/], ['HH', /(T| )\d\d/]];

        var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

        // date from iso format
        function configFromISO(config) {
            var i,
                l,
                string = config._i,
                match = from_string__isoRegex.exec(string);

            if (match) {
                getParsingFlags(config).iso = true;
                for (i = 0, l = isoDates.length; i < l; i++) {
                    if (isoDates[i][1].exec(string)) {
                        config._f = isoDates[i][0];
                        break;
                    }
                }
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(string)) {
                        // match[6] should be 'T' or space
                        config._f += (match[6] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (string.match(matchOffset)) {
                    config._f += 'Z';
                }
                configFromStringAndFormat(config);
            } else {
                config._isValid = false;
            }
        }

        // date from iso format or fallback
        function configFromString(config) {
            var matched = aspNetJsonRegex.exec(config._i);

            if (matched !== null) {
                config._d = new Date(+matched[1]);
                return;
            }

            configFromISO(config);
            if (config._isValid === false) {
                delete config._isValid;
                utils_hooks__hooks.createFromInputFallback(config);
            }
        }

        utils_hooks__hooks.createFromInputFallback = deprecate('moment construction falls back to js Date. This is ' + 'discouraged and will be removed in upcoming major ' + 'release. Please refer to ' + 'https://github.com/moment/moment/issues/1407 for more info.', function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        });

        function createDate(y, m, d, h, M, s, ms) {
            //can't just apply() to create a date:
            //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
            var date = new Date(y, m, d, h, M, s, ms);

            //the date constructor doesn't accept years < 1970
            if (y < 1970) {
                date.setFullYear(y);
            }
            return date;
        }

        function createUTCDate(y) {
            var date = new Date(Date.UTC.apply(null, arguments));
            if (y < 1970) {
                date.setUTCFullYear(y);
            }
            return date;
        }

        addFormatToken(0, ['YY', 2], 0, function () {
            return this.year() % 100;
        });

        addFormatToken(0, ['YYYY', 4], 0, 'year');
        addFormatToken(0, ['YYYYY', 5], 0, 'year');
        addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

        // ALIASES

        addUnitAlias('year', 'y');

        // PARSING

        addRegexToken('Y', matchSigned);
        addRegexToken('YY', match1to2, match2);
        addRegexToken('YYYY', match1to4, match4);
        addRegexToken('YYYYY', match1to6, match6);
        addRegexToken('YYYYYY', match1to6, match6);

        addParseToken(['YYYYY', 'YYYYYY'], YEAR);
        addParseToken('YYYY', function (input, array) {
            array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
        });
        addParseToken('YY', function (input, array) {
            array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
        });

        // HELPERS

        function daysInYear(year) {
            return isLeapYear(year) ? 366 : 365;
        }

        function isLeapYear(year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        }

        // HOOKS

        utils_hooks__hooks.parseTwoDigitYear = function (input) {
            return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
        };

        // MOMENTS

        var getSetYear = makeGetSet('FullYear', false);

        function getIsLeapYear() {
            return isLeapYear(this.year());
        }

        addFormatToken('w', ['ww', 2], 'wo', 'week');
        addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

        // ALIASES

        addUnitAlias('week', 'w');
        addUnitAlias('isoWeek', 'W');

        // PARSING

        addRegexToken('w', match1to2);
        addRegexToken('ww', match1to2, match2);
        addRegexToken('W', match1to2);
        addRegexToken('WW', match1to2, match2);

        addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        });

        // HELPERS

        // firstDayOfWeek       0 = sun, 6 = sat
        //                      the day of the week that starts the week
        //                      (usually sunday or monday)
        // firstDayOfWeekOfYear 0 = sun, 6 = sat
        //                      the first week is the week that contains the first
        //                      of this day of the week
        //                      (eg. ISO weeks use thursday (4))
        function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
            var end = firstDayOfWeekOfYear - firstDayOfWeek,
                daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
                adjustedMoment;

            if (daysToDayOfWeek > end) {
                daysToDayOfWeek -= 7;
            }

            if (daysToDayOfWeek < end - 7) {
                daysToDayOfWeek += 7;
            }

            adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
            return {
                week: Math.ceil(adjustedMoment.dayOfYear() / 7),
                year: adjustedMoment.year()
            };
        }

        // LOCALES

        function localeWeek(mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        }

        var defaultLocaleWeek = {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        };

        function localeFirstDayOfWeek() {
            return this._week.dow;
        }

        function localeFirstDayOfYear() {
            return this._week.doy;
        }

        // MOMENTS

        function getSetWeek(input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
        }

        function getSetISOWeek(input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
        }

        addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

        // ALIASES

        addUnitAlias('dayOfYear', 'DDD');

        // PARSING

        addRegexToken('DDD', match1to3);
        addRegexToken('DDDD', match3);
        addParseToken(['DDD', 'DDDD'], function (input, array, config) {
            config._dayOfYear = toInt(input);
        });

        // HELPERS

        //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
        function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
            var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear,
                janX = createUTCDate(year, 0, 1 + week1Jan),
                d = janX.getUTCDay(),
                dayOfYear;
            if (d < firstDayOfWeek) {
                d += 7;
            }

            weekday = weekday != null ? 1 * weekday : firstDayOfWeek;

            dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;

            return {
                year: dayOfYear > 0 ? year : year - 1,
                dayOfYear: dayOfYear > 0 ? dayOfYear : daysInYear(year - 1) + dayOfYear
            };
        }

        // MOMENTS

        function getSetDayOfYear(input) {
            var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
        }

        // Pick the first defined of two or three arguments.
        function defaults(a, b, c) {
            if (a != null) {
                return a;
            }
            if (b != null) {
                return b;
            }
            return c;
        }

        function currentDateArray(config) {
            var now = new Date();
            if (config._useUTC) {
                return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
            }
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }

        // convert an array to a date.
        // the array should mirror the parameters below
        // note: all values past the year are optional and will default to the lowest possible value.
        // [year, month, day , hour, minute, second, millisecond]
        function configFromArray(config) {
            var i,
                date,
                input = [],
                currentDate,
                yearToUse;

            if (config._d) {
                return;
            }

            currentDate = currentDateArray(config);

            //compute day of the year from weeks and weekdays
            if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
                dayOfYearFromWeekInfo(config);
            }

            //if the day of the year is set, figure out what it is
            if (config._dayOfYear) {
                yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

                if (config._dayOfYear > daysInYear(yearToUse)) {
                    getParsingFlags(config)._overflowDayOfYear = true;
                }

                date = createUTCDate(yearToUse, 0, config._dayOfYear);
                config._a[MONTH] = date.getUTCMonth();
                config._a[DATE] = date.getUTCDate();
            }

            // Default to current date.
            // * if no year, month, day of month are given, default to today
            // * if day of month is given, default month and year
            // * if month is given, default only year
            // * if year is given, don't default anything
            for (i = 0; i < 3 && config._a[i] == null; ++i) {
                config._a[i] = input[i] = currentDate[i];
            }

            // Zero out whatever was not defaulted, including time
            for (; i < 7; i++) {
                config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
            }

            // Check for 24:00:00.000
            if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                config._nextDay = true;
                config._a[HOUR] = 0;
            }

            config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
            // Apply timezone offset from input. The actual utcOffset can be changed
            // with parseZone.
            if (config._tzm != null) {
                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            }

            if (config._nextDay) {
                config._a[HOUR] = 24;
            }
        }

        function dayOfYearFromWeekInfo(config) {
            var w, weekYear, week, weekday, dow, doy, temp;

            w = config._w;
            if (w.GG != null || w.W != null || w.E != null) {
                dow = 1;
                doy = 4;

                // TODO: We need to take the current isoWeekYear, but that depends on
                // how we interpret now (local, utc, fixed offset). So create
                // a now version of current config (take local/utc/offset flags, and
                // create now).
                weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
                week = defaults(w.W, 1);
                weekday = defaults(w.E, 1);
            } else {
                dow = config._locale._week.dow;
                doy = config._locale._week.doy;

                weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
                week = defaults(w.w, 1);

                if (w.d != null) {
                    // weekday -- low day numbers are considered next week
                    weekday = w.d;
                    if (weekday < dow) {
                        ++week;
                    }
                } else if (w.e != null) {
                    // local weekday -- counting starts from begining of week
                    weekday = w.e + dow;
                } else {
                    // default to begining of week
                    weekday = dow;
                }
            }
            temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }

        utils_hooks__hooks.ISO_8601 = function () {};

        // date from string and format string
        function configFromStringAndFormat(config) {
            // TODO: Move this to another part of the creation flow to prevent circular deps
            if (config._f === utils_hooks__hooks.ISO_8601) {
                configFromISO(config);
                return;
            }

            config._a = [];
            getParsingFlags(config).empty = true;

            // This array is used to make a Date, either with `new Date` or `Date.UTC`
            var string = '' + config._i,
                i,
                parsedInput,
                tokens,
                token,
                skipped,
                stringLength = string.length,
                totalParsedInputLength = 0;

            tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

            for (i = 0; i < tokens.length; i++) {
                token = tokens[i];
                parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
                if (parsedInput) {
                    skipped = string.substr(0, string.indexOf(parsedInput));
                    if (skipped.length > 0) {
                        getParsingFlags(config).unusedInput.push(skipped);
                    }
                    string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                    totalParsedInputLength += parsedInput.length;
                }
                // don't parse if it's not a known token
                if (formatTokenFunctions[token]) {
                    if (parsedInput) {
                        getParsingFlags(config).empty = false;
                    } else {
                        getParsingFlags(config).unusedTokens.push(token);
                    }
                    addTimeToArrayFromToken(token, parsedInput, config);
                } else if (config._strict && !parsedInput) {
                    getParsingFlags(config).unusedTokens.push(token);
                }
            }

            // add remaining unparsed input length to the string
            getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
            if (string.length > 0) {
                getParsingFlags(config).unusedInput.push(string);
            }

            // clear _12h flag if hour is <= 12
            if (getParsingFlags(config).bigHour === true && config._a[HOUR] <= 12 && config._a[HOUR] > 0) {
                getParsingFlags(config).bigHour = undefined;
            }
            // handle meridiem
            config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

            configFromArray(config);
            checkOverflow(config);
        }

        function meridiemFixWrap(locale, hour, meridiem) {
            var isPm;

            if (meridiem == null) {
                // nothing to do
                return hour;
            }
            if (locale.meridiemHour != null) {
                return locale.meridiemHour(hour, meridiem);
            } else if (locale.isPM != null) {
                // Fallback
                isPm = locale.isPM(meridiem);
                if (isPm && hour < 12) {
                    hour += 12;
                }
                if (!isPm && hour === 12) {
                    hour = 0;
                }
                return hour;
            } else {
                // this is not supposed to happen
                return hour;
            }
        }

        function configFromStringAndArray(config) {
            var tempConfig, bestMoment, scoreToBeat, i, currentScore;

            if (config._f.length === 0) {
                getParsingFlags(config).invalidFormat = true;
                config._d = new Date(NaN);
                return;
            }

            for (i = 0; i < config._f.length; i++) {
                currentScore = 0;
                tempConfig = copyConfig({}, config);
                if (config._useUTC != null) {
                    tempConfig._useUTC = config._useUTC;
                }
                tempConfig._f = config._f[i];
                configFromStringAndFormat(tempConfig);

                if (!valid__isValid(tempConfig)) {
                    continue;
                }

                // if there is any input that was not parsed add a penalty for that format
                currentScore += getParsingFlags(tempConfig).charsLeftOver;

                //or tokens
                currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

                getParsingFlags(tempConfig).score = currentScore;

                if (scoreToBeat == null || currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }

            extend(config, bestMoment || tempConfig);
        }

        function configFromObject(config) {
            if (config._d) {
                return;
            }

            var i = normalizeObjectUnits(config._i);
            config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];

            configFromArray(config);
        }

        function createFromConfig(config) {
            var res = new Moment(checkOverflow(prepareConfig(config)));
            if (res._nextDay) {
                // Adding is smart enough around DST
                res.add(1, 'd');
                res._nextDay = undefined;
            }

            return res;
        }

        function prepareConfig(config) {
            var input = config._i,
                format = config._f;

            config._locale = config._locale || locale_locales__getLocale(config._l);

            if (input === null || format === undefined && input === '') {
                return valid__createInvalid({ nullInput: true });
            }

            if (typeof input === 'string') {
                config._i = input = config._locale.preparse(input);
            }

            if (isMoment(input)) {
                return new Moment(checkOverflow(input));
            } else if (isArray(format)) {
                configFromStringAndArray(config);
            } else if (format) {
                configFromStringAndFormat(config);
            } else if (isDate(input)) {
                config._d = input;
            } else {
                configFromInput(config);
            }

            return config;
        }

        function configFromInput(config) {
            var input = config._i;
            if (input === undefined) {
                config._d = new Date();
            } else if (isDate(input)) {
                config._d = new Date(+input);
            } else if (typeof input === 'string') {
                configFromString(config);
            } else if (isArray(input)) {
                config._a = map(input.slice(0), function (obj) {
                    return parseInt(obj, 10);
                });
                configFromArray(config);
            } else if (typeof input === 'object') {
                configFromObject(config);
            } else if (typeof input === 'number') {
                // from milliseconds
                config._d = new Date(input);
            } else {
                utils_hooks__hooks.createFromInputFallback(config);
            }
        }

        function createLocalOrUTC(input, format, locale, strict, isUTC) {
            var c = {};

            if (typeof locale === 'boolean') {
                strict = locale;
                locale = undefined;
            }
            // object construction must be done this way.
            // https://github.com/moment/moment/issues/1423
            c._isAMomentObject = true;
            c._useUTC = c._isUTC = isUTC;
            c._l = locale;
            c._i = input;
            c._f = format;
            c._strict = strict;

            return createFromConfig(c);
        }

        function local__createLocal(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, false);
        }

        var prototypeMin = deprecate('moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548', function () {
            var other = local__createLocal.apply(null, arguments);
            return other < this ? this : other;
        });

        var prototypeMax = deprecate('moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548', function () {
            var other = local__createLocal.apply(null, arguments);
            return other > this ? this : other;
        });

        // Pick a moment m from moments so that m[fn](other) is true for all
        // other. This relies on the function fn to be transitive.
        //
        // moments should either be an array of moment objects or an array, whose
        // first element is an array of moment objects.
        function pickBy(fn, moments) {
            var res, i;
            if (moments.length === 1 && isArray(moments[0])) {
                moments = moments[0];
            }
            if (!moments.length) {
                return local__createLocal();
            }
            res = moments[0];
            for (i = 1; i < moments.length; ++i) {
                if (!moments[i].isValid() || moments[i][fn](res)) {
                    res = moments[i];
                }
            }
            return res;
        }

        // TODO: Use [].sort instead?
        function min() {
            var args = [].slice.call(arguments, 0);

            return pickBy('isBefore', args);
        }

        function max() {
            var args = [].slice.call(arguments, 0);

            return pickBy('isAfter', args);
        }

        function Duration(duration) {
            var normalizedInput = normalizeObjectUnits(duration),
                years = normalizedInput.year || 0,
                quarters = normalizedInput.quarter || 0,
                months = normalizedInput.month || 0,
                weeks = normalizedInput.week || 0,
                days = normalizedInput.day || 0,
                hours = normalizedInput.hour || 0,
                minutes = normalizedInput.minute || 0,
                seconds = normalizedInput.second || 0,
                milliseconds = normalizedInput.millisecond || 0;

            // representation for dateAddRemove
            this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
            // Because of dateAddRemove treats 24 hours as different from a
            // day when working around DST, we need to store them separately
            this._days = +days + weeks * 7;
            // It is impossible translate months into days without knowing
            // which months you are are talking about, so we have to store
            // it separately.
            this._months = +months + quarters * 3 + years * 12;

            this._data = {};

            this._locale = locale_locales__getLocale();

            this._bubble();
        }

        function isDuration(obj) {
            return obj instanceof Duration;
        }

        function offset(token, separator) {
            addFormatToken(token, 0, 0, function () {
                var offset = this.utcOffset();
                var sign = '+';
                if (offset < 0) {
                    offset = -offset;
                    sign = '-';
                }
                return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
            });
        }

        offset('Z', ':');
        offset('ZZ', '');

        // PARSING

        addRegexToken('Z', matchOffset);
        addRegexToken('ZZ', matchOffset);
        addParseToken(['Z', 'ZZ'], function (input, array, config) {
            config._useUTC = true;
            config._tzm = offsetFromString(input);
        });

        // HELPERS

        // timezone chunker
        // '+10:00' > ['10',  '00']
        // '-1530'  > ['-15', '30']
        var chunkOffset = /([\+\-]|\d\d)/gi;

        function offsetFromString(string) {
            var matches = (string || '').match(matchOffset) || [];
            var chunk = matches[matches.length - 1] || [];
            var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
            var minutes = +(parts[1] * 60) + toInt(parts[2]);

            return parts[0] === '+' ? minutes : -minutes;
        }

        // Return a moment from input, that is local/utc/zone equivalent to model.
        function cloneWithOffset(input, model) {
            var res, diff;
            if (model._isUTC) {
                res = model.clone();
                diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - +res;
                // Use low-level api, because this fn is low-level api.
                res._d.setTime(+res._d + diff);
                utils_hooks__hooks.updateOffset(res, false);
                return res;
            } else {
                return local__createLocal(input).local();
            }
        }

        function getDateOffset(m) {
            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
            // https://github.com/moment/moment/pull/1871
            return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
        }

        // HOOKS

        // This function will be called whenever a moment is mutated.
        // It is intended to keep the offset in sync with the timezone.
        utils_hooks__hooks.updateOffset = function () {};

        // MOMENTS

        // keepLocalTime = true means only change the timezone, without
        // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
        // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
        // +0200, so we adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        function getSetOffset(input, keepLocalTime) {
            var offset = this._offset || 0,
                localAdjust;
            if (input != null) {
                if (typeof input === 'string') {
                    input = offsetFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                if (!this._isUTC && keepLocalTime) {
                    localAdjust = getDateOffset(this);
                }
                this._offset = input;
                this._isUTC = true;
                if (localAdjust != null) {
                    this.add(localAdjust, 'm');
                }
                if (offset !== input) {
                    if (!keepLocalTime || this._changeInProgress) {
                        add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        utils_hooks__hooks.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
                return this;
            } else {
                return this._isUTC ? offset : getDateOffset(this);
            }
        }

        function getSetZone(input, keepLocalTime) {
            if (input != null) {
                if (typeof input !== 'string') {
                    input = -input;
                }

                this.utcOffset(input, keepLocalTime);

                return this;
            } else {
                return -this.utcOffset();
            }
        }

        function setOffsetToUTC(keepLocalTime) {
            return this.utcOffset(0, keepLocalTime);
        }

        function setOffsetToLocal(keepLocalTime) {
            if (this._isUTC) {
                this.utcOffset(0, keepLocalTime);
                this._isUTC = false;

                if (keepLocalTime) {
                    this.subtract(getDateOffset(this), 'm');
                }
            }
            return this;
        }

        function setOffsetToParsedOffset() {
            if (this._tzm) {
                this.utcOffset(this._tzm);
            } else if (typeof this._i === 'string') {
                this.utcOffset(offsetFromString(this._i));
            }
            return this;
        }

        function hasAlignedHourOffset(input) {
            input = input ? local__createLocal(input).utcOffset() : 0;

            return (this.utcOffset() - input) % 60 === 0;
        }

        function isDaylightSavingTime() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }

        function isDaylightSavingTimeShifted() {
            if (typeof this._isDSTShifted !== 'undefined') {
                return this._isDSTShifted;
            }

            var c = {};

            copyConfig(c, this);
            c = prepareConfig(c);

            if (c._a) {
                var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
                this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
            } else {
                this._isDSTShifted = false;
            }

            return this._isDSTShifted;
        }

        function isLocal() {
            return !this._isUTC;
        }

        function isUtcOffset() {
            return this._isUTC;
        }

        function isUtc() {
            return this._isUTC && this._offset === 0;
        }

        var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

        function create__createDuration(input, key) {
            var duration = input,

            // matching against regexp is expensive, do it on demand
            match = null,
                sign,
                ret,
                diffRes;

            if (isDuration(input)) {
                duration = {
                    ms: input._milliseconds,
                    d: input._days,
                    M: input._months
                };
            } else if (typeof input === 'number') {
                duration = {};
                if (key) {
                    duration[key] = input;
                } else {
                    duration.milliseconds = input;
                }
            } else if (!!(match = aspNetRegex.exec(input))) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: 0,
                    d: toInt(match[DATE]) * sign,
                    h: toInt(match[HOUR]) * sign,
                    m: toInt(match[MINUTE]) * sign,
                    s: toInt(match[SECOND]) * sign,
                    ms: toInt(match[MILLISECOND]) * sign
                };
            } else if (!!(match = create__isoRegex.exec(input))) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: parseIso(match[2], sign),
                    M: parseIso(match[3], sign),
                    d: parseIso(match[4], sign),
                    h: parseIso(match[5], sign),
                    m: parseIso(match[6], sign),
                    s: parseIso(match[7], sign),
                    w: parseIso(match[8], sign)
                };
            } else if (duration == null) {
                // checks for null or undefined
                duration = {};
            } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
                diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

                duration = {};
                duration.ms = diffRes.milliseconds;
                duration.M = diffRes.months;
            }

            ret = new Duration(duration);

            if (isDuration(input) && hasOwnProp(input, '_locale')) {
                ret._locale = input._locale;
            }

            return ret;
        }

        create__createDuration.fn = Duration.prototype;

        function parseIso(inp, sign) {
            // We'd normally use ~~inp for this, but unfortunately it also
            // converts floats to ints.
            // inp may be undefined, so careful calling replace on it.
            var res = inp && parseFloat(inp.replace(',', '.'));
            // apply sign while we're at it
            return (isNaN(res) ? 0 : res) * sign;
        }

        function positiveMomentsDifference(base, other) {
            var res = { milliseconds: 0, months: 0 };

            res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
            if (base.clone().add(res.months, 'M').isAfter(other)) {
                --res.months;
            }

            res.milliseconds = +other - +base.clone().add(res.months, 'M');

            return res;
        }

        function momentsDifference(base, other) {
            var res;
            other = cloneWithOffset(other, base);
            if (base.isBefore(other)) {
                res = positiveMomentsDifference(base, other);
            } else {
                res = positiveMomentsDifference(other, base);
                res.milliseconds = -res.milliseconds;
                res.months = -res.months;
            }

            return res;
        }

        function createAdder(direction, name) {
            return function (val, period) {
                var dur, tmp;
                //invert the arguments, but complain about it
                if (period !== null && !isNaN(+period)) {
                    deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                    tmp = val;val = period;period = tmp;
                }

                val = typeof val === 'string' ? +val : val;
                dur = create__createDuration(val, period);
                add_subtract__addSubtract(this, dur, direction);
                return this;
            };
        }

        function add_subtract__addSubtract(mom, duration, isAdding, updateOffset) {
            var milliseconds = duration._milliseconds,
                days = duration._days,
                months = duration._months;
            updateOffset = updateOffset == null ? true : updateOffset;

            if (milliseconds) {
                mom._d.setTime(+mom._d + milliseconds * isAdding);
            }
            if (days) {
                get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
            }
            if (months) {
                setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
            }
            if (updateOffset) {
                utils_hooks__hooks.updateOffset(mom, days || months);
            }
        }

        var add_subtract__add = createAdder(1, 'add');
        var add_subtract__subtract = createAdder(-1, 'subtract');

        function moment_calendar__calendar(time, formats) {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're local/utc/offset or not.
            var now = time || local__createLocal(),
                sod = cloneWithOffset(now, this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
        }

        function clone() {
            return new Moment(this);
        }

        function isAfter(input, units) {
            var inputMs;
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = isMoment(input) ? input : local__createLocal(input);
                return +this > +input;
            } else {
                inputMs = isMoment(input) ? +input : +local__createLocal(input);
                return inputMs < +this.clone().startOf(units);
            }
        }

        function isBefore(input, units) {
            var inputMs;
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = isMoment(input) ? input : local__createLocal(input);
                return +this < +input;
            } else {
                inputMs = isMoment(input) ? +input : +local__createLocal(input);
                return +this.clone().endOf(units) < inputMs;
            }
        }

        function isBetween(from, to, units) {
            return this.isAfter(from, units) && this.isBefore(to, units);
        }

        function isSame(input, units) {
            var inputMs;
            units = normalizeUnits(units || 'millisecond');
            if (units === 'millisecond') {
                input = isMoment(input) ? input : local__createLocal(input);
                return +this === +input;
            } else {
                inputMs = +local__createLocal(input);
                return +this.clone().startOf(units) <= inputMs && inputMs <= +this.clone().endOf(units);
            }
        }

        function diff(input, units, asFloat) {
            var that = cloneWithOffset(input, this),
                zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
                delta,
                output;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month' || units === 'quarter') {
                output = monthDiff(this, that);
                if (units === 'quarter') {
                    output = output / 3;
                } else if (units === 'year') {
                    output = output / 12;
                }
            } else {
                delta = this - that;
                output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
            }
            return asFloat ? output : absFloor(output);
        }

        function monthDiff(a, b) {
            // difference in months
            var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
                anchor2,
                adjust;

            if (b - anchor < 0) {
                anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
                // linear across the month
                adjust = (b - anchor) / (anchor - anchor2);
            } else {
                anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
                // linear across the month
                adjust = (b - anchor) / (anchor2 - anchor);
            }

            return -(wholeMonthDiff + adjust);
        }

        utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

        function toString() {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
        }

        function moment_format__toISOString() {
            var m = this.clone().utc();
            if (0 < m.year() && m.year() <= 9999) {
                if ('function' === typeof Date.prototype.toISOString) {
                    // native implementation is ~50x faster, use it when we can
                    return this.toDate().toISOString();
                } else {
                    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
                }
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        }

        function format(inputString) {
            var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
            return this.localeData().postformat(output);
        }

        function from(time, withoutSuffix) {
            if (!this.isValid()) {
                return this.localeData().invalidDate();
            }
            return create__createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        }

        function fromNow(withoutSuffix) {
            return this.from(local__createLocal(), withoutSuffix);
        }

        function to(time, withoutSuffix) {
            if (!this.isValid()) {
                return this.localeData().invalidDate();
            }
            return create__createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        }

        function toNow(withoutSuffix) {
            return this.to(local__createLocal(), withoutSuffix);
        }

        function locale(key) {
            var newLocaleData;

            if (key === undefined) {
                return this._locale._abbr;
            } else {
                newLocaleData = locale_locales__getLocale(key);
                if (newLocaleData != null) {
                    this._locale = newLocaleData;
                }
                return this;
            }
        }

        var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        });

        function localeData() {
            return this._locale;
        }

        function startOf(units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
                case 'year':
                    this.month(0);
                /* falls through */
                case 'quarter':
                case 'month':
                    this.date(1);
                /* falls through */
                case 'week':
                case 'isoWeek':
                case 'day':
                    this.hours(0);
                /* falls through */
                case 'hour':
                    this.minutes(0);
                /* falls through */
                case 'minute':
                    this.seconds(0);
                /* falls through */
                case 'second':
                    this.milliseconds(0);
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            }
            if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        }

        function endOf(units) {
            units = normalizeUnits(units);
            if (units === undefined || units === 'millisecond') {
                return this;
            }
            return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
        }

        function to_type__valueOf() {
            return +this._d - (this._offset || 0) * 60000;
        }

        function unix() {
            return Math.floor(+this / 1000);
        }

        function toDate() {
            return this._offset ? new Date(+this) : this._d;
        }

        function toArray() {
            var m = this;
            return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
        }

        function toObject() {
            var m = this;
            return {
                years: m.year(),
                months: m.month(),
                date: m.date(),
                hours: m.hours(),
                minutes: m.minutes(),
                seconds: m.seconds(),
                milliseconds: m.milliseconds()
            };
        }

        function moment_valid__isValid() {
            return valid__isValid(this);
        }

        function parsingFlags() {
            return extend({}, getParsingFlags(this));
        }

        function invalidAt() {
            return getParsingFlags(this).overflow;
        }

        addFormatToken(0, ['gg', 2], 0, function () {
            return this.weekYear() % 100;
        });

        addFormatToken(0, ['GG', 2], 0, function () {
            return this.isoWeekYear() % 100;
        });

        function addWeekYearFormatToken(token, getter) {
            addFormatToken(0, [token, token.length], 0, getter);
        }

        addWeekYearFormatToken('gggg', 'weekYear');
        addWeekYearFormatToken('ggggg', 'weekYear');
        addWeekYearFormatToken('GGGG', 'isoWeekYear');
        addWeekYearFormatToken('GGGGG', 'isoWeekYear');

        // ALIASES

        addUnitAlias('weekYear', 'gg');
        addUnitAlias('isoWeekYear', 'GG');

        // PARSING

        addRegexToken('G', matchSigned);
        addRegexToken('g', matchSigned);
        addRegexToken('GG', match1to2, match2);
        addRegexToken('gg', match1to2, match2);
        addRegexToken('GGGG', match1to4, match4);
        addRegexToken('gggg', match1to4, match4);
        addRegexToken('GGGGG', match1to6, match6);
        addRegexToken('ggggg', match1to6, match6);

        addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        });

        addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
            week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
        });

        // HELPERS

        function weeksInYear(year, dow, doy) {
            return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
        }

        // MOMENTS

        function getSetWeekYear(input) {
            var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
            return input == null ? year : this.add(input - year, 'y');
        }

        function getSetISOWeekYear(input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add(input - year, 'y');
        }

        function getISOWeeksInYear() {
            return weeksInYear(this.year(), 1, 4);
        }

        function getWeeksInYear() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        }

        addFormatToken('Q', 0, 0, 'quarter');

        // ALIASES

        addUnitAlias('quarter', 'Q');

        // PARSING

        addRegexToken('Q', match1);
        addParseToken('Q', function (input, array) {
            array[MONTH] = (toInt(input) - 1) * 3;
        });

        // MOMENTS

        function getSetQuarter(input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        }

        addFormatToken('D', ['DD', 2], 'Do', 'date');

        // ALIASES

        addUnitAlias('date', 'D');

        // PARSING

        addRegexToken('D', match1to2);
        addRegexToken('DD', match1to2, match2);
        addRegexToken('Do', function (isStrict, locale) {
            return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
        });

        addParseToken(['D', 'DD'], DATE);
        addParseToken('Do', function (input, array) {
            array[DATE] = toInt(input.match(match1to2)[0], 10);
        });

        // MOMENTS

        var getSetDayOfMonth = makeGetSet('Date', true);

        addFormatToken('d', 0, 'do', 'day');

        addFormatToken('dd', 0, 0, function (format) {
            return this.localeData().weekdaysMin(this, format);
        });

        addFormatToken('ddd', 0, 0, function (format) {
            return this.localeData().weekdaysShort(this, format);
        });

        addFormatToken('dddd', 0, 0, function (format) {
            return this.localeData().weekdays(this, format);
        });

        addFormatToken('e', 0, 0, 'weekday');
        addFormatToken('E', 0, 0, 'isoWeekday');

        // ALIASES

        addUnitAlias('day', 'd');
        addUnitAlias('weekday', 'e');
        addUnitAlias('isoWeekday', 'E');

        // PARSING

        addRegexToken('d', match1to2);
        addRegexToken('e', match1to2);
        addRegexToken('E', match1to2);
        addRegexToken('dd', matchWord);
        addRegexToken('ddd', matchWord);
        addRegexToken('dddd', matchWord);

        addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
            var weekday = config._locale.weekdaysParse(input);
            // if we didn't get a weekday name, mark the date as invalid
            if (weekday != null) {
                week.d = weekday;
            } else {
                getParsingFlags(config).invalidWeekday = input;
            }
        });

        addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
            week[token] = toInt(input);
        });

        // HELPERS

        function parseWeekday(input, locale) {
            if (typeof input !== 'string') {
                return input;
            }

            if (!isNaN(input)) {
                return parseInt(input, 10);
            }

            input = locale.weekdaysParse(input);
            if (typeof input === 'number') {
                return input;
            }

            return null;
        }

        // LOCALES

        var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
        function localeWeekdays(m) {
            return this._weekdays[m.day()];
        }

        var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
        function localeWeekdaysShort(m) {
            return this._weekdaysShort[m.day()];
        }

        var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
        function localeWeekdaysMin(m) {
            return this._weekdaysMin[m.day()];
        }

        function localeWeekdaysParse(weekdayName) {
            var i, mom, regex;

            this._weekdaysParse = this._weekdaysParse || [];

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = local__createLocal([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        }

        // MOMENTS

        function getSetDayOfWeek(input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
            } else {
                return day;
            }
        }

        function getSetLocaleDayOfWeek(input) {
            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
        }

        function getSetISODayOfWeek(input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        }

        addFormatToken('H', ['HH', 2], 0, 'hour');
        addFormatToken('h', ['hh', 2], 0, function () {
            return this.hours() % 12 || 12;
        });

        function meridiem(token, lowercase) {
            addFormatToken(token, 0, 0, function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
            });
        }

        meridiem('a', true);
        meridiem('A', false);

        // ALIASES

        addUnitAlias('hour', 'h');

        // PARSING

        function matchMeridiem(isStrict, locale) {
            return locale._meridiemParse;
        }

        addRegexToken('a', matchMeridiem);
        addRegexToken('A', matchMeridiem);
        addRegexToken('H', match1to2);
        addRegexToken('h', match1to2);
        addRegexToken('HH', match1to2, match2);
        addRegexToken('hh', match1to2, match2);

        addParseToken(['H', 'HH'], HOUR);
        addParseToken(['a', 'A'], function (input, array, config) {
            config._isPm = config._locale.isPM(input);
            config._meridiem = input;
        });
        addParseToken(['h', 'hh'], function (input, array, config) {
            array[HOUR] = toInt(input);
            getParsingFlags(config).bigHour = true;
        });

        // LOCALES

        function localeIsPM(input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return (input + '').toLowerCase().charAt(0) === 'p';
        }

        var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
        function localeMeridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        }

        // MOMENTS

        // Setting the hour should keep the time, because the user explicitly
        // specified which hour he wants. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        var getSetHour = makeGetSet('Hours', true);

        addFormatToken('m', ['mm', 2], 0, 'minute');

        // ALIASES

        addUnitAlias('minute', 'm');

        // PARSING

        addRegexToken('m', match1to2);
        addRegexToken('mm', match1to2, match2);
        addParseToken(['m', 'mm'], MINUTE);

        // MOMENTS

        var getSetMinute = makeGetSet('Minutes', false);

        addFormatToken('s', ['ss', 2], 0, 'second');

        // ALIASES

        addUnitAlias('second', 's');

        // PARSING

        addRegexToken('s', match1to2);
        addRegexToken('ss', match1to2, match2);
        addParseToken(['s', 'ss'], SECOND);

        // MOMENTS

        var getSetSecond = makeGetSet('Seconds', false);

        addFormatToken('S', 0, 0, function () {
            return ~~(this.millisecond() / 100);
        });

        addFormatToken(0, ['SS', 2], 0, function () {
            return ~~(this.millisecond() / 10);
        });

        addFormatToken(0, ['SSS', 3], 0, 'millisecond');
        addFormatToken(0, ['SSSS', 4], 0, function () {
            return this.millisecond() * 10;
        });
        addFormatToken(0, ['SSSSS', 5], 0, function () {
            return this.millisecond() * 100;
        });
        addFormatToken(0, ['SSSSSS', 6], 0, function () {
            return this.millisecond() * 1000;
        });
        addFormatToken(0, ['SSSSSSS', 7], 0, function () {
            return this.millisecond() * 10000;
        });
        addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
            return this.millisecond() * 100000;
        });
        addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
            return this.millisecond() * 1000000;
        });

        // ALIASES

        addUnitAlias('millisecond', 'ms');

        // PARSING

        addRegexToken('S', match1to3, match1);
        addRegexToken('SS', match1to3, match2);
        addRegexToken('SSS', match1to3, match3);

        var token;
        for (token = 'SSSS'; token.length <= 9; token += 'S') {
            addRegexToken(token, matchUnsigned);
        }

        function parseMs(input, array) {
            array[MILLISECOND] = toInt(('0.' + input) * 1000);
        }

        for (token = 'S'; token.length <= 9; token += 'S') {
            addParseToken(token, parseMs);
        }
        // MOMENTS

        var getSetMillisecond = makeGetSet('Milliseconds', false);

        addFormatToken('z', 0, 0, 'zoneAbbr');
        addFormatToken('zz', 0, 0, 'zoneName');

        // MOMENTS

        function getZoneAbbr() {
            return this._isUTC ? 'UTC' : '';
        }

        function getZoneName() {
            return this._isUTC ? 'Coordinated Universal Time' : '';
        }

        var momentPrototype__proto = Moment.prototype;

        momentPrototype__proto.add = add_subtract__add;
        momentPrototype__proto.calendar = moment_calendar__calendar;
        momentPrototype__proto.clone = clone;
        momentPrototype__proto.diff = diff;
        momentPrototype__proto.endOf = endOf;
        momentPrototype__proto.format = format;
        momentPrototype__proto.from = from;
        momentPrototype__proto.fromNow = fromNow;
        momentPrototype__proto.to = to;
        momentPrototype__proto.toNow = toNow;
        momentPrototype__proto.get = getSet;
        momentPrototype__proto.invalidAt = invalidAt;
        momentPrototype__proto.isAfter = isAfter;
        momentPrototype__proto.isBefore = isBefore;
        momentPrototype__proto.isBetween = isBetween;
        momentPrototype__proto.isSame = isSame;
        momentPrototype__proto.isValid = moment_valid__isValid;
        momentPrototype__proto.lang = lang;
        momentPrototype__proto.locale = locale;
        momentPrototype__proto.localeData = localeData;
        momentPrototype__proto.max = prototypeMax;
        momentPrototype__proto.min = prototypeMin;
        momentPrototype__proto.parsingFlags = parsingFlags;
        momentPrototype__proto.set = getSet;
        momentPrototype__proto.startOf = startOf;
        momentPrototype__proto.subtract = add_subtract__subtract;
        momentPrototype__proto.toArray = toArray;
        momentPrototype__proto.toObject = toObject;
        momentPrototype__proto.toDate = toDate;
        momentPrototype__proto.toISOString = moment_format__toISOString;
        momentPrototype__proto.toJSON = moment_format__toISOString;
        momentPrototype__proto.toString = toString;
        momentPrototype__proto.unix = unix;
        momentPrototype__proto.valueOf = to_type__valueOf;

        // Year
        momentPrototype__proto.year = getSetYear;
        momentPrototype__proto.isLeapYear = getIsLeapYear;

        // Week Year
        momentPrototype__proto.weekYear = getSetWeekYear;
        momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

        // Quarter
        momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

        // Month
        momentPrototype__proto.month = getSetMonth;
        momentPrototype__proto.daysInMonth = getDaysInMonth;

        // Week
        momentPrototype__proto.week = momentPrototype__proto.weeks = getSetWeek;
        momentPrototype__proto.isoWeek = momentPrototype__proto.isoWeeks = getSetISOWeek;
        momentPrototype__proto.weeksInYear = getWeeksInYear;
        momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

        // Day
        momentPrototype__proto.date = getSetDayOfMonth;
        momentPrototype__proto.day = momentPrototype__proto.days = getSetDayOfWeek;
        momentPrototype__proto.weekday = getSetLocaleDayOfWeek;
        momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
        momentPrototype__proto.dayOfYear = getSetDayOfYear;

        // Hour
        momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

        // Minute
        momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

        // Second
        momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

        // Millisecond
        momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

        // Offset
        momentPrototype__proto.utcOffset = getSetOffset;
        momentPrototype__proto.utc = setOffsetToUTC;
        momentPrototype__proto.local = setOffsetToLocal;
        momentPrototype__proto.parseZone = setOffsetToParsedOffset;
        momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
        momentPrototype__proto.isDST = isDaylightSavingTime;
        momentPrototype__proto.isDSTShifted = isDaylightSavingTimeShifted;
        momentPrototype__proto.isLocal = isLocal;
        momentPrototype__proto.isUtcOffset = isUtcOffset;
        momentPrototype__proto.isUtc = isUtc;
        momentPrototype__proto.isUTC = isUtc;

        // Timezone
        momentPrototype__proto.zoneAbbr = getZoneAbbr;
        momentPrototype__proto.zoneName = getZoneName;

        // Deprecations
        momentPrototype__proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
        momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
        momentPrototype__proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
        momentPrototype__proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

        var momentPrototype = momentPrototype__proto;

        function moment__createUnix(input) {
            return local__createLocal(input * 1000);
        }

        function moment__createInZone() {
            return local__createLocal.apply(null, arguments).parseZone();
        }

        var defaultCalendar = {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        };

        function locale_calendar__calendar(key, mom, now) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.call(mom, now) : output;
        }

        var defaultLongDateFormat = {
            LTS: 'h:mm:ss A',
            LT: 'h:mm A',
            L: 'MM/DD/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        };

        function longDateFormat(key) {
            var format = this._longDateFormat[key],
                formatUpper = this._longDateFormat[key.toUpperCase()];

            if (format || !formatUpper) {
                return format;
            }

            this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
                return val.slice(1);
            });

            return this._longDateFormat[key];
        }

        var defaultInvalidDate = 'Invalid date';

        function invalidDate() {
            return this._invalidDate;
        }

        var defaultOrdinal = '%d';
        var defaultOrdinalParse = /\d{1,2}/;

        function ordinal(number) {
            return this._ordinal.replace('%d', number);
        }

        function preParsePostFormat(string) {
            return string;
        }

        var defaultRelativeTime = {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        };

        function relative__relativeTime(number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return typeof output === 'function' ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
        }

        function pastFuture(diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        }

        function locale_set__set(config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
            // Lenient ordinal parsing accepts just a number in addition to
            // number + (possibly) stuff coming from _ordinalParseLenient.
            this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + /\d{1,2}/.source);
        }

        var prototype__proto = Locale.prototype;

        prototype__proto._calendar = defaultCalendar;
        prototype__proto.calendar = locale_calendar__calendar;
        prototype__proto._longDateFormat = defaultLongDateFormat;
        prototype__proto.longDateFormat = longDateFormat;
        prototype__proto._invalidDate = defaultInvalidDate;
        prototype__proto.invalidDate = invalidDate;
        prototype__proto._ordinal = defaultOrdinal;
        prototype__proto.ordinal = ordinal;
        prototype__proto._ordinalParse = defaultOrdinalParse;
        prototype__proto.preparse = preParsePostFormat;
        prototype__proto.postformat = preParsePostFormat;
        prototype__proto._relativeTime = defaultRelativeTime;
        prototype__proto.relativeTime = relative__relativeTime;
        prototype__proto.pastFuture = pastFuture;
        prototype__proto.set = locale_set__set;

        // Month
        prototype__proto.months = localeMonths;
        prototype__proto._months = defaultLocaleMonths;
        prototype__proto.monthsShort = localeMonthsShort;
        prototype__proto._monthsShort = defaultLocaleMonthsShort;
        prototype__proto.monthsParse = localeMonthsParse;

        // Week
        prototype__proto.week = localeWeek;
        prototype__proto._week = defaultLocaleWeek;
        prototype__proto.firstDayOfYear = localeFirstDayOfYear;
        prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

        // Day of Week
        prototype__proto.weekdays = localeWeekdays;
        prototype__proto._weekdays = defaultLocaleWeekdays;
        prototype__proto.weekdaysMin = localeWeekdaysMin;
        prototype__proto._weekdaysMin = defaultLocaleWeekdaysMin;
        prototype__proto.weekdaysShort = localeWeekdaysShort;
        prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
        prototype__proto.weekdaysParse = localeWeekdaysParse;

        // Hours
        prototype__proto.isPM = localeIsPM;
        prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
        prototype__proto.meridiem = localeMeridiem;

        function lists__get(format, index, field, setter) {
            var locale = locale_locales__getLocale();
            var utc = create_utc__createUTC().set(setter, index);
            return locale[field](utc, format);
        }

        function list(format, index, field, count, setter) {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';

            if (index != null) {
                return lists__get(format, index, field, setter);
            }

            var i;
            var out = [];
            for (i = 0; i < count; i++) {
                out[i] = lists__get(format, i, field, setter);
            }
            return out;
        }

        function lists__listMonths(format, index) {
            return list(format, index, 'months', 12, 'month');
        }

        function lists__listMonthsShort(format, index) {
            return list(format, index, 'monthsShort', 12, 'month');
        }

        function lists__listWeekdays(format, index) {
            return list(format, index, 'weekdays', 7, 'day');
        }

        function lists__listWeekdaysShort(format, index) {
            return list(format, index, 'weekdaysShort', 7, 'day');
        }

        function lists__listWeekdaysMin(format, index) {
            return list(format, index, 'weekdaysMin', 7, 'day');
        }

        locale_locales__getSetGlobalLocale('en', {
            ordinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function ordinal(number) {
                var b = number % 10,
                    output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
            }
        });

        // Side effect imports
        utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
        utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

        var mathAbs = Math.abs;

        function duration_abs__abs() {
            var data = this._data;

            this._milliseconds = mathAbs(this._milliseconds);
            this._days = mathAbs(this._days);
            this._months = mathAbs(this._months);

            data.milliseconds = mathAbs(data.milliseconds);
            data.seconds = mathAbs(data.seconds);
            data.minutes = mathAbs(data.minutes);
            data.hours = mathAbs(data.hours);
            data.months = mathAbs(data.months);
            data.years = mathAbs(data.years);

            return this;
        }

        function duration_add_subtract__addSubtract(duration, input, value, direction) {
            var other = create__createDuration(input, value);

            duration._milliseconds += direction * other._milliseconds;
            duration._days += direction * other._days;
            duration._months += direction * other._months;

            return duration._bubble();
        }

        // supports only 2.0-style add(1, 's') or add(duration)
        function duration_add_subtract__add(input, value) {
            return duration_add_subtract__addSubtract(this, input, value, 1);
        }

        // supports only 2.0-style subtract(1, 's') or subtract(duration)
        function duration_add_subtract__subtract(input, value) {
            return duration_add_subtract__addSubtract(this, input, value, -1);
        }

        function absCeil(number) {
            if (number < 0) {
                return Math.floor(number);
            } else {
                return Math.ceil(number);
            }
        }

        function bubble() {
            var milliseconds = this._milliseconds;
            var days = this._days;
            var months = this._months;
            var data = this._data;
            var seconds, minutes, hours, years, monthsFromDays;

            // if we have a mix of positive and negative values, bubble down first
            // check: https://github.com/moment/moment/issues/2166
            if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                days = 0;
                months = 0;
            }

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absFloor(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absFloor(seconds / 60);
            data.minutes = minutes % 60;

            hours = absFloor(minutes / 60);
            data.hours = hours % 24;

            days += absFloor(hours / 24);

            // convert days to months
            monthsFromDays = absFloor(daysToMonths(days));
            months += monthsFromDays;
            days -= absCeil(monthsToDays(monthsFromDays));

            // 12 months -> 1 year
            years = absFloor(months / 12);
            months %= 12;

            data.days = days;
            data.months = months;
            data.years = years;

            return this;
        }

        function daysToMonths(days) {
            // 400 years have 146097 days (taking into account leap year rules)
            // 400 years have 12 months === 4800
            return days * 4800 / 146097;
        }

        function monthsToDays(months) {
            // the reverse of daysToMonths
            return months * 146097 / 4800;
        }

        function as(units) {
            var days;
            var months;
            var milliseconds = this._milliseconds;

            units = normalizeUnits(units);

            if (units === 'month' || units === 'year') {
                days = this._days + milliseconds / 864e5;
                months = this._months + daysToMonths(days);
                return units === 'month' ? months : months / 12;
            } else {
                // handle milliseconds separately because of floating point math errors (issue #1867)
                days = this._days + Math.round(monthsToDays(this._months));
                switch (units) {
                    case 'week':
                        return days / 7 + milliseconds / 6048e5;
                    case 'day':
                        return days + milliseconds / 864e5;
                    case 'hour':
                        return days * 24 + milliseconds / 36e5;
                    case 'minute':
                        return days * 1440 + milliseconds / 6e4;
                    case 'second':
                        return days * 86400 + milliseconds / 1000;
                    // Math.floor prevents floating point math errors here
                    case 'millisecond':
                        return Math.floor(days * 864e5) + milliseconds;
                    default:
                        throw new Error('Unknown unit ' + units);
                }
            }
        }

        // TODO: Use this.as('ms')?
        function duration_as__valueOf() {
            return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
        }

        function makeAs(alias) {
            return function () {
                return this.as(alias);
            };
        }

        var asMilliseconds = makeAs('ms');
        var asSeconds = makeAs('s');
        var asMinutes = makeAs('m');
        var asHours = makeAs('h');
        var asDays = makeAs('d');
        var asWeeks = makeAs('w');
        var asMonths = makeAs('M');
        var asYears = makeAs('y');

        function duration_get__get(units) {
            units = normalizeUnits(units);
            return this[units + 's']();
        }

        function makeGetter(name) {
            return function () {
                return this._data[name];
            };
        }

        var milliseconds = makeGetter('milliseconds');
        var seconds = makeGetter('seconds');
        var minutes = makeGetter('minutes');
        var hours = makeGetter('hours');
        var days = makeGetter('days');
        var months = makeGetter('months');
        var years = makeGetter('years');

        function weeks() {
            return absFloor(this.days() / 7);
        }

        var round = Math.round;
        var thresholds = {
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month
            M: 11 // months to year
        };

        // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
        function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
            return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
        }

        function duration_humanize__relativeTime(posNegDuration, withoutSuffix, locale) {
            var duration = create__createDuration(posNegDuration).abs();
            var seconds = round(duration.as('s'));
            var minutes = round(duration.as('m'));
            var hours = round(duration.as('h'));
            var days = round(duration.as('d'));
            var months = round(duration.as('M'));
            var years = round(duration.as('y'));

            var a = seconds < thresholds.s && ['s', seconds] || minutes === 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours === 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days === 1 && ['d'] || days < thresholds.d && ['dd', days] || months === 1 && ['M'] || months < thresholds.M && ['MM', months] || years === 1 && ['y'] || ['yy', years];

            a[2] = withoutSuffix;
            a[3] = +posNegDuration > 0;
            a[4] = locale;
            return substituteTimeAgo.apply(null, a);
        }

        // This function allows you to set a threshold for relative time strings
        function duration_humanize__getSetRelativeTimeThreshold(threshold, limit) {
            if (thresholds[threshold] === undefined) {
                return false;
            }
            if (limit === undefined) {
                return thresholds[threshold];
            }
            thresholds[threshold] = limit;
            return true;
        }

        function humanize(withSuffix) {
            var locale = this.localeData();
            var output = duration_humanize__relativeTime(this, !withSuffix, locale);

            if (withSuffix) {
                output = locale.pastFuture(+this, output);
            }

            return locale.postformat(output);
        }

        var iso_string__abs = Math.abs;

        function iso_string__toISOString() {
            // for ISO strings we do not use the normal bubbling rules:
            //  * milliseconds bubble up until they become hours
            //  * days do not bubble at all
            //  * months bubble up until they become years
            // This is because there is no context-free conversion between hours and days
            // (think of clock changes)
            // and also not between days and months (28-31 days per month)
            var seconds = iso_string__abs(this._milliseconds) / 1000;
            var days = iso_string__abs(this._days);
            var months = iso_string__abs(this._months);
            var minutes, hours, years;

            // 3600 seconds -> 60 minutes -> 1 hour
            minutes = absFloor(seconds / 60);
            hours = absFloor(minutes / 60);
            seconds %= 60;
            minutes %= 60;

            // 12 months -> 1 year
            years = absFloor(months / 12);
            months %= 12;

            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var Y = years;
            var M = months;
            var D = days;
            var h = hours;
            var m = minutes;
            var s = seconds;
            var total = this.asSeconds();

            if (!total) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
        }

        var duration_prototype__proto = Duration.prototype;

        duration_prototype__proto.abs = duration_abs__abs;
        duration_prototype__proto.add = duration_add_subtract__add;
        duration_prototype__proto.subtract = duration_add_subtract__subtract;
        duration_prototype__proto.as = as;
        duration_prototype__proto.asMilliseconds = asMilliseconds;
        duration_prototype__proto.asSeconds = asSeconds;
        duration_prototype__proto.asMinutes = asMinutes;
        duration_prototype__proto.asHours = asHours;
        duration_prototype__proto.asDays = asDays;
        duration_prototype__proto.asWeeks = asWeeks;
        duration_prototype__proto.asMonths = asMonths;
        duration_prototype__proto.asYears = asYears;
        duration_prototype__proto.valueOf = duration_as__valueOf;
        duration_prototype__proto._bubble = bubble;
        duration_prototype__proto.get = duration_get__get;
        duration_prototype__proto.milliseconds = milliseconds;
        duration_prototype__proto.seconds = seconds;
        duration_prototype__proto.minutes = minutes;
        duration_prototype__proto.hours = hours;
        duration_prototype__proto.days = days;
        duration_prototype__proto.weeks = weeks;
        duration_prototype__proto.months = months;
        duration_prototype__proto.years = years;
        duration_prototype__proto.humanize = humanize;
        duration_prototype__proto.toISOString = iso_string__toISOString;
        duration_prototype__proto.toString = iso_string__toISOString;
        duration_prototype__proto.toJSON = iso_string__toISOString;
        duration_prototype__proto.locale = locale;
        duration_prototype__proto.localeData = localeData;

        // Deprecations
        duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
        duration_prototype__proto.lang = lang;

        // Side effect imports

        addFormatToken('X', 0, 0, 'unix');
        addFormatToken('x', 0, 0, 'valueOf');

        // PARSING

        addRegexToken('x', matchSigned);
        addRegexToken('X', matchTimestamp);
        addParseToken('X', function (input, array, config) {
            config._d = new Date(parseFloat(input, 10) * 1000);
        });
        addParseToken('x', function (input, array, config) {
            config._d = new Date(toInt(input));
        });

        // Side effect imports


        utils_hooks__hooks.version = '2.10.6';

        setHookCallback(local__createLocal);

        utils_hooks__hooks.fn = momentPrototype;
        utils_hooks__hooks.min = min;
        utils_hooks__hooks.max = max;
        utils_hooks__hooks.utc = create_utc__createUTC;
        utils_hooks__hooks.unix = moment__createUnix;
        utils_hooks__hooks.months = lists__listMonths;
        utils_hooks__hooks.isDate = isDate;
        utils_hooks__hooks.locale = locale_locales__getSetGlobalLocale;
        utils_hooks__hooks.invalid = valid__createInvalid;
        utils_hooks__hooks.duration = create__createDuration;
        utils_hooks__hooks.isMoment = isMoment;
        utils_hooks__hooks.weekdays = lists__listWeekdays;
        utils_hooks__hooks.parseZone = moment__createInZone;
        utils_hooks__hooks.localeData = locale_locales__getLocale;
        utils_hooks__hooks.isDuration = isDuration;
        utils_hooks__hooks.monthsShort = lists__listMonthsShort;
        utils_hooks__hooks.weekdaysMin = lists__listWeekdaysMin;
        utils_hooks__hooks.defineLocale = defineLocale;
        utils_hooks__hooks.weekdaysShort = lists__listWeekdaysShort;
        utils_hooks__hooks.normalizeUnits = normalizeUnits;
        utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;

        var _moment = utils_hooks__hooks;

        return _moment;
    });
    /* global inject */
    inject(function (A) {
        A.Exports = {};
        Object.defineProperties(A.Exports, {
            personalizationId: {
                get: function get() {
                    return A.getPersonalizationId();
                }
            },
            VisitorId: {
                get: function get() {
                    return A.Config.products.SiteCatalyst.helper.getVisitorId();
                }
            }
        });
    }, 'Analytics');

    /* global inject */
    inject(function (Analytics, store, Config) {
        Analytics.Config = store('Config', Config);
        store('addAdapter', addAdapter);

        function addAdapter(adapter) {
            var dependencyConfig = { product: adapter.name };

            if (adapter.dependants) {
                dependencyConfig.dependants = adapter.dependants;
                //need "immediate" stuff here
            }

            Config.products[adapter.name] = adapter;
            Config.supportedProducts.push(adapter.name);
            Config.dependancies.push(dependencyConfig);
            return adapter;
        }
    }, 'Analytics', 'store', {
        products: {},
        initialParsedModels: {},
        supportedProducts: [],
        dependancies: []
    });

    /* global inject */
    inject(function (extend, store) {
        var BACKCOMPAT = true,
            resetData = {
            normalEnabledState: {}
        };

        extend(Adapter.prototype, {
            // these are the defaults for all adapters
            // they can be overridden in the constructor config for individual adapter instances

            // PROPERTIES
            name: '',
            enabled: true,
            mapping: undefined,
            adaptOnce: false,
            adapted: false,

            // METHODS
            enable: noop,
            disable: noop,
            validateEnabled: noop,
            reset: noop,
            map: noop,
            adapt: noop
        });

        store('Adapter', Adapter);

        /**
         * Adpater Class
         */
        function Adapter(config) {
            extend(this, config);
            augment(this);
            store('Adapter:' + this.name, this);

            if (BACKCOMPAT) {
                this.isOff = !this.enabled;
                this.turnOn = this.enable;
                this.turnOff = this.disable;
                this.adapter = this.adapt;
            }
        }

        function enable() {
            this.enabled = true;
            if (BACKCOMPAT) {
                this.isOff = false;
            }
        }

        function disable() {
            this.enabled = false;
            if (BACKCOMPAT) {
                this.isOff = true;
            }
        }

        function isEnabled() {
            return this.enabled;
        }

        function hasAdapted() {
            return this.adapted;
        }

        function reset() {
            this[resetData.normalEnabledState[this.name] ? 'enable' : 'disable']();
            this.adapted = false;
        }

        function adapt() {
            this.adapted = true;
        }

        function noop() {}

        function storeResetData(adapter) {
            resetData.normalEnabledState[adapter.name] = adapter.enabled;
        }

        function augment(adapter) {
            storeResetData(adapter);
            adapter.reset = sequence(reset, adapter.reset);
            adapter.enable = sequence(enable, adapter.enable);
            adapter.disable = sequence(disable, adapter.disable);
            adapter.adapt = conditional(isEnabled, sequence(adapter.adapt, adapt));
            if (adapter.adaptOnce) {
                adapter.adapt = conditional(not(hasAdapted), adapter.adapt);
            }
        }

        function sequence() {
            var fns = Array.prototype.slice.call(arguments);
            return function () {
                var _this = this,
                    _arguments = arguments;

                return fns.reduce(function (previousValue, fn) {
                    var result = fn.apply(_this, _arguments);
                    return result === undefined ? previousValue : result;
                }, undefined);
            };
        }

        function conditional(conditionFn, fn) {
            return function () {
                if (conditionFn.apply(this, arguments)) {
                    return fn.apply(this, arguments);
                }
            };
        }

        function not(conditionFn) {
            return function () {
                return !conditionFn.apply(this, arguments);
            };
        }
    }, 'extend', 'store');

    /* global inject */
    inject(function (Analytics, objForEach, Utils, $, Mustache, dbg, moment, store, isObject) {
        'use strict';

        var P = Analytics.Parsers = store('Parsers', {});

        //methods used to parse a model based on configured mapping
        P.isEmptyObject = function (obj) {
            var emptyResult = true,
                item;
            if (typeof obj !== 'string') {
                for (item in obj) {
                    if (obj.hasOwnProperty(item)) {
                        emptyResult = false;
                        break;
                    }
                }
            }

            return emptyResult;
        };

        P.isObject = isObject;

        P.isArray = Array.isArray;

        //normalizes string vs boolean true values
        P.toBoolean = function (obj) {
            if (obj && (obj === true || obj === 'true' || obj === '1' || obj === 1)) {
                return true;
            }

            return false;
        };

        P.parseDotNotation = function (parsed, address) {
            var value = address.split('.').reduce(function (node, prop) {
                if (node) {
                    return node[prop];
                }
            }, parsed);

            if (typeof value === 'function') {
                value = value();
            }

            return value;
        };

        //used to turn dot notation items into objects (example a.b.c=3 would become {a:{b:{c:3}}})
        P.expandString = function (stringNotation, val) {
            var currentObj = {},
                finalObj = {},
                keys,
                i = 0,
                l,
                key;

            //blank notation fails
            if (!stringNotation) {
                return false;
            }
            keys = stringNotation.split('.');
            l = keys.length - 1;

            //no dots fail
            if (l === 0) {
                return false;
            }

            //ok, lets parse some dots
            for (i; i < l; i++) {
                key = keys[i];

                currentObj[key] = {};
                if (i === 0) {
                    finalObj = currentObj;
                }
                currentObj = currentObj[key];
            }
            currentObj[keys[l]] = val;
            return finalObj;
        };

        function formatDate(params, strDate) {
            var inputFormat = [params.inputFormat || 'MM/DD/YYYY', 'YYYY-MM-DD'],
                outputFormat = params.outputFormat || 'YYYY-MM-DD';

            return moment(strDate, inputFormat).format(outputFormat);
        }

        P.applyFilter = function (applyTo, filters) {
            var i, l, keys, values, newArr, x, tmpArr, modifier, remove;

            objForEach(filters, function (params, filter) {
                switch (filter) {
                    case 'type':
                        if (params === 'integer' || params === 'int') {
                            applyTo = parseInt(applyTo, 10);
                        } else if (params === 'float') {
                            applyTo = parseFloat(applyTo).toFixed(2);
                        } else if (params === 'string') {
                            applyTo = applyTo.toString();
                        } else if (params === 'boolean') {
                            applyTo = P.toBoolean(applyTo);
                        }
                        break;

                    case 'date':
                        applyTo = formatDate(params, applyTo);
                        break;

                    case 'alpha':
                        if (Array.isArray(applyTo)) {
                            applyTo.sort();
                            if ('desc' === params) {
                                applyTo.reverse();
                            }
                        } else if (typeof applyTo === 'string') {
                            newArr = applyTo.split(',');
                            newArr.sort();
                            if ('desc' === params) {
                                newArr.reverse();
                            }
                            applyTo = newArr.join(',');
                        }
                        break;

                    case 'case':
                        switch (params) {
                            case 'title':
                                modifier = titleCase;
                                break;

                            case 'upper':
                                modifier = upperCase;
                                break;

                            default:
                                modifier = lowerCase;
                                break;
                        }

                        if (Array.isArray(applyTo)) {
                            applyTo.forEach(function (val, i, arr) {
                                arr[i] = modifier(val);
                            });
                        } else if (P.isObject(applyTo)) {
                            objForEach(applyTo, function (val, prop, obj) {
                                obj[prop] = modifier(val);
                            });
                        } else if (typeof applyTo === 'string') {
                            applyTo = modifier(applyTo);
                        }
                        break;

                    case 'length':
                        if (Array.isArray(applyTo)) {
                            applyTo.forEach(function (val, i) {
                                applyTo[i] = val.substring(0, params);
                            });
                        } else if (P.isObject(applyTo)) {
                            objForEach(applyTo, function (val, prop) {
                                applyTo[prop] = val.substring(0, params);
                            });
                        } else if (typeof applyTo === 'string') {
                            applyTo = applyTo.substring(0, params);
                        }
                        break;

                    case 'arrlength':
                        if (Array.isArray(applyTo)) {
                            newArr = [];
                            for (i = 0; i < params; i++) {
                                newArr.push(applyTo[i]);
                            }
                            applyTo = newArr;
                        } else if (typeof applyTo === 'string') {
                            tmpArr = applyTo.split(',');
                            newArr = [];
                            for (i = 0; i < params; i++) {
                                newArr.push(tmpArr[i]);
                            }
                            applyTo = newArr.join(',');
                        }
                        break;

                    case 'replace':
                        params.forEach(function (replaceArr) {
                            var toSearch = new RegExp(replaceArr[0], 'g'),
                                toReplace = replaceArr[1];

                            if (Array.isArray(applyTo)) {
                                applyTo.forEach(function (val, i, arr) {
                                    arr[i] = val.replace(toSearch, toReplace);
                                });
                            } else if (P.isObject(applyTo)) {
                                objForEach(applyTo, function (val, prop, obj) {
                                    obj[prop] = val.replace(toSearch, toReplace);
                                });
                            } else if (typeof applyTo === 'string') {
                                applyTo = applyTo.replace(toSearch, toReplace);
                            }
                        });
                        break;

                    case 'unique':
                        params = params || ',';
                        if (Array.isArray(applyTo)) {
                            applyTo = Utils.Array.getUnique(applyTo);
                        } else if (typeof applyTo === 'string') {
                            tmpArr = applyTo.split(params);
                            tmpArr = Utils.Array.getUnique(tmpArr);
                            applyTo = tmpArr.join(params);
                        }
                        break;

                    case 'forceArray':
                        if (P.isObject(applyTo)) {
                            tmpArr = $.map(applyTo, returnObjVal);
                            applyTo = tmpArr;
                        }
                        break;

                    case 'decode':
                        if (Array.isArray(applyTo)) {
                            for (i = 0; i < applyTo.length; i++) {
                                applyTo[i] = decodeURIComponent(applyTo[i]);
                            }
                        } else if (typeof applyTo === 'string') {
                            applyTo = decodeURIComponent(applyTo);
                        }
                        break;

                    case 'removeElement':
                        if (Array.isArray(applyTo) && P.isObject(params)) {
                            keys = params.keys || [params.key];
                            values = params.values || [params.value];
                            l = applyTo.length;
                            for (i = 0; i < l; i++) {
                                for (x = 0; x < keys.length; x++) {
                                    if (l > 0) {
                                        remove = false;
                                        if (!applyTo[i][keys[x]] && values[x] === '') {
                                            remove = true;
                                        } else if (applyTo[i][keys[x]] && applyTo[i][keys[x]] === values[x]) {
                                            remove = true;
                                        }

                                        if (remove === true) {
                                            applyTo.splice(i, 1);
                                            if (i > 0) {
                                                i--;
                                            }
                                            if (l > 0) {
                                                l--;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                }
            });
            return applyTo;
        };

        P.mergeObjects = function (target, source, properties, overrideTarget) {
            var i = 0,
                l,
                prop,
                result = $.extend(true, {}, target);
            if (Array.isArray(properties) && P.isObject(target) && P.isObject(source)) {
                l = properties.length;
                for (i; i < l; i++) {
                    prop = properties[i];
                    if (source[prop]) {
                        if (overrideTarget) {
                            result[prop] = source[prop];
                        } else if (!target[prop]) {
                            result[prop] = source[prop];
                        }
                    }
                }
            }
            return result;
        };

        /*will return a value event if a function is used to derive that value*/
        function getValueFromFunction(value, model, parentModel) {
            if (typeof value === 'function') {
                value = value(model, parentModel);
            }

            return value;
        }

        /*
         * function used to go through the mapping configuration as well as a semantic model recursively
         * to ultimately return a result that is fully mapped.
         *
         * since this function is fairly sophisticated, see framework.parsers.test.js for details of what it does
         * Params:
         * configProp - The property name in the product configuration
         * configVal - The value of the property name in the configuration
         * modelVal - The value of the property name in the model
         * result - As this function is recursivelly called, it is returning its results each step
         * parentResult - Used only in situations where an array configuarion is being parsed. It give the
         * array context to all other properties that were already mapped
         */
        function recursivelyMapProperties(configProp, configVal, modelVal, result, parentResult) {
            var nextModelVal = null,
                finalValue = null,
                mapping,
                transformers,
                transformer,
                unmappedItem,
                unmappedItemKey,
                unmappedItemValue,
                unmappedItems,
                unmappedItemsLen,
                mappedItem,
                mappedItems,
                srcDelimiter = ',',
                targDelimiter = ',',
                i,
                l,
                n,
                t,
                u = 0,
                prop,
                arrResult = [],
                configPropInArr,
                configValInArr,
                modelValInArr,
                resultInArray,
                retVal,
                tmpMapTo,
                preFinalItems,
                preFinalKey,
                preFinalFoundObject = false,
                foundRollUp = false,
                tpl;
            //if we have an object that is not an array
            if (P.isObject(configVal)) {
                if (!configVal.mapping) {
                    configVal.mapping = {
                        type: 'none'
                    };
                }
                if (configVal.applyFilter) {
                    P.applyFilter(modelVal, configVal.applyFilter);
                }
                for (prop in configVal) {
                    if (configVal.hasOwnProperty(prop)) {
                        if ('mapping' === prop) {
                            mapping = configVal[prop];
                            if (!mapping.type) {
                                mapping.type = 'simple';
                            }
                            if (mapping.type === 'simple') {

                                //perform transformations if specified
                                if (mapping.transformers) {
                                    transformers = mapping.transformers;
                                    for (t in transformers) {
                                        if (transformers.hasOwnProperty(t)) {
                                            transformer = transformers[t];
                                            /*add a value to the result map with the name of the transformer
                                             * as the key and the result of the transformer function as the value
                                             */

                                            if ('function' === typeof transformer) {
                                                if (t === 'preProcess') {
                                                    transformer(result, parentResult, modelVal);
                                                }
                                            }
                                        }
                                    }
                                }

                                if (modelVal === null) {
                                    if (mapping.defaultValue) {
                                        finalValue = getValueFromFunction(mapping.defaultValue, result, parentResult);
                                    }
                                } else {
                                    finalValue = modelVal;
                                    if (mapping.allowTokens) {
                                        if (mapping.allowTokens === true) {
                                            finalValue = Mustache.render(finalValue, result);
                                        }
                                    }
                                }

                                if (finalValue && mapping.applyFilter) {
                                    finalValue = P.applyFilter(finalValue, mapping.applyFilter);
                                }

                                if (mapping.mapTo && finalValue !== false) {
                                    result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult);
                                } else if (configProp) {
                                    result[configProp] = finalValue;
                                } else if (finalValue) {
                                    result = finalValue;
                                }
                            } else if (mapping.type === 'template' && mapping.template) {
                                if (modelVal && configProp) {
                                    result[configProp] = modelVal;
                                }

                                //set defaults for template mappings
                                if (modelVal === null && mapping.defaultValue && configProp) {
                                    result[configProp] = getValueFromFunction(mapping.defaultValue, result, parentResult);
                                }

                                //execute filters only on the value
                                if (mapping.applyFilter && result && configProp && result[configProp]) {
                                    result[configProp] = P.applyFilter(result[configProp], mapping.applyFilter);
                                }

                                //perform transformations if specified
                                if (mapping.transformers) {
                                    transformers = mapping.transformers;
                                    for (t in transformers) {
                                        if (transformers.hasOwnProperty(t)) {
                                            transformer = transformers[t];
                                            /*add a value to the result map with the name of the transformer
                                             * as the key and the result of the transformer function as the value
                                             */

                                            if ('function' === typeof transformer) {
                                                if (t === 'preProcess') {
                                                    transformer(result, parentResult, modelVal);
                                                } else {
                                                    result[t] = transformer(result, parentResult, modelVal);
                                                }
                                            }
                                        }
                                    }
                                }
                                if (typeof mapping.template === 'function') {
                                    tpl = mapping.template(result, parentResult);
                                } else {
                                    tpl = mapping.template;
                                }
                                finalValue = Mustache.render(tpl, result);

                                if (mapping.mapTo) {
                                    result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult);
                                } else if (configProp) {
                                    result[configProp] = finalValue;
                                } else {
                                    result = finalValue;
                                }
                            } else if (mapping.type === 'flex-array' && mapping.mapTo) {
                                if (!modelVal && mapping.defaultValue) {
                                    modelVal = mapping.defaultValue;
                                }
                                if (modelVal) {
                                    /**
                                     * The flex-array mapping allows the following as lists
                                     * 1) comma separated string for simple keys only example: "item1,item2,item3"
                                     * 2) arrays of strings. Example ["item1", "item2", "item3"]
                                     * 3) a combination of #2 and arrays of objecs when key values are needed.
                                     * Example: [{"item1":"value1"},"item2", "Item3"]
                                     * delimiters are configurable to allow the input and output delimiters to vary
                                     */

                                    // get our delimiters if they are set in the mapping. Otherwise, the default
                                    // value ',' will be used
                                    if (mapping.sourceDelimiter) {
                                        srcDelimiter = mapping.sourceDelimiter;
                                    }
                                    if (mapping.targetDelimiter) {
                                        targDelimiter = mapping.targetDelimiter;
                                    }

                                    //perform transformations if specified
                                    if (mapping.transformers) {
                                        transformers = mapping.transformers;
                                        for (t in transformers) {
                                            if (transformers.hasOwnProperty(t)) {
                                                transformer = transformers[t];
                                                /*add a value to the result map with the name of the transformer
                                                 * as the key and the result of the transformer function as the value
                                                 */

                                                if ('function' === typeof transformer) {
                                                    if (t === 'preProcess') {
                                                        transformer(result, parentResult, modelVal);
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    //force array structure on model value
                                    if (!Array.isArray(modelVal) && 'string' === typeof modelVal) {
                                        unmappedItems = modelVal.split(srcDelimiter);
                                    } else {
                                        unmappedItems = modelVal;
                                    }

                                    if (!Array.isArray(unmappedItems)) {
                                        dbg.info(configProp + ' does not send data in the right format. It must be a string or array');
                                    } else {
                                        if (P.isObject(mapping.mapTo)) {
                                            mappedItems = [];
                                            i = 0;
                                            l = unmappedItems.length;
                                            for (i; i < l; i++) {
                                                unmappedItem = unmappedItems[i];
                                                unmappedItemKey = null;

                                                if (mapping.defaultValue) {
                                                    unmappedItemValue = getValueFromFunction(mapping.defaultValue, result, parentResult);
                                                } else {
                                                    unmappedItemValue = null;
                                                }

                                                if ('string' === typeof unmappedItem) {
                                                    unmappedItemKey = unmappedItem.trim();
                                                } else if (P.isObject(unmappedItem)) {
                                                    //get the first key
                                                    for (n in unmappedItem) {
                                                        if (unmappedItem.hasOwnProperty(n)) {
                                                            unmappedItemKey = n.trim();
                                                            unmappedItemValue = unmappedItem[n];
                                                            break;
                                                        }
                                                    }
                                                }

                                                mappedItem = mapping.mapTo[unmappedItemKey];
                                                if (mappedItem) {
                                                    if (unmappedItemValue) {
                                                        mappedItem += '=' + unmappedItemValue;
                                                    }
                                                    mappedItems.push(mappedItem);
                                                }
                                            }

                                            result[configProp] = mappedItems.join(targDelimiter);
                                        } else {
                                            preFinalItems = [];
                                            unmappedItemsLen = unmappedItems.length;
                                            preFinalFoundObject = false;
                                            preFinalFoundObject = false;
                                            for (u; u < unmappedItemsLen; u++) {
                                                if (!P.isObject(unmappedItems[u])) {
                                                    preFinalItems.push(unmappedItems[u]);
                                                } else {
                                                    preFinalFoundObject = true;
                                                    for (preFinalKey in unmappedItems[u]) {
                                                        if (unmappedItems[u].hasOwnProperty(preFinalKey)) {
                                                            preFinalItems.push(preFinalKey);
                                                            if (mapping.dataSourceMapTo) {
                                                                if (!result[mapping.dataSourceMapTo]) {
                                                                    result[mapping.dataSourceMapTo] = {};
                                                                }
                                                                result[mapping.dataSourceMapTo][preFinalKey] = unmappedItems[u][preFinalKey];
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if (preFinalFoundObject === false) {
                                                finalValue = unmappedItems.join(targDelimiter);
                                            } else {
                                                finalValue = preFinalItems.join(targDelimiter);
                                            }

                                            if (mapping.valuePrefix) {
                                                finalValue = mapping.valuePrefix + finalValue;
                                            }

                                            if (mapping.applyFilter) {
                                                finalValue = P.applyFilter(finalValue, mapping.applyFilter);
                                            }

                                            result = mapValues(finalValue, configProp, mapping.mapTo, result, parentResult);
                                        }
                                    }
                                }
                            }
                        } else if (prop !== 'applyFilter') {
                            if (modelVal && modelVal[prop] !== undefined) {
                                nextModelVal = modelVal[prop];
                            }
                            result = recursivelyMapProperties(prop, configVal[prop], nextModelVal, result, parentResult);
                            nextModelVal = null;
                            finalValue = null;
                        }
                    }
                }
            } else if (Array.isArray(configVal)) {
                configValInArr = configVal[0];

                if (configValInArr.mapping && configValInArr.mapping.applyFilter) {
                    modelVal = P.applyFilter(modelVal, configValInArr.mapping.applyFilter);
                }

                if (Array.isArray(modelVal)) {
                    arrResult = [];
                    configPropInArr = null;

                    i = 0;
                    l = modelVal.length;

                    foundRollUp = false;
                    for (i; i < l; i++) {
                        modelValInArr = modelVal[i];
                        if (!P.isEmptyObject(modelValInArr)) {
                            resultInArray = {};
                            if (configValInArr.mapping) {
                                if (!configValInArr.mapping.rollUp) {
                                    configValInArr.mapping.rollUp = false;
                                }
                                if (configValInArr.mapping.mapTo && configValInArr.mapping.rollUp === true && configValInArr.mapping.targetDelimiter) {
                                    if (foundRollUp === false) {
                                        foundRollUp = true;
                                    }
                                    tmpMapTo = configValInArr.mapping.mapTo;
                                    retVal = recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result)[tmpMapTo];
                                    if (!result[configValInArr.mapping.mapTo]) {
                                        result[configValInArr.mapping.mapTo] = retVal;
                                    } else {
                                        result[configValInArr.mapping.mapTo] += configValInArr.mapping.targetDelimiter + retVal;
                                    }
                                } else {
                                    arrResult.push(recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result));
                                }
                            } else {
                                arrResult.push(recursivelyMapProperties(configPropInArr, configValInArr, modelValInArr, resultInArray, result));
                            }
                        }
                    }
                    if (foundRollUp === false) {
                        result[configProp] = arrResult;
                    }
                }
            }
            return result;
        }

        function mapValues(modelVal, configProp, mapToConfig, result, parentResult) {
            var mapToString, i, mapTo, dotNotationMapping;
            //customExtend;
            if (modelVal !== null && modelVal !== '' && mapToConfig) {
                if (P.isObject(mapToConfig)) {
                    mapToString = configProp;
                    if (mapToConfig[modelVal.trim()]) {
                        modelVal = mapToConfig[modelVal.trim()];
                    }
                } else if ('function' === typeof mapToConfig) {
                    mapToString = mapToConfig(result, parentResult);
                } else {
                    mapToString = mapToConfig;
                }
                if (mapToString) {
                    mapTo = mapToString.split(',');
                    for (i = 0; mapTo[i]; i++) {
                        /*check if we have a nested mapping notation. If so add the value within the structure
                        ensure that is an existing structure is there, it is preserved
                        */
                        dotNotationMapping = P.expandString(mapTo[i], modelVal);
                        if (dotNotationMapping) {
                            $.extend(true, result, dotNotationMapping);
                        } else {
                            result[mapTo[i]] = modelVal;
                        }
                    }
                }
            }
            return result;
        }

        //main parser method
        P.parseSemanticModel = function (modelInput, config, limitToModel) {
            var model = $.extend(true, {}, modelInput),
                result = limitToModel ? model : {},
                modelVal,
                configVal,
                prop,
                reprocessOnUpdate;

            for (prop in config) {
                if (config.hasOwnProperty(prop)) {
                    reprocessOnUpdate = false;
                    configVal = config[prop];
                    if (configVal && configVal.mapping && configVal.mapping.reprocessOnUpdate) {
                        reprocessOnUpdate = configVal.mapping.reprocessOnUpdate;
                    }
                    if (!limitToModel || limitToModel && model[prop] || reprocessOnUpdate === true) {
                        modelVal = null;
                        if (model[prop] || !isNaN(model[prop])) {
                            modelVal = model[prop];
                        }
                        result = recursivelyMapProperties(prop, configVal, modelVal, result);
                    }
                }
            }
            result = P.isEmptyObject(result) ? null : result;
            return result;
        };

        /* ------- Utility functions used within the parsers ------- */

        // used with wdwQuery.map to turn objects into arrays
        function returnObjVal(val) {
            return val;
        }

        function titleCase(str) {
            return str.replace(/\b\w/g, function (match) {
                return match.toUpperCase();
            });
        }

        function lowerCase(str) {
            return str.toLowerCase();
        }

        function upperCase(str) {
            return str.toUpperCase();
        }
    }, 'Analytics', 'objForEach', 'Utils', 'jQuery', 'Mustache', 'Debug', 'moment', 'store', 'isObject');

    /* global inject */
    inject(function (Config) {
        Config.supportedProducts.push('CEA', 'SiteCatalyst', 'GoogleRemarketing');
        Config.dependancies.push({
            product: 'SiteCatalyst',
            dependants: [{
                event: 'siteCatalystCallComplete',
                product: 'Dart',
                required: true
            }, {
                event: 'siteCatalystCallComplete',
                product: 'CEA',
                required: true
            }],
            // If there are dependants set and the parent product is not listed as a dependant
            // on another product this must be set
            immediate: true
        }, { product: 'GoogleRemarketing' });

        //Automatically create namespaces for supported products
        Config.supportedProducts.forEach(function (productName) {
            Config.products[productName] = Config.products[productName] || {};
        });
    }, 'Config');

    /* global inject */
    inject(function (addAdapter, Adapter, resolve) {
        var comScoreAdapter = new Adapter({
            name: 'ComScore',
            enabled: true,
            adapt: adapt,
            adaptOnce: true
        });
        addAdapter(comScoreAdapter);

        function adapt(model) {
            (window._comscore = window._comscore || []).push(model);
            resolve('addScript')('https://sb.scorecardresearch.com/beacon.js');
            resolve('Framework').fireEvent(document, 'ComScoreAdapterComplete', model);
        }
    }, 'addAdapter', 'Adapter', 'resolve');

    /* global inject */
    inject(function (comScoreAdapter) {
        comScoreAdapter.mapping = {
            configuration: {
                ComScore: {
                    advertiserId: {
                        mapping: {
                            mapTo: 'c2',
                            defaultValue: '6035140'
                        }
                    },
                    tagType: {
                        mapping: {
                            mapTo: 'c1',
                            defaultValue: '2'
                        }
                    },
                    triggerTimeout: {
                        mapping: {
                            mapTo: 'triggerTimeout'
                        }
                    }
                }
            }
        };
    }, 'Adapter:ComScore');

    /* global inject */
    inject(function (Analytics, addAdapter, Adapter, Mustache, objForEach, $, resolve) {
        var dartAdapter = new Adapter({
            name: 'Dart',
            enabled: true,
            adapt: adapt,
            adaptOnce: true
        });
        addAdapter(dartAdapter);

        function adapt(model) {
            var Framework = resolve('Framework');

            if (model.tags) {
                model.tags.forEach(function (dartConfig) {
                    var defaultConditions,
                        cTagsLength,
                        cTag,
                        j = 0,
                        cDartVars,
                        dartVars = {},
                        parentData = {},
                        newModel = $.extend(true, {}, model, {
                        src: dartConfig.src,
                        type: dartConfig.type,
                        cat: dartConfig.cat
                    });

                    delete newModel.tags;

                    if (newModel.conditionalTags) {
                        processConditionalTags(newModel, parentData);
                    }
                    if (newModel.type && newModel.cat) {
                        if (newModel && newModel.defaultConditions) {
                            defaultConditions = newModel.defaultConditions;
                            cTagsLength = defaultConditions.length;

                            if (cTagsLength > 0) {
                                j = 0;
                                for (j; j < cTagsLength; j++) {
                                    cTag = defaultConditions[j];
                                    cDartVars = {};

                                    if (matchesConditions(cTag, newModel)) {
                                        processVarsAndCreateIframe(cDartVars, newModel, parentData);
                                        break;
                                    }
                                }
                            }
                        } else {
                            processVarsAndCreateIframe(dartVars, newModel, parentData);
                        }
                    }
                });
                Framework.fireEvent(document, 'DartAdapterComplete', model);
            }
        }

        function processConditionalTags(model, parentData) {
            var j = 0,
                cTag,
                cDartVars,
                conditionalTags = model.conditionalTags || [],
                cTagsLength = conditionalTags.length;

            if (cTagsLength > 0) {
                for (j; j < cTagsLength; j++) {
                    cTag = conditionalTags[j];
                    if (cTag.activityTagString && (cTag.groupTagString || model.type)) {
                        cDartVars = {};
                        if (cTag.match) {
                            if (matchesConditions(cTag.match, model)) {
                                getLeafProperties(cDartVars, model);
                                cDartVars.cat = cTag.activityTagString;
                                cDartVars.src = cTag.advertiserId;
                                if (cTag.groupTagString) {
                                    cDartVars.type = cTag.groupTagString;
                                }
                                if (cTag.advertiserId) {
                                    cDartVars.src = cTag.advertiserId;
                                } else {
                                    cDartVars.src = model.src;
                                }
                                prepareIframe(model, cDartVars, parentData);
                            }
                        }
                    }
                }
            }
        }

        function processVarsAndCreateIframe(dartVars, model, parentData) {
            getLeafProperties(dartVars, model);
            prepareIframe(model, dartVars, parentData);
        }

        function matchesConditions(matches, model) {
            var match,
                hasMatched = true;
            if (Analytics.Parsers.isObject(matches)) {
                for (match in matches) {
                    if (matches.hasOwnProperty(match)) {
                        if (model[match] && typeof model[match] === 'string') {
                            if (model[match].toLowerCase() !== matches[match].toLowerCase()) {
                                hasMatched = false;
                                break;
                            }
                        } else {
                            hasMatched = false;
                            break;
                        }
                    }
                }
            } else {
                hasMatched = false;
            }

            return hasMatched;
        }

        // Recursively loops through a given model and stores the variables it
        // finds in dartVars
        function getLeafProperties(assignTo, subModel, indexName) {
            var leaf;
            if ('object' === typeof subModel) {
                for (leaf in subModel) {
                    if (subModel.hasOwnProperty(leaf)) {
                        // We need to make sure we arent going too deep
                        if (leaf !== 'interactiveElements') {
                            if (subModel.hasOwnProperty(leaf)) {
                                getLeafProperties(assignTo, subModel[leaf], leaf);
                            }
                        }
                    }
                }
            } else {
                if (0 === indexName.indexOf('u') || 'src' === indexName || 'cat' === indexName || 'type' === indexName || 'ord' === indexName || 'cost' === indexName || 'qty' === indexName) {
                    if (subModel) {
                        if (assignTo.hasOwnProperty(indexName)) {
                            assignTo[indexName] += ',' + subModel;
                        } else {
                            assignTo[indexName] = subModel;
                        }
                    }
                }
            }
        }
        function injectIframe(iFrameId, iframeSrc, dartVars) {
            var iframeHtml = '<iframe src="' + iframeSrc + '" border="0" height="0" width="0" style="display:none" id="' + iFrameId + '" class="DoubleClickIFrame"/>',
                iframeObj = $(iframeHtml),
                dbg = Analytics.Debug;

            $('body').append(iframeObj);
            dbg.info('Dart iFrame Attached: ', dartVars);
        }
        function prepareIframe(model, dartVars, parentData) {
            var dvar,
                Framework = resolve('Framework'),
                lastChar,
                iFrameId = 'Dart_' + dartVars.src + dartVars.type + dartVars.cat,
                u7Comma,
                iframeSrc;

            if (dartVars.u7 && dartVars.u7.indexOf) {
                u7Comma = dartVars.u7.indexOf(',');
                if (u7Comma > -1) {
                    dartVars.u7 = dartVars.u7.slice(0, u7Comma);
                }
            }

            // Dart Tag should be fired only once
            if ($('#' + iFrameId).size() === 0) {
                if (parentData && parentData.visitorId) {
                    // this may look a little hardcoded, but its the only way to do it
                    // since the model is already parsed
                    model.visitorId = parentData.visitorId;
                    model.u19 = parentData.visitorId;
                    dartVars.u19 = parentData.visitorId;
                }
                iframeSrc = 'https://' + dartVars.src + '.fls.doubleclick.net/activityi;src=' + dartVars.src + ';type=' + dartVars.type + ';cat=' + dartVars.cat;

                // loop the remaining attributes and place at the middle
                for (dvar in dartVars) {
                    if (dartVars.hasOwnProperty(dvar)) {
                        if (' src type cat num ord '.indexOf(dvar) === -1) {
                            iframeSrc += ';' + dvar + '=' + dartVars[dvar];
                        }
                    }
                }

                //This attribute has to be at the end
                if (dartVars.ord) {
                    iframeSrc += ';ord=' + dartVars.ord;
                }

                // only add num when ord is not present and it should be last
                if (dartVars.ord === '1') {
                    iframeSrc += ';num=' + Framework.getPageGroupId();
                }

                lastChar = iframeSrc[iframeSrc.length - 1];
                if (lastChar !== '?') {
                    iframeSrc += '?';
                }

                if (document.readyState === 'complete') {
                    injectIframe(iFrameId, iframeSrc, dartVars);
                } else {
                    $(window).load(function () {
                        injectIframe(iFrameId, iframeSrc, dartVars);
                    });
                }
            }
        }
    }, 'Analytics', 'addAdapter', 'Adapter', 'Mustache', 'objForEach', '$', 'resolve');

    /* global inject */
    inject(function (dartAdapter, WDPRO) {
        dartAdapter.mapping = {
            configuration: {
                currency: {
                    mapping: {
                        mapTo: 'u20',
                        defaultValue: 'USD'
                    }
                },
                contentLocale: {
                    mapping: {
                        defaultValue: 'us'
                    }
                },
                contentLanguage: {
                    mapping: {
                        defaultValue: 'en'
                    }
                },
                Dart: {

                    defaultConditions: [{
                        mapping: {}
                    }],
                    tags: [{
                        advertiserId: {
                            mapping: {
                                mapTo: 'src',
                                defaultValue: '2789293'
                            }
                        },
                        groupTagString: {
                            mapping: {
                                mapTo: 'type'
                            }
                        },
                        activityTagString: {
                            mapping: {
                                mapTo: 'cat'
                            }
                        },
                        mapping: {
                            mapTo: 'tags'
                        }
                    }],
                    conditionalTags: [{
                        mapping: {
                            applyFilter: {
                                forceArray: ''
                            }
                        },
                        match: {
                            mapping: {}
                        },
                        advertiserId: {
                            mapping: {}
                        },
                        groupTagString: {
                            mapping: {}
                        },
                        activityTagString: {
                            mapping: {}
                        }
                    }]
                },
                SiteCatalyst: {
                    turnOff: {
                        mapping: {
                            mapTo: 'siteCatalystTurnOff'
                        }
                    }
                }
            },

            secureProtocol: {
                mapping: {}
            },

            customerId: {
                mapping: {
                    mapTo: 'u1',
                    defaultValue: 'anonymous'
                }
            },
            pageId: {
                mapping: {
                    mapTo: 'pageId',
                    applyFilter: {
                        'case': 'lower',
                        replace: [['[^a-zA-Z0-9]', '']]
                    }
                }
            },
            guestType: {
                mapping: {
                    mapTo: 'u2'
                }
            },

            guestAffiliations: {
                mapping: {
                    type: 'flex-array',
                    targetDelimiter: ',',
                    mapTo: 'u3'
                }
            },
            products: [{
                productType: {
                    mapping: {
                        defaultValue: 'product'
                    }
                },
                productId: {
                    mapping: {
                        mapTo: 'u12'
                    }
                },
                quantity: {
                    mapping: {
                        mapTo: function mapTo(model) {
                            var result = 'qty';
                            if (model.productType === 'ticket') {
                                result += ',u11';
                            }
                            return result;
                        }
                    }
                },
                facilityName: {
                    mapping: {
                        mapTo: 'u5'
                    }
                },
                roomTypeId: {
                    mapping: {
                        type: 'template',
                        template: '{{#roomTypeId}}{{{roomTypeId}}}{{/roomTypeId}}',
                        mapTo: 'u10',
                        transformers: {
                            roomTypeId: function roomTypeId(model) {
                                if ('cruise' === model.productType) {
                                    return model.roomTypeId;
                                }
                            }
                        }
                    }
                },
                includedProducts: [{
                    id: {
                        mapping: {
                            mapTo: 'u10'
                        }
                    }
                }],
                packageType: {
                    mapping: {
                        mapTo: 'u8',
                        defaultValue: function defaultValue(model) {
                            var result = null;
                            if (model.productType === 'ticket') {
                                result = 'TicketsOnly';
                            }
                            return result;
                        }
                    }
                },
                orderType: {
                    mapping: {
                        mapTo: 'u9'
                    }
                },
                bookedArrivalDate: {
                    mapping: {
                        mapTo: 'u4'
                    }
                },
                numberRoomsBooked: {
                    mapping: {
                        mapTo: 'u6'
                    }
                },
                bookedAdults: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedChildren: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedInfants: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedSeniors: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedParty: {
                    mapping: {
                        type: 'template',
                        template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}' + 'A:{{{bookedChildren}}}C:{{{bookedInfants}}}I:' + '{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
                        mapTo: 'u18',
                        transformers: {
                            bookedPartyTotal: function bookedPartyTotal(model) {
                                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants) && !isNaN(model.bookedSeniors)) {
                                    return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                                }
                            }
                        }
                    }
                },
                bookedPartyMix: {
                    mapping: {
                        mapTo: 'u18'
                    }
                },
                bookedLengthOfStayNights: {
                    mapping: {
                        mapTo: 'u7'
                    }
                },
                mapping: {
                    type: 'none',
                    applyFilter: {
                        removeElement: {
                            keys: ['productType', 'productType', 'productType'],
                            values: ['groundTransportation', 'airTransportation', 'insurance']
                        }
                    }
                }
            }],
            visitorId: {
                mapping: {
                    defaultValue: function defaultValue() {
                        return WDPRO.Analytics.Exports.VisitorId;
                    },
                    mapTo: 'u19'
                }
            },
            orderId: {
                mapping: {
                    mapTo: 'ord',
                    defaultValue: '1',
                    reprocessOnUpdate: true
                }
            },
            totalPrice: {
                priceSubTotal: {
                    mapping: {
                        mapTo: 'u13'
                    }
                },
                grandTotal: {
                    mapping: {
                        mapTo: 'cost'
                    }
                }
            },
            productSubTotal: {
                mapping: {
                    mapTo: function mapTo(model) {
                        if (!model.u13) {
                            return 'u13';
                        }
                        return false;
                    }
                }
            },
            productTotal: {
                mapping: {
                    mapTo: function mapTo(model) {
                        if (!model.cost) {
                            return 'cost';
                        }
                        return false;
                    }
                }
            },
            totalBookedLengthOfStayNights: {
                mapping: {
                    mapTo: 'u7'
                }
            },
            interactiveElements: [{
                trackingType: {
                    mapping: {}
                },
                trackingModel: {
                    mapping: {}
                },
                triggerEvents: [{
                    type: {
                        mapping: {}
                    },
                    elementSelectors: {
                        mapping: {}
                    },
                    onCompleteEventName: {
                        mapping: {}
                    }
                }],
                mapping: {
                    applyFilter: {
                        forceArray: ''
                    },
                    type: 'none'
                }
            }]
        };
    }, 'Adapter:Dart', 'WDPRO');

    /*global document, WDPRO*/
    /* map SAM model to product
       http://wiki.wdpro.wdig.com/display/Tech/Analytics+Semantic+Model+v2.0
       the namespace will be automatically created if this product is supported (defined in the config.js) */

    /**
     * @param {object} A The WDPRO.Analytics object
     * @param {object} GR The WDPRO.Analytics.Config.products.GoogleRemarketing product
     * @return {undefined}
     */
    (function (A, GR) {
        if (GR) {
            GR.isOff = false;
            GR.hasFired = false;
            GR.conversionHasFired = false;
            GR.turnOff = turnOff;
            GR.turnOn = turnOn;
            GR.adapter = adapter;
            GR.turnOff = function () {
                GR.isOff = true;
            };
            GR.turnOn = function () {
                GR.isOff = false;
            };
        }

        /* ----------------------------------------------------------------------------------------------------------- */

        /**
         * Fires the request to GR via img tag
         * @param {object} model the model after being transformed via mapping and internal adapter processing
         * @return {undefined}
         */
        function fire(model) {
            var img = new Image(),
                srcTemplate = '//googleads.g.doubleclick.net/pagead/viewthroughconversion/{{{googleConversionId}}}/?' + 'value=0&guid=ON{{#data}}&data={{{data}}}{{/data}}&script=0',
                data = createURLParam(model.data || {}),
                src = A.Mustache.render(srcTemplate, {
                googleConversionId: model.googleConversionId,
                data: data
            });

            img.src = src;
            img.style.display = 'none';
            document.body.appendChild(img);
            GR.hasFired = true;
        }

        /**
         * Fires the conversion pixel via img tag
         * @param {object} model the model after being transformed via mapping and internal adapter processing
         * @return {undefined}
         */
        function fireConversion(model, conversionTagId) {
            var img = new Image(),
                conversionTemplate = '//www.googleadservices.com/pagead/conversion/1070398022/?label=' + '{{googleConversionLabel}}&guid=ON{{#data}}&data={{{data}}}{{/data}}&script=0',
                src = A.Mustache.render(conversionTemplate, {
                googleConversionLabel: conversionTagId,
                data: createURLParam(model.data)
            });
            img.src = src;
            img.style.display = 'none';
            document.body.appendChild(img);
            GR.conversionHasFired = true;
        }

        /**
         * The entry point to this adapter after the mapping has occurred
         * @param {object} model the model after mapping
         * @return {undefined}
         */
        function adapter(model) {
            if (!GR.isOff) {
                if (!GR.hasFired) {
                    fire(reconfigure(model));
                }

                if (!GR.conversionHasFired) {
                    if (model.data && model.data.events && model.conversions) {
                        model.data.events.split(',').forEach(function (event) {
                            if (model.productTypes && model.conversions && model.conversions[event]) {
                                model.productTypes.forEach(function (type) {
                                    var conversionTagId = model.conversions[event][type];
                                    if (conversionTagId) {
                                        fireConversion(model, conversionTagId);
                                    }
                                });
                            }
                            if (model.conversions && model.conversions[event] && model.conversions[event]['*']) {
                                fireConversion(model, model.conversions[event]['*']);
                            }
                        });
                    }
                }
                A.Framework.fireEvent(document, 'GoogleRemarketingAdapterComplete', model);
            }
        }

        /**
         * transforms the mapped model into the format that mustache template expects
         * @param {object} model the mapped model
         * @return {object} the transformed model
         */
        function reconfigure(model) {
            if (model.products) {
                model.data = model.data || {};
                model.data.products = model.products;
                delete model.products;
            }
            return model;
        }

        /**
         * Converts the object into a string suitable for use in a URL
         * @param {object} obj the object to convert
         * @return {string|undefined} the object properties in format name1=value1;name2=value2,value3,value4
         */
        function createURLParam(obj) {
            var paramArray = [],
                param,
                value,
                urlParam;

            for (param in obj) {
                if (obj.hasOwnProperty(param)) {
                    value = obj[param];
                    if (Array.isArray(value)) {
                        value = value.join(',');
                    }
                    paramArray.push(param + '=' + value);
                }
            }

            if (paramArray.length) {
                urlParam = encodeURIComponent(paramArray.join(';'));
            }

            return urlParam;
        }

        /**
         * Turns off this adapter
         * @return {undefined}
         */
        function turnOff() {
            GR.isOff = true;
        }

        /**
         * Turns on this adapter
         * @return {undefined}
         */
        function turnOn() {
            GR.isOff = false;
        }
    })(WDPRO.Analytics, WDPRO.Analytics.Config.products.GoogleRemarketing);

    /*global WDPRO*/
    /* map SAM model to product
       http://wiki.wdpro.wdig.com/display/Tech/Analytics+Semantic+Model+v2.0
       the namespace will be automatically created if this product is supported (defined in the config.js) */

    (function (GR) {
        if (GR) {
            GR.mapping = {
                configuration: {
                    GoogleRemarketing: {
                        advertiserId: {
                            mapping: {
                                mapTo: 'googleConversionId',
                                defaultValue: '970897162'
                            }
                        },
                        conversions: {
                            mapping: {
                                mapTo: 'conversions'
                            }
                        }
                    }
                },
                site: {
                    mapping: {
                        mapTo: 'data.site'
                    }
                },
                bookingSearchDaysBetweenSearchAndArrival: {
                    mapping: {
                        mapTo: 'data.bookingSearchWindow',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'data.bookingSearchLOS',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchAdults: {
                    mapping: {
                        mapTo: 'data.bookingSearchAdults',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchChildren: {
                    mapping: {
                        mapTo: 'data.bookingSearchChildren',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchInfants: {
                    mapping: {
                        mapTo: 'data.bookingSearchInfants',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchSeniors: {
                    mapping: {
                        mapTo: 'data.bookingSearchSenior',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },

                offerId: {
                    mapping: {
                        mapTo: 'data.offerId'
                    }
                },
                products: [{
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                resortVacation: 'res',
                                insurance: 'ins',
                                groundTransportation: 'auto',
                                airTransportation: 'air',
                                cruise: 'cruise',
                                fastPassPlus: 'gxa',
                                greatFoodFast: 'gxa',
                                dining: 'dine',
                                media: 'med',
                                ticket: 'tix',
                                enhancedExperience: 'eexp',
                                nonDisneyTicket: 'ndt'
                            }
                        }
                    },
                    productId: {
                        mapping: {
                            mapTo: 'productId'
                        }
                    },
                    facilityId: {
                        mapping: {
                            mapTo: 'facilityId'
                        }
                    },
                    roomTypeId: {
                        mapping: {
                            mapTo: 'roomTypeId'
                        }
                    },
                    quantity: {
                        mapping: {
                            mapTo: 'quantity'
                        }
                    },
                    packageType: {
                        mapping: {
                            mapTo: 'packageType'
                        }
                    },
                    mapping: {
                        type: 'template',
                        template: function template(product, parentModel) {
                            var template = '';
                            if (product.productType === 'res') {
                                template = '{{{productType}}};{{{productId}}}:{{{facilityId}}}:{{{roomTypeId}}};' + '{{{quantity}}};{{{packageType}}}';
                            } else if (product.productType === 'tix') {
                                template = '{{{productType}}};{{{productId}}};{{{quantity}}}';
                            }

                            if (!parentModel.productTypes) {
                                parentModel.productTypes = [];
                            }

                            if (parentModel.productTypes.indexOf(product.productType) === -1) {
                                parentModel.productTypes.push(product.productType);
                            }
                            return template;
                        }
                    }
                }],
                events: {
                    mapping: {
                        type: 'flex-array',
                        mapTo: 'data.events'
                    }
                },
                guestAffiliations: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: ',',
                        mapTo: 'data.guestAffiliations',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                }
            };
        }
    })(WDPRO.Analytics.Config.products.GoogleRemarketing);

    /*global document, WDPRO*/

    (function (CEA, A, $) {
        if (CEA) {
            CEA.dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
            CEA.isOff = true;
            CEA.firstRun = true;
            CEA.decisionOn = true;
            CEA.captureOn = true;
            CEA.trackElementList = {};
            CEA.pageData = {};
            CEA.callCount = 0;

            CEA.reset = function () {
                CEA.firstRun = true;
                CEA.isOff = true;
                CEA.decisionOn = true;
                CEA.captureOn = true;
                CEA.trackElementList = {};
                CEA.callCount = 0;
                CEA.pageData = {};

                // We need to remove any CEA handlers we may have added
                $(window).off('.CEATracking');
            };
            CEA.turnOff = function (parentModel) {
                CEA.isOff = true;
                CEA.captureOn = false;
                CEA.decisionOn = false;
                if (parentModel && parentModel.personalizations) {
                    delete parentModel.personalizations;
                }
            };
            CEA.turnOn = function () {
                CEA.isOff = false;
                CEA.captureOn = true;
                CEA.decisionOn = true;
            };
            CEA.trackElement = function (event, model) {
                var interactiveElm,
                    dbg = WDPRO.Analytics.Debug,
                    Utils = WDPRO.Analytics.Utils,
                    rmIdx,
                    events,
                    translatedEvent;

                if (event && CEA.isOff === false) {
                    if (model) {
                        model = $.extend(true, CEA.pageData, model);
                    } else {
                        model = CEA.pageData;
                    }
                    // if we are dealing with an interactive element that was predefined.
                    // See framework.CEA.trackElement.preConfigured.test.js
                    if (CEA.trackElementList[event]) {
                        interactiveElm = CEA.trackElementList[event];
                        if (interactiveElm.trackingModel) {
                            $.extend(true, model, interactiveElm.trackingModel);
                        }
                        CEA.helper.mergeInteractiveElements(interactiveElm, model);
                        model.trackingType = interactiveElm.trackingType;
                        model.linkId = model.data['link-id'] = interactiveElm.data['link-id'];
                    }

                    events = normalizeEvents(model && model.events);

                    if (events.length > 0) {
                        rmIdx = Utils.Array.indexOfFunc(events, 'd-pos-mod-revenue-event', 0, arrayContainsCompareFunction);
                        if (rmIdx > -1) {
                            events.splice(rmIdx, 1);
                        }

                        rmIdx = Utils.Array.indexOfFunc(events, 'd-neg-mod-revenue-event', 0, arrayContainsCompareFunction);
                        if (rmIdx > -1) {
                            events.splice(rmIdx, 1);
                        }

                        rmIdx = Utils.Array.indexOfFunc(events, 'd-pos-mod-nights-event', 0, arrayContainsCompareFunction);
                        if (rmIdx > -1) {
                            events.splice(rmIdx, 1);
                        }

                        rmIdx = Utils.Array.indexOfFunc(events, 'd-neg-mod-nights-event', 0, arrayContainsCompareFunction);
                        if (rmIdx > -1) {
                            events.splice(rmIdx, 1);
                        }
                        model.events = events.join(',');
                    }

                    if (model.trackingType === 'standardPage' || model.trackingType === 'customPage' || model.trackingType === 'page') {
                        CEA.helper.trackEvent('d-page', model);
                    } else if (model.trackingType === 'customLink' || model.trackingType === 'pic' || !model.trackingType) {

                        if (model.enableTrackElementLinkTracking) {
                            if (model.linkId) {
                                CEA.helper.trackEvent('d-link', model);
                            } else {
                                dbg.info('CEA trackElement: linkId property not set');
                            }
                        } else {
                            dbg.info('CEA trackElement: link tracking disabled');
                        }
                    } else if (model.trackingType === 'customEvent' && model.events) {
                        translatedEvent = CEA.mapping.events.mapping.mapTo[model.events];
                        CEA.helper.trackEvent(translatedEvent, model);
                    }
                } else {
                    dbg.info('event parameter was not set for SiteCatalyst trackElement');
                }
            };
            CEA.adapter = function (model) {
                var Utils = A.Utils,
                    F = A.Framework,
                    P = WDPRO.Analytics.Parsers,
                    helper = CEA.helper,
                    fireImpressions = [],
                    disabledPossibleAffiliations = ['Agent'],
                    numLocations = 0,
                    captureToggleName = model.captureToggleName,
                    decisionToggleName = model.decisionToggleName,
                    i,
                    m,
                    locations,
                    loc,
                    numImmediateImpressions,
                    numProductsDisp,
                    determineStatusFromToggles,
                    processInteractiveElements,
                    bindLinkTracking,
                    events,
                    facilityDisplayed,
                    distinctFacilitiesDisplayed = [],
                    distinctFacilitiesDisplayedId = [],
                    rmIdx;

                CEA.callCount++;

                if (!CEA.isOff) {
                    if (CEA.firstRun) {
                        model.enableTrackElementLinkTracking = P.toBoolean(model.enableTrackElementLinkTracking);
                        model.enableInteractiveElementLinkTracking = P.toBoolean(model.enableInteractiveElementLinkTracking);
                        model.enableTargetIntegration = P.toBoolean(model.enableTargetIntegration);
                        model.authToken = Utils.getCookie(model.authCookieName);
                        model.conversationId = Utils.getCookie(model.webSessionIdCookieName);
                    }

                    determineStatusFromToggles = function determineStatusFromToggles() {
                        if (model.releaseToggles && typeof model.releaseToggles[captureToggleName] !== 'undefined') {
                            CEA.captureOn = P.toBoolean(model.releaseToggles[captureToggleName]);
                        }

                        if (model.releaseToggles && typeof model.releaseToggles[decisionToggleName] !== 'undefined') {
                            CEA.decisionOn = P.toBoolean(model.releaseToggles[decisionToggleName]);
                        }
                        if (!CEA.decisionOn && !CEA.captureOn) {
                            CEA.isOff = true;
                        }
                    };

                    processInteractiveElements = function processInteractiveElements(model) {
                        var l,
                            i = 0,
                            it,
                            lt,
                            inTrackElementList,
                            triggerEvent,
                            interactiveElement;

                        //determine the type of interactive elements we are dealing with
                        if (Array.isArray(model.interactiveElements)) {
                            for (i, l = model.interactiveElements.length; i < l; i++) {
                                interactiveElement = model.interactiveElements[i];
                                if (interactiveElement) {
                                    /* determine if interactiveElement should go in the trackElementList
                                     * this will allow it to be invoked directly using the trackElement function
                                     */
                                    inTrackElementList = false;

                                    if (interactiveElement.triggerEvents && Array.isArray(interactiveElement.triggerEvents)) {
                                        it = 0;
                                        lt = interactiveElement.triggerEvents.length;

                                        for (it; it < lt; it++) {
                                            triggerEvent = interactiveElement.triggerEvents[it];

                                            if (!triggerEvent.elementSelectors && triggerEvent.type) {
                                                CEA.trackElementList[triggerEvent.type] = interactiveElement;
                                                inTrackElementList = true;
                                            }
                                        }
                                    }

                                    if (!inTrackElementList) {

                                        switch (interactiveElement.trackingType) {
                                            case 'page':
                                            case 'customPage':
                                            case 'standardPage':
                                            case 'pic':
                                            case 'customLink':
                                                if (model.enableInteractiveElementLinkTracking) {
                                                    helper.setupEvent(interactiveElement);
                                                }
                                                break;
                                            case 'vid':
                                            case 'video':
                                                if (interactiveElement.triggerEvents) {
                                                    helper.trackVideo(interactiveElement);
                                                }
                                                break;
                                            case 'customEvent':
                                                helper.setupEvent(interactiveElement);
                                                break;
                                            default:
                                                /**
                                                 * any elements with a tracking model or trigger event that is not
                                                 * specifically a page tracking type will be treated as a customLink
                                                 */
                                                if (model.enableInteractiveElementLinkTracking) {
                                                    if (interactiveElement.trackingModel || interactiveElement.triggerEvents) {
                                                        helper.setupEvent(interactiveElement);
                                                    }
                                                }
                                        }
                                    }
                                }
                            }
                        }
                    };

                    if (CEA.isOff === true) {
                        return;
                    }
                    if (CEA.firstRun) {
                        CEA.pageData = model;
                        determineStatusFromToggles();
                        if (model.possibleAffiliation) {
                            if (WDPRO.Analytics.Utils.Array.indexOf(disabledPossibleAffiliations, model.possibleAffiliation) > -1) {

                                CEA.captureOn = false;
                                CEA.decisionOn = false;
                                CEA.isOff = true;
                            }
                        }
                    }

                    if (CEA.captureOn) {
                        if (model.carts && model.carts[0] && model.carts[0].data) {
                            $.extend(model.data, model.carts[0].data);
                        }

                        if (model.productsDisplayed && model.productsDisplayed.length > 0) {
                            /***
                             * Typically products displayed is used for the room types displayed, so in the case
                             * of CEA we only need the facilityId & facilityTier from the first one
                             */
                            for (m = 0, numProductsDisp = model.productsDisplayed.length; m < numProductsDisp; m++) {
                                facilityDisplayed = model.productsDisplayed[m];
                                if (distinctFacilitiesDisplayedId.indexOf(facilityDisplayed.facilityId) === -1) {
                                    distinctFacilitiesDisplayed.push({
                                        facilityId: facilityDisplayed.facilityId,
                                        facilityTier: facilityDisplayed.facilityTier
                                    });
                                    distinctFacilitiesDisplayedId.push(facilityDisplayed.facilityId);
                                }
                            }
                            if (distinctFacilitiesDisplayed.length === 1) {
                                model.data['products-displayed-facility-id'] = distinctFacilitiesDisplayed[0].facilityId;
                                model.data['products-displayed-facility-tier'] = distinctFacilitiesDisplayed[0].facilityTier;
                            }
                        }
                        bindLinkTracking = function bindLinkTracking() {
                            $(document).bind('click', function (e) {
                                var el = e.target,
                                    tagName = el.tagName,
                                    name,
                                    id,
                                    analyticsLinkId,
                                    linkId,
                                    linkIdObj,
                                    idx;

                                if (tagName && tagName.toLowerCase() === 'a' || tagName && tagName.toLowerCase() === 'input') {

                                    if (typeof el.getAttribute === 'function') {
                                        name = el.getAttribute('name');
                                        analyticsLinkId = el.getAttribute('analyticsLinkId');
                                        id = el.id;
                                        if (name) {
                                            idx = name.indexOf('&lid=');
                                        } else {
                                            idx = -1;
                                        }

                                        if (idx > -1) {
                                            linkId = name.substr(5);
                                        } else if (analyticsLinkId) {
                                            linkId = analyticsLinkId;
                                        } else if (id) {
                                            linkId = id;
                                        } else {
                                            linkId = $(el).text();
                                        }
                                    }
                                    if (linkId) {
                                        linkIdObj = {
                                            prevPage: location.href,
                                            linkId: linkId
                                        };

                                        Utils.sessionStorage.setItem('tmpAnalyticsLinkId', linkIdObj);
                                    } else {
                                        Utils.sessionStorage.removeItem('tmpAnalyticsLinkId');
                                    }
                                }
                            });
                        };
                        bindLinkTracking();
                        if (CEA.firstRun) {
                            CEA.firstRun = false;
                            if (!model.events) {
                                model.events = ['d-page-view'];
                            }
                            events = normalizeEvents(model.events);

                            if (Utils.Array.indexOf(events, 'd-page-view') === -1) {
                                events.push('d-page-view');
                            }
                            rmIdx = Utils.Array.indexOfFunc(events, 'd-pos-mod-revenue-event', 0, arrayContainsCompareFunction);
                            if (rmIdx > -1) {
                                events.splice(rmIdx, 1);
                            }

                            rmIdx = Utils.Array.indexOfFunc(events, 'd-neg-mod-revenue-event', 0, arrayContainsCompareFunction);
                            if (rmIdx > -1) {
                                events.splice(rmIdx, 1);
                            }

                            rmIdx = Utils.Array.indexOfFunc(events, 'd-pos-mod-nights-event', 0, arrayContainsCompareFunction);
                            if (rmIdx > -1) {
                                events.splice(rmIdx, 1);
                            }

                            rmIdx = Utils.Array.indexOfFunc(events, 'd-neg-mod-nights-event', 0, arrayContainsCompareFunction);
                            if (rmIdx > -1) {
                                events.splice(rmIdx, 1);
                            }
                            model.events = events.join(',');
                            helper.makeClickStreamCall(model);
                        }

                        if (model.personalizations && Array.isArray(model.personalizations) && model.personalizations.length > 0 && CEA.decisionOn) {

                            locations = model.personalizations;
                            numLocations = locations.length;
                            for (i = 0; i < numLocations; i++) {
                                loc = locations[i];
                                if (loc.linkId) {
                                    $(loc.clickSelector || loc.selector).attr('name', '&lid=' + loc.linkId);
                                }
                                if (loc.engine) {
                                    CEA.helper.setupClickHandler(loc);
                                    switch (loc.impressionType) {
                                        case 'onPage':
                                            CEA.helper.setupPoll(loc);
                                            break;
                                        case 'visible':
                                            CEA.helper.setupVisible(loc);
                                            break;
                                        case 'customEvent':
                                            CEA.helper.setupCustomEvent(loc);
                                            break;
                                        default:
                                            fireImpressions.push(loc);
                                            break;
                                    }
                                }
                            }
                            $(document).one('CEACaptureCallComplete', function () {
                                for (i = 0, numImmediateImpressions = fireImpressions.length; i < numImmediateImpressions; i++) {
                                    CEA.helper.fireImpressionEvent(fireImpressions[i]);
                                }
                            });
                        }
                        processInteractiveElements(model);
                        F.fireEvent(document, 'CEAAdapterComplete', model);
                    }
                }
            };
        }

        function arrayContainsCompareFunction(value, searchValue) {
            return value.indexOf(searchValue) > -1;
        }

        function normalizeEvents(events) {
            var numEvents, key, i;

            if (events && typeof events === 'string') {
                events = events.split(',');
            } else if (!Array.isArray(events)) {
                events = [];
            }

            numEvents = events.length;
            for (i = 0; i < numEvents; i++) {
                if (typeof events[i] === 'object') {
                    for (key in events[i]) {
                        if (events[i].hasOwnProperty(key)) {
                            events[i] = key + '=' + events[i][key];
                        }
                    }
                }
            }

            return events;
        }
    })(WDPRO.Analytics.Config.products.CEA, WDPRO.Analytics, WDPRO.Analytics.wdwQuery);

    /*global WDPRO, mboxTrack, inject*/
    if (WDPRO.Analytics.Config.products.CEA) {
        (function (CEA) {
            var A = WDPRO.Analytics,
                $ = A.wdwQuery,
                trackVisibleLocationCount = 0,
                Utils = WDPRO.Analytics.Utils,
                isObject = inject.resolve('isObject');

            CEA.helper = {
                PERSONALIZATION_COOKIE_LIFE_DAYS: 730,
                getSessionId: function getSessionId() {
                    var id = null,
                        pageData = CEA.pageData,
                        cookieJar;
                    if (pageData.sessionIdCookieJarName && pageData.sessionIdCookieName) {
                        cookieJar = Utils.getCookie(pageData.sessionIdCookieJarName);
                        if (cookieJar) {
                            id = JSON.parse(cookieJar)[pageData.sessionIdCookieName];
                        }
                    } else if (!pageData.sessionIdCookieJarName && pageData.sessionIdCookieName) {
                        id = Utils.getCookie(pageData.sessionIdCookieName);
                    }

                    return id;
                },
                setPersonalizationId: function setPersonalizationId(personalizationId) {
                    var pageData = CEA.pageData,
                        encodeJSON = false,
                        cookieName,
                        cookieVal,
                        cookieJar;

                    if (!pageData.cookieJarName && pageData.cookieName) {
                        cookieName = pageData.cookieName;
                        cookieVal = personalizationId;
                    } else {
                        encodeJSON = true;
                        cookieName = pageData.cookieJarName || 'personalization_jar';
                        cookieJar = WDPRO.Analytics.Utils.getCookie(cookieName, true);
                        cookieVal = isObject(cookieJar) ? cookieJar : {};
                        cookieVal[pageData.cookieName || 'id'] = personalizationId;
                    }

                    WDPRO.Analytics.Utils.setCookie(cookieName, cookieVal, this.PERSONALIZATION_COOKIE_LIFE_DAYS, encodeJSON, undefined, window.location.protocol === 'https:');
                    pageData.personalizationId = personalizationId;
                },
                getServiceOverrideHeaders: function getServiceOverrideHeaders() {
                    var headers = {},
                        OVERRIDES = [{
                        prop: 'cea',
                        header: 'X-Disney-Internal-Environment-Change-Override-PersonalizationDAO'
                    }],
                        apiGroups = Utils.getCookie('apiGroups', true) || {};

                    OVERRIDES.forEach(function (pair) {
                        if (apiGroups[pair.prop]) {
                            headers[pair.header] = apiGroups[pair.prop];
                        }
                    });
                    return headers;
                },
                makeAPICall: function makeAPICall(serviceCall) {
                    if (!Utils.getCookie(CEA.pageData.authCookieName)) {
                        this.getAuthToken().then(function () {
                            serviceCall();
                        });
                    } else {
                        serviceCall();
                    }
                },
                getAuthToken: function getAuthToken() {
                    var deferred = new $.Deferred(),
                        dbg = WDPRO.Analytics.Debug;

                    $.ajax({
                        timeout: CEA.pageData.authTimeout,
                        type: 'GET',
                        dataType: 'json',
                        contentType: 'application/json',
                        url: CEA.pageData.authURL,
                        beforeSend: function beforeSend(request) {
                            if (CEA.pageData.conversationId) {
                                request.setRequestHeader('X-Conversation-Id', CEA.pageData.conversationId);
                            }
                        }
                    }).then(function (data) {
                        var domain = window.location.hostname.toString();
                        CEA.pageData.authToken = data.access_token;
                        if (CEA.pageData.authCookieIncludeSubDomains === true) {
                            domain = '.' + domain;
                        }
                        // setCookie takes expiration time in days but converts to millseconds
                        A.Utils.setCookie(CEA.pageData.authCookieName, data.access_token, data.expires_in * 1000 / 86400000, false, domain, true);
                        deferred.resolve(data.access_token);
                    }).fail(function (data) {
                        dbg.error('CEA, Auth Call Failed:', data);
                    });

                    return deferred.promise();
                },
                sendCaptureCall: function sendCaptureCall(data) {
                    var sessionId = CEA.helper.getSessionId();

                    data.channel = 'web';
                    return $.ajax({
                        timeout: CEA.pageData.captureTimeout,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        url: CEA.pageData.captureURL,
                        beforeSend: function beforeSend(request) {
                            var headers = CEA.helper.getServiceOverrideHeaders();

                            if (CEA.pageData.conversationId) {
                                headers['X-Conversation-Id'] = CEA.pageData.conversationId;
                            }

                            if (sessionId) {
                                headers.CausataId = sessionId;
                            }

                            headers.Authorization = 'BEARER ' + CEA.pageData.authToken;

                            inject.resolve('objForEach')(headers, function (val, key) {
                                request.setRequestHeader(key, val);
                            });
                        },
                        data: JSON.stringify(data),
                        fullData: data
                    }).done(function (data, status, xhr) {
                        var sessionId = xhr.getResponseHeader('CausataId'),
                            expiration = 0.02083333333333,
                            // 30 minutes in days
                        protocol = Utils.getURLProtocol();
                        if (sessionId) {
                            Utils.setCookie('causata_jar', { id: sessionId }, expiration, true, undefined, protocol.indexOf('https') > -1 ? true : false);
                        }
                        if (data.personalizationId) {
                            CEA.helper.setPersonalizationId(data.personalizationId);
                        }
                    });
                },
                makeCaptureCall: function makeCaptureCall(model, data) {
                    var deferred = new $.Deferred(),
                        dbg = WDPRO.Analytics.Debug;

                    if (!data.personalizationId) {
                        data.personalizationId = model.personalizationId;
                    }

                    this.sendCaptureCall(data).then(function (resp) {
                        var personalizations = model.personalizations || [],
                            location,
                            numP = personalizations.length,
                            i;

                        if (resp.personalizationId !== model.personalizationId) {
                            CEA.helper.setPersonalizationId(resp.personalizationId);
                        }

                        CEA.helper.setPersonalizationId(resp.personalizationId);

                        if (CEA.pageData.enableTargetIntegration && numP > 0) {
                            for (i = 0; i < numP; i++) {
                                location = personalizations[i];
                                A.Config.products.CEA.helper.fireAdobeTargetDecisionCall(location);
                            }
                        }
                        A.Framework.fireEvent(document, 'CEACaptureCallComplete', { model: model, data: data });
                        deferred.resolve(resp);
                    }).fail(function (data) {
                        dbg.error('CEA, Capture Call Failed:', data);
                    });

                    return deferred.promise();
                },
                setupClickHandler: function setupClickHandler(location) {
                    var selector, clickHandler;

                    if (CEA.captureOn) {
                        selector = location.clickSelector || location.selector || false;
                        clickHandler = function clickHandler(event, el) {
                            var getLinkId,
                                location = event.data;

                            getLinkId = function getLinkId(el) {
                                var $el = $(el);
                                if ($el.attr('name') && $el.attr('name').indexOf('&lid=') > -1) {
                                    return $el.attr('name').replace('&lid=', '');
                                }

                                return false;
                            };

                            CEA.helper.makeAPICall(function () {
                                var $ = WDPRO.Analytics.wdwQuery,
                                    CEA = WDPRO.Analytics.Config.products.CEA,
                                    data = {
                                    events: [],
                                    personalizationId: WDPRO.Analytics.getPersonalizationId()
                                },
                                    eventTime = WDPRO.Analytics.moment().format(CEA.dateTimeFormat) + 'Z',
                                    i,
                                    numSelections,
                                    optionId,
                                    optionName,
                                    position,
                                    selections = [],
                                    selectionValues,
                                    selectionValue;

                                if (location.selectionSelector) {
                                    selections = $(location.selectionSelector);
                                    if (selections.length > 0) {
                                        numSelections = selections.length;
                                        selectionValues = [];
                                        for (i = 0; i < numSelections; i++) {
                                            if (location.selectionOptionValueAttribute) {
                                                selectionValue = $(selections[i]).attr(location.selectionOptionValueAttribute);
                                                selectionValues.push(selectionValue);
                                                data.events.push({
                                                    datetime: eventTime,
                                                    eventType: 'd-personalization-click',
                                                    attributes: [{
                                                        name: 'decision-location',
                                                        value: location.location
                                                    }, {
                                                        name: 'option-name',
                                                        value: selectionValue
                                                    }, {
                                                        name: 'page-name',
                                                        value: CEA.pageData.pageName
                                                    }]
                                                });
                                            } else {
                                                WDPRO.Analytics.Debug.error('CEA Click Handler - location.selectionOptionValueAttribute value missing');
                                            }
                                        }
                                    }
                                } else if (!location.selectionSelector && !location.options) {
                                    data.events.push({
                                        datetime: eventTime,
                                        eventType: 'd-personalization-click',
                                        attributes: [{
                                            name: 'decision-location',
                                            value: location.location
                                        }, {
                                            name: 'option-name',
                                            value: location.decision || 'DEFAULT'
                                        }, {
                                            name: 'page-name',
                                            value: CEA.pageData.pageName
                                        }]
                                    });
                                } else if (!location.selectionSelector && location.options && location.options.length > 0 && !location.optionIdAttr) {
                                    location.options.forEach(function (val) {
                                        data.events.push({
                                            datetime: eventTime,
                                            eventType: 'd-personalization-click',
                                            attributes: [{
                                                name: 'decision-location',
                                                value: location.location
                                            }, {
                                                name: 'option-name',
                                                value: val.decision
                                            }, {
                                                name: 'page-name',
                                                value: CEA.pageData.pageName
                                            }]
                                        });
                                    });
                                } else if (!location.selectionSelector && location.options && location.options.length > 0 && location.optionIdAttr) {
                                    optionId = $(el).attr(location.optionIdAttr);
                                    optionName = location.options.reduce(function (prev, option) {
                                        return prev || (option.optionId === optionId ? option.decision : '');
                                    }, '');

                                    if (optionName) {
                                        position = $(location.clickSelector).index(el) + 1;

                                        data.events.push({
                                            datetime: eventTime,
                                            eventType: 'd-personalization-click',
                                            attributes: [{
                                                name: 'decision-location',
                                                value: location.location
                                            }, {
                                                name: 'option-name',
                                                value: optionName
                                            }, {
                                                name: 'page-name',
                                                value: CEA.pageData.pageName
                                            }, {
                                                name: 'decision-position',
                                                value: position
                                            }]
                                        });
                                    }
                                }
                                if (data.events.length > 0) {
                                    WDPRO.Analytics.Config.products.CEA.helper.sendCaptureCall(data).then(function () {
                                        var trackingModel = {
                                            linkId: location.linkId || getLinkId(el) || 'Personalization_' + location.locationShortName + '_' + (optionId ? optionId + '_' : '') + 'click',
                                            trackingType: 'customLink',
                                            personalizationClick: {
                                                locationShortName: location.locationShortName,
                                                customerGroup: location.engine
                                            },
                                            events: 'personalizationClick'
                                        },
                                            target = $(el).attr('target');

                                        if (location.options && !optionId) {
                                            trackingModel.personalizationClick.options = [];
                                            if (selectionValues && selectionValues.length > 0) {
                                                for (i = 0; i < numSelections; i++) {
                                                    trackingModel.personalizationClick.options.push({
                                                        optionId: selectionValues[i]
                                                    });
                                                }
                                            }
                                        } else if (!location.options) {
                                            trackingModel.personalizationClick.optionId = location.optionId || (location.engine ? 'DEFAULT' : 'control');
                                        } else if (location.options && optionId) {
                                            trackingModel.personalizationClick.options = [];
                                            trackingModel.personalizationClick.options.push({ optionId: optionId });
                                        }
                                        A.Config.products.SiteCatalyst.trackElement('personalization-click', trackingModel);
                                        if (CEA.pageData.enableTargetIntegration) {
                                            A.Config.products.CEA.helper.fireAdobeTargetClickCall(location, selectionValues);
                                        }
                                        if (!target || target === '_self' || target === '_top' || target === '_parent') {
                                            setTimeout(function () {
                                                A.Framework.fireEvent(document, 'CEAClickCallComplete', data);
                                                if (el && el.click) {
                                                    el.click();
                                                }
                                            }, 575);
                                        } else {
                                            A.Framework.fireEvent(document, 'CEAClickCallComplete', data);
                                        }
                                    }).fail(function () {
                                        WDPRO.Analytics.Debug.error('CEA Decision Click Capture Call Failed');
                                        A.Framework.fireEvent(el, 'click');
                                        if (el && el.click) {
                                            el.click();
                                        }
                                    }, 575);
                                }
                            });
                        };

                        if (selector) {
                            if (location.impressionType === 'onPage') {
                                $(window).on('click.CEATracking.CEAClick', selector, location, function (e) {
                                    $(this).off('.CEAClick', selector);
                                    clickHandler(e, this);
                                });
                            } else {
                                $(selector).one('click', location, function (e) {
                                    var target = $(this).attr('target');
                                    if (!target || target === '_self' || target === '_top' || target === '_parent') {
                                        e.preventDefault();
                                        e.stopImmediatePropagation();
                                    }
                                    clickHandler(e, this);
                                });
                            }
                        }
                    }
                },
                isElementVisible: function isElementVisible(el) {
                    var VISIBLE_MARGIN = 25,
                        hasRects,
                        result,
                        rect;

                    if (el) {
                        hasRects = !!el.getClientRects().length;
                        result = hasRects;

                        if (hasRects) {
                            rect = el.getBoundingClientRect();
                            result = !(rect.top > window.innerHeight - VISIBLE_MARGIN || rect.bottom < VISIBLE_MARGIN);
                        }
                    }

                    return result;
                },
                getFreshOptions: function getFreshOptions(locationName) {
                    var locations = WDPRO.Analytics.Framework.getParentModel().personalizations || undefined,
                        options = [];

                    if (locations && locations.length > 0) {
                        inject.resolve('objForEach')(locations, function (location) {
                            if (location.location === locationName && location.options) {
                                options = location.options;
                            }
                        });
                    }
                    return options;
                },
                fireImpressionEvent: function fireImpressionEvent(location) {
                    var impressionTime = WDPRO.Analytics.moment().utc().format(CEA.dateTimeFormat) + 'Z',
                        options = this.getFreshOptions(location.location),
                        data = {
                        events: []
                    };

                    if (options && options.length > 0) {
                        options.forEach(function (val, idx) {
                            data.events.push({
                                datetime: impressionTime,
                                eventType: 'd-personalization-impression',
                                attributes: [{
                                    name: 'decision-location',
                                    value: location.location
                                }, {
                                    name: 'option-name',
                                    value: val.decision || val.name
                                }, {
                                    name: 'page-name',
                                    value: CEA.pageData.pageName
                                }, {
                                    name: 'decision-position',
                                    value: idx + 1
                                }]
                            });
                        });
                    } else {
                        data.events.push({
                            datetime: impressionTime,
                            eventType: 'd-personalization-impression',
                            attributes: [{
                                name: 'decision-location',
                                value: location.location
                            }, {
                                name: 'option-name',
                                value: location.decision ? location.decision === '' ? 'DEFAULT' : location.decision : 'DEFAULT'
                            }, {
                                name: 'page-name',
                                value: CEA.pageData.pageName
                            }]
                        });
                    }

                    if (CEA.decisionOn) {
                        if (!data.personalizationId) {
                            data.personalizationId = WDPRO.Analytics.getPersonalizationId();
                        }
                        this.sendCaptureCall(data).then(function () {
                            if (CEA.pageData.enableTargetIntegration) {
                                A.Config.products.CEA.helper.fireAdobeTargetImpressionCall(location);
                            }
                            A.Framework.fireEvent(document, 'CEAImpressionCallComplete', data);
                        });
                    }
                },
                setupCustomEvent: function setupCustomEvent(location) {
                    var selector = location.impressionSelector || location.selector;
                    if (selector) {
                        $(selector).one(location.impressionEvent, location, function (e) {
                            CEA.helper.makeAPICall(function () {
                                CEA.helper.fireImpressionEvent(e.data);
                            });
                        });
                    }
                },
                setupVisible: function setupVisible(location) {
                    var namespace = 'CEAImpression' + trackVisibleLocationCount++;

                    $(window).on('DOMContentLoaded.CEATracking.' + namespace + ' load.CEATracking.' + namespace + ' resize.CEATracking.' + namespace + ' scroll.CEATracking.' + namespace, location, function (e) {
                        var isVisible = CEA.helper.isElementVisible($(e.data.selector).get(0));
                        if (isVisible && $(e.data.selector).is(':visible')) {
                            $(this).off('.' + namespace);
                            CEA.helper.fireImpressionEvent(e.data);
                        }
                    });
                },
                setupPoll: function setupPoll(location) {
                    if (location.selector) {
                        WDPRO.Analytics.Utils.pollForElement(location.selector, function () {
                            CEA.helper.fireImpressionEvent(location);
                        });
                    }
                },
                checkForExistingProperty: function checkForExistingProperty(existing, check) {
                    var length = existing.length,
                        i = 0;

                    for (i; i < length; i++) {
                        if (existing[i].name === check) {
                            return true;
                        }
                    }
                    return false;
                },
                breakdownEventData: function breakdownEventData(eventName, data) {
                    var prop, dataElement, numItems, i, event;

                    event = {
                        datetime: WDPRO.Analytics.moment().utc().format(CEA.dateTimeFormat) + 'Z',
                        eventType: eventName,
                        attributes: []
                    };
                    for (prop in data) {
                        if (data.hasOwnProperty(prop)) {
                            if (typeof data[prop] === 'string' || typeof data[prop] === 'number' || typeof data[prop] === 'boolean') {
                                if (!this.checkForExistingProperty(event.attributes, prop)) {
                                    if (typeof data[prop] === 'string') {
                                        data[prop] = data[prop].replace(/^\s+|\s+$/gm, '');
                                    }
                                    if (data[prop] !== '') {
                                        dataElement = {
                                            name: prop,
                                            value: data[prop]
                                        };
                                        event.attributes.push(dataElement);
                                    }
                                }
                            } else if (Array.isArray(data[prop])) {
                                numItems = data[prop].length;
                                for (i = 0; i < numItems; i++) {
                                    if (typeof data[prop][i] === 'string') {
                                        data[prop][i] = data[prop][i].replace(/^\s+|\s+$/gm, '');
                                    }
                                    if (data[prop][i] !== '') {
                                        dataElement = {
                                            name: prop,
                                            value: data[prop][i]
                                        };
                                        event.attributes.push(dataElement);
                                    }
                                }
                            }
                        }
                    }
                    return event;
                },
                resetArraysForMerge: function resetArraysForMerge(model, updatedModel) {
                    var baseProp;
                    if (model && updatedModel) {
                        for (baseProp in updatedModel) {
                            if (updatedModel.hasOwnProperty(baseProp)) {
                                if (Array.isArray(updatedModel[baseProp])) {
                                    model[baseProp] = [];
                                }
                            }
                        }
                    }
                },
                filterDuplicateAttributes: function filterDuplicateAttributes(attributes) {
                    var allowedDuplicates = ['booking-search-children-ages', 'products-booked-children-ages'],
                        attribute,
                        deleteItems = [],
                        foundAttributes = [],
                        i,
                        numAttributes = attributes.length,
                        numDeletes;

                    for (i = 0; i < numAttributes; i++) {
                        attribute = attributes[i];
                        if ($.inArray(attribute.name, foundAttributes) === -1 || $.inArray(attribute.name, allowedDuplicates) > -1) {
                            foundAttributes.push(attribute.name);
                        } else if ($.inArray(attribute.name, foundAttributes) > -1 && $.inArray(attribute.name, allowedDuplicates) === -1) {
                            deleteItems.push(i);
                            WDPRO.Analytics.Debug.log('Removed duplicate attribute:', attribute.name);
                        }
                    }
                    numDeletes = deleteItems.length;
                    for (i = numDeletes - 1; i >= 0; i--) {
                        attributes.splice(deleteItems[i], 1);
                    }
                },
                makeClickStreamCall: function makeClickStreamCall(model) {
                    var populateEventData,
                        numProducts = model.products ? model.products.length : 0,
                        i,
                        j,
                        k,
                        numItems,
                        dataElement,
                        numDataElements,
                        products = model.products || [],
                        newEvent,
                        appendEvents = [],
                        prop,
                        eventList,
                        data = {
                        events: []
                    };

                    populateEventData = function populateEventData(model) {
                        var events = model.events.split(','),
                            numEvents,
                            visitorId = WDPRO.Analytics.Config.products.SiteCatalyst.helper.getVisitorId(),
                            data = [];

                        for (i = 0, numEvents = events.length; i < numEvents; i++) {
                            dataElement = CEA.helper.breakdownEventData(events[i], model.data);
                            data.push(dataElement);
                            if (visitorId) {
                                data[i].attributes.push({
                                    name: 'omniture-cookie-id',
                                    value: visitorId
                                });
                            }
                        }

                        return data;
                    };

                    eventList = populateEventData(model);

                    if (products.length > 0) {
                        for (j = 0, numDataElements = eventList.length; j < numDataElements; j++) {
                            for (i = 0; i < numProducts; i++) {
                                if (products[i].events === 'cart-add=1') {
                                    products[i]['products-cart-action'] = 'cart-add';
                                    delete products[i].events;
                                } else if (products[i].events === 'cart-remove=1') {
                                    products[i]['products-cart-action'] = 'cart-remove';
                                    delete products[i].events;
                                }
                                newEvent = $.extend(true, {}, eventList[j]);
                                for (prop in products[i]) {
                                    if (products[i].hasOwnProperty(prop) && (prop.indexOf('-') > -1 || prop === 'events')) {
                                        if (typeof products[i][prop] === 'string' || typeof products[i][prop] === 'number' || typeof products[i][prop] === 'boolean') {
                                            if (products[i][prop] && products[i][prop] !== '') {
                                                newEvent.attributes.push({
                                                    name: prop,
                                                    value: products[i][prop]
                                                });
                                            }
                                        } else if (Array.isArray(products[i][prop])) {
                                            numItems = products[i][prop].length;
                                            for (k = 0; k < numItems; k++) {
                                                newEvent.attributes.push({
                                                    name: prop,
                                                    value: products[i][prop][k]
                                                });
                                            }
                                        }
                                    }
                                }
                                this.filterDuplicateAttributes(newEvent.attributes);
                                appendEvents.push(newEvent);
                            }
                        }
                        data.events = appendEvents;
                    } else {
                        data.events = eventList;
                    }

                    this.makeAPICall(function () {
                        CEA.helper.makeCaptureCall(model, data);
                    });
                },
                mergeInteractiveElements: function mergeInteractiveElements(interactiveElement, updatedModel) {
                    if (interactiveElement && updatedModel) {
                        this.resetArraysForMerge(interactiveElement.trackingModel, updatedModel.trackingModel);
                        $.extend(true, interactiveElement, updatedModel);
                    }
                },
                bindEvent: function bindEvent($el, triggerEvent, triggerType, interactiveElement) {
                    var translatedEvent,
                        bindType = 'bind';
                    if (triggerType === 'page') {
                        translatedEvent = 'd-page';
                    } else if (triggerType === 'customEvent') {
                        if (interactiveElement.trackingModel && interactiveElement.trackingModel.events) {
                            translatedEvent = WDPRO.Analytics.Config.products.CEA.mapping.events.mapping.mapTo[interactiveElement.trackingModel.events];
                            bindType = 'one';
                        } else {
                            translatedEvent = 'd-link';
                        }
                    } else {
                        translatedEvent = 'd-link';
                    }
                    $el.one(triggerEvent.type, { interactiveElement: interactiveElement }, function (cEvent, updatedModel) {
                        var me = this;
                        cEvent.preventDefault();
                        cEvent.stopImmediatePropagation();
                        CEA.helper.trackEvent(translatedEvent, cEvent.data.interactiveElement, updatedModel);
                        setTimeout(function () {
                            A.Framework.fireEvent(me, 'click');
                            if (bindType !== 'one') {
                                setTimeout(function () {
                                    CEA.helper.bindEvent($el, triggerEvent, triggerType, interactiveElement);
                                }, 300);
                            }
                        }, 600);
                    });
                },
                setupEvent: function setupEvent(interactiveElement) {
                    var triggerEvent, numEvents, i, $el, triggerType;
                    if (interactiveElement.triggerEvents) {
                        numEvents = interactiveElement.triggerEvents.length;
                        for (i = 0; i < numEvents; i++) {
                            triggerEvent = interactiveElement.triggerEvents[i];
                            triggerType = interactiveElement.trackingType;
                            if (triggerEvent.elementSelectors) {
                                $el = $(triggerEvent.elementSelectors);
                                this.bindEvent($el, triggerEvent, triggerType, interactiveElement);
                            }
                        }
                    }
                },
                trackEvent: function trackEvent(event, interactiveElement, updatedModel) {
                    var parsedModel,
                        P = WDPRO.Analytics.Parsers,
                        model,
                        CEA = WDPRO.Analytics.Config.products.CEA,
                        pageNameKey = CEA.mapping.pageId.mapping.mapTo.replace('data.', ''),
                        customerIdKey = CEA.mapping.customerId.mapping.mapTo.replace('data.', '');

                    if (CEA.firstRun === false) {
                        if (interactiveElement && updatedModel) {
                            CEA.helper.mergeInteractiveElements(interactiveElement, updatedModel);
                        }
                        CEA.helper.mergeInteractiveElements(interactiveElement, interactiveElement.trackingModel);
                        delete interactiveElement.trackingModel;
                        model = interactiveElement;
                        model.personalizationId = WDPRO.Analytics.getPersonalizationId();

                        parsedModel = P.parseSemanticModel(model, CEA.mapping);
                        parsedModel.events = event;
                        if ((event === 'd-link' || event === 'd-logged-out') && !model.pageId && !model.siteSection) {
                            if (model.data && model.data['link-id']) {
                                parsedModel.data['link-id'] = model.data['link-id'];
                            }
                            parsedModel.data[pageNameKey] = CEA.pageData.data[pageNameKey];
                            parsedModel.data[customerIdKey] = CEA.pageData.data[customerIdKey];
                        }
                        this.makeAPICall(function () {
                            CEA.helper.makeClickStreamCall(parsedModel);
                        });
                    } else {
                        WDPRO.Analytics.Debug.log('CEA: trackEvent called before firstRun');
                    }
                },
                bindTrackVideo: function bindTrackVideo(triggerEvent, interactiveElement) {
                    var CEA = WDPRO.Analytics.Config.products.CEA,
                        events,
                        event;

                    $(triggerEvent.elementSelectors).on(triggerEvent.type, {
                        interactiveElement: interactiveElement,
                        triggerEvent: triggerEvent
                    }, function (cEvent, updatedModel) {
                        var triggerEvent = cEvent.data.triggerEvent,
                            interactiveElement = cEvent.data.interactiveElement,
                            i,
                            dbg = WDPRO.Analytics.Debug;
                        if (Utils.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, triggerEvent.type) === -1) {
                            CEA.helper.mergeInteractiveElements(interactiveElement, updatedModel);
                            if (updatedModel.trackingModel) {
                                if (updatedModel.mediaId && updatedModel.mediaType && updatedModel.duration !== undefined && updatedModel.currentTime !== undefined && updatedModel.trackingModel.events) {
                                    events = updatedModel.trackingModel.events.split(',');
                                    i = 0;
                                    for (i; i < events.length; i++) {
                                        event = events[i];
                                        switch (event) {
                                            case 'videoStart':
                                                CEA.helper.trackEvent('d-video-start', interactiveElement);
                                                break;
                                            case 'videoPause':
                                                CEA.helper.trackEvent('d-video-pause', interactiveElement);
                                                break;
                                            case 'videoEnd':
                                                CEA.helper.trackEvent('d-video-stop', interactiveElement);
                                                break;
                                        }
                                    }
                                } else {
                                    dbg.info('CEA: Interactive Element is missing required properties. The following properties are required:\n\tmediaId\n\tmediaType\n\tduration\n\tcurrentTime\n\ttrackingModel.events');
                                }
                            } else {
                                dbg.info('CEA: Interactive Element is missing trackingModel');
                            }
                        } else {
                            dbg.info('CEA: TRIGGERED EVENT DISABLED: ', triggerEvent.type);
                        }
                    });
                },
                trackVideo: function trackVideo(interactiveElement) {
                    var triggerEvent,
                        i = 0,
                        l;

                    if (interactiveElement) {
                        l = interactiveElement.triggerEvents.length;
                        for (i; i < l; i++) {
                            triggerEvent = interactiveElement.triggerEvents[i];
                            if (triggerEvent.type && triggerEvent.elementSelectors) {
                                this.bindTrackVideo(triggerEvent, interactiveElement);
                            }
                        }
                    }
                },
                getStandardTargetData: function getStandardTargetData() {
                    var pageData = CEA.pageData,
                        data = ['site=' + pageData.site, 'contentLocale=' + pageData.contentLocale, 'contentLanguage=' + pageData.contentLanguage, 'pageId=' + pageData.pageId, 'siteSection=' + pageData.siteSection];
                    if (pageData.deviceInfo) {
                        data.push('deviceInfo=' + pageData.deviceInfo);
                    }
                    return data;
                },
                getDecisionImpressionForTarget: function getDecisionImpressionForTarget(location, filter) {
                    var decisions, decision, i, j, numFilters, numOptions, options;

                    if (location.options) {
                        options = location.options;
                        numOptions = options.length;
                        if (numOptions > 0) {
                            decisions = [];
                            if (filter && Array.isArray(filter)) {
                                numFilters = filter.length;
                                for (j = 0; j < numFilters; j++) {
                                    for (i = 0; i < numOptions; i++) {
                                        if (WDPRO.Analytics.Utils.Array.indexOf(filter[j])) {
                                            decisions.push(options[i].optionId);
                                        }
                                    }
                                }
                            } else {
                                for (i = 0; i < numOptions; i++) {
                                    decisions.push(options[i].optionId);
                                }
                            }
                            decision = decisions.join(',');
                        } else {
                            decision = location.engine ? 'DEFAULT' : 'control';
                        }
                    } else {
                        decision = location.optionId || (location.engine ? 'DEFAULT' : 'control');
                    }

                    return decision;
                },
                fireAdobeTargetDecisionCall: function fireAdobeTargetDecisionCall(location) {
                    var data = this.getStandardTargetData(),
                        pageData = CEA.pageData,
                        engine = location.engine || 'none',
                        targetAdapter = inject.resolve('Adapter:TestAndTarget'),
                        decision = this.getDecisionImpressionForTarget(location);

                    data = data.concat(['personalizationEvent=decision', 'pDecision=' + decision, 'pDecisionEngine=' + engine, 'pVPCSegment=' + (location.vpcSegment || 'unknown')]);

                    targetAdapter.defineAndUpdateMbox('body', pageData.site + '_Personalization_' + (location.locationShortName || location.location), 'append', data);

                    if (location.additionalMBox) {
                        setTimeout(function () {
                            targetAdapter.defineAndUpdateMbox('body', location.additionalMBox, 'append', []);
                        }, 500);
                    }

                    A.Framework.fireEvent(document, 'CEATargetDecisionCallComplete', data);
                },
                fireAdobeTargetImpressionCall: function fireAdobeTargetImpressionCall(location) {
                    var data = this.getStandardTargetData(),
                        decision = this.getDecisionImpressionForTarget(location),
                        engine = location.engine || 'none',
                        pageData = CEA.pageData;

                    data = data.concat(['personalizationEvent=impression', 'pDecision=' + decision, 'pDecisionEngine=' + engine, 'pVPCSegment=' + (location.vpcSegment || 'unknown')]);

                    mboxTrack(pageData.site + '_Personalization_' + (location.locationShortName || location.location), data.join('&'));

                    A.Framework.fireEvent(document, 'CEATargetImpressionCallComplete', data);
                },
                fireAdobeTargetClickCall: function fireAdobeTargetClickCall(location, selections) {
                    var data = this.getStandardTargetData(),
                        decision = this.getDecisionImpressionForTarget(location, selections),
                        engine = location.engine || 'none',
                        pageData = CEA.pageData;

                    data = data.concat(['personalizationEvent=click', 'pDecision=' + decision, 'pDecisionEngine=' + engine, 'pVPCSegment=' + (location.vpcSegment || 'unknown')]);

                    mboxTrack(pageData.site + '_Personalization_' + (location.locationShortName || location.location), data.join('&'));
                    A.Framework.fireEvent(document, 'CEATargetClickCallComplete', data);
                }
            };
        })(WDPRO.Analytics.Config.products.CEA);
    }

    /*global window, WDPRO*/
    /*map SAM model to product
    http://wiki.wdpro.wdig.com/display/Tech/Analytics+Semantic+Model+v2.0*/

    //the namespace will be automatically created this product is supported (defined in the config.js)
    (function (CEA) {
        if (CEA) {
            CEA.mapping = {
                userAgent: {
                    mapping: {
                        mapTo: 'data.user-agent',
                        defaultValue: window.navigator.userAgent
                    }
                },
                configuration: {
                    contentLocale: {
                        mapping: {
                            defaultValue: 'us',
                            mapTo: 'data.content-locale,contentLocale'
                        }
                    },
                    contentLanguage: {
                        mapping: {
                            defaultValue: 'en',
                            mapTo: 'data.content-language,contentLanguage'
                        }
                    },
                    marketingRegion: {
                        mapping: {
                            applyFilter: {
                                'case': 'lower'
                            }
                        }
                    },
                    CEA: {
                        personalizationIdCookieName: {
                            mapping: {
                                mapTo: 'cookieName',
                                defaultValue: 'personalizationId'
                            }
                        },
                        personalizationIdCookieJarName: {
                            mapping: {
                                mapTo: 'cookieJarName'
                            }
                        },
                        sessionIdCookieJarName: {
                            mapping: {
                                mapTo: 'sessionIdCookieJarName'
                            }
                        },
                        sessionIdCookieName: {
                            mapping: {
                                mapTo: 'sessionIdCookieName'
                            }
                        },
                        authCookieIncludeSubDomains: {
                            mapping: {
                                mapTo: 'authCookieIncludeSubDomains',
                                defaultValue: true
                            }
                        },
                        authCookieName: {
                            mapping: {
                                mapTo: 'authCookieName',
                                defaultValue: 'pep_oauth_token'
                            }
                        },
                        webSessionIdCookieName: {
                            mapping: {
                                defaultValue: 'PHPSESSID',
                                mapTo: 'webSessionIdCookieName'
                            }
                        },
                        channel: {
                            mapping: {
                                mapTo: 'data.channel',
                                defaultValue: 'web'
                            }
                        },
                        decisionToggleName: {
                            mapping: {
                                mapTo: 'decisionToggleName',
                                defaultValue: 'decisionCapture'
                            }
                        },
                        decisionTimeout: {
                            mapping: {
                                mapTo: 'decisionTimeout',
                                defaultValue: 200
                            }
                        },
                        decisionURL: {
                            mapping: {
                                mapTo: 'decisionURL',
                                defaultValue: '/api/wdpro/recommendation-service/personalization-decisions'
                            }
                        },
                        captureToggleName: {
                            mapping: {
                                mapTo: 'captureToggleName',
                                defaultValue: 'personalizationCapture'
                            }
                        },
                        captureTimeout: {
                            mapping: {
                                mapTo: 'captureTimeout',
                                defaultValue: 200
                            }
                        },
                        captureURL: {
                            mapping: {
                                mapTo: 'captureURL',
                                defaultValue: '/api/wdpro/recommendation-service/personalization-events'
                            }
                        },
                        authTimeout: {
                            mapping: {
                                mapTo: 'authTimeout',
                                defaultValue: 200
                            }
                        },
                        authURL: {
                            mapping: {
                                mapTo: 'authURL',
                                defaultValue: '/authentication/get-client-token/'
                            }
                        },
                        enableTargetIntegration: {
                            mapping: {
                                mapTo: 'enableTargetIntegration',
                                defaultValue: 'false'
                            }
                        },
                        enableInteractiveElementLinkTracking: {
                            mapping: {
                                mapTo: 'enableInteractiveElementLinkTracking',
                                defaultValue: 'false'
                            }
                        },
                        enableTrackElementLinkTracking: {
                            mapping: {
                                mapTo: 'enableTrackElementLinkTracking',
                                defaultValue: 'false'
                            }
                        },
                        rules: { mapping: {} }
                    },
                    SiteCatalyst: {
                        namespace: {
                            mapping: {
                                defaultValue: 'wdpro'
                            }
                        }
                    },
                    currency: {
                        mapping: {
                            mapTo: 'data.currency-code',
                            defaultValue: 'USD'
                        }
                    }
                },
                site: {
                    mapping: {
                        mapTo: 'site,data.site'
                    }
                },
                device: {
                    type: {
                        mapping: {}
                    },
                    viewType: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: function template(model) {
                            if (model.type && model.viewType) {
                                return '{{type}}:{{viewType}}';
                            }
                            return '';
                        },
                        mapTo: 'deviceInfo'
                    }
                },
                storeType: {
                    mapping: {
                        mapTo: 'storeType,data.store-type'
                    }
                },
                store: {
                    mapping: {
                        mapTo: 'store,data.store'
                    }
                },
                geo: {
                    dmaCode: {
                        mapping: {
                            mapTo: 'data.geolocation-dma-code'
                        }
                    },
                    country: {
                        mapping: {
                            mapTo: 'data.geolocation-country'
                        }
                    },
                    region: {
                        mapping: {
                            mapTo: 'data.geolocation-region'
                        }
                    },
                    zipcode: {
                        mapping: {
                            mapTo: 'data.geolocation-zip-code'
                        }
                    }
                },
                events: {
                    mapping: {
                        type: 'flex-array',
                        sourceDelimiter: ',',
                        targetDelimiter: ',', // a comma is the default but can support any character,
                        transformers: {
                            preProcess: function preProcess(model, parentModel, modelVal) {
                                var events = modelVal,
                                    event,
                                    i,
                                    numEvents,
                                    key,
                                    prop,
                                    modEventMap;

                                modEventMap = {
                                    posModRevenueEvent: 'pos-mod-revenue',
                                    negModRevenueEvent: 'neg-mod-revenue',
                                    posModNightsEvent: 'pos-mod-nights',
                                    negModNightsEvent: 'neg-mod-nights'
                                };
                                if (!Array.isArray(modelVal)) {
                                    events = modelVal.split(',');
                                }

                                numEvents = events.length;
                                for (i = 0; i < numEvents; i++) {
                                    event = events[i];
                                    if (!WDPRO.Analytics.Parsers.isObject(event)) {
                                        if (event.indexOf('=') > -1) {
                                            event = event.split('=');
                                            key = modEventMap[event[0]];
                                            if (key) {
                                                model.data[key] = event[1];
                                            }
                                        }
                                    } else {
                                        for (prop in event) {
                                            if (event.hasOwnProperty(prop)) {
                                                key = modEventMap[prop];
                                                if (key) {
                                                    model.data[key] = event[prop];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        mapTo: {
                            pageView: 'd-page-view',
                            videoPause: 'd-video-pause',
                            videoStart: 'd-video-start',
                            assetStart: 'd-asset-start',
                            videoStop: 'd-video-stop',
                            videoEnd: 'd-video-stop',
                            assetComplete: 'd-asset-complete',
                            registration: 'd-registration',
                            leadGenerated: 'd-lead-generated',
                            internalSearch: 'd-internal-search',
                            productView: 'd-product-view',
                            prodView: 'd-product-view',
                            cartCreate: 'd-cart-create',
                            cartView: 'd-cart-view',
                            cartProductAdd: 'd-cart-product-add',
                            cartProductRemove: 'd-cart-product-remove',
                            purchase: 'd-purchase',
                            internalSearchClick: 'd-internal-search-click',
                            checkoutDelivery: 'd-checkout-delivery',
                            checkoutInsurance: 'd-checkout-insurance',
                            checkoutApplyPayment: 'd-checkout-apply-payment',
                            checkoutReviewQuote: 'd-checkout-review-quote',
                            checkoutGuestInfo: 'd-checkout-guest-info',
                            guestInfoSubmit: 'd-checkout-guest-info',
                            scCheckout: 'd-checkout',
                            checkout: 'd-checkout',
                            loggedIn: 'd-logged-in',
                            loggedOut: 'd-logged-out',
                            postCheckoutPayment: 'd-post-checkout-paymentonline',
                            selfServiceInitiated: 'd-self-service-initiated',
                            selfServiceCompleted: 'd-self-service-completed',
                            compareVacationModify: 'd-compare-vacation-modify',
                            checkoutExpressCheckout: 'd-checkout-express-checkout',
                            modificationEvent: 'd-modification-event',
                            posModRevenueEvent: 'd-pos-mod-revenue-event',
                            negModRevenueEvent: 'd-neg-mod-revenue-event',
                            posModNightsEvent: 'd-pos-mod-nights-event',
                            negModNightsEvent: 'd-neg-mod-nights-event',
                            VPDOrder: 'd-vpd-order'
                        }
                    }
                },
                posModNightsEvent: {
                    mapping: {
                        mapTo: 'data.modification-positive-nights'
                    }
                },
                negModNightsEvent: {
                    mapping: {
                        mapTo: 'data.modification-negative-nights'
                    }
                },
                posModRevenueEvent: {
                    mapping: {
                        mapTo: 'data.modification-positive-revenue'
                    }
                },
                negModRevenueEvent: {
                    mapping: {
                        mapTo: 'data.modification-negative-revenue'
                    }
                },
                claimContext: {
                    mapping: {
                        mapTo: 'data.claim-context'
                    }
                },
                siteSection: {
                    mapping: {
                        mapTo: 'siteSection,data.site-section',
                        defaultValue: 'notset',
                        allowTokens: true,
                        applyFilter: {
                            'case': 'lower',
                            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}\/]', '']]
                        }
                    }
                },
                hierarchy: {
                    mapping: {
                        type: 'template',
                        reprocessOnUpdate: true,
                        template: '{{#namespace}}' + '{{{namespace}}}/{{{lcSite}}}/{{#marketingRegion}}{{{marketingRegion}}}{{/marketingRegion}}' + '{{^marketingRegion}}{{{contentLocale}}}{{/marketingRegion}}/{{{contentLanguage}}}/' + '{{{siteSection}}}{{/namespace}}',
                        transformers: {
                            lcSite: function lcSite(model) {
                                'use strict';

                                if (model.site) {
                                    return model.site.toLowerCase();
                                }
                            }
                        },
                        mapTo: 'hierarchy'
                    }
                },
                pageId: {
                    mapping: {
                        type: 'template',
                        template: '{{#hierarchy}}{{{hierarchy}}}/{{{pageId}}}{{/hierarchy}}',
                        mapTo: 'data.page-name,pageName',
                        defaultValue: 'notset',
                        applyFilter: {
                            'case': 'lower',
                            replace: [['[^a-zA-Z0-9]', '']]
                        }
                    }
                },
                pageUrl: {
                    mapping: {
                        mapTo: 'data.page-url',
                        defaultValue: window.location.toString()
                    }
                },
                referrer: {
                    mapping: {
                        mapTo: 'data.referrer',
                        defaultValue: window.document.referrer
                    }
                },
                pageVariant: {
                    mapping: {
                        mapTo: 'data.page-variant'
                    }
                },
                toggleStatus: {
                    releaseToggles: { mapping: {} },
                    mapping: {
                        type: 'template',
                        mapTo: 'toggles',
                        template: '{{#toggleStatus}}{{#ft}},{{{ft}}}{{/ft}}{{#rt}},{{{rt}}}{{/rt}}' + '{{#flt}},{{{flt}}}{{/flt}}{{/toggleStatus}}',
                        transformers: {
                            ft: function ft(model) {
                                var toggles = [],
                                    toggle,
                                    featureToggles;
                                if (model.toggleStatus && model.toggleStatus.featureToggles) {
                                    featureToggles = model.toggleStatus.featureToggles;
                                    for (toggle in featureToggles) {
                                        if (featureToggles.hasOwnProperty(toggle)) {
                                            toggles.push('ft;' + toggle + ':' + featureToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            },
                            rt: function rt(model) {
                                var toggles = [],
                                    toggle,
                                    releaseToggles;
                                if (model.toggleStatus && model.toggleStatus.releaseToggles) {
                                    releaseToggles = model.toggleStatus.releaseToggles;
                                    for (toggle in releaseToggles) {
                                        if (releaseToggles.hasOwnProperty(toggle)) {
                                            toggles.push('rt;' + toggle + ':' + releaseToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            },
                            flt: function flt(model) {
                                var toggles = [],
                                    toggle,
                                    flowToggles;
                                if (model.toggleStatus && model.toggleStatus.flowToggles) {
                                    flowToggles = model.toggleStatus.flowToggles;
                                    for (toggle in flowToggles) {
                                        if (flowToggles.hasOwnProperty(toggle)) {
                                            toggles.push('flt;' + toggle + ':' + flowToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            }
                        }
                    }
                },
                contentDisplayed: {
                    mapping: {
                        type: 'template',
                        template: '{{{contentDisplayed}}}{{#toggles}}{{{toggles}}}{{/toggles}}',
                        mapTo: 'data.content-displayed'
                    }
                },
                leadType: {
                    mapping: {
                        mapTo: 'data.lead-type'
                    }
                },
                linkId: {
                    mapping: {
                        mapTo: 'data.link-id',
                        defaultValue: function defaultValue() {
                            var linkIdObj = WDPRO.Analytics.Utils.sessionStorage.getItem('tmpAnalyticsLinkId');
                            if (linkIdObj && linkIdObj.prevPage && linkIdObj.linkId || WDPRO.Analytics.forceReferrer) {
                                if (linkIdObj.prevPage === document.referrer || linkIdObj.prevPage === WDPRO.Analytics.forceReferrer) {

                                    return linkIdObj.linkId;
                                }
                            }
                        }
                    }
                },
                regionId: {
                    mapping: {
                        mapTo: 'data.objectID'
                    }
                },
                registrationTemplateId: {
                    mapping: {
                        mapTo: 'data.registration-template-id'
                    }
                },
                siteType: {
                    mapping: {
                        mapTo: 'data.site-type'
                    }
                },
                customerId: {
                    mapping: {
                        mapTo: 'data.swid'
                    }
                },
                guestType: {
                    mapping: {
                        mapTo: 'data.guest-type'
                    }
                },
                selfServiceType: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: '|',
                        mapTo: 'data.self-service-type'
                    }
                },
                registrationStatus: {
                    mapping: {
                        mapTo: 'data.registration-status'
                    }
                },
                homeCountry: {
                    mapping: {
                        mapTo: 'data.home-country'
                    }
                },
                homeState: {
                    mapping: {
                        mapTo: 'data.home-state'
                    }
                },
                homeCity: {
                    mapping: {
                        mapTo: 'data.home-city'
                    }
                },
                homeZip: {
                    mapping: {
                        mapTo: 'data.home-zip'
                    }
                },
                title: {
                    mapping: {
                        mapTo: 'data.title'
                    }
                },
                age: {
                    mapping: {
                        mapTo: 'data.age'
                    }
                },
                productTotal: {
                    mapping: {
                        mapTo: 'data.product-total'
                    }
                },
                guestAffiliations: {
                    mapping: {
                        mapTo: 'guestAffiliations',
                        type: 'flex-array',
                        targetDelimiter: ',',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        },
                        transformers: {
                            preProcess: function preProcess(model, parentModel, modelVal) {
                                var i, numItems, val;
                                if (!model.data) {
                                    model.data = {};
                                }

                                if (Array.isArray(modelVal)) {
                                    numItems = modelVal.length;
                                    for (i = 0; i < numItems; i++) {
                                        val = modelVal[i];
                                        if (val.toLowerCase().indexOf('florida resident') > -1) {
                                            model.data['guest-affiliations-fl-res'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('california resident') > -1) {
                                            model.data['guest-affiliations-cal-res'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('canada resident') > -1) {
                                            model.data['guest-affiliations-canada-res'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('dvc') > -1) {
                                            model.data['guest-affiliations-dvc'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('passholder') > -1) {
                                            model.data['guest-affiliations-passholder'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('socal') > -1) {
                                            model.data['guest-affiliations-socal-res'] = true;
                                        }

                                        if (val.toLowerCase().indexOf('united kingdom') > -1) {
                                            model.data['guest-affiliations-uk-res'] = true;
                                        }
                                    }
                                } else {
                                    if (modelVal.toLowerCase().indexOf('florida resident') > -1) {
                                        model.data['guest-affiliations-fl-res'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('california resident') > -1) {
                                        model.data['guest-affiliations-cal-res'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('canada resident') > -1) {
                                        model.data['guest-affiliations-canada-res'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('dvc') > -1) {
                                        model.data['guest-affiliations-dvc'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('passholder') > -1) {
                                        model.data['guest-affiliations-passholder'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('socal') > -1) {
                                        model.data['guest-affiliations-socal-res'] = true;
                                    }

                                    if (modelVal.toLowerCase().indexOf('united kingdom') > -1) {
                                        model.data['guest-affiliations-uk-res'] = true;
                                    }
                                }
                            }
                        }
                    }
                },
                affiliationsAvailable: {
                    mapping: {
                        mapTo: 'data.affiliations-available',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                },
                internalSearchKeywords: {
                    mapping: {
                        mapTo: 'data.internal-search-keywords'
                    }
                },
                internalSearchNumResults: {
                    mapping: {
                        mapTo: 'data.internal-search-num-results'
                    }
                },
                internalSearchType: {
                    mapping: {
                        mapTo: 'data.internal-search-type'
                    }
                },
                bookingSearchNumResults: {
                    mapping: {
                        mapTo: 'data.booking-search-num-results'
                    }
                },
                bookingSearchDaysBetweenSearchAndArrival: {
                    mapping: {
                        mapTo: 'data.booking-search-days-between-search-and-arrival',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchArrivalDate: {
                    mapping: {
                        mapTo: 'data.booking-search-arrival-date',
                        applyFilter: {
                            date: 'YYYY-MM-DD'
                        }
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'data.booking-search-length-of-stay-nights',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchDepartureDate: {
                    mapping: {
                        mapTo: 'data.booking-search-departure-date',
                        defaultValue: function defaultValue(model) {
                            if (model.data['booking-search-arrival-date'] && model.data['booking-search-length-of-stay-nights']) {
                                return WDPRO.Analytics.moment(model.data['booking-search-arrival-date'], 'YYYY-MM-DD').add(model.data['booking-search-length-of-stay-nights'], 'd').format('YYYY-MM-DD');
                            }
                            return '';
                        }
                    }
                },
                bookingSearchSeason: {
                    mapping: {
                        mapTo: 'data.booking-search-season'
                    }
                },
                bookingSearchTweenTeens: {
                    mapping: {
                        mapTo: 'data.booking-search-tweenteens',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookinhSearchInfantsToddlers: {
                    mapping: {
                        mapTo: 'data.booking-search-infantstoddlers',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchAdults: {
                    mapping: {
                        mapTo: 'data.booking-search-adults,bookingSearchAdults',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchChildren: {
                    mapping: {
                        mapTo: 'data.booking-search-children,bookingSearchChildren',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchChildrenAges: {
                    mapping: {
                        mapTo: 'data.booking-search-children-ages'
                    }
                },
                bookingSearchInfants: {
                    mapping: {
                        mapTo: 'data.booking-search-infants,bookingSearchInfants',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                bookingSearchPartySize: {
                    mapping: {
                        mapTo: 'data.booking-search-party-size'
                    }
                },
                bookingSearchParty: {
                    mapping: {
                        type: 'template',
                        reprocessOnUpdate: true,
                        template: '{{#bookingSearchPartyTotal}}' + '{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}' + 'C:{{{bookingSearchInfants}}}I' + '{{/bookingSearchPartyTotal}}',
                        mapTo: 'data.booking-search-party-size',
                        transformers: {
                            bookingSearchPartyTotal: function bookingSearchPartyTotal(model) {
                                'use strict';

                                if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants)) {

                                    return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants);
                                }
                            }
                        }
                    }
                },
                bookingSearchFacilityTier: {
                    mapping: {
                        mapTo: 'data.booking-search-facility-tier'
                    }
                },
                bookingSearchResort: {
                    mapping: {
                        mapTo: 'data.booking-search-resort-onesource'
                    }
                },
                facetsUtilized: [{
                    name: {
                        mapping: {
                            mapTo: 'data.facets-utilized-name',
                            transformers: {
                                preProcess: function preProcess(model, parentModel, modelVal) {
                                    parentModel.data['facets-utilized-name'] = modelVal;
                                }
                            }
                        }
                    },
                    action: {
                        mapping: {
                            mapTo: 'data.facets-utilized-action',
                            transformers: {
                                preProcess: function preProcess(model, parentModel, modelVal) {
                                    parentModel.data['facets-utilized-action'] = modelVal;
                                }
                            }
                        }
                    }
                }],
                itineraryDay: {
                    mapping: {
                        mapTo: 'data.itinerary-day'
                    }
                },
                itineraryLength: {
                    mapping: {
                        mapTo: 'data.itinerary-length'
                    }
                },
                totalBookedLengthOfStayNights: {
                    mapping: {
                        mapTo: 'data.total-booked-length-of-stay-nights',
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                payment: {
                    type: {
                        mapping: {
                            mapTo: 'data.payment-type'
                        }
                    },
                    paymentAmount: {
                        mapping: {
                            mapTo: 'data.payment-amount'
                        }
                    },
                    totalPrice: {
                        mapping: {
                            mapTo: 'data.payment-total-price',
                            applyFilter: {
                                type: 'float'
                            }
                        }
                    },
                    paymentFrequency: {
                        mapping: {
                            mapTo: 'data.payment-frequency'
                        }
                    },
                    paymentMethods: {
                        creditCardName: {
                            mapping: {
                                mapTo: 'data.payment-methods-credit-card-name'
                            }
                        },
                        giftCardName: {
                            mapping: {
                                mapTo: 'data.payment-methods-gift-card-name'
                            }
                        },
                        rewardsCardName: {
                            mapping: {
                                mapTo: 'data.payment-methods-rewards-card-name'
                            }
                        },
                        pointsPaymentName: {
                            mapping: {
                                mapTo: 'data.payment-methods-points-payment-name'
                            }
                        },
                        instantCreditName: {
                            mapping: {
                                mapTo: 'data.payment-methods-instant-credit-name'
                            }
                        }
                    }
                },
                mediaType: {
                    mapping: {
                        mapTo: 'data.interactive-elements-media-type'
                    }
                },
                mediaId: {
                    mapping: {
                        mapTo: 'data.interactive-elements-media-id'
                    }
                },
                interactiveElements: [{
                    trackingType: {
                        mapping: {
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    mediaType: {
                        mapping: {
                            mapTo: 'data.interactive-elements-media-type'
                        }
                    },
                    mediaId: {
                        mapping: {
                            mapTo: 'data.interactive-elements-media-id'
                        }
                    },
                    linkId: {
                        mapping: {
                            mapTo: 'data.link-id',
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    linkIdSelectors: {
                        mapping: {
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    regionId: {
                        mapping: {}
                    },
                    trackingModel: {
                        mapping: {}
                    },
                    triggerEvents: [{
                        type: {
                            mapping: {}
                        },
                        elementSelectors: {
                            mapping: {}
                        },
                        onCompleteEventName: {
                            mapping: {}
                        }
                    }],
                    trackPromoImpressions: {
                        mapping: {
                            type: 'template',
                            template: 'false',
                            defaultValue: false,
                            transformers: {
                                /* will add items that are specified in the promoImpressions list*/
                                preProcess: function preProcess(model, parentModel) {
                                    var $ = WDPRO.Analytics.wdwQuery,
                                        P = WDPRO.Analytics.Parsers;
                                    if (P.toBoolean(model.trackPromoImpressions) && model.linkId) {
                                        //make sure the selector is an actual item on the page
                                        if ($(model.linkIdSelectors).length > 0 || Array.isArray(model.triggerEvents) && $(model.triggerEvents[0].elementSelectors).length > 0) {

                                            //save this information in the parentModel as trackPromoImpressions
                                            if (!parentModel.trackPromoImpressions) {
                                                parentModel.trackPromoImpressions = model.linkId;
                                            } else {
                                                parentModel.trackPromoImpressions += ',' + model.linkId;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    mapping: {
                        type: 'none',
                        applyFilter: {
                            forceArray: ''
                        }
                    }
                }],
                /*must be after interactiveElements since trackPromoImpressions will automatically add to this list*/
                promoImpressionsList: {
                    mapping: {
                        type: 'template',
                        template: '{{#promoImpressions}}{{promoImpressions}}{{/promoImpressions}}',
                        transformers: {
                            promoImpressions: function promoImpressions(model) {
                                // put what is in promoImpressionsList togther with what was potentially from the
                                // interactiveElements
                                if (model.promoImpressionsList && model.trackPromoImpressions) {
                                    model.promoImpressionsList += ',' + model.trackPromoImpressions;
                                } else if (model.trackPromoImpressions) {
                                    model.promoImpressionsList = model.trackPromoImpressions;
                                }
                                return model.promoImpressionsList;
                            }
                        },
                        mapTo: 'data.promo-impressions-list'
                    }
                },
                offerId: {
                    mapping: {
                        mapTo: 'data.offer-id'
                    }
                },
                offersShown: {
                    mapping: {
                        type: 'flex-array',
                        valuePrefix: 'SoList;',
                        targetDelimiter: ';',
                        mapTo: 'data.offer-shown'
                    }
                },
                socialInteractionType: {
                    mapping: {
                        applyFilter: {
                            replace: [[' ', '']]
                        },
                        mapTo: function mapTo(model) {
                            var eventNum = 'social-interaction';
                            if (!model.events) {
                                model.events = eventNum;
                            } else if (model.events.indexOf(eventNum) === -1) {
                                model.events += ',' + eventNum;
                            }

                            return 'data.social-interaction-type';
                        }
                    }
                },
                products: [{
                    orderType: {
                        mapping: {
                            mapTo: 'products-order-type'
                        }
                    },
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                resortVacation: 'res',
                                insurance: 'ins',
                                groundTransportation: 'auto',
                                airTransportation: 'air',
                                cruise: 'cruise',
                                fastPassPlus: 'gxa',
                                greatFoodFast: 'gxa',
                                dining: 'dine',
                                ticket: 'tix',
                                media: 'med',
                                enhancedExperience: 'eexp',
                                nonDisneyTicket: 'ndt',
                                preOrder: 'pre',
                                event: 'evt'
                            }
                        }
                    },
                    productId: {
                        mapping: {
                            mapTo: 'product-id'
                        }
                    },
                    prodType: {
                        mapping: {
                            mapTo: 'product-type',
                            type: 'template',
                            template: '{{#productType}}{{{productType}}}{{/productType}}'
                        }
                    },
                    facilityId: {
                        mapping: {
                            mapTo: 'products-facility-id'
                        }
                    },
                    facilityTier: {
                        mapping: {
                            mapTo: 'products-facility-tier'
                        }
                    },
                    packageType: {
                        mapping: {
                            mapTo: 'products-package-type'
                        }
                    },
                    roomTypeId: {
                        mapping: {
                            mapTo: 'products-room-type-id'
                        }
                    },
                    portId: {
                        mapping: {}
                    },
                    includedProducts: [{
                        applyFilter: {
                            removeElement: {
                                keys: ['type'],
                                values: ['diningPlan']
                            }
                        },
                        type: {
                            mapping: {
                                defaultValue: 'ticket'
                            }
                        },
                        id: {
                            mapping: {
                                mapTo: 'products-included-products-id'
                            }
                        },
                        price: {
                            mapping: {
                                mapTo: 'products-included-products-price',
                                applyFilter: {
                                    type: 'float'
                                }
                            }
                        },
                        quantity: {
                            mapping: {
                                mapTo: 'products-included-products-quantity',
                                applyFilter: {
                                    type: 'integer'
                                }
                            }
                        }
                    }],
                    dateReservationMade: {
                        mapping: {
                            mapTo: 'products-date-reservation-made',
                            applyFilter: {
                                date: 'YYYY-MM-DD'
                            }
                        }
                    },
                    bookingSearchDaysBetweenSearchAndArrival: {
                        mapping: {
                            mapTo: 'booking-search-days-between-search-and-arrival',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookingSearchLengthOfStayNights: {
                        mapping: {
                            mapTo: 'booking-search-length-of-stay-nights',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookingSearchArrivalDate: {
                        mapping: {
                            mapTo: 'booking-search-arrival-date',
                            applyFilter: {
                                date: 'YYYY-MM-DD'
                            }
                        }
                    },
                    bookingSearchDepartureDate: {
                        mapping: {
                            mapTo: 'booking-search-departure-date',
                            defaultValue: function defaultValue(model) {
                                if (model['booking-search-arrival-date'] && model['booking-search-length-of-stay-nights']) {
                                    return WDPRO.Analytics.moment(model['booking-search-arrival-date'], 'YYYY-MM-DD').add(model['booking-search-length-of-stay-nights'], 'd').format('YYYY-MM-DD');
                                }
                                return '';
                            }
                        }
                    },
                    bookingSearchAdults: {
                        mapping: {
                            defaultValue: '0',
                            mapTo: 'booking-search-adults'
                        }
                    },
                    bookingSearchChildren: {
                        mapping: {
                            defaultValue: '0',
                            mapTo: 'booking-search-children',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookingSearchInfants: {
                        mapping: {
                            mapTo: 'booking-search-infants',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookingSearchChildrenAges: {
                        mapping: {
                            mapTo: 'booking-search-children-ages'
                        }
                    },
                    bookedAdults: {
                        mapping: {
                            mapTo: 'products-booked-adults',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookedChildren: {
                        mapping: {
                            mapTo: 'products-booked-children',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookedChildrenAges: {
                        mapping: {
                            mapTo: 'products-booked-children-ages'
                        }
                    },
                    bookedInfants: {
                        mapping: {
                            mapTo: 'products-booked-infants',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookedArrivalDate: {
                        mapping: {
                            mapTo: 'products-booked-arrival-date',
                            applyFilter: {
                                date: 'YYYY-MM-DD'
                            }
                        }
                    },
                    bookedLengthOfStayNights: {
                        mapping: {
                            mapTo: 'products-booked-length-of-stay-nights',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    bookedDepartureDate: {
                        mapping: {
                            mapTo: 'products-booked-departure-date',
                            defaultValue: function defaultValue(model) {
                                var departDate;

                                if (model['products-booked-arrival-date'] && model['products-booked-length-of-stay-nights']) {

                                    departDate = WDPRO.Analytics.moment(model['products-booked-arrival-date']).add(model['products-booked-length-of-stay-nights'], 'd').format('YYYY-MM-DD');

                                    return departDate;
                                }
                                return '';
                            }
                        }
                    },
                    quantity: {
                        mapping: {
                            mapTo: 'products-quantity',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    price: {
                        total: {
                            mapping: {
                                mapTo: 'price-total',
                                applyFilter: {
                                    type: 'float'
                                }
                            }
                        },
                        subTotal: {
                            mapping: {
                                mapTo: 'price-subtotal',
                                applyFilter: {
                                    type: 'float'
                                }
                            }
                        },
                        tax: {
                            mapping: {
                                mapTo: 'price-tax',
                                applyFilter: {
                                    type: 'float'
                                }
                            }
                        },
                        shipping: {
                            mapping: {
                                mapTo: 'price-shipping',
                                applyFilter: {
                                    type: 'float'
                                }
                            }
                        }
                    },
                    confirmationNumber: {
                        mapping: {
                            mapTo: 'products-confirmation-number'
                        }
                    },
                    daysBetweenBookingAndArrival: {
                        mapping: {
                            mapTo: 'products-days-between-booking-and-arrival',
                            applyFilter: {
                                type: 'integer'
                            }
                        }
                    },
                    events: {
                        mapping: {
                            type: 'flex-array',
                            defaultValue: '1',
                            targetDelimiter: '|',
                            mapTo: {
                                cartAdd: 'cart-add',
                                cartRemove: 'cart-remove'
                            }
                        }
                    },
                    mapping: {
                        mapTo: 'products',
                        applyFilter: {
                            forceArray: ''
                        },
                        transformers: {
                            //used to perform preliminary transformations without setting
                            //a particular value to the model*/
                            preProcess: function preProcess(model) {
                                'use strict';

                                var ip, n;
                                //for now we only expect 1 item in the included products (tickets)
                                if (model.includedProducts && model.includedProducts.length > 0) {
                                    ip = model.includedProducts[0];
                                    for (n in ip) {
                                        if (ip.hasOwnProperty(n)) {
                                            model[n] = ip[n];
                                        }
                                    }
                                }
                            }
                        }
                    }
                }],
                productsCompared: [{
                    productName: {
                        mapping: {
                            mapTo: 'data.products-compared-product-name'
                        }
                    },
                    productId: {
                        mapping: {}
                    },
                    productsCompared: {
                        mapping: {
                            mapTo: 'data.products-compared-facility-id'
                        }
                    }
                }],
                productsDisplayed: [{
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                ticket: 'tix'
                            }
                        }
                    },
                    prodType: {
                        mapping: {
                            type: 'template',
                            template: '{{#productType}}{{{productType}}}{{/productType}}',
                            mapTo: 'data.products-displayed-product-type'
                        }
                    },
                    facilityId: {
                        mapping: {
                            mapTo: 'data.products-displayed-facility-id'
                        }
                    },
                    facilityTier: {
                        mapping: {
                            mapTo: 'data.products-displayed-facility-tier'
                        }
                    },
                    roomTypeId: {
                        mapping: {
                            mapTo: 'data.products-displayed-room-type-id'
                        }
                    },
                    isAvailable: {
                        mapping: {
                            mapTo: 'data.products-displayed-is-available'
                        }
                    },
                    productId: {
                        mapping: {
                            mapTo: 'data.products-displayed-product-id'
                        }
                    },
                    mapping: {
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                if (model.productType === 'prod') {
                                    if (parentModel.numAvailable === undefined) {
                                        parentModel.numAvailable = 0;
                                    }
                                    if (!parentModel.availableMatrix) {
                                        parentModel.availableMatrix = '';
                                    }
                                    if (model.isAvailable === true) {
                                        parentModel.numAvailable++;
                                        parentModel.availableMatrix += ';1';
                                    } else if (model.isAvailable === false) {
                                        parentModel.availableMatrix += ';0';
                                    } else {
                                        parentModel.availableMatrix += ';' + model.isAvailable;
                                    }
                                }
                            }
                        }
                    }
                }],
                carts: [{
                    id: {
                        mapping: {
                            mapTo: 'data.cart-id'
                        }
                    },
                    status: {
                        mapping: {
                            mapTo: 'data.cart-status'
                        }
                    }
                }],
                recommenderInfo: {
                    conversationId: {
                        mapping: {
                            mapTo: 'data.recommender-info-conversation-id'
                        }
                    },
                    messageId: {
                        mapping: {
                            mapTo: 'data.recommender-info-message-id'
                        }
                    }
                },
                compareVacationNumber: {
                    mapping: {
                        mapTo: 'data.compare-vacation-number'
                    }
                },
                currencyDisplayed: {
                    mapping: {
                        mapTo: 'data.currency-displayed'
                    }
                },
                server: {
                    mapping: {
                        mapTo: 'server'
                    }
                },
                currentEntitlements: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: ',',
                        mapTo: 'data.current-entitlements',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                },
                modificationType: {
                    mapping: {
                        mapTo: 'data.modification-event'
                    }
                },
                personalizations: [{
                    location: {
                        mapping: {
                            mapTo: 'location'
                        }
                    },
                    locationShortName: {
                        mapping: {
                            mapTo: 'locationShortName'
                        }
                    },
                    customerGroup: {
                        mapping: {
                            mapTo: 'engine'
                        }
                    },
                    selector: {
                        mapping: {
                            mapTo: 'selector'
                        }
                    },
                    // Used to bind even to element for click tracking
                    clickSelector: {
                        mapping: {
                            mapTo: 'clickSelector'
                        }
                    },
                    selectionSelector: {
                        mapping: {
                            mapTo: 'selectionSelector'
                        }
                    },
                    selectionOptionValueAttribute: {
                        mapping: {
                            mapTo: 'selectionOptionValueAttribute'
                        }
                    },
                    optionIdAttr: {
                        mapping: {
                            mapTo: 'optionIdAttr'
                        }
                    },
                    /***
                     * Setting this will override a linkId that is set using the name attribute method
                     **/
                    linkId: {
                        mapping: {
                            mapTo: 'linkId'
                        }
                    },
                    type: {
                        mapping: {
                            mapTo: 'type',
                            defaultValue: 'standard'
                        }
                    },
                    impressionType: {
                        mapping: {
                            mapTo: 'impressionType',
                            defaultValue: 'view'
                        }
                    },
                    impressionEvent: {
                        mapping: {
                            mapTo: 'impressionEvent'
                        }
                    },
                    impressionSelector: {
                        mapping: {
                            mapTo: 'impressionSelector'
                        }
                    },
                    additionalMBox: {
                        mapping: {
                            mapTo: 'additionalMBox'
                        }
                    },
                    // name of experience delivered
                    decision: {
                        mapping: {
                            mapTo: 'decision'
                        }
                    },
                    // identifier passed to SiteCatalyst for decision
                    optionId: {
                        mapping: {
                            mapTo: 'optionId'
                        }
                    },
                    options: [{
                        optionId: {
                            mapping: {
                                mapTo: 'optionId'
                            }
                        },
                        decision: {
                            mapping: {
                                mapTo: 'decision'
                            }
                        },
                        mapping: {
                            type: 'none',
                            applyFilter: {
                                forceArray: ''
                            }
                        }
                    }],
                    mapping: {
                        type: 'none',
                        applyFilter: {
                            forceArray: ''
                        }
                    }
                }],
                possibleAffiliation: {
                    mapping: {
                        mapTo: 'possibleAffiliation'
                    }
                },
                personalizationId: {
                    mapping: {
                        mapTo: 'personalizationId'
                    }
                },
                availableGuestMedia: {
                    mapping: {
                        mapTo: 'data.photopass-media-available',
                        applyFilter: {
                            type: 'string'
                        }
                    }
                }
            };
        }
        //the namespace will be automatically created if this product is supported (defined in the config.js)
    })(WDPRO.Analytics.Config.products.CEA);

    /*global WDPRO, setSiteCatalystAccountVar, s_wdpro */

    /*map SAM model to product
    http://wiki.wdpro.wdig.com/display/Tech/Analytics+Semantic+Model+v2.0*/

    //the namespace will be automatically created this product is supported (defined in the config.js)
    if (WDPRO.Analytics.Config.products.SiteCatalyst) {
        (function (SiteCatalyst) {
            var pageNameExport;
            SiteCatalyst.CALL_NUMBER_COUNTER = 0;

            SiteCatalyst.firstCall = true;
            SiteCatalyst.isOff = false;
            SiteCatalyst.trackElementList = {};
            SiteCatalyst.turnOff = function () {
                SiteCatalyst.isOff = true;
            };
            SiteCatalyst.turnOn = function () {
                SiteCatalyst.isOff = false;
            };

            Object.defineProperty(WDPRO.Analytics.Exports, 'pageName', {
                get: function get() {
                    return pageNameExport;
                }
            });

            SiteCatalyst.trackElement = function (event, model) {
                var interactiveElm,
                    dbg = WDPRO.Analytics.Debug;

                if (event) {
                    /*if we are dealing with an interactive element that was predefined.
                    See framework.SiteCatalyst.trackElement.preConfigured.test.js
                    */
                    if (SiteCatalyst.trackElementList[event]) {
                        interactiveElm = SiteCatalyst.trackElementList[event];
                        if (model) {
                            SiteCatalyst.helper.mergeInteractiveElements(interactiveElm, model);
                        }
                        model = interactiveElm.trackingModel || {};
                        model.trackingType = interactiveElm.trackingType;
                        model.linkId = interactiveElm.linkId;
                    }
                    if (model.trackingType === 'standardPage' || model.trackingType === 'customPage' || model.trackingType === 'page') {
                        SiteCatalyst.helper.trackPage(event, model);
                    } else if (model.trackingType === 'customLink' || model.trackingType === 'pic' || !model.trackingType) {
                        if (model.linkId) {
                            SiteCatalyst.helper.trackClick(event, model);
                        } else {
                            dbg.info('linkId property not set');
                        }
                    } else if (model.trackingType === 'standardLink') {
                        if (model.linkIdSelectors) {
                            SiteCatalyst.helper.createLinkId(event, model);
                        } else {
                            dbg.info('linkIdSelectors not set for SiteCatalyst trackElement (standardLink) : ', event, model);
                        }
                    }
                } else {
                    dbg.info('event parameter was not set for SiteCatalyst trackElement');
                }
            };

            SiteCatalyst.adapter = function (model) {
                'use strict';

                var Parsers = WDPRO.Analytics.Parsers,
                    Utils = WDPRO.Analytics.Utils,
                    addTriggerEventIfNeeded,
                    fireCustomLink,
                    fireStandardPage,
                    createInteractiveElementLinkId,
                    fireCustomPage,
                    interactiveElement,
                    openVideo,
                    playVideo,
                    pauseVideo,
                    endVideo,
                    closeVideo,
                    fireTrackVideo,
                    isVideoOpen,
                    openVideos = [],
                    bindCustomPage,
                    bindCustomLink,
                    bindTrackVideo,
                    bindElementExists,
                    setupCustomLink,
                    init,
                    applyCookieDomainRules,
                    helper = SiteCatalyst.helper;

                applyCookieDomainRules = function applyCookieDomainRules(rules) {
                    var i,
                        modelProp,
                        numRules = rules.length,
                        periods = model.cookieDomainPeriods,
                        rule,
                        ruleMatch = true;

                    for (i = 0; i < numRules; i++) {
                        rule = rules[i];
                        for (modelProp in rule.match) {
                            if (rule.match.hasOwnProperty(modelProp)) {
                                if (model[modelProp] && model[modelProp].toLowerCase() !== rule.match[modelProp].toLowerCase()) {
                                    ruleMatch = false;
                                    break;
                                }
                            }
                        }
                        if (ruleMatch && rule.periods) {
                            periods = rule.periods;
                            break;
                        }
                    }

                    model.cookieDomainPeriods = periods;
                };

                if (model.cookieDomainPeriodRules) {
                    applyCookieDomainRules(model.cookieDomainPeriodRules);
                }

                addTriggerEventIfNeeded = function addTriggerEventIfNeeded(interactiveElement) {
                    var identifier;
                    if (!interactiveElement.triggerEvents) {
                        identifier = interactiveElement.linkIdSelectors ? interactiveElement.linkIdSelectors : '#' + interactiveElement.linkId;
                        interactiveElement.triggerEvents = [{
                            type: 'click',
                            elementSelectors: identifier
                        }];
                    }
                    return interactiveElement;
                };

                //private functions
                fireStandardPage = function fireStandardPage(model) {
                    if (model && model.reportSuiteId) {
                        setSiteCatalystAccountVar(model.reportSuiteId, Parsers.toBoolean(model.appendReportSuiteIds));
                        window.s_wdpro = helper.filterModelForSiteCatalyst(model, s_wdpro);
                    }
                    if (window.s_account !== '') {
                        s_wdpro.t();
                        helper.siteCatalystCallCompleteEvent('standardPage', s_wdpro);
                    }
                };

                createInteractiveElementLinkId = function createInteractiveElementLinkId(interactiveElement) {
                    var elem,
                        identifier,
                        dbg = WDPRO.Analytics.Debug,
                        helper = SiteCatalyst.helper;
                    if (interactiveElement.linkId) {
                        identifier = interactiveElement.linkIdSelectors ? interactiveElement.linkIdSelectors : interactiveElement.linkId;
                        elem = WDPRO.Analytics.Framework.getElementByIdOrSelector(identifier);
                        if (!helper.doesLinkIdExist(WDPRO.Analytics.wdwQuery(elem))) {
                            WDPRO.Analytics.wdwQuery(elem).attr('name', '&lid=' + interactiveElement.linkId).bind('click', {
                                interactiveElement: interactiveElement
                            }, function (cEvent) {
                                dbg.log('STANDARD LINK TRIGGERED: ', cEvent.data.interactiveElement);
                                dbg.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
                                WDPRO.Analytics.Framework.flagDisableCustomLinks = true;
                            });
                        }
                    }
                };

                bindCustomPage = function bindCustomPage(triggerEvent, interactiveElement, model) {
                    var objAdditionalVariables,
                        dbg = WDPRO.Analytics.Debug;
                    WDPRO.Analytics.wdwQuery(triggerEvent.elementSelectors).bind(triggerEvent.type, {
                        interactiveElement: interactiveElement,
                        triggerEvent: triggerEvent
                    }, function (cEvent, updatedModel) {
                        var triggerEvent = cEvent.data.triggerEvent,
                            interactiveElement = cEvent.data.interactiveElement;
                        dbg.info('CUSTOM PAGE TRIGGERED: ', cEvent.data.triggerEvent.type);
                        if (Utils.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, triggerEvent.type) === -1) {
                            //extend function merges recursively two elements
                            helper.mergeInteractiveElements(interactiveElement, updatedModel);
                            if (interactiveElement.trackingModel) {
                                objAdditionalVariables = helper.getSiteCatalystModelFromInteractiveElement(interactiveElement, model);
                                s_wdpro.trackPage(interactiveElement.trackingModel.pageId, interactiveElement.linkId, this, objAdditionalVariables);
                                helper.siteCatalystCallCompleteEvent('customPage', objAdditionalVariables, triggerEvent.onCompleteEventName);
                            }
                        } else {
                            dbg.info('TRIGGERED EVENT DISABLED: ', triggerEvent.type);
                        }
                    });
                };

                fireCustomPage = function fireCustomPage(interactiveElement, model) {
                    var triggerEvent,
                        i = 0,
                        l;
                    if (interactiveElement) {
                        addTriggerEventIfNeeded(interactiveElement);
                        l = interactiveElement.triggerEvents.length;
                        for (i; i < l; i++) {
                            triggerEvent = interactiveElement.triggerEvents[i];
                            if (triggerEvent.type && triggerEvent.elementSelectors) {
                                bindCustomPage(triggerEvent, interactiveElement, model);
                            }
                        }
                    }
                };

                bindElementExists = function bindElementExists(interactiveElement, model) {
                    var triggerEvents = interactiveElement.triggerEvents,
                        numTriggerEvents = triggerEvents.length,
                        maxTries,
                        triggerEvent,
                        i;

                    for (i = 0; i < numTriggerEvents; i++) {
                        triggerEvent = triggerEvents[i];
                        maxTries = triggerEvent.pollMaxTries || 5;
                        if (triggerEvent.elementSelectors) {
                            WDPRO.Analytics.wdwQuery('body').delegate(triggerEvent.elementSelectors, 'onPage', {
                                interactiveElement: interactiveElement,
                                model: model
                            }, function (cData) {
                                fireCustomLink('onPage', cData.data.interactiveElement, cData.data.model);
                            });
                            WDPRO.Analytics.Utils.pollForElement(triggerEvent.elementSelectors, function (elm) {
                                WDPRO.Analytics.Framework.fireEvent(elm[0], 'onPage');
                            }, maxTries);
                        }
                    }
                };

                fireCustomLink = function fireCustomLink(triggerEvent, interactiveElement, updatedModel) {
                    var dbg = WDPRO.Analytics.Debug,
                        objAdditionalVariables;

                    dbg.info('CUSTOM LINK FIRED: ', interactiveElement);
                    if (WDPRO.Analytics.Framework.flagDisableCustomLinks === false) {
                        if (Utils.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, triggerEvent.type) === -1) {
                            //extend function merges recursively two elements
                            helper.mergeInteractiveElements(interactiveElement, updatedModel);
                            objAdditionalVariables = helper.getSiteCatalystModelFromInteractiveElement(interactiveElement, model);
                            s_wdpro.trackClick({}, interactiveElement.linkId, objAdditionalVariables);
                            helper.siteCatalystCallCompleteEvent('customLink', objAdditionalVariables, triggerEvent.onCompleteEventName);
                        } else {
                            dbg.info('TRIGGERED EVENT DISABLED: ', interactiveElement);
                        }
                    } else {
                        dbg.info('CUSTOM LINK EVENTS DISABLED BY STANDARD LINK CLICK: ', interactiveElement);
                    }
                };

                bindCustomLink = function bindCustomLink(triggerEvent, interactiveElement) {
                    WDPRO.Analytics.wdwQuery(triggerEvent.elementSelectors).bind(triggerEvent.type, {
                        interactiveElement: interactiveElement,
                        triggerEvent: triggerEvent
                    }, function (cEvent, updatedModel) {
                        var triggerEvent = cEvent.data.triggerEvent,
                            interactiveElement = cEvent.data.interactiveElement;
                        fireCustomLink(triggerEvent, interactiveElement, updatedModel);
                    });
                };

                setupCustomLink = function setupCustomLink(interactiveElement, model) {
                    var triggerEvent,
                        i = 0,
                        l;

                    if (interactiveElement) {
                        addTriggerEventIfNeeded(interactiveElement);
                        l = interactiveElement.triggerEvents.length;
                        for (i; i < l; i++) {
                            triggerEvent = interactiveElement.triggerEvents[i];
                            if (triggerEvent.type && triggerEvent.elementSelectors) {
                                bindCustomLink(triggerEvent, interactiveElement, model);
                            }
                        }
                    }
                };

                isVideoOpen = function isVideoOpen(mediaId) {
                    if (openVideos[mediaId]) {
                        if (openVideos[mediaId] === true) {
                            return true;
                        }
                    }
                    return false;
                };

                openVideo = function openVideo(interactiveElement) {
                    openVideos[interactiveElement.mediaId] = true;

                    if (interactiveElement.duration === null) {
                        interactiveElement.duration = 0;
                    }
                    s_wdpro.Media.open(interactiveElement.mediaType + ':' + interactiveElement.mediaId, interactiveElement.duration, 'Media Player');
                };

                playVideo = function playVideo(interactiveElement) {
                    if (isVideoOpen(interactiveElement.mediaId) === false) {
                        openVideo(interactiveElement);
                    }
                    s_wdpro.Media.play('vid:' + interactiveElement.mediaId, interactiveElement.currentTime);
                };

                pauseVideo = function pauseVideo(interactiveElement) {
                    s_wdpro.Media.stop('vid:' + interactiveElement.mediaId, interactiveElement.currentTime);
                };

                closeVideo = function closeVideo(interactiveElement) {
                    if (isVideoOpen(interactiveElement.mediaId)) {
                        s_wdpro.Media.stop('vid:' + interactiveElement.mediaId, interactiveElement.currentTime);
                        s_wdpro.Media.close('vid:' + interactiveElement.mediaId);
                        delete openVideos[interactiveElement.mediaId];
                    }
                };

                endVideo = function endVideo(interactiveElement) {
                    s_wdpro.Media.complete('vid:' + interactiveElement.mediaId, interactiveElement.currentTime);
                    s_wdpro.Media.close('vid:' + interactiveElement.mediaId);
                    delete openVideos[interactiveElement.mediaId];
                };

                bindTrackVideo = function bindTrackVideo(triggerEvent, interactiveElement) {
                    var events, event;
                    WDPRO.Analytics.wdwQuery(triggerEvent.elementSelectors).bind(triggerEvent.type, {
                        interactiveElement: interactiveElement,
                        triggerEvent: triggerEvent
                    }, function (cEvent, updatedModel) {
                        var triggerEvent = cEvent.data.triggerEvent,
                            interactiveElement = cEvent.data.interactiveElement,
                            i,
                            dbg = WDPRO.Analytics.Debug;
                        if (Utils.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, triggerEvent.type) === -1) {
                            helper.mergeInteractiveElements(interactiveElement, updatedModel);
                            if (updatedModel.trackingModel) {
                                if (updatedModel.mediaId && updatedModel.mediaType && updatedModel.duration !== undefined && updatedModel.currentTime !== undefined && updatedModel.trackingModel.events) {
                                    events = updatedModel.trackingModel.events.split(',');
                                    i = 0;
                                    for (i; i < events.length; i++) {
                                        event = events[i];
                                        switch (event) {
                                            case 'videoStart':
                                                playVideo(interactiveElement);
                                                break;
                                            case 'videoPause':
                                                pauseVideo(interactiveElement);
                                                break;
                                            case 'videoClose':
                                                closeVideo(interactiveElement);
                                                break;
                                            case 'videoEnd':
                                                endVideo(interactiveElement);
                                                break;
                                        }
                                    }
                                } else {
                                    dbg.info('Interactive Element is missing required properties. ' + 'The following properties are required:\n\tmediaId\n\tmediaType\n\tduration\n\t' + 'currentTime\n\ttrackingModel.events');
                                }
                            } else {
                                dbg.info('Interactive Element is missing trackingModel');
                            }
                        } else {
                            dbg.info('TRIGGERED EVENT DISABLED: ', triggerEvent.type);
                        }
                    });
                };

                /* Will make the specified calls to the s_code media plugin */
                fireTrackVideo = function fireTrackVideo(interactiveElement) {
                    var triggerEvent,
                        i = 0,
                        l;

                    if (interactiveElement) {
                        l = interactiveElement.triggerEvents.length;
                        for (i; i < l; i++) {
                            triggerEvent = interactiveElement.triggerEvents[i];
                            if (triggerEvent.type && triggerEvent.elementSelectors) {
                                bindTrackVideo(triggerEvent, interactiveElement);
                            }
                        }
                    }
                };

                init = function init() {
                    var i, l, it, lt, triggerEvent, inTrackElementList, parentModel;

                    /*fire a standard page only the first time & add click handler to anchors with linkId's */
                    if (SiteCatalyst.firstCall) {
                        pageNameExport = model.pageName;
                        /*
                         * We should not disable custom link tracking for javascript links or links within the same page.
                         */
                        WDPRO.Analytics.wdwQuery('a[name^="&lid="]').filter('[href]').not('a[href^="#"]').not('a[href*="javascript"]').bind('click', function () {
                            var dbg = WDPRO.Analytics.Debug;
                            dbg.log('PRESET STANDARD LINK TRIGGERED: ', WDPRO.Analytics.wdwQuery(this).attr('name'));
                            dbg.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
                            WDPRO.Analytics.Framework.flagDisableCustomLinks = true;
                        });
                        fireStandardPage(model);
                        SiteCatalyst.firstCall = false;
                    } else {
                        parentModel = WDPRO.Analytics.Framework.getParentModel();
                        if (model.siteSection === 'notset' && parentModel.siteSection) {
                            model.site = parentModel.site;
                            model.siteSection = parentModel.siteSection;
                            if (!model.storeType && parentModel.storeType) {
                                model.storeType = parentModel.storeType;
                            }
                        }
                    }

                    //determine the type of interactive elements we are dealing with
                    if (Array.isArray(model.interactiveElements)) {
                        l = model.interactiveElements.length;
                        if (l > 0) {
                            for (i = 0; i < l; i++) {
                                interactiveElement = model.interactiveElements[i];
                                if (interactiveElement) {

                                    /*determine if interactiveElement should go in the trackElementList
                                    this will allow it to be invoked directly using the trackElement function
                                    * */
                                    inTrackElementList = false;

                                    if (interactiveElement.triggerEvents && Array.isArray(interactiveElement.triggerEvents)) {
                                        it = 0;
                                        lt = interactiveElement.triggerEvents.length;

                                        for (it; it < lt; it++) {
                                            triggerEvent = interactiveElement.triggerEvents[it];

                                            if (!triggerEvent.elementSelectors && triggerEvent.type) {
                                                SiteCatalyst.trackElementList[triggerEvent.type] = interactiveElement;
                                                inTrackElementList = true;
                                            }
                                        }
                                    }

                                    if (!inTrackElementList) {

                                        switch (interactiveElement.trackingType) {
                                            case 'page':
                                            case 'customPage':
                                            case 'standardPage':
                                                fireCustomPage(interactiveElement, model);
                                                break;
                                            case 'pic':
                                            case 'customLink':
                                                setupCustomLink(interactiveElement, model);
                                                break;
                                            case 'standardLink':
                                                createInteractiveElementLinkId(interactiveElement);
                                                break;
                                            case 'vid':
                                            case 'video':
                                                if (interactiveElement.triggerEvents) {
                                                    fireTrackVideo(interactiveElement, model);
                                                }
                                                break;
                                            case 'elementExists':
                                                if (interactiveElement.triggerEvents) {
                                                    bindElementExists(interactiveElement, model);
                                                }
                                                break;
                                            default:
                                                /**
                                                 * any elements with a tracking model or trigger event that is not
                                                 * specifically a page tracking type will be treated as a customLink
                                                 */
                                                if (interactiveElement.trackingModel || interactiveElement.triggerEvents) {
                                                    setupCustomLink(interactiveElement, model);
                                                    /**
                                                     * element has a link id but no tracking model or trigger event
                                                     * is a standardLink
                                                     */
                                                } else if (interactiveElement.linkId) {
                                                    createInteractiveElementLinkId(interactiveElement);
                                                }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    WDPRO.Analytics.Framework.fireEvent(document, 'SiteCatalystAdapterComplete', model);
                };

                init();
            };
        })(WDPRO.Analytics.Config.products.SiteCatalyst);
    }

    /* global WDPRO, visitor, s_wdpro */

    if (WDPRO.Analytics.Config.products.SiteCatalyst && WDPRO.Analytics.Config.products.SiteCatalyst.adapter) {
        WDPRO.Analytics.Config.products.SiteCatalyst.helper = {
            doesLinkIdExist: function doesLinkIdExist(element) {
                var retVal = false;
                if (element.attr('name')) {
                    retVal = true;
                }
                return retVal;
            },
            trackClick: function trackClick(event, model) {
                var P = WDPRO.Analytics.Parsers,
                    S = WDPRO.Analytics.Config.products.SiteCatalyst,
                    U = WDPRO.Analytics.Utils,
                    siteCatalystModel,
                    dbg = WDPRO.Analytics.Debug;
                if (U.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, event) === -1) {
                    model = P.parseSemanticModel(model, S.mapping, true);
                    siteCatalystModel = this.filterModelForSiteCatalyst(model, {});
                    s_wdpro.trackClick({}, model.linkId, siteCatalystModel);
                    this.siteCatalystCallCompleteEvent('trackClick', siteCatalystModel);
                } else {
                    dbg.info('trackClick EVENT DISABLED: ', event, model);
                }
            },
            trackPage: function trackPage(event, model) {
                var P = WDPRO.Analytics.Parsers,
                    U = WDPRO.Analytics.Utils,
                    objAdditionalVariables,
                    dbg = WDPRO.Analytics.Debug;
                if (U.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, event) === -1) {
                    if (!P.isEmptyObject(model)) {
                        objAdditionalVariables = this.getSiteCatalystModelFromSemanticModel(model, WDPRO.Analytics.Framework.getParentModel());
                        if (!model.linkId) {
                            model.linkId = '';
                        }
                        s_wdpro.trackPage(model.pageId, model.linkId, {}, objAdditionalVariables);
                        this.siteCatalystCallCompleteEvent('trackPage', objAdditionalVariables);
                    }
                } else {
                    dbg.info('trackPage EVENT DISABLED: ', event, model);
                }
            },
            createLinkId: function createLinkId(event, model) {
                var elem,
                    identifier,
                    U = WDPRO.Analytics.Utils,
                    helper = WDPRO.Analytics.Config.products.SiteCatalyst.helper,
                    dbg = WDPRO.Analytics.Debug;

                if (U.Array.indexOf(WDPRO.Analytics.Framework.disabledEvents, event) === -1) {
                    if (model.linkId) {
                        identifier = model.linkIdSelectors ? model.linkIdSelectors : model.linkId;
                        elem = WDPRO.Analytics.Framework.getElementByIdOrSelector(identifier);
                        if (!helper.doesLinkIdExist(WDPRO.Analytics.wdwQuery(elem))) {
                            WDPRO.Analytics.wdwQuery(elem).attr('name', '&lid=' + model.linkId).bind('click', {
                                model: model
                            }, function (cEvent) {
                                dbg.log('STANDARD LINK TRIGGERED: ', cEvent.data.model);
                                dbg.log('CUSTOM LINK EVENTS HAVE NOW BEEN DISABLED');
                                WDPRO.Analytics.Framework.flagDisableCustomLinks = true;
                            });
                        }
                    }
                } else {
                    dbg.info('createLinkId EVENT DISABLED: ', event, model);
                }
            },
            filterModelForSiteCatalyst: function filterModelForSiteCatalyst(model, scVar) {
                var prop,
                    strFacetsUtilized,
                    strFacetsProgress,
                    cart,
                    cProp,
                    parts,
                    numParts,
                    i = 0,
                    mapPart;
                for (prop in model) {
                    if (model.hasOwnProperty(prop) && '' !== model[prop]) {
                        //only add relevant items into s_wdpro
                        if (prop.indexOf('prop') > -1 || prop.indexOf('eVar') > -1 || prop.indexOf('trackingServer') > -1 || prop === 'hier1' || prop === 'pageName' || prop === 'events' || prop === 'state' || prop === 'zip' || prop === 'purchaseID' || prop === 'formList' || prop === 'linkInternalFilters' || prop === 'linkExternalFilters' || prop === 'channelSep' || prop === 'cookieDomainPeriods' || prop === 'currencyCode' || prop === 'cookieLifetime' || prop === 'server' || prop === 'contextData') {

                            if (prop.indexOf('=') === -1) {
                                scVar[prop] = model[prop];
                            } else {
                                /* Lets Cut Down on duplicate mappings and use the D= method
                                 * See the following URL for additional details:
                                 * http://adobe.ly/1KiFK1R
                                 */
                                parts = prop.split('=');
                                numParts = parts.length;
                                mapPart = '';
                                i = 0;
                                for (i; i < numParts; i++) {
                                    if (i === 0) {
                                        mapPart = parts[i].replace('prop', 'c').replace('eVar', 'v');
                                        scVar[parts[i]] = model[prop];
                                    } else {
                                        scVar[parts[i]] = 'D=' + mapPart;
                                    }
                                }
                            }
                        } else if ('products' === prop && Array.isArray(model.products)) {
                            scVar.products = model.products.join(',');
                        } else if ('facetsUtilized' === prop && Array.isArray(model.facetsUtilized)) {
                            strFacetsUtilized = model.facetsUtilized.join(',');
                            scVar.eVar13 = strFacetsUtilized;
                            scVar.prop20 = strFacetsUtilized;
                        } else if ('facetsProgress' === prop && Array.isArray(model.facetsProgress)) {
                            strFacetsProgress = model.facetsProgress.join(',');
                            scVar.eVar14 = strFacetsProgress;
                        } else if ('carts' === prop && Array.isArray(model.carts)) {
                            //currently only 1 cart is supported so lets grab the first one
                            if (model.carts.length > 0) {
                                cart = model.carts[0];
                                //map any ever or prop in that model
                                for (cProp in cart) {
                                    if (cart.hasOwnProperty(cProp) && (-1 < cProp.indexOf('prop') || -1 < cProp.indexOf('eVar'))) {
                                        scVar[cProp] = cart[cProp];
                                    }
                                }
                            }
                        } else if ('productsCompared' === prop && Array.isArray(model.productsCompared)) {
                            scVar.prop41 = model.productsCompared.join(',');
                        } else if ('productsDisplayed' === prop && Array.isArray(model.productsDisplayed)) {
                            scVar.eVar50 = model.productsDisplayedEvent + ';' + model.productsDisplayed.join(';');
                        }
                    }
                }
                return scVar;
            },
            siteCatalystCallCompleteEvent: function siteCatalystCallCompleteEvent(trackingType, dataSent, onCompleteEventName) {
                var SiteCatalyst = WDPRO.Analytics.Config.products.SiteCatalyst;

                setTimeout(function () {
                    var dbg = WDPRO.Analytics.Debug,
                        eventObj = {
                        callNumber: ++SiteCatalyst.CALL_NUMBER_COUNTER,
                        trackingType: trackingType,
                        dataSent: dataSent,
                        visitorId: WDPRO.Analytics.Config.products.SiteCatalyst.helper.getVisitorId()
                    };

                    //trigger specific call back if specified
                    if (onCompleteEventName) {
                        WDPRO.Analytics.Framework.fireEvent(document, onCompleteEventName, eventObj);
                    }
                    //trigger general event
                    WDPRO.Analytics.Framework.fireEvent(document, 'siteCatalystCallComplete', eventObj);

                    dbg.info('SiteCatalyst Call Completed: ', eventObj);
                }, 500);
            },
            getVisitorId: function getVisitorId() {
                var result = null,
                    s_vi,
                    pattern,
                    aVisitorId,
                    dbg = WDPRO.Analytics.Debug;
                /**
                 * Both the Visitor API Service is present and an instance exists
                 */
                if (window.Visitor && window.visitor) {
                    result = visitor.getMarketingCloudVisitorID();
                } else {
                    s_vi = WDPRO.Analytics.Utils.getCookie('s_vi');
                    /***
                     * Legacy Support
                     */

                    // check if s_vi cookie is available before proceeding
                    if (s_vi !== null) {
                        if (s_vi.length !== 0) {
                            /**
                             * example of expected value which would match this pattern:
                             * "[CS]v1|2759601A85160D22-400001A660000CDD[CE]
                             */
                            pattern = /\[CS\]v1\|([A-Z0-9\-]+)\[CE\]/;

                            aVisitorId = pattern.exec(s_vi);
                            /**
                             * expecting 2 values:
                             * aVisitorId[0] = holds matched expression
                             * aVisitorId[1] = holds first back reference value which in this case would be the
                             * visitor id (i.e. 2759601A85160D22-400001A660000CDD)
                             */
                            if (aVisitorId.length === 2) {
                                result = aVisitorId[1].replace('-', '|'); //
                            }
                        }
                    }
                }
                dbg.info('get Visitor ID Call: ', result);
                return result;
            },
            resetArraysForMerge: function resetArraysForMerge(model, updatedModel) {
                var baseProp;
                if (model && updatedModel) {
                    for (baseProp in updatedModel) {
                        if (updatedModel.hasOwnProperty(baseProp)) {
                            if (Array.isArray(updatedModel[baseProp])) {
                                model[baseProp] = [];
                            }
                        }
                    }
                }
            },
            mergeInteractiveElements: function mergeInteractiveElements(interactiveElement, updatedModel) {
                //var P = WDPRO.Analytics.Parsers;

                if (interactiveElement && updatedModel) {
                    this.resetArraysForMerge(interactiveElement.trackingModel, updatedModel.trackingModel);
                    WDPRO.Analytics.wdwQuery.extend(true, interactiveElement, updatedModel);
                }
            },
            getSiteCatalystModelFromSemanticModel: function getSiteCatalystModelFromSemanticModel(updatedModel, model) {
                var parsedModel,
                    P = WDPRO.Analytics.Parsers,
                    S = WDPRO.Analytics.Config.products.SiteCatalyst;

                if (updatedModel.pageId || updatedModel.siteSection) {
                    //get some existing properties that may not have been set in the interactive element
                    parsedModel = P.mergeObjects(updatedModel, model, WDPRO.Analytics.Framework.mergeObjParams, false);
                } else {
                    parsedModel = model;
                }

                //convert the semantic model to a siteCatalyst model
                parsedModel = P.parseSemanticModel(parsedModel, S.mapping);
                return this.filterModelForSiteCatalyst(parsedModel, {});
            },
            getSiteCatalystModelFromInteractiveElement: function getSiteCatalystModelFromInteractiveElement(interactiveElement, model) {
                var siteCatalystModel = {},
                    SiteCatalyst = WDPRO.Analytics.Config.products.SiteCatalyst,
                    parsedModel,
                    P = WDPRO.Analytics.Parsers;

                /*mediaType and mediaId can be in the main interactiveElement object but it really is
                 part of the trackingModel. Let's add it there instead
                 */
                if (interactiveElement.mediaType) {
                    interactiveElement.trackingModel = interactiveElement.trackingModel || {};
                    interactiveElement.trackingModel.mediaType = interactiveElement.mediaType;
                }
                if (interactiveElement.mediaId) {
                    interactiveElement.trackingModel = interactiveElement.trackingModel || {};
                    interactiveElement.trackingModel.mediaId = interactiveElement.mediaId;
                }

                if (interactiveElement.trackingModel) {

                    if (interactiveElement.trackingModel.pageId || interactiveElement.trackingModel.siteSection) {
                        //get some existing properties that may not have been set in the interactive element
                        parsedModel = P.mergeObjects(interactiveElement.trackingModel, model, WDPRO.Analytics.Framework.mergeObjParams, false);
                    } else {
                        parsedModel = interactiveElement.trackingModel;
                    }

                    //convert the semantic model to a siteCatalyst model
                    parsedModel = P.parseSemanticModel(parsedModel, SiteCatalyst.mapping, true);
                    siteCatalystModel = this.filterModelForSiteCatalyst(parsedModel, {});
                }

                return siteCatalystModel;
            }
        };
    }

    /*global WDPRO, s_wdpro, unid*/

    /* map SAM model to product https://wiki.wdpro.wdig.com/display/Tech/Semantic+Analytics+Model+v2.0 */

    (function (SiteCatalyst) {
        function addTicketVisualIds(model, parentModel) {
            var MAX_VISUAL_IDS = 13,
                visualIds,
                numLeft;

            if (typeof model.visualId === 'string') {
                model.visualId = model.visualId.split(',');
            }

            parentModel.contextData = parentModel.contextData || {};
            parentModel.contextData.visualId = parentModel.contextData.visualId || '';

            visualIds = parentModel.contextData.visualId ? parentModel.contextData.visualId.split(',') : [];
            if (visualIds.length < MAX_VISUAL_IDS) {
                numLeft = MAX_VISUAL_IDS - visualIds.length;
                parentModel.contextData.visualId = visualIds.concat(model.visualId.slice(0, numLeft)).join(',');
            }
        }
        if (SiteCatalyst) {
            SiteCatalyst.mapping = {
                osVersion: {
                    mapping: {
                        mapTo: 'prop22'
                    }
                },
                configuration: {
                    contentLocale: {
                        mapping: {
                            defaultValue: 'us',
                            applyFilter: {
                                'case': 'lower'
                            }
                        }
                    },
                    contentLanguage: {
                        mapping: {
                            defaultValue: 'en',
                            applyFilter: {
                                'case': 'lower'
                            }
                        }
                    },
                    marketingRegion: {
                        mapping: {
                            applyFilter: {
                                'case': 'lower'
                            }
                        }
                    },
                    formsToTrack: {
                        mapping: {
                            mapTo: 'formList'
                        }
                    },
                    siteDomains: {
                        mapping: {
                            mapTo: 'linkInternalFilters'
                        }
                    },
                    externalSiteDomains: {
                        mapping: {
                            mapTo: 'linkExternalFilters'
                        }
                    },
                    SiteCatalyst: {
                        reportSuiteId: {
                            mapping: {
                                defaultValue: 'wdgwdprodev'
                            }
                        },
                        trackingServer: {
                            mapping: {
                                defaultValue: 'w88.go.com'
                            }
                        },
                        trackingServerSecure: {
                            mapping: {
                                defaultValue: 'sw88.go.com'
                            }
                        },
                        namespace: {
                            mapping: {
                                defaultValue: 'wdpro'
                            }
                        },
                        cookieDomainPeriods: {
                            mapping: {
                                defaultValue: '2'
                            }
                        },
                        cookieDomainPeriodRules: [{
                            match: {
                                mapping: {}
                            },
                            periods: {
                                mapping: {}
                            },
                            mapping: {
                                mapTo: 'cookieDomainPeriodRules'
                            }
                        }],
                        appendReportSuiteIds: {
                            mapping: {
                                defaultValue: 'true'
                            }
                        },
                        channelSeparator: {
                            mapping: {
                                mapTo: 'channelSep',
                                defaultValue: '/'
                            }
                        },
                        cookieLifetime: {
                            mapping: {
                                mapTo: 'cookieLifetime'
                            }
                        },
                        triggerTimeout: {
                            mapping: {
                                mapTo: 'triggerTimeout'
                            }
                        }
                    },
                    currency: {
                        mapping: {
                            mapTo: 'currencyCode',
                            defaultValue: 'USD'
                        }
                    }
                },
                localization: {
                    mapping: {
                        type: 'template',
                        mapTo: 'prop51',
                        template: '{{#marketingRegion}}{{{marketingRegion}}}|{{{contentLanguage}}}-{{{contentLocale}}}' + '{{/marketingRegion}}{{^marketingRegion}}{{{contentLocale}}}/{{{contentLanguage}}}' + '{{/marketingRegion}}'
                    }
                },
                site: {
                    mapping: {
                        mapTo: 'site,prop1=eVar10',
                        defaultValue: 'notset'
                    }
                },
                storeType: {
                    mapping: {
                        mapTo: 'storeType'
                    }
                },
                store: {
                    mapping: {
                        mapTo: 'eVar7'
                    }
                },
                trackingType: {
                    mapping: {
                        defaultValue: 'standardPage'
                    }
                },
                events: {
                    mapping: {
                        type: 'flex-array',
                        sourceDelimiter: ',',
                        targetDelimiter: ',', // a comma is the default but can support any character
                        mapTo: {
                            videoStart: 'event1',
                            assetStart: 'event1',
                            internalSearch: 'event2',
                            pageView: 'event3',
                            registration: 'event4',
                            internalSearchClick: 'event5',
                            internalAdClick: 'event7',
                            VPDOrder: 'event8',
                            purchaseWithPoints: 'event9',
                            cancellation: 'event10',
                            assetComplete: 'event11',
                            videoStop: 'event11',
                            reviewQuote: 'event12',
                            bookingSearch: 'event13',
                            cartProductAdd: 'event14,scAdd',
                            leadGenerated: 'event15',
                            ticketOrder: 'event16',
                            activityCancellation: 'event27',
                            activityModification: 'event28',
                            activityView: 'event105',
                            systemProductRemoval: 'event29',
                            quickQuoteSearch: 'event30',
                            checkoutDelivery: 'event31',
                            checkoutInsurance: 'event32',
                            checkoutApplyPayment: 'event33',
                            checkoutReviewQuote: 'event34',
                            benchListViewed: 'event35',
                            mapCustomization: 'event36',
                            recommendationSeen: 'event37',
                            recommendationSaved: 'event38',
                            activityBooking: 'event39',
                            productView: 'event42,prodView',
                            prodView: 'event42,prodView',
                            checkoutGuestInfo: 'event46',
                            guestInfoSubmit: 'event46',
                            selfServiceInitiated: 'event48',
                            selfServiceCompleted: 'event49',
                            mediaDownloads: 'event53',
                            loggedIn: 'event58',
                            postCheckoutPayment: 'event59',
                            failedProduct: 'event60',
                            cartCreate: 'event61',
                            compareVacationModify: 'event62',
                            checkoutExpressCheckout: 'event66',
                            modificationEvent: 'event67',
                            posModRevenueEvent: 'event68',
                            negModRevenueEvent: 'event69',
                            posModNightsEvent: 'event70',
                            negModNightsEvent: 'event71',
                            personalizationClick: 'event72',
                            scCheckout: 'scCheckout',
                            checkout: 'scCheckout',
                            cartView: 'scView',
                            cartProductRemove: 'scRemove',
                            purchase: 'purchase'
                        }
                    }
                },
                claimContext: {
                    mapping: {}
                },
                siteSection: {
                    mapping: {
                        defaultValue: 'notset',
                        allowTokens: true,
                        applyFilter: {
                            'case': 'lower',
                            replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}\/]', '']]
                        }
                    }
                },
                hierarchy: {
                    mapping: {
                        type: 'template',
                        reprocessOnUpdate: true,
                        template: '{{#namespace}}' + '{{{namespace}}}/{{{lcSite}}}/{{#marketingRegion}}' + '{{{marketingRegion}}}{{/marketingRegion}}' + '{{^marketingRegion}}{{{contentLocale}}}' + '{{/marketingRegion}}/{{{contentLanguage}}}/' + '{{{siteSection}}}{{/namespace}}',
                        transformers: {
                            lcSite: function lcSite(model) {
                                'use strict';

                                if (model.site) {
                                    return model.site.toLowerCase();
                                }
                            }
                        },
                        mapTo: 'hierarchy,hier1'
                    }
                },
                pageId: {
                    mapping: {
                        type: 'template',
                        template: '{{#hierarchy}}{{{hierarchy}}}/{{{pageId}}}{{/hierarchy}}',
                        mapTo: 'pageName',
                        defaultValue: 'notset',
                        applyFilter: {
                            type: 'string',
                            'case': 'lower',
                            replace: [['[^a-zA-Z0-9]', '']]
                        }
                    }
                },
                pageVariant: {
                    mapping: {
                        mapTo: 'prop56'
                    }
                },
                toggleStatus: {
                    mapping: {
                        type: 'template',
                        mapTo: 'toggles',
                        template: '{{#toggleStatus}}' + '{{#ft}},{{{ft}}}{{/ft}}' + '{{#rt}},{{{rt}}}{{/rt}}' + '{{#flt}},{{{flt}}}{{/flt}}{{/toggleStatus}}',
                        transformers: {
                            ft: function ft(model) {
                                var toggles = [],
                                    toggle,
                                    featureToggles;
                                if (model.toggleStatus && model.toggleStatus.featureToggles) {
                                    featureToggles = model.toggleStatus.featureToggles;
                                    for (toggle in featureToggles) {
                                        if (featureToggles.hasOwnProperty(toggle)) {
                                            toggles.push('ft;' + toggle + ':' + featureToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            },
                            rt: function rt(model) {
                                var toggles = [],
                                    toggle,
                                    releaseToggles;
                                if (model.toggleStatus && model.toggleStatus.releaseToggles) {
                                    releaseToggles = model.toggleStatus.releaseToggles;
                                    for (toggle in releaseToggles) {
                                        if (releaseToggles.hasOwnProperty(toggle)) {
                                            toggles.push('rt;' + toggle + ':' + releaseToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            },
                            flt: function flt(model) {
                                var toggles = [],
                                    toggle,
                                    flowToggles;
                                if (model.toggleStatus && model.toggleStatus.flowToggles) {
                                    flowToggles = model.toggleStatus.flowToggles;
                                    for (toggle in flowToggles) {
                                        if (flowToggles.hasOwnProperty(toggle)) {
                                            toggles.push('flt;' + toggle + ':' + flowToggles[toggle]);
                                        }
                                    }
                                }

                                return toggles.join(',');
                            }
                        }
                    }
                },
                contentDisplayed: {
                    mapping: {
                        type: 'template',
                        template: '{{{contentDisplayed}}}{{#toggles}}{{{toggles}}}{{/toggles}}',
                        mapTo: 'prop19=eVar24'
                    }
                },
                elementAnalyticsId: {
                    mapping: {
                        mapTo: 'prop9'
                    }
                },
                leadType: {
                    mapping: {
                        mapTo: 'eVar23'
                    }
                },
                errorCodes: {
                    mapping: {
                        mapTo: 'prop26=prop27=eVar22',
                        applyFilter: {
                            unique: ',',
                            replace: [[' ', '']]
                        }
                    }
                },
                linkId: {
                    mapping: {
                        mapTo: 'linkId,prop9'
                    }
                },
                regionId: {
                    mapping: {
                        mapTo: 'objectID'
                    }
                },
                registrationTemplateId: {
                    mapping: {
                        mapTo: 'eVar40'
                    }
                },
                siteType: {
                    mapping: {
                        mapTo: 'prop32'
                    }
                },
                customerId: {
                    mapping: {
                        mapTo: 'prop2,customerId',
                        defaultValue: 'D=SWID'
                    }
                },
                guestType: {
                    mapping: {
                        mapTo: 'guestType'
                    }
                },
                experienceId: {
                    mapping: {
                        type: 'template',
                        template: '{{#experienceId}}{{{guestType}}}:{{{experienceId}}}:{{{customerId}}}{{/experienceId }}',
                        mapTo: 'prop4'
                    }
                },
                partnerId: {
                    type: {
                        mapping: {}
                    },
                    id: {
                        mapping: {}
                    },
                    instance: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: function template(model) {
                            if (model.type || model.id || model.instance) {
                                return '{{{type}}};{{{id}}};{{{instance}}}';
                            }
                            return '';
                        },
                        mapTo: 'eVar52',
                        transformers: {
                            preProcess: function preProcess(model) {
                                if (model.storeType && model.storeType.toLowerCase().indexOf('travelagent') > -1) {
                                    model.eVar6 = model.id;
                                }
                            }
                        }
                    }
                },
                DTALoginId: {
                    mapping: {
                        mapTo: 'eVar6'
                    }
                },
                alternateAggregation: {
                    mapping: {
                        mapTo: 'prop49'
                    }
                },
                selfServiceType: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: '|',
                        mapTo: 'eVar51'
                    }
                },
                memberNumber: {
                    mapping: {
                        mapTo: 'prop25'
                    }
                },
                registrationStatus: {
                    mapping: {
                        mapTo: 'prop29'
                    }
                },
                homeState: {
                    mapping: {
                        mapTo: 'state'
                    }
                },
                homeCity: {
                    mapping: {
                        mapTo: 'eVar29'
                    }
                },
                homeZip: {
                    mapping: {
                        mapTo: 'zip'
                    }
                },
                departureCity: {
                    mapping: {
                        mapTo: 'eVar30'
                    }
                },
                guestLifeStage: {
                    mapping: {
                        mapTo: 'prop30'
                    }
                },
                guestAffiliations: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: ',',
                        mapTo: 'prop14=eVar59',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                },
                affiliationsAvailable: {
                    mapping: {
                        mapTo: 'prop13',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                },
                internalSearchKeywords: {
                    mapping: {
                        mapTo: 'prop7'
                    }
                },
                internalSearchNumResults: {
                    mapping: {
                        mapTo: 'prop8'
                    }
                },
                internalSearchType: {
                    mapping: {
                        mapTo: 'eVar5'
                    }
                },
                bookingSearchNumResults: {
                    mapping: {
                        mapTo: 'eVar35'
                    }
                },
                bookingSearchDaysBetweenSearchAndArrival: {
                    mapping: {
                        mapTo: 'prop15=eVar31'
                    }
                },
                bookingSearchArrivalDate: {
                    mapping: {
                        mapTo: 'prop16=eVar32'
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'prop17=eVar33'
                    }
                },
                bookingSearchAdults: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchChildren: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchInfants: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchSeniors: {
                    mapping: {
                        defaultValue: '0',
                        reprocessOnUpdate: true
                    }
                },
                bookingSearchPartySize: {
                    mapping: {
                        mapTo: 'prop18=eVar34'
                    }
                },
                bookingSearchParty: {
                    mapping: {
                        type: 'template',
                        reprocessOnUpdate: true,
                        template: '{{#bookingSearchPartyTotal}}' + '{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}' + 'C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
                        mapTo: 'prop18=eVar34',
                        transformers: {
                            bookingSearchPartyTotal: function bookingSearchPartyTotal(model) {
                                'use strict';

                                if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {

                                    return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                                }
                            }
                        }
                    }
                },
                bookingSearchResort: {
                    mapping: {
                        mapTo: 'prop11'
                    }
                },
                bookingSearchDeparturePort: {
                    mapping: {}
                },
                bookingSearchShip: {
                    mapping: {
                        type: 'template',
                        template: '{{#bookingSearchDeparturePort}}' + '{{{bookingSearchDeparturePort}}}:' + '{{{bookingSearchShip}}}{{/bookingSearchDeparturePort}}',
                        mapTo: 'prop11'
                    }
                },
                facetsUtilized: [{
                    name: {
                        mapping: {}
                    },
                    action: {
                        mapping: {
                            defaultValue: 'Add'
                        }
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#name}}{{{action}}}:{{{name}}}{{/name}}'
                    }
                }],
                facetsProgress: [{
                    name: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#name}}{{{name}}}{{/name}}'
                    }
                }],
                orderId: {
                    mapping: {
                        mapTo: 'purchaseID'
                    }
                },
                itineraryDay: {
                    mapping: {}
                },
                itineraryLength: {
                    mapping: {
                        type: 'template',
                        template: '{{#itineraryDay}}{{{itineraryDay}}}:{{{itineraryLength}}}{{/itineraryDay}}',
                        mapTo: 'prop34=eVar58'
                    }
                },
                totalBookedLengthOfStayNights: {
                    mapping: {}
                },
                pointsSpent: {
                    mapping: {
                        mapTo: 'eVar42'
                    }
                },
                pointsBudget: {
                    mapping: {
                        mapTo: 'eVar43'
                    }
                },
                carts: [{
                    friendlyId: {
                        mapping: {}
                    },
                    id: {
                        mapping: {
                            type: 'template',
                            mapTo: 'eVar47',
                            template: '{{#id}}{{{id}}}:{{{friendlyId}}}{{/id}}'
                        }
                    },
                    age: {
                        mapping: {}
                    },
                    status: {
                        mapping: {}
                    },

                    changeType: {
                        mapping: {}
                    },
                    isGift: {
                        mapping: {
                            transformers: {
                                preProcess: function preProcess(model, parentModel, val) {
                                    var P = WDPRO.Analytics.Parsers,
                                        gift = '';

                                    if (P.toBoolean(val)) {
                                        gift = 'Gift';
                                    }

                                    parentModel.gift = gift;
                                }
                            }
                        }
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#age}}{{{age}}}{{/age}}:{{#status}}{{{status}}}{{/status}}:{{#changeType}}{{{changeType}}}{{/changeType}}',
                        mapTo: 'eVar45'
                    }
                }],
                payment: {
                    type: {
                        mapping: {}
                    },
                    paymentAmount: {
                        mapping: {}
                    },
                    totalPrice: {
                        mapping: {}
                    },
                    paymentFrequency: {
                        mapping: {}
                    },
                    paymentMethods: [{
                        type: {
                            mapping: {}
                        },
                        name: {
                            mapping: {}
                        },
                        status: {
                            mapping: {}
                        },
                        mapping: {
                            transformers: {
                                preProcess: function preProcess(model, parentModel) {
                                    if (parentModel) {
                                        parentModel.paymentInfo = parentModel.paymentInfo || {};
                                        parentModel.paymentInfo[model.type] = {
                                            name: model.name,
                                            status: model.status || 'unknown'
                                        };
                                    }
                                }
                            }
                        }
                    }],
                    mapping: {
                        type: 'template',
                        template: function template(model) {
                            if (model.type || model.paymentAmount || model.totalPrice || model.gift) {
                                return '{{type}}:{{paymentAmount}}:{{totalPrice}}:{{pctPaid}}:{{gift}}';
                            }
                            return '';
                        },
                        mapTo: 'prop54',
                        transformers: {
                            pctPaid: function pctPaid(model) {
                                if (model.paymentAmount && model.totalPrice) {
                                    return (model.paymentAmount / model.totalPrice).toFixed(2);
                                }
                                return '';
                            }
                        }
                    }
                },
                paymentInfo: {
                    mapping: {
                        type: 'template',
                        template: '{{#paymentInfo}}' + '{{#creditCard.name}}{{{creditCard.name}}}_' + '{{#creditCard.status}}{{{creditCard.status}}}{{/creditCard.status}}' + '{{/creditCard.name}}:{{#giftCard.name}}{{{giftCard.name}}}_' + '{{#giftCard.status}}{{{giftCard.status}}}{{/giftCard.status}}' + '{{/giftCard.name}}:{{#rewardsCard.name}}{{{rewardsCard.name}}}_' + '{{#rewardsCard.status}}{{{rewardsCard.status}}}{{/rewardsCard.status}}' + '{{/rewardsCard.name}}:{{#pointsPayment.name}}{{{pointsPayment.name}}}_' + '{{#pointsPayment.status}}{{{pointsPayment.status}}}{{/pointsPayment.status}}' + '{{/pointsPayment.name}}:{{#instantCredit.name}}{{{instantCredit.name}}}_' + '{{#instantCredit.status}}{{{instantCredit.status}}}{{/instantCredit.status}}' + '{{/instantCredit.name}}' + '{{/paymentInfo}}',
                        mapTo: 'paymentInfo'
                    }
                },
                personalizations: [{
                    locationShortName: { mapping: { mapTo: 'locationShortName' } },
                    // decision engine that was used to choose experience
                    customerGroup: { mapping: { mapTo: 'customerGroup' } },
                    optionId: { mapping: { mapTo: 'optionId' } },
                    options: [{
                        optionId: {
                            mapping: {
                                mapTo: 'multiOptionId'
                            }
                        },
                        mapping: {
                            type: 'template',
                            targetDelimiter: ',',
                            mapTo: 'options',
                            rollUp: true,
                            template: '{{{multiOptionId}}}'
                        }
                    }],
                    mapping: {
                        type: 'template',
                        targetDelimiter: ';',
                        mapTo: 'prop60',
                        rollUp: true,
                        applyFilter: {
                            forceArray: ''
                        },
                        template: '{{#locationShortName}}{{#customerGroup}}' + '{{{customerGroup}}}:{{{locationShortName}}}:' + '{{#optionId}}{{{optionId}}}{{/optionId}}' + '{{#options}}{{{options}}}{{/options}}' + '{{/customerGroup}}{{/locationShortName}}',
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                var group, prop;
                                if (!parentModel.personalizationGroup) {
                                    prop = WDPRO.Analytics.Config.products.SiteCatalyst.mapping.personalizationGroup.mapping.mapTo;
                                    if (!parentModel.personalizationGroup && model.customerGroup === 'c') {
                                        group = 'Control';
                                    } else if (!parentModel.personalizationGroup) {
                                        group = 'Personalized';
                                    }
                                    parentModel.personalizationGroup = group;
                                    parentModel[prop] = group;
                                }
                            }
                        }
                    }
                }],
                vpcSegment: { mapping: { mapTo: 'eVar71' } },
                personalizationGroup: { mapping: { mapTo: 'prop61' } },
                personalizationClick: {
                    locationShortName: { mapping: { mapTo: 'locationShortName' } },
                    // decision engine that was used to choose experience
                    customerGroup: { mapping: { mapTo: 'customerGroup' } },
                    optionId: { mapping: { mapTo: 'optionId' } },
                    options: [{
                        optionId: {
                            mapping: {
                                mapTo: 'multiOptionId'
                            }
                        },
                        mapping: {
                            type: 'template',
                            targetDelimiter: ',',
                            mapTo: 'options',
                            rollUp: true,
                            template: '{{{multiOptionId}}}'
                        }
                    }],
                    mapping: {
                        type: 'template',
                        targetDelimiter: ';',
                        mapTo: 'prop62,eVar70',
                        rollUp: true,
                        template: '{{#locationShortName}}{{{customerGroup}}}:{{{locationShortName}}}:' + '{{#optionId}}{{{optionId}}}{{/optionId}}' + '{{#options}}{{{options}}}{{/options}}' + '{{/locationShortName}}'
                    }
                },
                interactiveElements: [{
                    trackingType: {
                        mapping: {
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    mediaType: {
                        mapping: {}
                    },
                    mediaId: {
                        mapping: {}
                    },
                    linkId: {
                        mapping: {
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    linkIdSelectors: {
                        mapping: {
                            applyFilter: {
                                replace: [['^\\s*\"*\\s*|\\s*\"*\\s*$', '']]
                            }
                        }
                    },
                    regionId: {
                        mapping: {}
                    },
                    trackingModel: {
                        mapping: {}
                    },
                    triggerEvents: [{
                        type: {
                            mapping: {}
                        },
                        elementSelectors: {
                            mapping: {}
                        },
                        onCompleteEventName: {
                            mapping: {}
                        }
                    }],
                    trackPromoImpressions: {
                        mapping: {
                            type: 'template',
                            template: 'false',
                            defaultValue: false,
                            transformers: {
                                /* will add items that are specified in the promoImpressions list*/
                                preProcess: function preProcess(model, parentModel) {
                                    var $ = WDPRO.Analytics.wdwQuery,
                                        P = WDPRO.Analytics.Parsers;
                                    if (P.toBoolean(model.trackPromoImpressions) && model.linkId) {
                                        //make sure the selector is an actual item on the page
                                        if ($(model.linkIdSelectors).length > 0 || Array.isArray(model.triggerEvents) && $(model.triggerEvents[0].elementSelectors).length > 0) {

                                            //save this information in the parentModel as trackPromoImpressions
                                            if (!parentModel.trackPromoImpressions) {
                                                parentModel.trackPromoImpressions = model.linkId;
                                            } else {
                                                parentModel.trackPromoImpressions += ',' + model.linkId;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    mapping: {
                        type: 'none',
                        applyFilter: {
                            forceArray: ''
                        }
                    }
                }],
                /*must be after interactiveElements since trackPromoImpressions will automatically add to this list*/
                promoImpressionsList: {
                    mapping: {
                        type: 'template',
                        template: '{{#promoImpressions}}{{promoImpressions}}{{/promoImpressions}}',
                        transformers: {
                            promoImpressions: function promoImpressions(model) {
                                // put what is in promoImpressionsList togther with what was potentially from the
                                // interactiveElements
                                if (model.promoImpressionsList && model.trackPromoImpressions) {
                                    model.promoImpressionsList += ',' + model.trackPromoImpressions;
                                } else if (model.trackPromoImpressions) {
                                    model.promoImpressionsList = model.trackPromoImpressions;
                                }
                                return model.promoImpressionsList;
                            }
                        },
                        mapTo: 'eVar9'
                    }
                },
                mediaType: {
                    mapping: {}
                },
                mediaId: {
                    mapping: {
                        type: 'template',
                        template: '{{#mediaId}}{{{mediaType}}}:{{{mediaId}}}{{/mediaId}}',
                        mapTo: 'prop3=eVar2'
                    }
                },
                mediaViewed: {
                    id: {
                        mapping: {
                            mapTo: 'mv.id',
                            transformers: {
                                preProcess: function preProcess(model, parent, val) {
                                    var e1, e2;

                                    if (val) {
                                        e1 = 'event100:' + val;
                                        e2 = 'event101';
                                        switch (typeof model.events) {
                                            case 'string':
                                                model.events += (model.events ? ',' : '') + e1 + ',' + e2;
                                                break;
                                            case 'object':
                                                model.events.push(e1, e2);
                                                break;
                                            case 'undefined':
                                                model.events = e1 + ',' + e2;
                                                break;
                                        }
                                    }
                                }
                            }
                        }
                    },
                    type: {
                        mapping: {
                            mapTo: 'mv.type'
                        }
                    },
                    captureDateTime: {
                        mapping: {
                            mapTo: 'captureDateTime',
                            transformers: {
                                preProcess: function preProcess(model, parentModel, val) {
                                    var m;
                                    if (val) {
                                        m = WDPRO.Analytics.moment.utc(val);
                                        model.mv = model.mv || {};
                                        model.mv.captureDate = m.format('YYYY/MM/DD');
                                        model.mv.captureTime = m.format('h:mmA');
                                        model.mv.viewWindow = WDPRO.Analytics.moment().diff(m, 'days');
                                    }
                                }
                            }
                        }
                    },
                    campus: {
                        mapping: {
                            mapTo: 'mv.campus'
                        }
                    },
                    venue: {
                        mapping: {
                            mapTo: 'mv.venue',
                            applyFilter: {
                                case: 'title',
                                replace: [[' ', '']]
                            }
                        }
                    },
                    location: {
                        mapping: {
                            mapTo: 'mv.location',
                            applyFilter: {
                                case: 'title',
                                replace: [[' ', '']]
                            }
                        }
                    },
                    subjects: {
                        mapping: {
                            defaultValue: 'Guest',
                            type: 'flex-array',
                            mapTo: 'mv.subjects',
                            applyFilter: {
                                case: 'title'
                            }
                        }
                    },
                    mapping: {
                        type: 'template',
                        mapTo: 'eVar74',
                        template: '{{#mv.captureDate}}{{{mv.captureDate}}};{{{mv.captureTime}}};{{{mv.viewWindow}}};' + '{{{mv.campus}}};{{{mv.venue}}};{{{mv.location}}};{{mv.subjects}}{{/mv.captureDate}}'
                    }
                },
                offerId: {
                    mapping: {
                        mapTo: 'eVar49,offerId'
                    }
                },
                offersShown: {
                    mapping: {
                        type: 'flex-array',
                        valuePrefix: 'SoList;',
                        targetDelimiter: ';',
                        mapTo: 'eVar53'
                    }
                },
                socialInteractionType: {
                    mapping: {
                        applyFilter: {
                            replace: [[' ', '']]
                        },
                        mapTo: function mapTo(model) {
                            //make sure event6 is set and eVar60 contains the value set in socialInteractionType
                            var eventNum = 'event6';
                            if (!model.events) {
                                model.events = eventNum;
                            } else if (model.events.indexOf(eventNum) === -1) {
                                model.events += ',' + eventNum;
                            }

                            //now return eVar60 so that the value is mapped to it
                            return 'eVar60';
                        }
                    }
                },
                products: [{
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                resortVacation: 'res',
                                insurance: 'ins',
                                groundTransportation: 'auto',
                                airTransportation: 'air',
                                cruise: 'prod',
                                fastPassPlus: 'gxa',
                                greatFoodFast: 'gxa',
                                dining: 'dine',
                                ticket: 'tix',
                                datedTicket: 'dtx',
                                annualPass: 'tix',
                                media: 'med',
                                enhancedExperience: 'eexp',
                                nonDisneyTicket: 'ndt',
                                preOrder: 'pre',
                                event: 'evt',
                                merchandise: 'merch'
                            }
                        }
                    },
                    productId: {
                        mapping: {
                            mapTo: function mapTo(model) {
                                'use strict';

                                var result = 'productId';
                                if (model.productType === 'tix' || model.productType === 'med' || model.productType === 'ndt' || model.productType === 'dtx') {
                                    return 'ticketId';
                                }
                                return result;
                            }
                        }
                    },
                    facilityId: {
                        mapping: {}
                    },
                    packageType: {
                        mapping: {}
                    },
                    roomTypeId: {
                        mapping: {}
                    },
                    portId: {
                        mapping: {}
                    },
                    includedProducts: [{
                        type: {
                            defaultValue: 'ticket'
                        },
                        id: {
                            mapping: {
                                mapTo: 'ticketId'
                            }
                        },
                        price: {
                            mapping: {
                                mapTo: 'event17'
                            }
                        },
                        quantity: {
                            mapping: {
                                mapTo: 'event18'
                            }
                        },
                        mapping: {
                            mapTo: 'includedProducts',
                            applyFilter: {
                                removeElement: {
                                    keys: ['type'],
                                    values: ['diningPlan']
                                }
                            }
                        }
                    }],
                    bookingSearchDaysBetweenSearchAndArrival: {
                        mapping: {
                            mapTo: 'parentVars.eVar31,parentVars.prop15'
                        }
                    },
                    bookingSearchArrivalDate: {
                        mapping: {
                            mapTo: function mapTo(model) {
                                if (model.productType !== 'dtx' && model.productType !== 'eexp') {
                                    return 'parentVars.eVar32,parentVars.prop16';
                                } else {
                                    return 'bookingSearchArrivalDate';
                                }
                            }
                        }
                    },
                    bookingSearchLengthOfStayNights: {
                        mapping: {
                            mapTo: 'parentVars.eVar33,parentVars.prop17'
                        }
                    },
                    bookingSearchAdults: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookingSearchChildren: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookingSearchInfants: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookingSearchSeniors: {
                        mapping: {
                            defaultValue: '0',
                            reprocessOnUpdate: true
                        }
                    },
                    bookingSearchParty: {
                        mapping: {
                            type: 'template',
                            template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:' + '{{{bookingSearchAdults}}}A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
                            mapTo: 'parentVars.eVar34',
                            transformers: {
                                bookingSearchPartyTotal: function bookingSearchPartyTotal(model) {
                                    'use strict';

                                    if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {

                                        return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                                    }
                                }
                            }
                        }
                    },
                    bookedAdults: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookedChildren: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookedInfants: {
                        mapping: {
                            defaultValue: '0'
                        }
                    },
                    bookedSeniors: {
                        mapping: {
                            defaultValue: '0',
                            reprocessOnUpdate: true
                        }
                    },
                    bookedParty: {
                        mapping: {
                            type: 'template',
                            template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}' + 'A:{{{bookedChildren}}}C:{{{bookedInfants}}}I:' + '{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
                            mapTo: 'eVar16',
                            transformers: {
                                bookedPartyTotal: function bookedPartyTotal(model) {
                                    'use strict';

                                    if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants && !isNaN(model.bookedSeniors))) {

                                        return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                                    }
                                }
                            }
                        }
                    },
                    bookedArrivalDate: {
                        mapping: {
                            mapTo: function mapTo(model) {
                                if (model.productType !== 'dtx' && model.productType !== 'eexp') {
                                    return 'parentVars.eVar18';
                                } else {
                                    return 'bookedArrivalDate';
                                }
                            }
                        }
                    },
                    bookedLengthOfStayNights: {
                        mapping: {
                            mapTo: 'parentVars.eVar19'
                        }
                    },
                    bookedTimeOfDay: {
                        mapping: {
                            mapTo: 'eVar67'
                        }
                    },
                    quantity: {
                        mapping: {}
                    },
                    price: {
                        total: {
                            mapping: {
                                mapTo: 'totalPrice'
                            }
                        }
                    },
                    confirmationNumber: {
                        mapping: {
                            mapTo: 'eVar15'
                        }
                    },
                    daysBetweenBookingAndArrival: {
                        mapping: {
                            mapTo: 'parentVars.eVar17'
                        }
                    },
                    discountCode: {
                        mapping: {
                            mapTo: 'eVar21'
                        }
                    },
                    originalChannel: {
                        mapping: {
                            mapTo: 'eVar65'
                        }
                    },
                    elapsedBookingTime: {
                        mapping: {
                            mapTo: 'eVar66'
                        }
                    },
                    visualId: {
                        mapping: {
                            mapTo: 'visualId'
                        }
                    },
                    events: {
                        mapping: {
                            type: 'flex-array',
                            defaultValue: '1',
                            targetDelimiter: '|',
                            mapTo: {
                                cartAdd: 'event44',
                                cartRemove: 'event45'
                            }
                        }
                    },
                    parentId: {
                        mapping: {
                            mapTo: 'parentId'
                        }
                    },
                    availabilityChannel: {
                        mapping: {
                            mapTo: 'availChannel'
                        }
                    },
                    inventory: {
                        mapping: {
                            mapTo: 'inventory'
                        }
                    },
                    useDate: {
                        mapping: {
                            type: 'template',
                            template: '{{#useDate}}:::{{{useDate}}}{{/useDate}}',
                            mapTo: function mapTo(model) {
                                if (model.productType === 'dtx' || model.productType === 'eexp') {
                                    return 'eVar36';
                                }
                                return undefined;
                            },
                            defaultValue: function defaultValue(model) {
                                if (model.productType === 'dtx' || model.productType == 'eexp') {
                                    if (model.bookingSearchArrivalDate) {
                                        return model.bookingSearchArrivalDate;
                                    } else if (model.bookedArrivalDate) {
                                        return model.bookedArrivalDate;
                                    }
                                }
                                return undefined;
                            }
                        }
                    },
                    productInfo: {
                        mapping: {
                            type: 'template',
                            defaultValue: function defaultValue(model) {
                                return model.productType === 'merch';
                            },
                            mapTo: function mapTo(model) {
                                if (model.productType === 'merch') {
                                    return 'eVar36';
                                }
                            },
                            transformers: {
                                preProcess: function preProcess(model) {
                                    if (!model.parentId && model.productId) {
                                        model.parentId = model.productId;
                                    }
                                    if (model.inventory && model.inventory.toLowerCase() === 'out of stock') {
                                        model.availChannel = 'Not Available';
                                    }
                                }
                            },
                            template: '{{{parentId}}}:' + '{{{availChannel}}}:' + '{{{inventory}}}:'
                        }
                    },
                    mapping: {
                        type: 'template',
                        template: function template(model) {
                            var tpl = '' + '{{productType}};';

                            if (model.productType === 'eexp' || model.productType === 'merch') {
                                tpl += '{{{productId}}}';
                            } else {
                                tpl += '{{{productId}}}:' + '{{{facilityId}}}{{#portId}}_{{{portId}}}{{/portId}}:' + '{{{roomTypeId}}}' + '{{^portId}}:{{{ticketId}}}{{/portId}}';
                            }

                            tpl += ';{{{quantity}}};' + '{{{totalPrice}}};' + '{{{eventsString}}};' + '{{{eVarString}}}';

                            return tpl;
                        },
                        transformers: {
                            //used to perform preliminary transformations without setting
                            //a particular value to the model*/
                            preProcess: function preProcess(model, parentModel) {
                                'use strict';

                                var ip, n, prop;

                                //for now we only expect 1 item in the included products (tickets)
                                if (model.includedProducts && model.includedProducts.length > 0) {
                                    ip = model.includedProducts[0];
                                    for (n in ip) {
                                        if (ip.hasOwnProperty(n)) {
                                            model[n] = ip[n];
                                        }
                                    }
                                }
                                /*there are a few variables we need outside of the product string, lets get them
                                 */
                                if (parentModel.paymentInfo) {
                                    model.eVar20 = parentModel.paymentInfo;
                                }

                                if (model.productType === 'tix' && model.visualId) {
                                    addTicketVisualIds(model, parentModel);
                                }

                                if (model.parentVars) {
                                    for (prop in model.parentVars) {
                                        if (model.parentVars.hasOwnProperty(prop)) {
                                            parentModel[prop] = model.parentVars[prop];
                                        }
                                    }
                                }
                            },

                            /**
                             * transforms eVar properties in a model to a concatinated string.
                             * Ex : an object with {'eVar1' : 'v12','eVar2' : 'v33' }
                             * would become a string "eVar1=v12|eVar2=v33"
                             */
                            eVarString: function eVarString(model) {
                                'use strict';

                                var results = [],
                                    prop;
                                for (prop in model) {
                                    if (model.hasOwnProperty(prop) && model[prop] && prop.indexOf('eVar') !== -1) {
                                        results.push(prop + '=' + model[prop]);
                                    }
                                }
                                return results.join('|');
                            },
                            //same concept as eVars but for events
                            eventsString: function eventsString(model, parentModel, modelVal) {
                                'use strict';

                                var results = [],
                                    prop,
                                    i,
                                    l,
                                    eventParts,
                                    part,
                                    addEventToParent = function addEventToParent(parentModel, eventNum) {
                                    //add events to main events string if it is not already there
                                    if (!parentModel.events) {
                                        parentModel.events = eventNum;
                                    } else if (parentModel.events.indexOf(eventNum) === -1) {
                                        parentModel.events += ',' + eventNum;
                                    }
                                };

                                for (prop in model) {
                                    if (model.hasOwnProperty(prop) && model[prop] && prop.indexOf('event') !== -1) {
                                        //check if prop is literally 'events' this means that we have an event in the
                                        //product object itself
                                        if ('events' === prop) {
                                            results.push(model[prop]);
                                            //split the string to an array (from eventx=1|eventy=2)
                                            eventParts = model[prop].split(/[|=]+/);
                                            i = 0;
                                            l = eventParts.length;
                                            for (i; i < l; i += 1) {
                                                part = eventParts[i];
                                                if (part.indexOf('event') !== -1) {
                                                    addEventToParent(parentModel, part);
                                                }
                                            }
                                        } else {
                                            results.push(prop + '=' + model[prop]);
                                            addEventToParent(parentModel, prop);
                                        }
                                    }
                                }

                                if (parentModel.totalBookedLengthOfStayNights && (model.productType === 'prod' || model.productType === 'res')) {

                                    if (parentModel.site && parentModel.site.toUpperCase() === 'DLR') {
                                        results.push('event25=' + parentModel.totalBookedLengthOfStayNights);
                                        addEventToParent(parentModel, 'event25');
                                    } else {
                                        results.push('event26=' + parentModel.totalBookedLengthOfStayNights);
                                        addEventToParent(parentModel, 'event26');
                                    }
                                }
                                if (modelVal.productType === 'fastPassPlus') {
                                    results.push('event65=' + (model.quantity || 1));
                                    addEventToParent(parentModel, 'event65');
                                }
                                return results.join('|');
                            }
                        }
                    }
                }],
                failedProducts: [{
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                resortVacation: 'res',
                                insurance: 'ins',
                                groundTransportation: 'auto',
                                airTransportation: 'air',
                                cruise: 'prod',
                                fastPassPlus: 'gxa',
                                greatFoodFast: 'gxa',
                                dining: 'dine',
                                ticket: 'tix',
                                datedTicket: 'dtx',
                                annualPass: 'tix',
                                media: 'med',
                                enhancedExperience: 'eexp'
                            }
                        }
                    },
                    productId: {
                        mapping: {
                            mapTo: function mapTo(model) {
                                'use strict';

                                var result = 'productId';
                                if (model.productType === 'tix' || model.productType === 'med') {
                                    return 'ticketId';
                                }
                                return result;
                            }
                        }
                    },
                    facilityId: {
                        mapping: {}
                    },
                    roomTypeId: {
                        mapping: {}
                    },
                    mapping: {
                        rollUp: true,
                        mapTo: 'eVar62',
                        type: 'template',
                        targetDelimiter: ',',
                        template: function template(model) {
                            var tpl = '{{{productType}}};{{{productId}}}:{{{facilityId}}}:{{{roomTypeId}}}:' + '{{{ticketId}}}';
                            if (model.productType === 'eexp') {
                                tpl = '{{{productType}}};{{{productId}}}';
                            } else if (model.productType === 'merch') {
                                tpl = '{{{productType}}};{{{productId}}}';
                            }

                            return tpl;
                        },
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                var evt = 'event60';
                                if (model.productType && (model.productId || model.ticketId)) {
                                    if (parentModel.events) {
                                        if (parentModel.events.indexOf(evt) === -1) {
                                            parentModel.events += ',' + evt;
                                        }
                                    } else {
                                        parentModel.events = evt;
                                    }
                                }
                            }
                        }
                    }
                }],
                productsCompared: [{
                    productName: {
                        mapping: {}
                    },
                    productId: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#productId}}{{{productId}}}{{/productId}}{{^productId}}{{{productName}}}' + '{{/productId}}'
                    }
                }],
                productsDisplayedEvent: {
                    mapping: {
                        defaultValue: 'notset'
                    }
                },
                productsDisplayed: [{
                    productType: {
                        mapping: {
                            defaultValue: 'prod',
                            mapTo: {
                                product: 'prod',
                                ticket: 'tix',
                                datedTicket: 'dtx',
                                annualPass: 'tix',
                                cruise: 'prod'
                            }
                        }
                    },
                    facilityId: {
                        mapping: {}
                    },
                    roomTypeId: {
                        mapping: {}
                    },
                    isAvailable: {
                        mapping: {
                            defaultValue: 'u'
                        }
                    },
                    productId: {
                        mapping: {}
                    },
                    visualId: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        reprocessOnUpdate: true,
                        template: function template(model) {
                            var tpl = '{{#facilityId}}{{{facilityId}}}{{/facilityId}}:' + '{{#roomTypeId}}{{{roomTypeId}}}{{/roomTypeId}}';
                            if (model.productType === 'tix') {
                                tpl = '{{{productId}}}';
                            }

                            return tpl;
                        },
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                if (model.productType === 'prod') {
                                    if (parentModel.numAvailable === undefined) {
                                        parentModel.numAvailable = 0;
                                    }
                                    if (!parentModel.availableMatrix) {
                                        parentModel.availableMatrix = '';
                                    }
                                    if (model.isAvailable === true) {
                                        parentModel.numAvailable++;
                                        parentModel.availableMatrix += ';1';
                                    } else if (model.isAvailable === false) {
                                        parentModel.availableMatrix += ';0';
                                    } else {
                                        parentModel.availableMatrix += ';' + model.isAvailable;
                                    }
                                } else if (model.productType === 'tix' && model.visualId) {
                                    addTicketVisualIds(model, parentModel);
                                }
                            }
                        }
                    }
                }],
                productsAvailable: {
                    mapping: {
                        reprocessOnUpdate: true,
                        type: 'template',
                        template: '{{#availableMatrix}}{{{numAvailable}}}{{{availableMatrix}}}{{/availableMatrix}}',
                        mapTo: 'eVar63'
                    }
                },
                contentId: {
                    mapping: {
                        mapTo: 'prop35'
                    }
                },
                recommenderInfo: {
                    conversationId: {
                        mapping: {}
                    },
                    messageId: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#conversationId}}{{{conversationId}}},{{{messageId}}}{{/conversationId}}',
                        mapTo: 'prop42'
                    }
                },
                pageGroupId: {
                    mapping: {
                        type: 'template',
                        mapTo: 'prop52',
                        template: '{{#pageGroupIdVal}}{{{pageGroupIdVal}}}{{/pageGroupIdVal}}',
                        transformers: {
                            pageGroupIdVal: function pageGroupIdVal(model) {
                                'use strict';

                                if (!model.purchaseID) {
                                    return model.pageGroupId;
                                }
                            }
                        }
                    }
                },
                targusId: {
                    mapping: {
                        mapTo: 'eVar46'
                    }
                },
                compareVacationNumber: {
                    mapping: {
                        mapTo: 'eVar64'
                    }
                },
                currencyDisplayed: {
                    mapping: {
                        mapTo: 'prop70'
                    }
                },
                server: {
                    mapping: {
                        mapTo: 'server'
                    }
                },
                device: {
                    type: {
                        mapping: {}
                    },
                    viewType: {
                        mapping: {}
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#type}}{{#viewType}}{{type}}:{{viewType}}{{/viewType}}{{/type}}',
                        mapTo: 'prop32'
                    }
                },
                currentEntitlements: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: ',',
                        mapTo: 'prop55',
                        applyFilter: {
                            alpha: 'asc',
                            replace: [[' ', '']]
                        }
                    }
                },
                modificationType: {
                    mapping: {
                        mapTo: 'eVar68'
                    }
                },
                article: {
                    id: {
                        mapping: {
                            mapTo: 'articleId'
                        }
                    },
                    title: {
                        mapping: {
                            mapTo: 'articleName'
                        }
                    },
                    publicationDate: {
                        mapping: {
                            mapTo: 'articlePublicationDate',
                            applyFilter: {
                                date: {
                                    inputFormat: 'YYYY-MM-DD'
                                }
                            }
                        }
                    },
                    author: {
                        mapping: {
                            mapTo: 'articleAuthor'
                        }
                    },
                    categories: {
                        mapping: {
                            mapTo: 'prop33'
                        }
                    }
                },
                articleMetaData: {
                    mapping: {
                        type: 'template',
                        mapTo: 'prop57,eVar72',
                        template: '{{#articleId}}{{{articleId}}}:{{{articleName}}}{{/articleId}}'
                    }
                },
                articleIdentifiers: {
                    mapping: {
                        type: 'template',
                        template: '{{#articleId}}{{{articleId}}}:{{{articlePublicationDate}}}:' + '{{{articleAuthor}}}{{/articleId}}',
                        mapTo: 'prop58,eVar73'
                    }
                },
                geo: {
                    country: {
                        mapping: {
                            mapTo: 'geoCountry',
                            applyFilter: {
                                'case': 'lower'
                            }
                        }
                    }
                },
                personalizationId: {
                    mapping: {
                        mapTo: 'prop63'
                    }
                },
                previousPageLoadTime: {
                    mapping: {
                        mapTo: 'prop45',
                        defaultValue: function defaultValue(model) {
                            var cookieVal, loadTime, prevLoadTime, prevPage, utils;

                            // This should only run on a base model, as we dont want subsequent parsings to trigger this
                            if (model.pageName && model.reportSuiteId) {
                                utils = WDPRO.Analytics.Utils;
                                prevLoadTime = utils.sessionStorage.getItem('prevPageLoadTime');
                                prevPage = s_wdpro.getPreviousValue(model.pageName, 's_gpv_pn', '');

                                if (prevLoadTime) {
                                    prevLoadTime = prevLoadTime.split('|');
                                    if (prevPage === prevLoadTime[0]) {
                                        model.previousPageLoadTime = prevLoadTime[1];
                                    }
                                }

                                try {
                                    loadTime = (window.performance.timing.domContentLoadedEventStart - window.performance.timing.navigationStart) / 1000;
                                    loadTime = loadTime.toFixed(1);
                                    cookieVal = model.pageName + '|' + loadTime;
                                } catch (e) {
                                    cookieVal = model.pageName + '|unknown';
                                }
                                utils.sessionStorage.setItem('prevPageLoadTime', cookieVal);
                                if (model.previousPageLoadTime) {
                                    return model.previousPageLoadTime;
                                } else {
                                    return false;
                                }
                            }
                        }
                    }
                },
                shipping: {
                    method: {
                        mapping: {
                            mapTo: 'shippingMethod',
                            applyFilter: {
                                replace: [[' ', '']]
                            }
                        }
                    },
                    price: {
                        mapping: {
                            mapTo: 'shippingPrice',
                            defaultValue: function defaultValue() {
                                return 0;
                            }
                        }
                    },
                    time: {
                        mapping: {
                            mapTo: 'shippingTime',
                            applyFilter: {
                                replace: [[' ', '']]
                            }
                        }
                    },
                    mapping: {
                        type: 'template',
                        template: '{{#shippingMethod}}' + '{{{shippingMethod}}}:{{{shippingPrice}}}:{{{shippingTime}}}' + '{{/shippingMethod}}',
                        mapTo: 'eVar61'
                    }
                },
                guest: {
                    uuid: {
                        mapping: {
                            mapTo: 'contextData.user.uuid'
                        }
                    }
                },
                UNID: {
                    mapping: {
                        defaultValue: function defaultValue() {
                            if (window.unid && unid.value) {
                                return unid.value;
                            }
                        },
                        mapTo: 'contextData.unid'
                    }
                }
            };
        }
        //the namespace will be automatically created if this product is supported (defined in the config.js)
    })(WDPRO.Analytics.Config.products.SiteCatalyst);

    /* global WDPRO, inject, mboxDefine, mboxUpdate, mboxTrack */
    inject(function (addAdapter, Adapter, objForEach, $, mbox, dbg, Parsers, Mustache) {
        var targetAdapter = new Adapter({
            name: 'TestAndTarget',
            enabled: true,
            adapt: adapt,
            adaptOnce: false,
            dynamicMboxesSet: false,
            globalMboxSet: false,
            reset: reset
        });
        addAdapter(targetAdapter);

        targetAdapter.definedMboxes = [];

        function reset() {
            this.dynamicMboxesSet = false;
            this.globalMboxSet = false;
        }

        function isBookedProduct(events) {
            if (events.indexOf('purchase') > -1) {
                return true;
            }
            return false;
        }

        function adapt(model) {
            'use strict';

            var tests,
                parameters = [],
                productId,
                mboxName = [],
                elementId = [],
                contentPosition = [],
                eventsProfiles = [],
                events,
                bindFirstMboxUpdateComplete,
                removeProduct,
                regEx,
                stdMboxes = [],
                evtMboxes = [],
                createBoundMbox,
                timestamp,
                framework = WDPRO.Analytics.Framework;

            targetAdapter.dynamicMboxesSet = false;
            targetAdapter.globalMboxSet = false;

            targetAdapter.defineAndUpdateMbox = function (selector, mboxName, position, parameters) {
                var $testingElement = $(framework.getElementByIdOrSelector(selector)),
                    mboxData,
                    mboxElementName;

                if ($testingElement.length) {
                    // add a div inside of the $testingElement content to allow
                    // TestAndTarget to be able to manipulate it
                    position = position.trim();
                    mboxElementName = 'WDPRO_MBox_' + mboxName;

                    if (targetAdapter.definedMboxes.indexOf(mboxElementName) === -1) {
                        if (position === 'replace') {
                            $testingElement.html('<div id="' + mboxElementName + '">' + $testingElement.html() + '</div>');
                        } else {
                            if (!$testingElement[position]) {
                                dbg.warn('Invalid contentPosition Specified (' + position + '), defaulting to append');
                                position = 'append';
                            }
                            $testingElement[position]('<div id="' + mboxElementName + '"></div>');
                        }
                        mboxDefine(mboxElementName, mboxName);
                        targetAdapter.definedMboxes.push(mboxElementName);
                    }
                    parameters.unshift(mboxName);
                    mboxUpdate.apply(this, parameters);
                    mboxData = {
                        name: mboxName,
                        params: parameters
                    };
                    framework.fireEvent(document, 'mBoxCallInitiated', mboxData);
                }
            };

            if (!model.contentTests) {
                model.contentTests = [];
            }

            timestamp = new Date();
            targetAdapter.timestamp = timestamp.getTime();

            if (Parsers.toBoolean(model.globalMbox) === true && model.site && targetAdapter.globalMboxSet === false) {
                model.contentTests.push({
                    contentPosition: 'append',
                    contentTestHTMLTargetElement: 'body',
                    contentTestModuleName: model.site.toUpperCase() + '_Global_Mbox'
                });
                targetAdapter.globalMboxSet = true;
            }

            if (Parsers.toBoolean(model.dynamicMboxes) === true && model.site && model.params && model.params.siteSection && model.params.pageId && model.channelSeparator && targetAdapter.dynamicMboxesSet === false) {
                regEx = new RegExp(model.channelSeparator, 'g');
                model.contentTests.push({
                    contentPosition: 'append',
                    contentTestHTMLTargetElement: 'body',
                    contentTestModuleName: model.site.toUpperCase() + '_' + model.params.siteSection.replace(regEx, '_') + '_' + model.params.pageId + '_Mbox'
                });
                targetAdapter.dynamicMboxesSet = true;
            }

            // Start by checking if there are tests in the model
            tests = model.contentTests;
            if (tests.length === 0) {
                framework.fireEvent(document, 'TestAndTargetAdapterComplete', model);
                return false;
            }

            // Save the number of test on this page so we know how many mboxUpdate calls
            // to expect
            mbox.numberOfTestsOnThisPage = tests.length;
            mbox.numberOfUpdateCallsCompleted = 0;

            // This callback is called whenever the mbox.show() function is executed
            mbox.mboxShowCallback = function (B) {
                // When 1 == B it means the mbox call is completed
                if (1 === B) {
                    mbox.numberOfUpdateCallsCompleted += 1;
                    if (1 === mbox.numberOfUpdateCallsCompleted) {
                        framework.fireEvent(document, 'firstMboxUpdateComplete');
                        dbg.debug('Event Triggered: firstMboxUpdateComplete');
                    }

                    if (mbox.numberOfUpdateCallsCompleted === mbox.numberOfTestsOnThisPage) {
                        framework.fireEvent(document, 'lastMboxUpdateComplete');
                        dbg.debug('Event Triggered: lastMboxUpdateComplete');
                    }
                }

                return B;
            };

            events = model.params && model.params.events ? model.params.events.split(',') : [];

            // Getting events from the model and convert it into an array of profile params
            events.forEach(function (event) {
                if (event !== '[object Object]') {
                    if (model.eventsData && model.eventsData[event]) {
                        eventsProfiles.push('profile.' + event + '=' + model.eventsData[event]);
                    } else {
                        eventsProfiles.push('profile.' + event + '=' + targetAdapter.timestamp);
                    }
                }
            });

            bindFirstMboxUpdateComplete = function bindFirstMboxUpdateComplete(i, mBoxName, contentPosition, parameters) {
                $(document).one('firstMboxUpdateComplete', {
                    elementId: elementId[i],
                    mboxName: mBoxName[i],
                    contentPosition: contentPosition[i],
                    parameters: parameters[i]
                }, function (e) {
                    targetAdapter.defineAndUpdateMbox(e.data.elementId, e.data.mboxName, e.data.contentPosition, e.data.parameters);
                });
            };

            if (model.productsDisplayed && model.productsDisplayed.length > 0) {
                objForEach(model.productsDisplayed[0].params, function (param, key) {
                    model.params[key] = param;
                });
            }
            tests.forEach(function (test, i) {
                var paramHolder = [];
                // Don't do anything if contentTestModuleName or contentTestHTMLTargetElement or
                // contentTestProfileParams were not provided
                elementId[i] = test.contentTestHTMLTargetElement;
                mboxName[i] = test.contentTestModuleName;
                if (test.contentPosition) {
                    contentPosition[i] = test.contentPosition;
                } else {
                    contentPosition[i] = 'replace';
                }

                // Parameters that will be passed to mboxUpdate
                parameters[i] = [];

                // Merging contentTestParams with general parameters
                objForEach(test.contentTestParams, function (value, param) {
                    parameters[i].push(param + '=' + value);
                });

                // Merging events from model
                if (eventsProfiles.length > 0) {
                    //set event as profile (for last time check)
                    parameters[i] = parameters[i].concat(eventsProfiles);
                }

                //handle the products array
                if (Array.isArray(model.products) && model.products.length > 0) {
                    model.products.forEach(function (product) {
                        if (product.productId || product.ticketId || product.facilityId || product.productType === 'ins') {
                            product.params = product.params || {};
                            product.productParams = product.productParams || {};
                            removeProduct = false;

                            if (product.hasOwnProperty('events')) {
                                if (product.events.indexOf('cartRemove') > -1) {
                                    removeProduct = true;
                                }
                            }

                            if (!removeProduct) {
                                /*most properties are pre-mapped but the product Id required some special
                                treatment so we are mapping it here*/

                                /* Tickets products are special since the ticketId must always be at the end and
                                no productId at the beginning*/
                                if ((product.productType === 'tix' || product.productType === 'med') && !product.ticketId) {
                                    product.ticketId = product.productId;
                                    product.productId = '';
                                }
                                if (Array.isArray(product.includedProducts)) {
                                    //we only care about the first included product (ticket id)
                                    product.ticketId = product.includedProducts[0].id;
                                }

                                productId = Mustache.render('{{productType}};{{productId}}:{{{facilityId}}}:{{roomTypeId}}:{{ticketId}}', product);

                                if (isBookedProduct(events)) {
                                    product.productParams.productPurchasedId = productId;
                                } else {
                                    product.productParams.productId = productId;
                                }

                                // Take params and move to top level - these should not be comma separated
                                $.extend(true, model.params, product.params);
                                $.extend(true, model.profiles, product.profiles);

                                objForEach(product.productParams, function (val, pParam) {
                                    paramHolder[pParam] = paramHolder[pParam] || [];
                                    paramHolder[pParam].push(val);
                                });
                            }
                        }
                    });
                    objForEach(paramHolder, function (val, paramKey) {
                        parameters[i].push(paramKey + '=' + val.join(','));
                    });
                }

                //handle the productsPurchased array
                if (Array.isArray(model.productsPurchased) && model.productsPurchased.length > 0) {
                    model.productsPurchased.forEach(function (product) {
                        if (product.productId || product.ticketId || product.facilityId || product.productType === 'ins') {
                            product.params = product.params || {};
                            product.productParams = product.productParams || {};

                            /*most properties are pre-mapped but the product Id required some special treatment so we
                            are mapping it here*/

                            /* Tickets products are special since the ticketId must always be at the end and
                            no productId at the beginning*/
                            if ((product.productType === 'tix' || product.productType === 'med') && !product.ticketId) {
                                product.ticketId = product.productId;
                                product.productId = '';
                            }
                            if (Array.isArray(product.includedProducts)) {
                                //we only care about the first included product (ticket id)
                                product.ticketId = product.includedProducts[0].id;
                            }

                            product.productParams.productsPurchased = Mustache.render('{{productType}};{{productId}}:{{{facilityId}}}:{{roomTypeId}}:{{ticketId}}', product);

                            // Take params and move to top level - these should not be comma separated
                            $.extend(true, model.params, product.params);

                            objForEach(product.productParams, function (val, pParam) {
                                paramHolder[pParam] = paramHolder[pParam] || [];
                                paramHolder[pParam].push(val);
                            });
                        }
                    });
                    //map the final results of product params
                    objForEach(paramHolder, function (val, paramKey) {
                        parameters[i].push(paramKey + '=' + val.join(','));
                    });
                }

                //grab all items that are explicitly in params
                objForEach(model.params, function (value, key) {
                    parameters[i].push(key.toString().replace(/\-dot\-/ig, '.') + '=' + value);
                });

                //grab all items that are explicitly in profiles
                objForEach(model.profiles, function (profile, key) {
                    parameters[i].push('profile.' + key + '=' + profile);
                });

                test.idxPos = i.toString();
                if (test.contentTestTriggerEvent || test.contentTestTriggerElement) {
                    evtMboxes.push(test);
                } else {
                    stdMboxes.push(test);
                }
            });

            stdMboxes.forEach(function (stdMbox, k) {
                // Bind all mboxUpdate calls but the last one to firstMboxUpdateComplete
                if (k < stdMboxes.length - 1) {
                    bindFirstMboxUpdateComplete(stdMbox.idxPos, mboxName, contentPosition, parameters);
                } else {
                    targetAdapter.defineAndUpdateMbox(elementId[stdMbox.idxPos], mboxName[stdMbox.idxPos], contentPosition[stdMbox.idxPos], parameters[stdMbox.idxPos]);
                }
            });

            createBoundMbox = function createBoundMbox(test) {
                test.contentTestTriggerEventBindType = test.contentTestTriggerEventBindType || 'one';

                $(test.contentTestTriggerElement)[test.contentTestTriggerEventBindType](test.contentTestTriggerEvent, test, function (e) {
                    var idxPos = e.data.idxPos;
                    targetAdapter.defineAndUpdateMbox(elementId[idxPos], mboxName[idxPos], contentPosition[idxPos], parameters[idxPos]);
                });
            };
            evtMboxes.forEach(function (evtMbox) {
                if (evtMbox.contentTestTriggerEvent && evtMbox.contentTestTriggerElement) {
                    createBoundMbox(evtMbox);
                }
            });
            framework.fireEvent(document, 'TestAndTargetAdapterComplete', model);
        }

        $.fn.mboxTrack = function (options) {
            var settings = {},
                defaults = {
                reclick: false,
                timeout: 580,
                param: ''
            };

            if (!options) {
                return false;
            } else if (!options.mbox) {
                return false;
            }
            $.extend(true, settings, defaults, options);
            return this.one('click', function (event) {
                var el = this;
                if (settings.reclick) {
                    event.preventDefault();
                }
                mboxTrack(settings.mbox, settings.param);
                if (settings.reclick) {
                    setTimeout(function () {
                        el.click();
                    }, settings.timeout);
                }
            });
        };
    }, ['addAdapter', 'Adapter', 'objForEach', '$', 'mbox', 'Debug', 'Parsers', 'Mustache']);

    /* global inject */
    inject(function (targetAdapter, convertStringToDate) {
        var productTypeMapping = {
            defaultValue: 'prod',
            mapTo: {
                product: 'prod',
                resortVacation: 'res',
                insurance: 'ins',
                groundTransportation: 'auto',
                airTransportation: 'air',
                cruise: 'cruise',
                fastPassPlus: 'gxa',
                greatFoodFast: 'gxa',
                dining: 'dine',
                ticket: 'tix',
                annualPass: 'tix',
                media: 'med',
                enhancedExperience: 'eexp',
                nonDisneyTicket: 'ndt',
                preOrder: 'pre',
                event: 'evt'
            }
        };

        targetAdapter.mapping = {
            configuration: {
                TestAndTarget: {
                    dynamicMboxes: {
                        mapping: {
                            defaultValue: 'false'
                        }
                    },
                    globalMbox: {
                        mapping: {
                            defaultValue: 'false'
                        }
                    },
                    triggerTimeout: {
                        mapping: {
                            mapTo: 'triggerTimeout'
                        }
                    }
                },
                SiteCatalyst: {
                    channelSeparator: {
                        mapping: {
                            defaultValue: '/'
                        }
                    }
                },
                contentLocale: {
                    mapping: {
                        defaultValue: 'us',
                        mapTo: 'params.contentLocale'
                    }
                },
                contentLanguage: {
                    mapping: {
                        defaultValue: 'en',
                        mapTo: 'params.contentLanguage'
                    }
                },
                marketingRegion: {
                    mapping: {
                        mapTo: 'params.marketingRegion',
                        applyFilter: {
                            'case': 'lower'
                        }
                    }
                }
            },
            device: {
                type: {
                    mapping: {}
                },
                viewType: {
                    mapping: {}
                },
                mapping: {
                    type: 'template',
                    template: function template(model) {
                        if (model.type && model.viewType) {
                            return '{{type}}:{{viewType}}';
                        }
                        return '';
                    },
                    mapTo: 'params.deviceInfo'
                }
            },
            site: {
                mapping: {}
            },
            targusScore: {
                mapping: {
                    mapTo: 'profiles.targusScore'
                }
            },
            contentTests: {
                mapping: {
                    applyFilter: {
                        forceArray: '',
                        removeElement: {
                            keys: ['contentTestType', 'contentTestModuleName', 'contentTestHTMLTargetElement'],
                            values: ['inline', '', '']
                        }
                    }
                }
            },
            bookingSearchArrivalDate: {
                mapping: {
                    mapTo: 'params.bookingSearchArrivalDate,profiles.bookingSearchArrivalDate',
                    applyFilter: {
                        date: {
                            outputFormat: 'YYYY-MM-DD'
                        }
                    }
                }
            },
            bookingSearchDepartureDate: {
                mapping: {
                    mapTo: 'params.bookingSearchDepartureDate',
                    applyFilter: {
                        date: {
                            outputFormat: 'YYYY-MM-DD'
                        }
                    }
                }
            },
            bookingSearchDaysBetweenSearchAndArrival: {
                mapping: {
                    mapTo: 'params.prodSearchBookingWindow',
                    defaultValue: function defaultValue(model) {
                        var result,
                            dateStr,
                            date,
                            today,
                            diff,
                            ONE_DAY = 1000 * 60 * 60 * 24;

                        if (model.params) {
                            dateStr = model.params.bookingSearchArrivalDate;
                            if (dateStr) {
                                date = convertStringToDate(dateStr);

                                if (date) {
                                    today = new Date();
                                    today.setHours(0);
                                    today.setMinutes(0);
                                    today.setSeconds(0);
                                    today.setMilliseconds(0);
                                    diff = Math.abs(today.getTime() - date.getTime());
                                    result = Math.round(diff / ONE_DAY);
                                }
                            }
                        }
                        return result;
                    }
                }
            },
            bookingSearchLengthOfStayNights: {
                mapping: {
                    mapTo: 'params.bookingSearchLOSNights'
                }
            },
            bookingSearchItinerary: {
                mapping: {
                    mapTo: 'params.bookingSearchItinerary'
                }
            },
            bookingSearchFacilityTier: {
                mapping: {
                    mapTo: 'params.bookingSearchFacilityTier'
                }
            },
            customerId: {
                mapping: {
                    mapTo: 'params.SWID'
                }
            },
            guestType: {
                mapping: {
                    mapTo: 'params.guestType'
                }
            },
            guestAffiliations: {
                mapping: {
                    type: 'flex-array',
                    targetDelimiter: ',',
                    mapTo: 'params.guestAffiliations'
                }
            },
            registrationStatus: {
                mapping: {
                    mapTo: 'params.registrationStatus'
                }
            },
            homeState: {
                mapping: {
                    mapTo: 'profiles.homeState'
                }
            },
            homeZip: {
                mapping: {
                    mapTo: 'params.homeZip'
                }
            },
            homeCountry: {
                mapping: {
                    mapTo: 'profiles.homeCountry'
                }
            },
            title: {
                mapping: {
                    mapTo: 'params.title'
                }
            },
            age: {
                mapping: {
                    mapTo: 'profiles.age'
                }
            },
            birthdate: {
                mapping: {
                    mapTo: 'profiles.birthdate'
                }
            },
            gender: {
                mapping: {
                    mapTo: 'params.gender'
                }
            },
            homeCity: {
                mapping: {
                    mapTo: 'profiles.homeCity'
                }
            },
            pageId: {
                mapping: {
                    mapTo: 'params.pageId',
                    applyFilter: {
                        'case': 'lower',
                        replace: [['[^a-zA-Z0-9]', '']]
                    }
                }
            },
            storeType: {
                mapping: {
                    mapTo: 'storeType,params.storeType'
                }
            },
            siteSection: {
                mapping: {
                    allowTokens: true,
                    mapTo: 'params.siteSection',
                    applyFilter: {
                        'case': 'lower',
                        replace: [['&amp;', 'and'], ['&', 'and'], ['[^a-zA-Z0-9{}\/]', '']]
                    }
                }
            },
            events: {
                mapping: {
                    type: 'flex-array',
                    sourceDelimiter: ',',
                    targetDelimiter: ',', // a comma is the default but can support any character
                    dataSourceMapTo: 'eventsData',
                    mapTo: 'params.events'
                }
            },
            offerId: {
                mapping: {
                    mapTo: 'params.offerId'
                }
            },
            store: {
                mapping: {
                    mapTo: 'params.store'
                }
            },
            orderId: {
                mapping: {
                    mapTo: 'params.orderId'
                }
            },
            productTotal: {
                mapping: {
                    mapTo: 'params.orderTotal'
                }
            },
            totalBookedLengthOfStayNights: {
                mapping: {
                    mapTo: 'params.totalBookedLengthOfStayNights'
                }
            },
            bookingSearchAdults: {
                mapping: {
                    defaultValue: '0'
                }
            },
            bookingSearchChildren: {
                mapping: {
                    defaultValue: '0'
                }
            },
            bookingSearchInfants: {
                mapping: {
                    defaultValue: '0'
                }
            },
            bookingSearchSeniors: {
                mapping: {
                    defaultValue: '0'
                }
            },
            bookingSearchParty: {
                mapping: {
                    type: 'template',
                    template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:{{{bookingSearchAdults}}}' + 'A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
                    mapTo: 'params.bookingSearchParty,profiles.bookingSearchParty',
                    transformers: {
                        bookingSearchPartyTotal: function bookingSearchPartyTotal(model) {
                            if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants && !isNaN(model.bookingSearchSeniors))) {

                                return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                            }
                        }
                    }
                }
            },
            payment: {
                paymentAmount: {
                    mapping: {
                        mapTo: 'params.paymentAmount'
                    }
                },
                paymentPct: {
                    mapping: {
                        mapTo: function mapTo(model) {
                            if (model.params && model.params.orderTotal && model.params.paymentAmount) {
                                return 'params.paymentPct';
                            }

                            return undefined;
                        },
                        defaultValue: function defaultValue(model) {
                            if (model.params.orderTotal && model.params.paymentAmount) {
                                return (parseFloat(model.params.paymentAmount) / parseFloat(model.params.orderTotal) * 100).toFixed(0);
                            } else {
                                return false;
                            }
                        }
                    }
                },
                paymentFrequency: {
                    mapping: {}
                },
                paymentMethods: [{
                    type: {
                        mapping: {}
                    },
                    name: {
                        mapping: {}
                    },
                    status: {
                        mapping: {}
                    },
                    mapping: {
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                parentModel.paymentInfo = parentModel.paymentInfo || {};
                                parentModel.paymentInfo[model.type] = {
                                    name: model.name,
                                    status: model.status || 'unknown'
                                };
                            }
                        }
                    }
                }]
            },
            paymentInfo: {
                mapping: {
                    type: 'template',
                    template: '{{#paymentInfo}}' + '{{#creditCard.name}}{{{creditCard.name}}}_' + '{{#creditCard.status}}{{{creditCard.status}}}{{/creditCard.status}}' + '{{/creditCard.name}}:{{#giftCard.name}}{{{giftCard.name}}}_' + '{{#giftCard.status}}{{{giftCard.status}}}{{/giftCard.status}}' + '{{/giftCard.name}}:{{#rewardsCard.name}}{{{rewardsCard.name}}}_' + '{{#rewardsCard.status}}{{{rewardsCard.status}}}{{/rewardsCard.status}}' + '{{/rewardsCard.name}}:{{#pointsPayment.name}}{{{pointsPayment.name}}}_' + '{{#pointsPayment.status}}{{{pointsPayment.status}}}{{/pointsPayment.status}}' + '{{/pointsPayment.name}}:{{#instantCredit.name}}{{{instantCredit.name}}}_' + '{{#instantCredit.status}}{{{instantCredit.status}}}{{/instantCredit.status}}' + '{{/instantCredit.name}}' + '{{/paymentInfo}}',
                    mapTo: 'params.payment'
                }
            },
            products: [{
                productType: {
                    mapping: productTypeMapping
                },
                productId: {
                    mapping: {}
                },
                facilityTier: {
                    mapping: {
                        mapTo: 'params.facilityTier'
                    }
                },
                facilityId: {
                    mapping: {}
                },
                roomTypeId: {
                    mapping: {}
                },
                portId: {
                    mapping: {}
                },
                includedProducts: [{
                    id: {
                        mapping: {}
                    },
                    type: {
                        mapping: {
                            defaultValue: 'ticket'
                        }
                    },
                    name: {
                        mapping: {}
                    },
                    mapping: {
                        transformers: {
                            preProcess: function preProcess(model, parentModel) {
                                if (model.type === 'diningPlan') {
                                    if (!parentModel.params) {
                                        parentModel.params = {};
                                    }
                                    parentModel.params.packageIncludesDinePlan = true;
                                    parentModel.params.dinePlanType = model.name;
                                }
                            }
                        }
                    }
                }],
                bookingSearchDeparturePort: {
                    mapping: {
                        mapTo: 'params.bookingSearchDeparturePort'
                    }
                },
                bookingSearchShip: {
                    mapping: {
                        mapTo: 'params.bookingSearchShip'
                    }
                },
                bookingSearchDaysBetweenSearchAndArrival: {
                    mapping: {
                        mapTo: 'params.prodBookingWindow'
                    }
                },
                bookingSearchFacilityTier: {
                    mapping: {
                        mapTo: 'params.bookingSearchFacilityTier'
                    }
                },
                bookingSearchArrivalDate: {
                    mapping: {
                        mapTo: 'params.prodSearchArrivalDate,profiles.bookingSearchArrivalDate',
                        applyFilter: {
                            date: {
                                outputFormat: 'YYYY-MM-DD'
                            }
                        }
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'params.prodSearchLOS'
                    }
                },
                bookingSearchAdults: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchChildren: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchInfants: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchSeniors: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchParty: {
                    mapping: {
                        type: 'template',
                        template: '{{#bookingSearchPartyTotal}}{{{bookingSearchPartyTotal}}}:{{{bookingSearchAdults}}}' + 'A:{{{bookingSearchChildren}}}C:{{{bookingSearchInfants}}}I:' + '{{{bookingSearchSeniors}}}S{{/bookingSearchPartyTotal}}',
                        mapTo: 'productParams.prodSearchParty,profiles.bookingSearchParty',
                        transformers: {
                            bookingSearchPartyTotal: function bookingSearchPartyTotal(model) {
                                'use strict';

                                if (!isNaN(model.bookingSearchAdults) && !isNaN(model.bookingSearchChildren) && !isNaN(model.bookingSearchInfants) && !isNaN(model.bookingSearchSeniors)) {

                                    return Number(model.bookingSearchAdults) + Number(model.bookingSearchChildren) + Number(model.bookingSearchInfants) + Number(model.bookingSearchSeniors);
                                }
                            }
                        }
                    }
                },
                bookedAdults: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedChildren: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookingSearchChildrenAges: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: ',',
                        mapTo: 'productParams.bookingSearchChildrenAges'
                    }
                },
                bookedInfants: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedSeniors: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedParty: {
                    mapping: {
                        type: 'template',
                        template: '{{#bookedPartyTotal}}{{{bookedPartyTotal}}}:{{{bookedAdults}}}A:{{{bookedChildren}}}' + 'C:{{{bookedInfants}}}I:{{{bookedSeniors}}}S{{/bookedPartyTotal}}',
                        mapTo: 'productParams.prodBookedParty',
                        transformers: {
                            bookedPartyTotal: function bookedPartyTotal(model) {
                                'use strict';

                                if (!isNaN(model.bookedAdults) && !isNaN(model.bookedChildren) && !isNaN(model.bookedInfants) && !isNaN(model.bookedSeniors)) {
                                    return Number(model.bookedAdults) + Number(model.bookedChildren) + Number(model.bookedInfants) + Number(model.bookedSeniors);
                                }
                            }
                        }
                    }
                },
                bookedArrivalDate: {
                    mapping: {
                        mapTo: 'params.prodBookedArrivalDate',
                        applyFilter: {
                            date: {
                                outputFormat: 'YYYY-MM-DD'
                            }
                        }
                    }
                },
                bookedLengthOfStayNights: {
                    mapping: {
                        mapTo: 'params.prodLOS'
                    }
                },
                dateReservationMade: {
                    mapping: {
                        mapTo: 'params.dateReservationMade'
                    }
                },
                daysBetweenBookingAndArrival: {
                    mapping: {
                        mapTo: 'params.daysBetweenBookingAndArrival'
                    }
                },
                quantity: {
                    mapping: {
                        mapTo: 'productParams.prodQuantity'
                    }
                },
                price: {
                    total: {
                        mapping: {
                            mapTo: 'productParams.prodPrice'
                        }
                    }
                },
                packageType: {
                    mapping: {
                        mapTo: 'params.packageType,profiles.packageType'
                    }
                },
                orderType: {
                    mapping: {
                        mapTo: 'productParams.orderType'
                    }
                },
                events: {
                    mapping: {
                        type: 'flex-array',
                        targetDelimiter: '|',
                        mapTo: {
                            cartAdd: 'cartAdd',
                            cartRemove: 'cartRemove'
                        }
                    }
                }
            }],
            productsDisplayed: [{
                facilityId: {
                    mapping: {
                        mapTo: 'params.productsDisplayedFacilityId'
                    }
                },
                facilityTier: {
                    mapping: {
                        mapTo: 'params.productsDisplayedFacilityTier'
                    }
                }
            }],
            productsPurchased: [{
                productType: {
                    mapping: productTypeMapping
                },
                productId: {
                    mapping: {}
                },
                facilityId: {
                    mapping: {}
                },
                roomTypeId: {
                    mapping: {}
                }
            }],
            bookingSearchDeparturePort: {
                mapping: {
                    mapTo: 'params.bookingSearchDeparturePort'
                }
            },
            bookingSearchShip: {
                mapping: {
                    mapTo: 'params.bookingSearchShip'
                }
            },
            bookingSearchChildrenAges: {
                mapping: {
                    type: 'flex-array',
                    targetDelimiter: ',',
                    mapTo: 'params.bookingSearchChildrenAges'
                }
            },
            seenCampaigns: {
                mapping: {
                    mapTo: 'params.seenCampaigns',
                    defaultValue: function defaultValue() {
                        return window.tnt_wdpro.getCampaigns();
                    }
                }
            },
            toggleStatus: {
                mapping: {
                    type: 'template',
                    mapTo: 'params.toggles',
                    template: '{{#toggleStatus}}{{#ft}}{{{ft}}}{{/ft}}{{#rt}}{{#ft}},{{/ft}}{{{rt}}}{{/rt}}{{#flt}}' + '{{#rt}},{{/rt}}{{^rt}}{{#ft}},{{/ft}}{{/rt}}{{{flt}}}{{/flt}}{{/toggleStatus}}',
                    transformers: {
                        ft: function ft(model) {
                            var toggles = [],
                                toggle,
                                featureToggles = model.toggleStatus && model.toggleStatus.featureToggles;
                            if (featureToggles) {
                                for (toggle in featureToggles) {
                                    if (featureToggles.hasOwnProperty(toggle)) {
                                        toggles.push('ft;' + toggle + ':' + featureToggles[toggle]);
                                    }
                                }
                            }

                            return toggles.join(',');
                        },
                        rt: function rt(model) {
                            var toggles = [],
                                toggle,
                                releaseToggles = model.toggleStatus && model.toggleStatus.releaseToggles;
                            if (releaseToggles) {
                                for (toggle in releaseToggles) {
                                    if (releaseToggles.hasOwnProperty(toggle)) {
                                        toggles.push('rt;' + toggle + ':' + releaseToggles[toggle]);
                                    }
                                }
                            }

                            return toggles.join(',');
                        },
                        flt: function flt(model) {
                            var toggles = [],
                                toggle,
                                flowToggles = model.toggleStatus && model.toggleStatus.flowToggles;
                            if (flowToggles) {
                                for (toggle in flowToggles) {
                                    if (flowToggles.hasOwnProperty(toggle)) {
                                        toggles.push('flt;' + toggle + ':' + flowToggles[toggle]);
                                    }
                                }
                            }

                            return toggles.join(',');
                        }
                    }
                }
            },
            compareVacationNumber: {
                mapping: {
                    mapTo: 'params.compareVacationNum'
                }
            },
            currencyDisplayed: {
                mapping: {
                    mapTo: 'params.currencyDisplayed'
                }
            },
            facility: {
                id: {
                    mapping: {
                        mapTo: 'params.entity-dot-id'
                    }
                },
                name: {
                    mapping: {
                        mapTo: 'params.entity-dot-name',
                        applyFilter: {
                            replace: [['\'', '&#39;'], ['"', '&#34;'], ['`', '&#96;']]
                        }
                    }
                }
            },
            vpcSegment: {
                mapping: {
                    mapTo: 'params.vpcSegment'
                }
            }
        };
    }, ['Adapter:TestAndTarget', 'WDPRO.Analytics.Utils.convertStringToDate']);

    /* global inject */
    inject(function (addAdapter, Adapter, addScript, once, ref, set, objForEach, ensureArray, ensureObject, removeDuplicates, resolve) {
        var fbInit;
        var facebookAdapter = new Adapter({
            name: 'Facebook',
            enabled: true,
            adapt: adapt,
            adaptOnce: true
        });
        addAdapter(facebookAdapter);
        loadFacebookLibrary();

        fbInit = once(function fbInit(pixelId) {
            // warns if called more than once
            window.fbq('init', pixelId);
        });

        function adapt(model) {
            fbInit(model.config.pixelId);

            fbNormalize(model);
            promoteProductArrayProps(model);
            promoteProductProps(model);
            model.params.destination_ids = removeDuplicates(model.params.destination_ids);
            model.params.content_type = removeDuplicates(model.params.content_type);

            processUrlMappings(model);
            if (model.params.destination_ids.length === 0) delete model.params.destination_ids;
            if (model.params.content_type.length === 0) delete model.params.content_type;
            if (model.params.destination_ids) model.params.content_ids = model.params.destination_ids;

            if (model.event[0] === 'PageView' && model.params.destination_ids) {
                model.event = ['ViewContent'];
            }

            model.event.forEach(function (event) {
                return window.fbq('track', event, model.params);
            });

            resolve('Framework').fireEvent(document, 'FacebookAdapterComplete', {
                fbPixelId: model.config.pixelId,
                event: model.event.join(','),
                params: model.params
            });

            return model;
        }

        function loadFacebookLibrary() {
            var fbq;
            if (window.fbq) return;

            fbq = window.fbq = function () {
                if (fbq.callMethod) {
                    fbq.callMethod.apply(fbq, arguments);
                } else {
                    fbq.queue.push(arguments);
                }
            };

            if (!window._fbq) window._fbq = fbq;

            fbq.push = fbq;
            fbq.loaded = true;
            fbq.version = '2.0';
            fbq.queue = [];

            addScript('//connect.facebook.net/en_US/fbevents.js');
        }

        function fbNormalize(model) {
            normalizeParams(model);

            model.productsDisplayed = ensureArray(model.productsDisplayed);
            model.productsDisplayed.forEach(normalizeParams);

            model.products = ensureArray(model.products);
            model.products.sort(byProductType);
            model.products.forEach(normalizeParams);
        }

        function normalizeParams(obj) {
            obj.params = ensureObject(obj.params);
            obj.params.destination_ids = ensureArray(obj.params.destination_ids);
            obj.params.content_type = ensureArray(obj.params.content_type);
        }

        function byProductType(a, b) {
            var sortValues = {
                resortVacation: 2,
                cruise: 1
            };
            return (sortValues[a.productType] || 0) - (sortValues[b.productType] || 0);
        }

        function promoteProductArrayProps(model) {
            [model.productsDisplayed, model.products].forEach(function (arr) {
                arr.forEach(function (prod) {
                    Array.prototype.push.apply(model.params.destination_ids, prod.params.destination_ids);
                    Array.prototype.push.apply(model.params.content_type, prod.params.content_type);
                    delete prod.params.destination_ids;
                    delete prod.params.content_type;
                });
            });
        }

        function promoteProductProps(model) {
            [model.productsDisplayed, model.products].forEach(function (arr) {
                arr.forEach(function (prod) {
                    objForEach(prod.params, moveProp);
                });
            });

            function moveProp(val, key, obj) {
                model.params[key] = val;
                delete obj[key];
            }
        }

        function processUrlMappings(model) {
            if (Array.isArray(model.config.urlMapping)) {
                model.config.urlMapping.forEach(function (obj) {
                    var reg, match, result, currentValue;
                    if (obj.to && Array.isArray(obj.regexp) && (reg = new RegExp(obj.regexp[0], obj.regexp[1])) && (match = reg.exec(location.href)) && (result = match[1] || match[0])) {
                        // normalize obj.to for backwards compatibility
                        if (obj.to === 'fbDestinationId') {
                            obj.to = 'params.destination_ids';
                        } else if (obj.to === 'params.destination_id') {
                            obj.to = 'params.destination_ids';
                        }

                        currentValue = ref(obj.to, model);
                        if (obj.push || obj.to === 'params.destination_ids' || obj.to === 'params.content_type') {
                            currentValue = ensureArray(currentValue);
                            currentValue.push(result);
                            set(model, obj.to, currentValue);
                        } else if (obj.overwrite || currentValue === undefined) {
                            set(model, obj.to, result);
                        }
                    }
                });
            }
        }
    }, 'addAdapter', 'Adapter', 'addScript', 'once', 'ref', 'set', 'objForEach', 'ensureArray', 'ensureObject', 'removeArrayDuplicates', 'resolve');

    /* global inject */
    inject(function (facebookAdapter, moment, ref) {
        facebookAdapter.mapping = {
            configuration: {
                Facebook: {
                    advertiserId: {
                        mapping: {
                            mapTo: 'config.pixelId',
                            defaultValue: '397422390408189'
                        }
                    },
                    destinationId: {
                        mapping: {
                            mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
                        }
                    },
                    urlMapping: {
                        mapping: {
                            mapTo: 'config.urlMapping'
                        }
                    },
                    destination: {
                        mapping: {
                            mapTo: 'Search.destination,ViewContent.destination,InitiateCheckout.destination,Purchase.destination'
                        }
                    },
                    enableMonth: {
                        mapping: {
                            mapTo: 'config.enableMonth',
                            defaultValue: false
                        }
                    },
                    pageType: {
                        mapping: {
                            mapTo: 'InitiateCheckout.page_type'
                        }
                    }
                },
                currency: {
                    mapping: {
                        mapTo: 'ViewContent.currency,InitiateCheckout.currency,Purchase.currency',
                        defaultValue: 'USD'
                    }
                }
            },
            site: {
                mapping: {
                    mapTo: 'PageView.site,Search.site,ViewContent.site,InitiateCheckout.site,Purchase.site'
                }
            },
            events: {
                mapping: {
                    mapTo: 'events'
                }
            },
            pageType: {
                mapping: {
                    mapTo: 'InitiateCheckout.page_type'
                }
            },
            bookingSearchSeniors: {
                mapping: {
                    mapTo: 'bookingSearchSeniors'
                }
            },
            bookingSearchAdults: {
                mapping: {
                    mapTo: 'bookingSearchAdults'
                }
            },
            num_adults: {
                mapping: {
                    mapTo: 'Search.num_adults,ViewContent.num_adults,InitiateCheckout.num_adults,Purchase.num_adults',
                    defaultValue: function defaultValue(mappedModel) {
                        return (+mappedModel.bookingSearchAdults || 0) + (+mappedModel.bookingSearchSeniors || 0);
                    }
                }
            },
            bookingSearchChildren: {
                mapping: {
                    mapTo: 'bookingSearchChildren'
                }
            },
            bookingSearchInfants: {
                mapping: {
                    mapTo: 'bookingSearchInfants'
                }
            },
            num_children: {
                mapping: {
                    mapTo: 'Search.num_children,ViewContent.num_children,InitiateCheckout.num_children,Purchase.num_children',
                    defaultValue: function defaultValue(mappedModel) {
                        return (+mappedModel.bookingSearchInfants || 0) + (+mappedModel.bookingSearchChildren || 0);
                    }
                }
            },
            bookingSearchDaysBetweenSearchAndArrival: {
                mapping: {
                    mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
                }
            },
            bookingSearchArrivalDate: {
                mapping: {
                    mapTo: 'Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
                    applyFilter: {
                        date: 1
                    }
                }
            },
            bookingSearchDepartureDate: {
                mapping: {
                    mapTo: 'Search.checkout_date,ViewContent.checkout_date,InitiateCheckout.checkout_date,Purchase.checkout_date',
                    applyFilter: {
                        date: 1
                    }
                }
            },
            bookingSearchLengthOfStayNights: {
                mapping: {
                    mapTo: 'Search.number_nights,ViewContent.number_nights,InitiateCheckout.number_nights,Purchase.number_nights'
                }
            },
            bookingSearchShip: {
                mapping: {
                    mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                }
            },
            ship: {
                mapping: {
                    mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                }
            },
            device: {
                type: {
                    mapping: {
                        mapTo: 'Search.device_type,ViewContent.device_type,InitiateCheckout.device_type,Purchase.device_type'
                    }
                }
            },
            productsDisplayed: [{
                facilityId: {
                    mapping: {
                        mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
                    }
                },
                sailingId: {
                    mapping: {
                        mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
                    }
                },
                bookingSearchShip: {
                    mapping: {
                        mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                    }
                },
                ship: {
                    mapping: {
                        mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                    }
                },
                content_type: {
                    mapping: {
                        mapTo: 'PageView.content_type,Search.content_type,ViewContent.content_type,InitiateCheckout.content_type,Purchase.content_type',
                        defaultValue: ['hotel', 'product', 'destination']
                    }
                }
            }],
            location: {
                city: {
                    mapping: {
                        mapTo: 'Search.city,ViewContent.city,InitiateCheckout.city,Purchase.city'
                    }
                },
                region: {
                    mapping: {
                        mapTo: 'Search.region,ViewContent.region,InitiateCheckout.region,Purchase.region'
                    }
                },
                country: {
                    mapping: {
                        mapTo: 'Search.country,ViewContent.country,InitiateCheckout.country,Purchase.country'
                    }
                }
            },
            products: [{
                productType: {
                    mapping: {
                        mapTo: 'ViewContent.content_category,InitiateCheckout.content_category,productType'
                    }
                },
                quantity: {
                    mapping: {
                        applyFilter: {
                            type: 'integer'
                        }
                    }
                },
                facilityId: {
                    mapping: {
                        mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
                    }
                },
                sailingId: {
                    mapping: {
                        mapTo: 'Search.destination_ids,ViewContent.destination_ids,InitiateCheckout.destination_ids,Purchase.destination_ids'
                    }
                },
                destination: {
                    mapping: {
                        mapTo: 'Search.destination,ViewContent.destination,InitiateCheckout.destination,Purchase.destination'
                    }
                },
                facilityName: {
                    mapping: {
                        mapTo: function mapTo(product) {
                            if (product.productType === 'cruise') {
                                return 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship';
                            }
                            return 'ViewContent.destination_name,InitiateCheckout.destination_name,Purchase.destination_name';
                        }
                    }
                },
                bookingSearchShip: {
                    mapping: {
                        mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                    }
                },
                ship: {
                    mapping: {
                        mapTo: 'Search.ship,ViewContent.ship,InitiateCheckout.ship,Purchase.ship'
                    }
                },
                stateroom: {
                    location: {
                        mapping: {
                            mapTo: 'InitiateCheckout.ship_location,Purchase.ship_location'
                        }
                    },
                    category: {
                        mapping: {
                            mapTo: 'InitiateCheckout.category,Purchase.category'
                        }
                    }
                },
                facilityTier: {
                    mapping: {
                        mapTo: 'ViewContent.resort_type,InitiateCheckout.resort_type,Purchase.resort_type'
                    }
                },
                bookingSearchArrivalDate: {
                    mapping: {
                        mapTo: 'checkin_date,Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
                        applyFilter: {
                            date: 1
                        }
                    }
                },
                bookedArrivalDate: {
                    mapping: {
                        mapTo: 'checkin_date,Search.checkin_date,ViewContent.checkin_date,InitiateCheckout.checkin_date,Purchase.checkin_date',
                        applyFilter: {
                            date: 1
                        }
                    }
                },
                arrival_window: {
                    mapping: {
                        mapTo: 'Purchase.arrival_window',
                        defaultValue: function defaultValue(product) {
                            if (product.checkin_date) {
                                return moment(product.checkin_date).diff(moment().startOf('day'), 'days');
                            }
                        }
                    }
                },
                month: {
                    mapping: {
                        mapTo: 'Search.month,ViewContent.month,InitiateCheckout.month,Purchase.month',
                        defaultValue: function defaultValue(product, model) {
                            if (model.config.enableMonth && product.checkin_date) {
                                return moment(product.checkin_date).format('M');
                            }
                        }
                    }
                },
                bookingSearchDepartureDate: {
                    mapping: {
                        mapTo: 'Search.checkout_date,ViewContent.checkout_date,InitiateCheckout.checkout_date,Purchase.checkout_date',
                        applyFilter: {
                            date: 1
                        }
                    }
                },
                bookingSearchDaysBetweenSearchAndArrival: {
                    mapping: {
                        mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
                    }
                },
                daysBetweenBookingAndArrival: {
                    mapping: {
                        mapTo: 'Search.booking_window,ViewContent.booking_window,InitiateCheckout.booking_window,Purchase.booking_window'
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'Search.number_nights,ViewContent.number_nights,InitiateCheckout.number_nights,Purchase.number_nights'
                    }
                },
                bookedLengthOfStayNights: {
                    mapping: {
                        mapTo: 'Search.number_nights,ViewContent.number_nights,InitiateCheckout.number_nights,Purchase.number_nights'
                    }
                },
                bookingSearchSeniors: {
                    mapping: {
                        mapTo: 'partymix.seniors'
                    }
                },
                bookedSeniors: {
                    mapping: {
                        mapTo: 'partymix.seniors'
                    }
                },
                bookingSearchAdults: {
                    mapping: {
                        mapTo: 'partymix.adults'
                    }
                },
                bookedAdults: {
                    mapping: {
                        mapTo: 'partymix.adults'
                    }
                },
                bookingSearchChildren: {
                    mapping: {
                        mapTo: 'partymix.children'
                    }
                },
                bookedChildren: {
                    mapping: {
                        mapTo: 'partymix.children'
                    }
                },
                bookingSearchInfants: {
                    mapping: {
                        mapTo: 'partymix.infants'
                    }
                },
                bookedInfants: {
                    mapping: {
                        mapTo: 'partymix.infants'
                    }
                },
                num_adults: {
                    mapping: {
                        mapTo: 'Search.num_adults,ViewContent.num_adults,InitiateCheckout.num_adults,Purchase.num_adults',
                        defaultValue: function defaultValue(product) {
                            if (product.partymix) {
                                return (+product.partymix.adults || 0) + (+product.partymix.seniors || 0);
                            }
                        }
                    }
                },
                num_children: {
                    mapping: {
                        mapTo: 'Search.num_children,ViewContent.num_children,InitiateCheckout.num_children,Purchase.num_children',
                        defaultValue: function defaultValue(product) {
                            if (product.partymix) {
                                return (+product.partymix.children || 0) + (+product.partymix.infants || 0);
                            }
                        }
                    }
                },
                numberRoomsBooked: {
                    mapping: {
                        mapTo: 'ViewContent.num_rooms,Purchase.num_rooms'
                    }
                },
                content_type: {
                    mapping: {
                        mapTo: 'PageView.content_type,Search.content_type,ViewContent.content_type,InitiateCheckout.content_type,Purchase.content_type',
                        defaultValue: ['hotel', 'product', 'destination']
                    }
                },
                events: {
                    mapping: {
                        type: 'flex-array',
                        mapTo: {
                            cartAdd: 'AddToCart'
                        }
                    }
                },
                price: {
                    total: {
                        mapping: {
                            mapTo: 'product_value'
                        }
                    }
                },
                embarkation: {
                    city: {
                        mapping: {
                            mapTo: 'Search.city,ViewContent.city,InitiateCheckout.city,Purchase.city'
                        }
                    },
                    region: {
                        mapping: {
                            mapTo: 'Search.region,ViewContent.region,InitiateCheckout.region,Purchase.region'
                        }
                    },
                    country: {
                        mapping: {
                            mapTo: 'Search.country,ViewContent.country,InitiateCheckout.country,Purchase.country'
                        }
                    }
                },
                disembarkation: {
                    city: {
                        mapping: {
                            mapTo: 'Search.disembarkation_city,ViewContent.disembarkation_city,InitiateCheckout.disembarkation_city,Purchase.disembarkation_city'
                        }
                    },
                    region: {
                        mapping: {
                            mapTo: 'Search.disembarkation_region,ViewContent.disembarkation_region,InitiateCheckout.disembarkation_region,Purchase.disembarkation_region'
                        }
                    },
                    country: {
                        mapping: {
                            mapTo: 'Search.disembarkation_country,ViewContent.disembarkation_country,InitiateCheckout.disembarkation_country,Purchase.disembarkation_country'
                        }
                    }
                }
            }],
            totalBookedLengthOfStayNights: {
                mapping: {
                    mapTo: 'Search.number_nights,ViewContent.number_nights,InitiateCheckout.number_nights,Purchase.number_nights'
                }
            },
            productTotal: {
                mapping: {
                    mapTo: 'ViewContent.value,InitiateCheckout.value,Purchase.value',
                    defaultValue: '0'
                }
            },
            themepark_tickets: {
                mapping: {
                    mapTo: 'InitiateCheckout.themepark_tickets,Purchase.themepark_tickets',
                    defaultValue: function defaultValue(mappedModel) {
                        if (Array.isArray(mappedModel.products)) {
                            return mappedModel.products.reduce(function (p, c) {
                                return p + (c.productType === 'ticket' ? c.quantity : 0);
                            }, 0);
                        }
                    }
                }
            },
            room_value: {
                mapping: {
                    mapTo: 'ViewContent.room_value,InitiateCheckout.room_value,Purchase.room_value',
                    defaultValue: function defaultValue(mappedModel) {
                        if (Array.isArray(mappedModel.products)) {
                            return mappedModel.products.reduce(function (p, c) {
                                return p + (c.productType === 'resortVacation' ? +c.product_value || 0 : 0);
                            }, 0);
                        }
                    }
                }
            },
            event: {
                mapping: {
                    mapTo: 'event',
                    defaultValue: function defaultValue(model) {
                        var event = ['PageView'],
                            events = model.events;

                        if (events === undefined) events = [];
                        if (typeof events === 'string') events = events.split(',');
                        if (!Array.isArray(events)) events = [events];

                        if (someMatch(events, /purchase/i)) {
                            event = ['Purchase'];
                        } else if (someMatch(events, /checkout|cart/i)) {
                            event = ['InitiateCheckout', 'AddToCart'];
                        } else if (someMatch(events, /search/i)) {
                            event = ['Search'];
                        } else if (ref('ViewContent.destination_ids', model) || ref('productsDisplayed.0.ViewContent.destination_ids', model) || someMatch(events, /prodview|productview/i)) {
                            event = ['ViewContent'];
                        }

                        promoteEvent(event, model);
                        return event;
                    }
                }
            }
        };

        function promoteEvent(event, model) {
            var e = event[0];
            if (model) {
                if (model[e]) model.params = model[e];
                delete model.PageView;
                delete model.Search;
                delete model.ViewContent;
                delete model.InitiateCheckout;
                delete model.Purchase;
                [model.productsDisplayed, model.products].forEach(function (prodArr) {
                    if (Array.isArray(prodArr)) {
                        prodArr.forEach(function (prod) {
                            promoteEvent(event, prod);
                        });
                    }
                });
            }
        }

        function someMatch(strArr, regex) {
            return strArr.some(function (str) {
                return typeof str === 'string' && str.match(regex);
            });
        }
    }, 'Adapter:Facebook', 'moment', 'ref');

    /* global inject */
    inject(function (addAdapter, Adapter, Mustache, objForEach, resolve) {
        var adometryAdapter = new Adapter({
            name: 'Adometry',
            enabled: false,
            adapt: adapt,
            adaptOnce: true
        });
        addAdapter(adometryAdapter);

        function adapt(model) {
            promoteProductData(model);
            resolve('addScript')('//js.dmtry.com/channel.js#' + Mustache.render(model.srcTemplate, model));
        }

        function promoteProductData(model) {
            if (model.products) {
                model.products.forEach(function (product) {
                    objForEach(product.cus, function (val, key) {
                        var hasVal = key in model.cus,
                            currentVal = model.cus[key];
                        model.cus[key] = hasVal ? currentVal + ',' + val : val;
                    });
                });
                delete model.products;
            }
        }
    }, 'addAdapter', 'Adapter', 'Mustache', 'objForEach', 'resolve');

    /* global inject */
    inject(function (adometryAdapter) {
        adometryAdapter.mapping = {
            configuration: {
                Adometry: {
                    campaignId: {
                        mapping: {
                            mapTo: 'gid',
                            defaultValue: 4066
                        }
                    },
                    advertiserId: {
                        mapping: {
                            mapTo: 'advid',
                            defaultValue: 1013
                        }
                    },
                    placementId: {
                        mapping: {
                            mapTo: 'pid',
                            defaultValue: 967699
                        }
                    },
                    registrationTemplate: {
                        mapping: {
                            mapTo: 'config.registrationTemplate',
                            defaultValue: 'gid:{{gid}};advid:{{advid}};pid:{{pid}};cus.swd:{{cus.swd}};cus.lob:{{cus.lob}}'
                        }
                    },
                    registrationPlacementId: {
                        mapping: {
                            mapTo: 'config.rpid'
                        }
                    },
                    landingTemplate: {
                        mapping: {
                            mapTo: 'config.landingTemplate',
                            defaultValue: 'gid:{{gid}};advid:{{advid}};pid:{{pid}};cus.swd:{{cus.swd}};cus.lob:{{cus.lob}}'
                        }
                    },
                    conversionTemplate: {
                        mapping: {
                            mapTo: 'config.conversionTemplate',
                            defaultValue: 'gid:{{gid}};advid:{{advid}};pid:{{pid}};cus.rev:{{cus.rev}};' + 'cus.rnt:{{cus.rnt}};cus.rvp:{{cus.rvp}};cus.pid:{{cus.pid}};cus.swd:{{cus.swd}};' + 'cus.riv:{{cus.riv}};cus.pts:{{cus.pts}};cus.bkw:{{cus.bkw}};cus.ard:{{cus.ard}};' + 'cus.lob:{{cus.lob}};cus.pdc:{{cus.pdc}};cus.str:{{cus.str}};cus.tkd:{{cus.tkd}};' + 'cus.pdt:{{cus.pdt}}'
                        }
                    },
                    conversionPlacementId: {
                        mapping: {
                            mapTo: 'config.cpid'
                        }
                    }
                }
            },
            site: {
                mapping: {
                    mapTo: 'cus.lob'
                }
            },
            customerId: {
                mapping: {
                    mapTo: 'cus.swd'
                }
            },
            events: {
                mapping: {}
            },
            products: [{
                packageType: {
                    mapping: {
                        mapTo: 'cus.rvp',
                        applyFilter: {
                            case: 'lower',
                            replace: [['^packages$', 'package']]
                        }
                    }
                },
                productType: {
                    mapping: {
                        mapTo: 'cus.pdt'
                    }
                },
                confirmationNumber: {
                    mapping: {
                        mapTo: 'cus.riv'
                    }
                },
                daysBetweenBookingAndArrival: {
                    mapping: {
                        mapTo: 'cus.bkw'
                    }
                },
                bookedArrivalDate: {
                    mapping: {
                        mapTo: 'cus.ard',
                        applyFilter: {
                            date: 'YYYY-MM-DD'
                        }
                    }
                },
                facilityId: {
                    mapping: {
                        mapTo: 'facilityId'
                    }
                },
                roomTypeId: {
                    mapping: {
                        mapTo: 'roomTypeId'
                    }
                },
                portId: {
                    mapping: {
                        mapTo: 'portId'
                    }
                },
                productId: {
                    mapping: {
                        type: 'template',
                        mapTo: 'cus.pdc',
                        template: function template(model) {
                            var template = '{{{productId}}}';

                            if (model.portId) {
                                template = '{{{productId}}}-{{{facilityId}}}_{{{portId}}}-{{{roomTypeId}}}';
                            }
                            return template;
                        }
                    }
                },
                bookedAdults: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedChildren: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedInfants: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedSeniors: {
                    mapping: {
                        defaultValue: '0'
                    }
                },
                bookedLengthOfStayNights: {
                    mapping: {
                        mapTo: 'cus.rnt'
                    }
                },
                bookingSearchLengthOfStayNights: {
                    mapping: {
                        mapTo: 'cus.rnt'
                    }
                },
                pts: {
                    mapping: {
                        type: 'template',
                        template: function template(model) {
                            return model.bookedPartyTotal ? '{{{bookedPartyTotal}}}:{{{bookedSeniors}}}:{{{bookedAdults}}}:{{{bookedChildren}}}:' + '{{{bookedInfants}}}' : '';
                        },
                        mapTo: 'cus.pts',
                        transformers: {
                            bookedPartyTotal: function bookedPartyTotal(model) {
                                return +model.bookedAdults + +model.bookedChildren + +model.bookedInfants + +model.bookedSeniors;
                            }
                        }
                    }
                }
            }],
            bookingSearchLengthOfStayNights: {
                mapping: {
                    mapTo: 'cus.rnt'
                }
            },
            totalBookedLengthOfStayNights: {
                mapping: {
                    mapTo: 'cus.rnt'
                }
            },
            orderId: {
                mapping: {
                    mapTo: 'cus.pid'
                }
            },
            store: {
                mapping: {
                    mapTo: 'cus.str'
                }
            },
            productTotal: {
                mapping: {
                    mapTo: 'cus.rev'
                }
            },
            srcTemplate: {
                mapping: {
                    defaultValue: function defaultValue(model) {
                        if (model.events) {
                            if (model.events.indexOf('purchase') > -1) {
                                if (model.config.cpid) {
                                    model.pid = model.config.cpid;
                                }
                                return model.config.conversionTemplate;
                            } else if (model.events.indexOf('registration') > -1) {
                                if (model.config.rpid) {
                                    model.pid = model.config.rpid;
                                }
                                return model.config.registrationTemplate;
                            }
                        }
                        return model.config.landingTemplate;
                    }
                }
            }
        };
    }, 'Adapter:Adometry');

    /* global inject */
    inject(function (addAdapter, Adapter, $, resolve) {
        var omniAdapter = new Adapter({
            name: 'Omni',
            enabled: false,
            adapt: adapt,
            adaptOnce: true
        });
        addAdapter(omniAdapter);

        function adapt(model) {
            var Framework = resolve('Framework'),
                csrfToken = $(model.config.csrfSelector).val(),
                data = {
                analyticsId: model.visitorId
            };

            data[model.config.csrfField] = csrfToken;

            $.post(model.config.endpoint, data).done(function () {
                Framework.fireEvent(document, 'OmniVisitorPostSuccess.framework');
            }).fail(function () {
                Framework.fireEvent(document, 'OmniVisitorPostFailure.framework');
            }).always(function () {
                Framework.fireEvent(document, 'OmniAdapterComplete.framework');
            });
        }
    }, 'addAdapter', 'Adapter', '$', 'resolve');

    /* global inject */
    inject(function (omniAdapter, Analytics) {
        omniAdapter.mapping = {
            configuration: {
                Omni: {
                    endpoint: {
                        mapping: {
                            mapTo: 'config.endpoint',
                            defaultValue: '/session/set-analytics-id'
                        }
                    },
                    csrfField: {
                        mapping: {
                            mapTo: 'config.csrfField',
                            defaultValue: 'pep_csrf'
                        }
                    },
                    csrfSelector: {
                        mapping: {
                            mapTo: 'config.csrfSelector',
                            defaultValue: '#csrfToken'
                        }
                    }
                }
            },
            visitorId: {
                mapping: {
                    mapTo: 'visitorId',
                    defaultValue: function defaultValue() {
                        return Analytics.Exports.VisitorId;
                    }
                }
            }
        };
    }, 'Adapter:Omni', 'Analytics');

    /* global inject */
    inject(function (addAdapter, Adapter, getURLParameter, localStorage, addPixel, objForEach) {
        var derbySoftAdapter = new Adapter({
            name: 'DerbySoft',
            enabled: false,
            adapt: adapt,
            adaptOnce: true,
            validateEnabled: validateEnabled,
            channelCodeKey: 'afdscc',
            channelSiteKey: 'afdscs'
        });
        addAdapter(derbySoftAdapter);
        acquire();

        function adapt(model) {
            var params = [];
            if (!model.params || !model.params.channelCode) return;
            objForEach(model.params, function (value, key) {
                params.push(key + '=' + encodeURIComponent(value));
            });
            addPixel('https://linkcenterus.derbysoftca.com/dplatform-linkcenter/trackBooking?' + params.join('&'));
        }

        function validateEnabled(model) {
            var events = model.events;
            if (this.enabled) {
                if (Array.isArray(events)) {
                    events = events.join(',');
                }
                if (typeof events !== 'string' || (',' + events.toLowerCase() + ',').indexOf(',purchase,') === -1 || !localStorage.getItem(derbySoftAdapter.channelCodeKey)) {
                    this.disable();
                }
            }
        }

        function remember(urlParam, storageKey, days) {
            var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

            var value = getURLParameter(urlParam);
            if (value) {
                localStorage.setItem(storageKey, value, days);
                callback(value);
            }
        }

        function acquire() {
            remember('channelCode', derbySoftAdapter.channelCodeKey, 30, remember.bind(null, 'channelSite', derbySoftAdapter.channelSiteKey, 30, undefined));
        }
    }, 'addAdapter', 'Adapter', 'getURLParameter', 'localStorage', 'addPixel', 'objForEach');

    /* global inject */
    inject(function (derbySoftAdapter, moment, ref, localStorage, getCookie, isoDate) {
        var channelSite = void 0;

        derbySoftAdapter.mapping = {
            products: {
                mapping: {}
            },
            rrooms: {
                mapping: {
                    mapTo: 'rooms',
                    defaultValue: function defaultValue(model) {
                        return model.products.filter(function (r) {
                            return r.productType === 'resortVacation';
                        });
                    }
                }
            },
            configuration: {
                DerbySoft: {
                    accountCode: {
                        mapping: {
                            mapTo: 'params.accountCode',
                            defaultValue: 'disney'
                        }
                    }
                },
                currency: {
                    mapping: {
                        mapTo: 'params.currency',
                        defaultValue: 'USD'
                    }
                }
            },
            orderId: {
                mapping: {
                    mapTo: 'params.bookingNo'
                }
            },
            channelCode: {
                mapping: {
                    mapTo: 'params.channelCode',
                    defaultValue: function defaultValue() {
                        return localStorage.getItem(derbySoftAdapter.channelCodeKey);
                    }
                }
            },
            channelSite: {
                mapping: {
                    defaultValue: function defaultValue() {
                        return channelSite = localStorage.getItem(derbySoftAdapter.channelSiteKey);
                    },
                    mapTo: function mapTo() {
                        return channelSite ? 'params.channelSite' : undefined;
                    }
                }
            },
            hotelCode: {
                mapping: {
                    mapTo: 'params.hotelCode',
                    defaultValue: firstObjProp('rooms', 'facilityId')
                }
            },
            roomTypeCode: {
                mapping: {
                    mapTo: 'params.roomTypeCode',
                    defaultValue: firstObjProp('rooms', 'roomTypeId')
                }
            },
            ratePlanCode: {
                mapping: {
                    mapTo: 'params.ratePlanCode',
                    defaultValue: firstObjProp('rooms', 'offerId')
                }
            },
            checkInDate: {
                mapping: {
                    mapTo: 'params.checkInDate',
                    defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchArrivalDate'))
                }
            },
            checkOutDate: {
                mapping: {
                    mapTo: 'params.checkOutDate',
                    defaultValue: isoDateFn(firstObjProp('rooms', 'bookingSearchDepartureDate'))
                }
            },
            guests: {
                mapping: {
                    mapTo: 'params.guests',
                    defaultValue: function defaultValue(model) {
                        return model.rooms.reduce(function (p, c) {
                            return p + (+c.bookingSearchSeniors || 0) + (+c.bookingSearchAdults || 0) + (+c.bookingSearchChildren || 0) + (+c.bookingSearchInfants || 0);
                        }, 0);
                    }
                }
            },
            rooms: {
                mapping: {
                    mapTo: 'params.rooms',
                    defaultValue: function defaultValue(model) {
                        return model.rooms.reduce(function (p, c) {
                            return p + (+c.numberRoomsBooked || +c.quantity || 0);
                        }, 0);
                    }
                }
            },
            netAmount: {
                mapping: {
                    mapTo: 'params.netAmount',
                    defaultValue: function defaultValue(model) {
                        return model.rooms.reduce(function (p, c) {
                            return p + (+ref('price.subTotal', c) || 0);
                        }, 0);
                    }
                }
            },
            totalAmount: {
                mapping: {
                    mapTo: 'params.totalAmount',
                    defaultValue: function defaultValue(model) {
                        return model.rooms.reduce(function (p, c) {
                            return p + (+ref('price.total', c) || 0);
                        }, 0);
                    }
                }
            },
            device: {
                type: {
                    mapping: {
                        mapTo: 'params.device'
                    }
                },
                viewType: {
                    mapping: {
                        mapTo: 'params.device'
                    }
                }
            },
            cookiedevice: {
                mapping: {
                    mapTo: 'params.device',
                    defaultValue: function defaultValue(model) {
                        if (!model.params.device) {
                            return ref('deviceInfo.device', getCookie('WDPROView', true));
                        }
                    }
                }
            }
        };

        function firstObjProp(arrRef, prop) {
            var startingValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            return function (model) {
                return ref(arrRef, model).reduce(function (p, c) {
                    return p || c[prop];
                }, startingValue);
            };
        }

        function isoDateFn(fn) {
            return function () {
                return isoDate(fn.apply(this, arguments));
            };
        }
    }, 'Adapter:DerbySoft', 'moment', 'ref', 'localStorage', 'getCookie', 'isoDate');

    /* global inject */

    inject.store('DPIConfirmationPageFix', function DPIConfirmationPageFix(model) {
        if (model.configuration && model.configuration.modelSpec === 'photopass' && model.pageId === 'Confirmation' && model.siteSection === 'Commerce') {
            model.events = 'purchase,pageView';
        }
    });

    /* global inject */

    inject.store('changeConfigWcaToFacebook', function changeConfigWcaToFacebook(model) {
        var config = model.configuration;
        var facebookProperty = 'Facebook';
        var websiteCustomAudiencesProperty = 'WebsiteCustomAudiences';

        if (config) {
            if (!config[facebookProperty] && config[websiteCustomAudiencesProperty]) {
                config[facebookProperty] = config[websiteCustomAudiencesProperty];
            }
            delete config[websiteCustomAudiencesProperty];
        }
    });

    /* global inject */

    inject(function (Parsers, store) {
        store('complexToggles', function complexToggles(model) {
            var toggles, toggleType, toggle;

            if (model.toggleStatus) {
                toggles = model.toggleStatus;
                for (toggleType in toggles) {
                    if (toggles.hasOwnProperty(toggleType)) {
                        for (toggle in toggles[toggleType]) {
                            if (toggles[toggleType].hasOwnProperty(toggle)) {
                                if (Parsers.isObject(toggles[toggleType][toggle])) {
                                    if (typeof toggles[toggleType][toggle].decision !== 'undefined') {
                                        toggles[toggleType][toggle] = toggles[toggleType][toggle].decision.toString();
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }, 'Parsers', 'store');

    /* global inject */
    inject(function (store, ensureArray, moment) {
        store('deriveDepartureDate', function deriveDepartureDate(model) {
            makeDepartureDate(model);
            ensureArray(model.products).forEach(makeDepartureDate);
        });

        function makeDepartureDate(obj) {
            var arrival = obj.bookingSearchArrivalDate;
            var numNights = +obj.bookingSearchLengthOfStayNights;
            if (!obj.bookingSearchDepartureDate && arrival && numNights && (arrival = moment(arrival, ['MM/DD/YYYY', 'YYYY-MM-DD'])) && arrival.isValid()) {
                obj.bookingSearchDepartureDate = arrival.add(numNights, 'days').format('YYYY-MM-DD');
            }
        }
    }, 'store', 'ensureArray', 'moment');

    /* global inject */
    inject(function (Parsers, cleanArray, store) {
        store('forceContentTestsArray', function forceContentTestsArray(model) {
            if (model.contentTests) {
                if (Parsers.isObject(model.contentTests)) {
                    model.contentTests = Parsers.applyFilter(model.contentTests, { forceArray: '' });
                }
                model.contentTests = cleanArray(model.contentTests);
            }
        });
    }, 'Parsers', 'cleanArray', 'store');

    /* global inject */

    inject.store('getGenderfromTitle', function getGenderfromTitle(model) {
        var genders = {
            'Mr.': 'M',
            'Ms.': 'F',
            'Miss.': 'F',
            'Mrs.': 'F',
            'Mstr.': 'M'
        };
        if (!model.gender && model.title && genders[model.title]) {
            model.gender = genders[model.title];
        }
    });

    /* global inject */

    inject.store('getOSfromUserAgent', function getOSfromUserAgent(model) {
        var userAgent = model.userAgent || window.navigator.userAgent,
            start,
            end,
            result = '';

        if (userAgent) {
            start = userAgent.indexOf('(');
            end = userAgent.indexOf(')', start);
            if (start > -1 && end > -1) {
                result = userAgent.substring(start + 1, end);
            } else {
                result = userAgent;
            }
        }

        model.osVersion = result;
    });

    /* global inject */

    inject(function ($, store) {
        store('legacyPaymentMethods', function getOSfromUserAgent(model) {
            var paymentMethods = ['creditCard', 'giftCard', 'pointsPayment', 'instantCredit', 'rewardsCard'],
                oldMethods;

            if (model.payment && model.payment.paymentMethods && !Array.isArray(model.payment.paymentMethods)) {
                oldMethods = $.extend(true, {}, model.payment.paymentMethods);
                model.payment.paymentMethods = [];
                paymentMethods.forEach(function (method) {
                    var methodName = method + 'Name',
                        oldMethod = oldMethods[methodName];

                    if (oldMethod) {
                        model.payment.paymentMethods.push({
                            name: oldMethod,
                            type: method,
                            status: 'unknown'
                        });
                    }
                });
            }
        });
    }, '$', 'store');

    /* global inject */
    // Move contentLanguage & contentLocale into configuration if not in there and set on root model
    inject(function (store, moveProp) {
        store('moveLanguageLocale', function (model) {
            if (model.configuration) {
                moveProp(model, ['contentLanguage', 'contentLocale'], model.configuration);
            }
        });
    }, 'store', 'moveProp');

    /* global inject */
    inject(function (Analytics, Parsers, cleanArray, store) {
        store('normalizePersonalizationObject', function normalizePersonalizationObject(model) {
            var personalizationId;

            if (model.personalizations) {
                if (Parsers.isObject(model.personalizations)) {
                    model.personalizations = Parsers.applyFilter(model.personalizations, { forceArray: '' });
                }
                model.personalizations = cleanArray(model.personalizations);
                model.personalizations.forEach(function (location) {
                    if (location.vpcSegment) {
                        model.vpcSegment = location.vpcSegment;
                    }
                });
            }

            personalizationId = Analytics.getPersonalizationId(model);
            if (personalizationId) {
                model.personalizationId = personalizationId;
            }
        });
    }, 'Analytics', 'Parsers', 'cleanArray', 'store');

    /* global inject */

    // Used to convert old Dart config format to the new one which utilizes an array of tags inside configuration.Dart.tags

    inject.store('oldFormatDartTagConversion', function oldFormatDartTagConversion(model) {
        if (model.configuration && model.configuration.Dart && !model.configuration.Dart.tags) {
            model.configuration.Dart.tags = [{
                advertiserId: model.configuration.Dart.advertiserId,
                groupTagString: model.configuration.Dart.groupTagString,
                activityTagString: model.configuration.Dart.activityTagString
            }];
        }
    });

    /* global inject */

    inject.store('populateAdditionalDataFromProducts', function populateAdditionalDataFromProducts(model) {
        var productTotal = 0,
            productSubTotal = 0,
            foundOfferId = false;

        if (model.products) {
            model.products.forEach(function (prod) {
                if (prod && prod.price) {
                    if (prod.price.total) {
                        productTotal += +prod.price.total || 0;
                    }

                    if (prod.price.subTotal) {
                        productSubTotal += +prod.price.subTotal || 0;
                    } else if (prod.price.total) {
                        productSubTotal += (+prod.price.total || 0) - (+prod.price.tax || 0) - (+prod.price.shipping || 0);
                    }
                }

                /**
                * offerId can easily be confused as being part of a product
                * so if its set for a resortVacation product and a top level
                * offerId is not set then we'll set the top level offerId to
                * the first offerId found in a resortVacation product.
                */
                if (!foundOfferId) {
                    if (prod.productType && prod.productType === 'resortVacation' && prod.offerId && !model.offerId) {
                        // offerId should not be moved up if event for product is cartRemove
                        if (!prod.events || prod.events.indexOf('cartRemove') === -1) {
                            model.offerId = prod.offerId;
                            foundOfferId = true;
                        }
                    }
                }
            });

            model.productTotal = Math.round(productTotal * 100) / 100;
            model.productSubTotal = Math.round(productSubTotal * 100) / 100;
        }
    });

    /* global inject */

    inject(function (Parsers, store) {
        store('removeExtraPersonalizationLocations', function removeExtraPersonalizationLocations(model) {
            var numLocations, i, location;
            if (model.personalizations) {
                if (Array.isArray(model.personalizations)) {
                    numLocations = model.personalizations.length;
                    if (numLocations) {
                        for (i = numLocations - 1; i >= 0; i--) {
                            location = model.personalizations[i];
                            location.locationType = location.locationType || 'default';
                            if (!location.customerGroup && location.locationType === 'default') {
                                model.personalizations.splice(i, 1);
                            }
                        }
                    }
                } else if (Parsers.isObject(model.personalizations)) {
                    for (location in model.personalizations) {
                        if (model.personalizations.hasOwnProperty(location)) {
                            model.personalizations[location].locationType = model.personalizations[location].locationType || 'default';
                            if (!model.personalizations[location].customerGroup && model.personalizations[location].locationType === 'default') {

                                delete model.personalizations[location];
                            }
                        }
                    }
                }
            }
        });
    }, 'Parsers', 'store');

    /* global inject */

    inject.store('removeLeadingTrailingSlashes', function removeLeadingTrailingSlashes(model) {
        if (model.pageId) {
            model.pageId = model.pageId.toString();
            if (model.pageId.substr(0, 1) === '/') {
                model.pageId = model.pageId.substr(1);
            }
            if (model.pageId.substr(model.pageId.length - 1, 1) === '/') {
                model.pageId = model.pageId.slice(0, -1);
            }
        }

        if (model.siteSection) {
            if (model.siteSection.substr(0, 1) === '/') {
                model.siteSection = model.siteSection.substr(1);
            }
            if (model.siteSection.substr(model.siteSection.length - 1, 1) === '/') {
                model.siteSection = model.siteSection.slice(0, -1);
            }
        }
    });

    /* global inject */

    // Since the Analytics Post Processor for Configulator messes up outputing objects that use brackets we
    // decided to use dashes in place of dots (in products rules)
    // Example: foo.bar[baz.boo]=1 outputs to foo.bar[]=1 which is not what we want
    // so we went with the following: foo.bar.baz-boo=1

    inject(function (Config, store) {
        store('restoreProductRuleDots', function restoreProductRuleDots(model) {
            Object.keys(Config.products).forEach(function (product) {
                var rules;
                if (model.configuration && model.configuration[product] && model.configuration[product].rules) {
                    rules = model.configuration[product].rules;
                    Object.keys(rules).forEach(function (rule) {
                        var newRule;
                        if (rule.indexOf('-') > -1) {
                            newRule = rule.replace('-', '.');
                            rules[newRule] = rules[rule];
                            delete rules[rule];
                        }
                    });
                }
            });
        });
    }, 'Config', 'store');

    /* global inject */
    inject(function (store, ensureArray) {
        store('transitionCruisesToCruiseType', function transitionCruisesToCruiseType(model) {
            ['products', 'productsDisplayed', 'failedProducts'].forEach(function (prop) {
                ensureArray(model[prop]).forEach(function (prod) {
                    if (prod.portId || prod.bookingSearchDeparturePort) {
                        prod.productType = 'cruise';
                    }
                });
            });
        });
    }, 'store', 'ensureArray');

    /* global inject */
    /*
    Normalization of the data layer is good for:
      😀 populating computed values that apply across all sites
      😀 converting multiple allowed input formats into the canonical version (delimited string > array)
      😀 changing the model structure while maintaining backwards compatibility
    
    Normalization is 𝙉𝙊𝙏 for:
      😡 site-specific logic and fixes
      😡 DOM-based data (since that's unlikely to be future-proof nor consistent across all sites)
    */

    inject(function (resolve, store) {
        var normalizeFns;

        store('normalize', function normalize(model) {
            if (model) {
                normalizeFunctions().forEach(function (fn) {
                    fn(model);
                });
            }
        });

        function normalizeFunctions() {
            return normalizeFns || (normalizeFns = ['changeConfigWcaToFacebook', 'oldFormatDartTagConversion', 'forceContentTestsArray', 'normalizePersonalizationObject', 'restoreProductRuleDots', 'moveLanguageLocale', 'getOSfromUserAgent', 'transitionCruisesToCruiseType', 'deriveDepartureDate', 'populateAdditionalDataFromProducts', 'getGenderfromTitle', 'DPIConfirmationPageFix', 'removeExtraPersonalizationLocations', 'complexToggles', 'removeLeadingTrailingSlashes', 'legacyPaymentMethods'].map(resolve));
        }
    }, 'resolve', 'store');

    /* global inject, s_wdpro, mboxExecutionOrder:true */
    inject(function (Analytics, Config, $, Debug, Parsers, Utils, objForEach, store, normalize, convertPromise, mergeObjectsByKey, iniBoolean) {
        'use strict';

        var parentModelRef = {},
            F;

        Analytics.additionalModelData = Analytics.additionalModelData || [];

        F = Analytics.Framework = {
            analyticsModel: [],
            baseModelPromise: $.Deferred(),
            base64DecodedModel: false,
            baseModelProcessed: false,
            pageHasAnalytics: false,
            PROD_BASE_URL: 'http://secure.cdn1.wdpromedia.com/analytics/framework/',
            PROD_SECURE_URL: 'https://secure.cdn1.wdpromedia.com/analytics/framework/',
            QA_BASE_URL: 'http://analytics-qa.disney.go.com/analytics/framework/',
            QA_SECURE_URL: 'https://cdn1.wdpromedia-le.disney.go.com/analytics/framework/',
            LT_BASE_URL: 'http://wdpromedia-lt.disney.go.com/analytics/framework/',
            LT_SECURE_URL: 'https://wdpromedia-lt.disney.go.com/analytics/framework/',
            modelSpec: false,
            environment: 'PROD',
            disabledEvents: [],
            flagDisableCustomLinks: false,
            pageGroupId: false,
            modelQueue: [],
            trackElementQueue: [],
            mergeObjParams: ['namespace', 'storeType', 'site', 'contentLocale', 'contentLanguage', 'siteSection', 'pageId'],
            defaultProductIsOff: {},
            fireEvent: function fireEvent(node, event, data) {
                $(node).trigger(event, data || {});
            },
            // Do a deep merge of two model objects
            mergeModel: function mergeModel(updatedObj, existingObj) {
                var parsedModel = Parsers.mergeObjects(updatedObj, existingObj, this.mergeObjParams, false);
                return parsedModel;
            },
            checkForAnalyticsData: function checkForAnalyticsData() {
                if (!this.pageHasAnalytics && $('[data-analytics]').size() > 0) {
                    this.pageHasAnalytics = true;
                }

                return this.pageHasAnalytics;
            },
            reset: function reset() {
                var prop;

                for (prop in s_wdpro) {
                    if (s_wdpro.hasOwnProperty(prop)) {
                        //only add relevant items into s_wdpro
                        if (prop.indexOf('prop') > -1 || prop.indexOf('eVar') > -1 || prop.indexOf('hier') > -1 || prop === 'pageName' || prop === 'events' || prop === 'products' || prop === 'state' || prop === 'zip' || prop === 'purchaseID' || prop === 'channel' || prop === 'getPPVid' || prop === 'pageURL') {
                            delete s_wdpro[prop];
                        }
                    }
                }
                s_wdpro.contextData = {};
                F.base64DecodedModel = false;
                F.analyticsModel = [];
                parentModelRef = {};

                if (F.modelSpec) {
                    F.modelSpec = false;
                }

                /* reset isOff to default state for all products */
                objForEach(F.defaultProductIsOff, function (offState, productName) {
                    var product = Config.products[productName];
                    if (product) {
                        product.isOff = offState;
                        if (typeof product.reset === 'function') {
                            product.reset();
                        }
                    }
                });

                Config.products.SiteCatalyst.firstCall = true;
                if (Config.products.CEA) {
                    Config.products.CEA.firstRun = true;
                    Config.products.CEA.captureOn = true;
                    Config.products.CEA.decisionOn = true;
                    Config.products.CEA.pageData = {};
                }
                if (Config.products.MyPoints) {
                    delete Config.products.MyPoints;
                }
                F.flagDisableCustomLinks = false;
                F.disabledEvents = [];
                F.baseModelProcessed = false;
                F.modelSpec = false;
                F.pageHasAnalytics = false;
                $('iframe.DoubleClickIFrame').remove();
                Config.products.SiteCatalyst.CALL_NUMBER_COUNTER = 0;
                if (typeof mboxExecutionOrder !== 'undefined') {
                    mboxExecutionOrder = [];
                }

                if (Config.products.WebsiteCustomAudiences) {
                    Config.products.WebsiteCustomAudiences.hasFired = false;
                }

                if (Config.products.GoogleRemarketing) {
                    Config.products.GoogleRemarketing.hasFired = false;
                    Config.products.GoogleRemarketing.conversionHasFired = false;
                }
                if (Config.products.DITracking) {
                    Config.products.DITracking.hasFired = false;
                }

                if (F.baseModelPromise.state() === 'pending') {
                    F.baseModelPromise.reject();
                }

                F.baseModelPromise = $.Deferred();

                setupBaseModelResolution();
            },
            processModelQueue: function processModelQueue() {
                var i,
                    queue = F.modelQueue,
                    queueSize = queue.length,
                    trackElementQueue = F.trackElementQueue,
                    trackElementQueueLength = trackElementQueue.length,
                    model = {};

                if (queueSize > 0) {
                    for (i = 0; i < queueSize; i++) {
                        $.extend(true, model, queue[i]);
                    }
                    F.modelQueue = [];
                    this.processModel(model);
                }

                for (i = 0; i < trackElementQueueLength; i++) {
                    F.trackElement(trackElementQueue[i].event, trackElementQueue[i].model);
                }
                F.trackElementQueue = [];
            },
            /*Used for dynamicaly passing semantic models to the framework for processing*/
            update: function update(semanticModel) {
                if (!semanticModel) {
                    return false;
                }

                //Clone the object to avoid changes to the model causing issues if the site maintains references
                semanticModel = $.extend(true, {}, semanticModel);

                if (!this.baseModelProcessed) {
                    // there is not a full model coming in we'll add this to a queue
                    if (!semanticModel.configuration) {
                        F.modelQueue.push(semanticModel);
                        return false;
                    }
                }

                if (this.baseModelPromise.state() === 'pending') {
                    this.baseModelPromise.resolve(semanticModel);
                } else {
                    processUpdate(semanticModel);
                }

                Debug.debug('update method called with semantic model: ', semanticModel);
            },
            /*Used to get an array of semantic models that were set. The first item in the array is always the main model*/
            getModels: function getModels() {
                return this.analyticsModel;
            },
            resetModels: function resetModels() {
                this.analyticsModel = [];
            },
            /*get the parent model*/
            getParentModel: function getParentModel() {
                return parentModelRef;
            },
            updateElement: function updateElement(selector, event, model) {
                F.fireEvent(selector, event, model);
            },
            trackElement: function trackElement(event, model) {
                var product,
                    products = Config.products;
                if (!this.baseModelProcessed) {
                    this.trackElementQueue.push({ event: event, model: model });
                } else {
                    normalize(model);
                    for (product in products) {
                        if (products.hasOwnProperty(product)) {
                            if (products[product].adapter && products[product].trackElement) {
                                products[product].trackElement(event, model);
                            }
                        }
                    }
                }
            },
            addListener: function addListener(eventName, callback) {
                $(document).bind(eventName, callback);
            },
            genPageGroupId: function genPageGroupId(force) {
                var nowDate = new Date();
                if (this.pageGroupId === false || force) {
                    this.pageGroupId = Utils.getUTCTime(nowDate).toString() + Utils.getRandomInt(100000, 999999).toString();
                }
                return this.pageGroupId;
            },
            getPageGroupId: function getPageGroupId() {
                return this.pageGroupId;
            },
            /*
             * This should realy only be used for customEvents and not for
             * a generic click event as unbind without a handler reference
             * will unbind all of that type of events, thus this is why this
             * method is hard coded to not disable clicks
             *
             * Example of usage would be:
             * WDPRO.Analytics.Framework.disableEvent('facetTrack');
             */
            disableEvent: function disableEvent(event) {
                var disabledEvents = this.disabledEvents;
                if (event !== 'click') {
                    if (this.isEventEnabled(event) === true) {
                        Debug.info('Adding ' + event + ' to disabled events');
                        disabledEvents.push(event);
                    }
                }
            },
            enableEvent: function enableEvent(event) {
                var idx;
                if (this.isEventEnabled(event) === false) {
                    Debug.info('Removing ' + event + ' from disabled events');
                    idx = Utils.Array.indexOf(this.disabledEvents, event);
                    Utils.Array.remove(this.disabledEvents, idx);
                }
            },
            isEventEnabled: function isEventEnabled(event) {
                return Utils.Array.indexOf(this.disabledEvents, event) === -1;
            },
            getLibrary: function getLibrary() {
                return {
                    name: 'jQuery',
                    version: $.jquery,
                    ref: $
                };
            },
            getVersion: function getVersion() {
                return '4.0.43';
            }
        };
        store('Framework', F);
        store('productMap', productMap);

        function initializeFramework() {
            /**
             * Generate a Random ID that can be used for SiteCatalyst & Dart Requests on this instance of the page
             */
            F.genPageGroupId();

            /**
             * getAnalyticsModel
             * Gets model from data-analytics attribute on an items on the page, parses it and stores it on WDPRO.Analytics.Framework.analyticsModel
             *
             * @return boolean true on success
             */
            F.getAnalyticsModel = function () {
                var decodedModels,
                    encodedModel,
                    match = /^[a-z0-9/+]+[=]*$/i,
                    decodedModel,
                    parsedModel;
                decodedModels = $('[data-analytics]').map(function () {
                    try {
                        encodedModel = $(this).attr('data-analytics');
                        if (encodedModel) {
                            if (match.test(encodedModel) === true) {
                                decodedModel = atob(encodedModel);
                                parsedModel = $.parseJSON(decodedModel);
                            } else {
                                Debug.error('Encoded analytics model contains invalid characters');
                                if (encodedModel.length % 3 !== 0) {
                                    Debug.error('Encoded analytics model is not proper length, ' + 'length should be divisible by 3');
                                }
                            }
                            if (parsedModel) {
                                return parsedModel;
                            }
                        }
                    } catch (err) {
                        Debug.log(encodedModel);
                        Debug.error('There was a problem while trying to decode the analytics model: ' + err.toString());
                        Debug.log(decodedModel);
                    }
                });

                if (!encodedModel) {
                    return false;
                }
                // There should only ever be one encoded model on the page
                F.base64DecodedModel = decodedModels[0];
                return true;
            };

            /**
             * checkForModelSpec
             * scans all defined models for a modelSpec so that the appropriate packages can be loaded before
             * processing the model
             * if default package is set return true. return false if a package needs to be loaded and the
             * processing of the model(s) will be defered
             */

            F.checkForModelSpec = function (semanticModel, callback) {
                var modelArr,
                    model,
                    m = 0,
                    foundSpec = false;

                if (F.modelSpec === false) {
                    // Model spec should only be loaded once
                    //we potentially have an array of SAM's but not always. We will normalize this
                    if (!Array.isArray(semanticModel) && Parsers.isObject(semanticModel)) {
                        modelArr = [semanticModel];
                    } else if (Array.isArray(semanticModel)) {
                        modelArr = semanticModel;
                    } else {
                        return false;
                    }

                    //loopining through each model
                    for (m; modelArr[m]; m++) {
                        model = modelArr[m];

                        if (model.configuration) {
                            if (model.configuration.modelSpec) {
                                if (model.configuration.modelSpec.length > 0) {
                                    foundSpec = model.configuration.modelSpec;
                                    if (model.configuration.environment) {
                                        F.environment = model.configuration.environment.toUpperCase();
                                    }
                                    break; // Only the first instance of modelSpec should be loaded
                                }
                            }
                        }
                    }
                    if (foundSpec === false) {
                        foundSpec = 'default';
                        F.modelSpec = 'default';
                        Debug.info('modelSpec defaulting to default');
                    }
                    if (foundSpec !== 'default') {
                        Debug.info('modelSpec being set to: ' + foundSpec);
                        F.loadModelSpec(foundSpec, function () {
                            callback(semanticModel);
                        });
                        // we do not need to continue on, processModel will be called once the bundle is loaded
                        return;
                    }
                }
                callback(semanticModel);
                return true;
            };

            F.getPackageURL = function (packageName) {
                var type = Utils.getURLProtocol() === 'https://' ? 'SECURE' : 'BASE',
                    path,
                    env = F.environment.toUpperCase(),
                    basePath;

                // EXAMPLE: https://analytics.disney.go.com/analytics/framework/1.5.0/packages/photopass/photopass.min.js
                basePath = F[env + '_' + type + '_URL'] || F['PROD_' + type + '_URL'];
                basePath = '' + basePath + F.getVersion() + '/packages/';
                if (F.modelSpecPathOverride && location.hostname === 'localhost') {
                    basePath = F.modelSpecPathOverride;
                }
                path = '' + basePath + packageName + '/' + packageName + (Debug.isEnabled ? '' : '.min') + '.js';

                return path;
            };

            /**
             * loadSpec
             * load a modelSpec package from a remote server
             *
             */
            F.loadModelSpec = function (packages, callback) {
                var src,
                    length,
                    deferreds = [],
                    idx;

                packages = packages.split(',');
                length = packages.length;

                if (!$.loadPackage) {
                    $.loadPackage = function (url, options) {
                        // allow user to set any option except for dataType, cache, and url
                        options = $.extend(options || {}, {
                            dataType: 'script',
                            cache: !Debug.isEnabled,
                            url: url
                        });
                        // Use $.ajax() since it is more flexible than $.getScript
                        // Return the jqXHR object so we can chain callbacks
                        return $.ajax(options).fail(function () {
                            Debug.log('Failed to Load: ' + src + ' For the following reason (' + arguments[1] + ') - ' + arguments[2]);
                        });
                    };
                }

                for (idx = 0; idx < length; idx++) {
                    src = F.getPackageURL(packages[idx]);
                    deferreds.push($.loadPackage(src));
                }

                $.when.apply($, deferreds).done(function () {

                    F.modelSpec = packages.join(',');
                    Debug.log('Calling Callback for loadModelSpec');
                    if (callback) {
                        callback();
                    }
                });
            };

            /**
             * processModel
             * Processes model passed as param
             *
             * @return boolean true on success
             */
            F.processModel = function (semanticModel) {
                var pName,
                    p,
                    modelArr,
                    model,
                    mappedModel,
                    i,
                    l,
                    m = 0,
                    sp,
                    de,
                    dep,
                    timeoutFire = [],
                    child,
                    toLength,
                    createBoundEvent,
                    j = 0,
                    k = 0,
                    createTimeout,
                    prodDependancies,
                    prodDepLength;

                Config.initialParsedModels = [];

                //we potentially have an array of SAM's but not always. We will normalize this
                if (!Array.isArray(semanticModel) && Parsers.isObject(semanticModel)) {
                    modelArr = [semanticModel];
                } else if (Array.isArray(semanticModel)) {
                    modelArr = semanticModel;
                } else {
                    return false;
                }

                //loopining through each model
                for (m; modelArr[m]; m++) {
                    model = modelArr[m];
                    normalize(model);

                    if (model) {
                        model.pageGroupId = F.getPageGroupId();

                        //Lets make sure the framework is not off
                        if (model.configuration && Parsers.toBoolean(model.configuration.turnOff)) {
                            return;
                        }

                        /**
                         * Populate the disabled events via disableEvents property in configuration object
                         */
                        if (model.configuration) {
                            if (Array.isArray(model.configuration.disabledEvents)) {
                                for (de = 0; de < model.configuration.disabledEvents.length; de++) {
                                    F.disableEvent(model.configuration.disabledEvents[de]);
                                }
                            }
                        }

                        /* for now we are looking at the config to figure out which products to run, in the furture we will be able to use properties from a model in combination with the config to determine what to run */
                        if (Config) {
                            sp = Config.supportedProducts;
                            l = sp.length;

                            sp.forEach(function (pName) {
                                return processProductRules(pName, model);
                            });

                            //go through all supported products
                            for (i = 0; i < l; i++) {
                                pName = sp[i];
                                p = Config.products[pName];
                                mappedModel = productMap(p, pName, model);
                                if (mappedModel) {
                                    Config.initialParsedModels[pName] = mappedModel;
                                }
                            }
                        }
                    }
                }

                createBoundEvent = function createBoundEvent(child) {
                    var newChild = $.extend(true, {}, child);
                    $(document).one(newChild.event, newChild, function (event) {
                        var product = Config.products[event.data.product];
                        if (product && typeof product.adapter === 'function' && product.isOff !== true) {
                            product.adapter(event.data.model);
                        }
                    });
                };

                createTimeout = function createTimeout(timeout, event) {
                    setTimeout(function () {
                        F.fireEvent(document, event);
                    }, timeout);
                };
                prodDependancies = $.extend(true, [], Config.dependancies);
                prodDepLength = prodDependancies.length;
                for (j; j < prodDepLength; j++) {
                    dep = prodDependancies[j];
                    if (dep.dependants) {
                        k = 0;
                        for (k; k < dep.dependants.length; k++) {
                            child = dep.dependants[k];
                            if (child.event) {

                                if (Config.products[dep.product].isOff === false || Config.products[child.product].isOff === false) {
                                    child.model = $.extend(true, {}, Config.initialParsedModels[child.product]);
                                    if (Config.products[dep.product].isOff === true && child.required === true && !child.timeout) {
                                        child.event = 'parseModelComplete.framework';
                                    } else if (Config.products[dep.product].isOff === true && child.required === true && child.timeout) {
                                        child.event = child.product + '_TimedEvent.framework';
                                        timeoutFire.push(child);
                                    }

                                    createBoundEvent(child);
                                }
                            }
                        }
                        if (dep.immediate && dep.immediate === true && Config.products[dep.product].isOff === false) {
                            dep.event = 'parseModelComplete.framework';
                            dep.model = $.extend(true, {}, Config.initialParsedModels[dep.product]);
                            if (dep.model.triggerTimeout) {
                                dep.timeout = parseInt(dep.model.triggerTimeout, 10);
                                dep.event = dep.product + '_TimedEvent.framework';
                                timeoutFire.push(dep);
                            }
                            createBoundEvent(dep);
                        }
                    } else {
                        dep.event = 'parseModelComplete.framework';
                        dep.model = $.extend(true, {}, Config.initialParsedModels[dep.product]);
                        if (dep.model.triggerTimeout) {
                            dep.timeout = parseInt(dep.model.triggerTimeout, 10);
                            dep.event = dep.product + '_TimedEvent.framework';
                            timeoutFire.push(dep);
                        }
                        createBoundEvent(dep);
                    }
                }

                toLength = timeoutFire.length;
                if (toLength > 0) {
                    i = 0;
                    for (i; i < toLength; i++) {
                        createTimeout(timeoutFire[i].timeout, timeoutFire[i].event);
                    }
                }
                F.baseModelProcessed = true;
                F.fireEvent(document, 'parseModelComplete.framework', semanticModel);
                F.processModelQueue();
            };

            /*
             * start
             * Parses and maps the semantic model received to the configurations for
             * each product and calls the adapaters for each product
             */
            F.start = function () {
                $(function () {
                    var enableDbg = Parsers.toBoolean(Utils.getURLParameter('AnalyticsDbg'));
                    Debug.setDebug(enableDbg);
                    if (F.getAnalyticsModel() === true) {
                        F.update(F.base64DecodedModel);
                    }
                });
            };

            // used to allow framework to accept either an id or a jquery selector for elements and actually sets it to
            // the element
            F.getElementByIdOrSelector = function (elementId) {
                var element;
                //test if element id is a selector and not an actual id
                element = document.getElementById(elementId);
                if (!element) {
                    /*We will only get the first result of a selector since Id's must be unique*/
                    element = $(elementId).first()[0];
                }
                return element;
            };

            F.turnOn = function (pName, model) {
                var mappedModel,
                    p = Config.products[pName] || {};

                model = model || F.getParentModel();
                if (model && p.adapter) {
                    normalize(model);

                    if (typeof p.turnOn === 'function') {
                        p.turnOn();
                    }

                    mappedModel = productMap(p, pName, model, true);
                    p.adapter(mappedModel);
                }
            };

            /* Save the default isOff state so it can be restored during reset() */
            objForEach(Config.products, function (product, productName) {
                if ('isOff' in product) {
                    F.defaultProductIsOff[productName] = product.isOff;
                }
            });

            F.start();
        }

        function processUpdate(semanticModel) {
            if (F.analyticsModel.length === 0) {
                F.analyticsModel.push($.extend(parentModelRef, semanticModel));
            } else {
                F.analyticsModel.push($.extend({}, semanticModel));
            }
            F.checkForModelSpec(semanticModel, F.processModel);
        }

        function setupBaseModelResolution() {
            var baseModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : F.baseModelPromise;

            var dfds = [baseModel].concat(Analytics.additionalModelData.map(convertPromise));
            Analytics.additionalModelData.length = 0;
            /*
            * If WDPRO.Analytics.additionalModelData contains any promises this will wait until those
            * promises are resolved before proceeding, if the array doesnt contain any promises it will
            * just see those as all being resolved and proceed
            */
            return F.when = $.when.apply($, dfds).then(function (baseModel) {
                extendDataLayer.apply(null, arguments);
                if (Analytics.additionalModelData.length > 0) {
                    // more data may have been added since
                    return setupBaseModelResolution(baseModel);
                } else {
                    processUpdate(baseModel);
                    Debug.debug('Additional Data Promise Resolved');
                }
            }, function () {
                $.when(baseModel).then(function (baseModel) {
                    processUpdate(baseModel);
                    Debug.debug('Additional Data Promise Failed - continuing on without merging data');
                });
            });
        }
        setupBaseModelResolution();
        initializeFramework();

        function extendDataLayer(dataLayer) {
            if (dataLayer.personalizations && !dataLayer.personalizations.length) {
                dataLayer.personalizations = Parsers.applyFilter(dataLayer.personalizations, { forceArray: '' });
            }

            for (var _len = arguments.length, moreDataLayers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                moreDataLayers[_key - 1] = arguments[_key];
            }

            moreDataLayers.forEach(function (nextDataLayer) {
                if (dataLayer.personalizations && nextDataLayer.personalizations) {
                    mergeObjectsByKey('location', dataLayer.personalizations, nextDataLayer.personalizations, true);
                    delete nextDataLayer.personalizations;
                }
                $.extend(true, dataLayer, nextDataLayer);
            });
            return dataLayer;
        }

        function processProductRules(productName, model) {
            var matchValue,
                rules,
                turnOff = false,
                productConfig,
                ruleValue;

            if (model.configuration && model.configuration[productName] && model.configuration[productName].rules) {
                productConfig = model.configuration[productName];
                rules = productConfig.rules;
                Object.keys(rules).forEach(function (rule) {
                    if (!turnOff) {
                        ruleValue = Parsers.parseDotNotation(model, rule);
                        matchValue = rules[rule];

                        // For the sake of keeping things simple, we'll only compare against simple strings
                        if (typeof ruleValue === 'string') {
                            if (typeof matchValue === 'string') {
                                matchValue = matchValue.split(',');
                            }

                            if (Array.isArray(matchValue)) {
                                turnOff = !matchValue.some(function (curVal) {
                                    return curVal.toLowerCase().indexOf(ruleValue.toLowerCase()) > -1;
                                });
                            }
                        } else if (typeof ruleValue === 'undefined' || ruleValue === null) {
                            turnOff = true;
                        }
                    }
                });
            }

            if (turnOff) {
                // If any product utilizes any toggles then we need to update those toggles as well
                if (productConfig.dependantToggles) {
                    objForEach(productConfig.dependantToggles, function (depToggles, toggleType) {
                        if (model.toggleStatus && model.toggleStatus[toggleType]) {
                            depToggles.forEach(function (depToggle) {
                                if (model.toggleStatus[toggleType][depToggle]) {
                                    model.toggleStatus[toggleType][depToggle] = false;
                                }
                            });
                        }
                    });
                }
                productConfig.turnOff = true;
            }
        }

        function productMap(product, productName, model, ignoreModelConfigDisable) {
            var mappedModel, modelProductConfig, turnOff;

            if (product && model) {
                model.configuration = model.configuration || {};
                modelProductConfig = model.configuration[productName] || {};
                turnOff = iniBoolean(modelProductConfig.turnOff);

                // do not process if a particular product is turned off in the model
                if (!product.isOff && turnOff && !ignoreModelConfigDisable) {
                    if (typeof product.turnOff === 'function') {
                        product.turnOff();
                    }
                    product.isOff = true;
                    return;
                }

                if (product.isOff && turnOff === false) {
                    if (typeof product.turnOn === 'function') {
                        product.turnOn();
                    }
                    product.isOff = false;
                }

                if (typeof product.validateEnabled === 'function') {
                    product.validateEnabled(model, modelProductConfig);
                }
                if (product.isOff) {
                    return;
                }

                if (product.adapter && product.mapping && (modelProductConfig.parseModel = iniBoolean(modelProductConfig.parseModel, true))) {
                    mappedModel = Parsers.parseSemanticModel(model, product.mapping);
                }
            }

            return mappedModel || model;
        }

        /**
         * NOTE: It is possible for the personalization Id to change on a given page.
         * That being said since each model will pass through this function and the value will be pulled from the
         * cookie at that time this should not be an issue as the model will contain the value of the cookie at the
         * time that it was processed.
         */
        Analytics.getPersonalizationId = function (model) {
            var parentModel, id, CEA, cookieJar;

            if (model && model.configuration && model.configuration.CEA) {
                CEA = model.configuration.CEA;

                if (CEA.personalizationIdCookieJarName && CEA.personalizationIdCookieName) {
                    cookieJar = Utils.getCookie(CEA.personalizationIdCookieJarName, true);
                    if (cookieJar) {
                        id = cookieJar[CEA.personalizationIdCookieName];
                    }
                } else if (!CEA.personalizationIdCookieJarName && CEA.personalizationIdCookieName) {
                    id = Utils.getCookie(CEA.personalizationIdCookieName);
                } else {
                    cookieJar = Utils.getCookie('personalization_jar', true);
                    if (cookieJar) {
                        id = cookieJar.id;
                    }
                }

                return id;
            } else {
                parentModel = F.getParentModel();
                if (model !== parentModel) {
                    return Analytics.getPersonalizationId(parentModel);
                }
            }
        };
    }, 'Analytics', 'Config', 'jQuery', 'Debug', 'Parsers', 'Utils', 'objForEach', 'store', 'normalize', 'convertPromise', 'mergeObjectsByKey', 'iniBoolean');
})(window, document, location);
//# sourceMappingURL=framework-bottom.js.map
